/* ============ MIDNIGHT CREW · EDITOR ============
   Vídeo do Pinterest + áudio (MP3/M4A ou upload) + texto animado (Bebas Neue)
   Preview e export renderizados em canvas.
================================================== */
(function(){
'use strict';

/* ── Config GAS (mesmo backend do downloader) ── */
var MC_API   = 'https://script.google.com/macros/s/AKfycbx4cDDEvk8YNl8_ObUtTyXL44ASWsO24yYbN4RUmPpSekq3eGhyuZGRQ4ieg8_DBoUq/exec';
var MC_TOKEN = 'mc_cc6f126b6aaf46bfa553068c22727813';

/* ── JSONP genérico ── */
function gas(params, cb, tmoMs){
  var cbName = '_mce_cb_' + Date.now() + '_' + Math.random().toString(36).slice(2);
  params = params || {};
  params.key = MC_TOKEN;
  params.callback = cbName;
  var qs = Object.keys(params).map(function(k){ return encodeURIComponent(k)+'='+encodeURIComponent(params[k]); }).join('&');
  var s = document.createElement('script');
  var to = setTimeout(function(){
    try{ delete window[cbName]; }catch(e){}
    if(s.parentNode) s.parentNode.removeChild(s);
    cb(new Error('Timeout — servidor demorou demais'));
  }, tmoMs || 180000);
  window[cbName] = function(d){
    clearTimeout(to);
    try{ delete window[cbName]; }catch(e){}
    if(s.parentNode) s.parentNode.removeChild(s);
    cb(null, d);
  };
  s.onerror = function(){
    clearTimeout(to);
    try{ delete window[cbName]; }catch(e){}
    if(s.parentNode) s.parentNode.removeChild(s);
    cb(new Error('Erro de rede'));
  };
  s.src = MC_API + '?' + qs;
  document.head.appendChild(s);
}

function b64ToBlob(b64, mime){
  var bin = atob(b64);
  var bytes = new Uint8Array(bin.length);
  for(var i=0;i<bin.length;i++) bytes[i] = bin.charCodeAt(i);
  return new Blob([bytes], {type: mime || 'application/octet-stream'});
}

/* ══════════ ESTADO ══════════ */
var FPS = 24;                 /* timeline e export em 24fps */
var FRAME = 1 / FPS;          /* corte mínimo = 1 frame */
var ZOOMS = [5, 10, 20, 40, 80, 160, 320, 640, 1280];
var zoomIdx = 3;
function PPS(){ return ZOOMS[zoomIdx]; }

/* vídeo: números maiores em cima (V2,V1) · áudio: A1 em cima, novos embaixo
   padrão: 1 faixa de texto e 1 de áudio */
var tracks = [
  { id:'t1', kind:'text',  label:'TEXTO', volume:1 },
  { id:'v2', kind:'video', label:'MÍDIA 2', volume:1 },
  { id:'v1', kind:'video', label:'MÍDIA 1', volume:1 },
  { id:'a1', kind:'audio', label:'ÁUDIO 1', volume:1 }
];
var trackSeq = { video:2, audio:1, text:1, speed:1 };

/* clip: {id,kind,trackId,start,dur,in,srcDur,el,name,pair,muted,audioOff,
          text,x,y,size} — pair = id do clipe irmão (vídeo↔áudio do mesmo pin) */
var clips = [];
var clipSeq = 0;

var selId    = null;   /* clipe "primário" (painel de texto etc.) */
var selIds   = [];     /* seleção múltipla (marquee, pares vinculados) */
var tCur     = 0;
var playing  = false;
var rafId    = null;
var lastTs   = 0;
var exporting = false;
var exportRec = null;
var exportChunks = [];
var audioCtx = null, audioDest = null;

/* ── DOM ── */
var $ = function(id){ return document.getElementById(id); };
function on(id, evt, fn){ var el = $(id); if(el) el.addEventListener(evt, fn); }

/* qualquer erro JS aparece no status em vez de travar mudo */
window.addEventListener('error', function(ev){
  var el = $('mce-src-status');
  if(el){
    el.textContent = 'erro js: ' + String(ev.message || 'desconhecido').slice(0, 90);
    el.className = 'mc-tag s-err';
  }
});
var cv = $('mce-canvas'), ctx = cv.getContext('2d');
var elHeads = $('mce-tl-heads'), elLanes = $('mce-lanes'), elRuler = $('mce-ruler');
var elInner = $('mce-tl-inner'), elScroll = $('mce-tl-scroll'), elPlayhead = $('mce-playhead');

/* resolução do projeto (export) vs preview mais leve (evita stuttering) */
var PROJ_W = 1080, PROJ_H = 1920;
var PREVIEW_SCALE = 0.5;
function setCanvasRes(scale){
  cv.width  = Math.round(PROJ_W * scale);
  cv.height = Math.round(PROJ_H * scale);
}
setCanvasRes(PREVIEW_SCALE);

/* altura vertical de cada faixa (shift+scroll no nome da faixa)
   texto bem fina (fica fixa no topo); áudio alta pra ler a waveform */
function trackH(tr){ return tr.h || (tr.kind === 'text' ? 34 : (tr.kind === 'audio' ? 88 : 64)); }

/* ── scroll vertical das faixas (segurar e arrastar a divisória grossa,
   como no DaVinci) — a faixa de texto fica fixa, fora do scroll ── */
function startVScroll(e){
  e.preventDefault();
  e.stopPropagation();
  var y0 = e.clientY, s0 = elScroll.scrollTop;
  document.body.style.cursor = 'grabbing';
  var mv = function(ev){
    /* clampa no menor máximo dos dois containers — a área das lanes perde
       altura pra scrollbar horizontal, então o limite dela difere do da
       coluna de nomes; sem isso as duas param em pontos diferentes */
    var max = Math.min(
      Math.max(0, elScroll.scrollHeight - elScroll.clientHeight),
      Math.max(0, elHeads.scrollHeight - elHeads.clientHeight)
    );
    var v = clamp(s0 - (ev.clientY - y0), 0, max);
    elScroll.scrollTop = v;
    elHeads.scrollTop = v;
  };
  var up = function(){
    document.body.style.cursor = '';
    document.removeEventListener('mousemove', mv);
    document.removeEventListener('mouseup', up);
  };
  document.addEventListener('mousemove', mv);
  document.addEventListener('mouseup', up);
}
function makeVScrollGrip(){
  var g = document.createElement('div');
  g.className = 'mce-vscroll-grip';
  g.title = 'Segurar e arrastar pra rolar as faixas';
  g.addEventListener('mousedown', startVScroll);
  return g;
}

/* ── ícones SVG (minimalistas, currentColor) ── */
var ICONS = {
  play:  '<svg viewBox="0 0 16 16" width="12" height="12" fill="currentColor"><path d="M4 2.5v11l9-5.5z"/></svg>',
  pause: '<svg viewBox="0 0 16 16" width="12" height="12" fill="currentColor"><rect x="3.5" y="2.5" width="3" height="11"/><rect x="9.5" y="2.5" width="3" height="11"/></svg>',
  plus:  '<svg viewBox="0 0 16 16" width="9" height="9" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><line x1="8" y1="3" x2="8" y2="13"/><line x1="3" y1="8" x2="13" y2="8"/></svg>',
  x:     '<svg viewBox="0 0 16 16" width="9" height="9" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><line x1="4" y1="4" x2="12" y2="12"/><line x1="12" y1="4" x2="4" y2="12"/></svg>',
  eye:   '<svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M1.5 8s2.5-4.5 6.5-4.5S14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8z"/><circle cx="8" cy="8" r="2"/></svg>',
  eyeoff:'<svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M1.5 8s2.5-4.5 6.5-4.5S14.5 8 14.5 8 12 12.5 8 12.5 1.5 8 1.5 8z"/><circle cx="8" cy="8" r="2"/><line x1="2.5" y1="13.5" x2="13.5" y2="2.5"/></svg>',
  vol:   '<svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"><path d="M2.5 6v4H5l3.5 3V3L5 6z"/><path d="M10.5 5.5a3.5 3.5 0 0 1 0 5"/><path d="M12.3 3.6a6 6 0 0 1 0 8.8"/></svg>',
  volx:  '<svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round"><path d="M2.5 6v4H5l3.5 3V3L5 6z"/><line x1="10.5" y1="6" x2="14.5" y2="10"/><line x1="14.5" y1="6" x2="10.5" y2="10"/></svg>'
};
var meterFills = {};

/* fontes dos textos — Montserrat Bold e Bebas Neue. O canvas NÃO dispara o
   download de fontes CSS sozinho (só o DOM dispara), então sem estes load()
   explícitos a Bebas Neue nunca carregava: o modelo 3 saía com a fonte
   fallback (métricas/altura de linha diferentes) no preview E no render.
   Ao ficarem prontas, redesenha o frame e os previews dos modelos. */
try{
  var _fontRedraw = function(){
    try{ if(typeof drawFrame === 'function') drawFrame(); }catch(e){}
    try{ if(typeof renderTextModal === 'function') renderTextModal(); }catch(e){}
  };
  document.fonts.load('700 100px "Montserrat"').then(_fontRedraw).catch(function(){});
  document.fonts.load('400 100px "Bebas Neue"').then(_fontRedraw).catch(function(){});
}catch(e){}

/* ══════════ UTILS ══════════ */
function uid(){ return 'c' + (++clipSeq); }
function byId(id){ for(var i=0;i<clips.length;i++) if(clips[i].id===id) return clips[i]; return null; }
function pairOf(c){ return c && c.pair ? byId(c.pair) : null; }
function trackById(id){ for(var i=0;i<tracks.length;i++) if(tracks[i].id===id) return tracks[i]; return null; }
function sel(){ return byId(selId); }
function setSel(ids){
  selIds = ids.slice();
  selId  = ids.length ? ids[ids.length-1] : null;
}
function selectClip(c){
  if(!c){ setSel([]); return; }
  var ids = [c.id];
  var p = pairOf(c);
  if(p) ids.push(p.id);          /* seleção vinculada por padrão */
  setSel(ids);
  selId = c.id;
}
function selectedClips(){
  return clips.filter(function(c){ return selIds.indexOf(c.id) > -1; });
}
function clamp(v,a,b){ return v<a?a:(v>b?b:v); }
function snap(v){ return Math.round(v * FPS) / FPS; }   /* quantiza em frames (24fps) */
/* elementos flutuantes (modal, menu, toast) nascem DENTRO do #mc-root.mc —
   fora dele as variáveis CSS não existem e o tema da Shopify contamina tudo */
function uiRoot(){ return document.getElementById('mc-root') || document.body; }
/* ── velocidade por clipe (retime) ──
   rate 1 = normal, 2 = 2x mais rápido (consome 2s de mídia por 1s de timeline) */
function clipRate(c){ return c && c.rate ? c.rate : 1; }
function mediaTimeAt(c, t){ return (c.in || 0) + (t - c.start) * clipRate(c); }
function easeOut(p){ p = clamp(p,0,1); return 1 - Math.pow(1-p, 3); }
function projDur(){
  var d = 0;
  for(var i=0;i<clips.length;i++) d = Math.max(d, clips[i].start + clips[i].dur);
  return d;
}
/* fim do conteúdo de MÍDIA (vídeo/áudio) — ignora texto/velocímetro.
   Assim, com a timeline "vazia" (só texto), o vídeo novo entra no segundo 0
   e o texto se adapta sozinho (cadeado) */
function mediaEnd(){
  var d = 0;
  for(var i=0;i<clips.length;i++){
    var c = clips[i];
    if(c.kind === 'video' || c.kind === 'audio') d = Math.max(d, c.start + c.dur);
  }
  return d;
}
/* fim da mídia IGNORANDO SFX — usado pra posicionar um vídeo novo: ele entra
   logo após o último clipe de vídeo/áudio comum, sem levar o SFX em conta
   (o SFX se adapta sozinho ao vídeo pelo cadeado) */
function videoInsertEnd(trackId){
  /* fim da mídia considerada pro ponto de inserção. Com trackId: SÓ os clipes
     daquela faixa (mídia em outra faixa — ex.: imagem na MÍDIA 2 — é ignorada;
     o clipe novo entra no início ou após o último clipe da PRÓPRIA faixa).
     Sem trackId: fim geral (vídeo, áudio, imagem e SFX). */
  var d = 0;
  for(var i=0;i<clips.length;i++){
    var c = clips[i];
    if(trackId){
      if(c.trackId !== trackId) continue;
      if(c.kind === 'video' || c.kind === 'image') d = Math.max(d, c.start + c.dur);
    } else {
      if(c.kind === 'video' || c.kind === 'audio' || c.kind === 'image') d = Math.max(d, c.start + c.dur);
    }
  }
  return d;
}
function fmt(t){
  if(t<0) t=0;
  var m = Math.floor(t/60), s = Math.floor(t%60), f = Math.floor((t%1)*FPS + 0.0001);
  return (m<10?'0':'')+m+':'+(s<10?'0':'')+s+':'+(f<10?'0':'')+f;   /* MM:SS:FF (24fps) */
}
/* timecode completo estilo DaVinci Resolve: HH:MM:SS:FF com offset de 1h
   (o Resolve começa a timeline em 01:00:00:00 por padrão) */
var TC_OFFSET = 3600;
function fmtTC(t){
  if(t<0) t=0;
  t += TC_OFFSET;
  var f = Math.round((t % 1) * FPS);
  var ti = Math.floor(t);
  if(f >= FPS){ f = 0; ti += 1; }
  var h = Math.floor(ti/3600), m = Math.floor((ti%3600)/60), s = ti%60;
  var z = function(n){ return (n<10?'0':'')+n; };
  return z(h)+':'+z(m)+':'+z(s)+':'+z(f);
}
function activeAt(c, t){ return t >= c.start && t < c.start + c.dur; }

function ownerEl(c){
  /* elemento de mídia que toca este clipe (áudio pareado usa o <video> do irmão) */
  if(c.el) return c.el;
  var p = pairOf(c);
  return p ? p.el : null;
}

/* ══════════ ONDAS SONORAS (waveform) ══════════ */
var waveCache = {};      /* src → {peaks} | 'loading' | 'fail' */
var waveAC = null;
function clipSrc(c){
  var el = ownerEl(c);
  return el ? (el.currentSrc || el.src || '') : '';
}
function loadWave(src){
  var got = waveCache[src];
  if(got) return;                       /* já pronto, carregando ou falhou */
  waveCache[src] = 'loading';
  try{
    fetch(src).then(function(r){ return r.arrayBuffer(); }).then(function(buf){
      var AC = window.AudioContext || window.webkitAudioContext;
      if(!AC) throw new Error('sem AudioContext');
      if(!waveAC) waveAC = new AC();
      return waveAC.decodeAudioData(buf);
    }).then(function(audio){
      var ch = audio.getChannelData(0);
      var N = 8000, peaks = new Float32Array(N);   /* resolução alta pro zoom */
      var step = Math.max(1, Math.floor(ch.length / N));
      var maxP = 0;
      for(var i=0;i<N;i++){
        var p = 0, base = i*step, fim = Math.min(ch.length, base+step);
        for(var j=base;j<fim;j+=8){ var v = Math.abs(ch[j]); if(v>p) p = v; }
        peaks[i] = p;
        if(p > maxP) maxP = p;
      }
      waveCache[src] = { peaks: peaks, max: maxP || 1, dur: audio.duration };
      renderClips();                    /* redesenha com a onda real */
      if(typeof sfxModalOpen === 'function' && sfxModalOpen()) renderSfxModal();   /* atualiza a duração na galeria */
    }).catch(function(){ waveCache[src] = 'fail'; });
  }catch(e){ waveCache[src] = 'fail'; }
}
/* desenha só a fatia visível do clipe — nítido em qualquer zoom.
   curva estilo DaVinci: silêncio/ruído de fundo fica rente à linha (abaixo
   do piso), e acima dele um expoente suave (^0.7) deixa as partes baixas
   visíveis sem jogar o médio/alto todo no teto — a diferença entre muito
   baixo e médio-alto fica nítida */
var WAVE_FLOOR = 0.02;   /* fração do pico considerada "silêncio" */
function waveCurve(p){
  if(p <= WAVE_FLOOR) return p * (0.06 / WAVE_FLOOR);            /* rente */
  return 0.06 + Math.pow((p - WAVE_FLOOR) / (1 - WAVE_FLOOR), 0.7) * 0.94;
}
function drawWaveSlice(canvas, cache, c, fracA, fracB){
  var g = canvas.getContext('2d');
  var W = canvas.width, H = canvas.height;
  var peaks = cache.peaks, mx = cache.max || 1;
  var span = c.dur * clipRate(c);   /* mídia consumida (retime) */
  var total = c.srcDur || (c.in + span) || 1;
  var s0 = clamp((c.in + fracA * span) / total, 0, 1);
  var s1 = clamp((c.in + fracB * span) / total, 0, 1);
  g.clearRect(0, 0, W, H);
  g.fillStyle = 'rgba(234,252,240,.9)';
  /* volume do clipe (painel de áudio): o espectro cresce/encolhe junto */
  var volS = (typeof clipVol === 'function') ? clipVol(c) : 1;
  for(var x=0; x<W; x+=2){
    var idx = Math.floor((s0 + (s1 - s0) * (x / W)) * peaks.length);
    var v = Math.min(1, waveCurve((peaks[Math.min(peaks.length-1, idx)] || 0) / mx) * volS);
    var h = Math.max(1, v * (H - 2));
    g.fillRect(x, (H - h)/2, 1.4, h);
  }
}

/* ══════════ MINIATURAS DE VÍDEO (filmstrip nos clipes) ══════════ */
var thumbCache = {};      /* src → {canvas,fw,fh,n} | 'loading' | 'fail' */
var THUMB_H = 44, THUMB_N = 16;
function loadThumbs(src, cors){
  if(!src || thumbCache[src]) return;
  thumbCache[src] = 'loading';
  var v = document.createElement('video');
  v.muted = true; v.playsInline = true; v.preload = 'auto';
  if(cors) v.crossOrigin = 'anonymous';
  v.addEventListener('error', function(){ thumbCache[src] = 'fail'; }, { once:true });
  v.addEventListener('loadedmetadata', function(){
    var ar = (v.videoWidth && v.videoHeight) ? v.videoWidth / v.videoHeight : 0.56;
    var fw = Math.max(8, Math.round(THUMB_H * ar));
    var strip = document.createElement('canvas');
    strip.width = fw * THUMB_N; strip.height = THUMB_H;
    var g = strip.getContext('2d');
    var idx = 0;
    var step = (v.duration || 1) / THUMB_N;
    var onSeek = function(){
      try{ g.drawImage(v, idx * fw, 0, fw, THUMB_H); }catch(e){}
      idx++;
      if(idx >= THUMB_N){
        v.removeEventListener('seeked', onSeek);
        thumbCache[src] = { canvas: strip, fw: fw, fh: THUMB_H, n: THUMB_N };
        renderClips();
      } else {
        try{ v.currentTime = Math.min((v.duration || 1) - 0.05, idx * step + 0.01); }catch(e){}
      }
    };
    v.addEventListener('seeked', onSeek);
    try{ v.currentTime = Math.min((v.duration || 1) - 0.05, 0.01); }catch(e){}
  }, { once:true });
  v.src = src;
  v.load();
}

function drawThumbSlice(canvas, tc, c, fracA, fracB){
  var g = canvas.getContext('2d');
  var W = canvas.width, H = canvas.height;
  g.clearRect(0, 0, W, H);
  var span = c.dur * clipRate(c);   /* mídia consumida (retime) */
  var total = c.srcDur || span || 1;
  var fw2 = Math.max(6, Math.round(H * (tc.fw / tc.fh)));
  for(var x=0; x<W; x+=fw2){
    var frac = fracA + (fracB - fracA) * (x / W);
    var t = c.in + frac * span;
    var fi = clamp(Math.floor(t / total * tc.n), 0, tc.n - 1);
    g.drawImage(tc.canvas, fi * tc.fw, 0, tc.fw, tc.fh, x, 0, fw2, H);
  }
}

function updateThumbWindows(){
  var sl = elScroll.scrollLeft, vw = elScroll.clientWidth;
  var els = elLanes.querySelectorAll('canvas.mce-clip-thumbc');
  for(var i=0;i<els.length;i++){
    var el = els[i];
    var clip = byId(el.parentNode.dataset.id);
    if(!clip) continue;
    var src = clipSrc(clip);
    var tc = src ? thumbCache[src] : null;
    if(!tc || !tc.canvas) continue;
    var clipL = clip.start * PPS(), clipW = Math.max(clip.dur * PPS(), 14);
    var visL = Math.max(clipL, sl - 200), visR = Math.min(clipL + clipW, sl + vw + 200);
    if(visR <= visL){ el.width = 1; el.style.width = '1px'; continue; }
    var w = Math.round(visR - visL);
    var h = Math.max(10, (el.parentNode.clientHeight || 40) - 15);
    el.width = w; el.height = h;
    el.style.left = Math.round(visL - clipL) + 'px';
    el.style.width = w + 'px';
    el.style.height = h + 'px';
    drawThumbSlice(el, tc, clip, (visL - clipL) / clipW, (visR - clipL) / clipW);
  }
}

/* re-renderiza as ondas cobrindo apenas a área visível (scroll/zoom) */
function updateWaveWindows(){
  var sl = elScroll.scrollLeft, vw = elScroll.clientWidth;
  var els = elLanes.querySelectorAll('canvas.mce-clip-wavec');
  for(var i=0;i<els.length;i++){
    var el = els[i];
    var clip = byId(el.parentNode.dataset.id);
    if(!clip) continue;
    var src = clipSrc(clip);
    var cache = src ? waveCache[src] : null;
    if(!cache || !cache.peaks) continue;
    var clipL = clip.start * PPS(), clipW = Math.max(clip.dur * PPS(), 14);
    var visL = Math.max(clipL, sl - 200), visR = Math.min(clipL + clipW, sl + vw + 200);
    if(visR <= visL){ el.width = 1; el.style.width = '1px'; continue; }
    var w = Math.round(visR - visL);
    var h = Math.max(10, (el.parentNode.clientHeight || 40) - 15);   /* -15 = barra do nome */
    el.width = w; el.height = h;
    el.style.left = Math.round(visL - clipL) + 'px';
    el.style.width = w + 'px';
    el.style.height = h + 'px';
    drawWaveSlice(el, cache, clip, (visL - clipL) / clipW, (visR - clipL) / clipW);
  }
  updateThumbWindows();
}

/* ══════════ TIMELINE (render) ══════════ */
function tlDur(){ return Math.max(projDur() + 30, 600); }   /* mínimo 10 min, como no Resolve */

function groupSep(prevKind, tr){
  /* linha mais grossa separando os grupos texto / vídeo / áudio */
  return prevKind && prevKind !== tr.kind ? ' mce-group-sep' : '';
}

function renderHeads(){
  elHeads.innerHTML = '';
  var prevKind = null;
  var stickyTop = 0;
  tracks.forEach(function(tr){
    var sep = groupSep(prevKind, tr);
    var d = document.createElement('div');
    d.className = 'mce-track-head' + (tr.hidden || tr.muted ? ' is-off' : '') + sep;
    prevKind = tr.kind;
    d.style.height = trackH(tr) + 'px';
    /* texto fixo no topo (fora do scroll vertical) */
    if(tr.kind === 'text'){
      d.classList.add('is-sticky');
      d.style.top = stickyTop + 'px';
      stickyTop += trackH(tr);
    }
    /* divisória grossa = alça de scroll vertical (segurar e arrastar) */
    if(sep) d.appendChild(makeVScrollGrip());
    var lbl = document.createElement('span');
    lbl.className = 'mce-track-head-label';
    lbl.textContent = tr.label;
    d.appendChild(lbl);

    var row = document.createElement('div');
    row.className = 'mce-track-head-actions';
    var extraRow = null;   /* 2ª linha do cabeçalho (áudio: cadeado + +SFX) */

    if(tr.kind === 'audio'){
      var smWrap = document.createElement('div');
      smWrap.className = 'mce-mix-sm';
      var bS2 = document.createElement('button');
      bS2.className = 'mx-s' + (tr.solo ? ' is-on' : '');
      bS2.title = 'Solo: só as faixas em solo tocam';
      bS2.textContent = 'S';
      bS2.addEventListener('click', function(){ snapshot(); tr.solo = !tr.solo; syncMuted(); renderHeads(); });
      smWrap.appendChild(bS2);
      var bM2 = document.createElement('button');
      bM2.className = 'mx-m' + (tr.muted ? ' is-on' : '');
      bM2.title = tr.muted ? 'Ativar o som da faixa' : 'Mutar a faixa';
      bM2.textContent = 'M';
      bM2.addEventListener('click', function(){ snapshot(); tr.muted = !tr.muted; syncMuted(); renderHeads(); });
      smWrap.appendChild(bM2);
      row.appendChild(smWrap);
      /* 2ª linha (abaixo de S e M): cadeado + +SFX */
      extraRow = document.createElement('div');
      extraRow.className = 'mce-track-head-actions';
      /* cadeado: áudio trancado à duração do vídeo (limitado ao tamanho do áudio) */
      var alk = document.createElement('button');
      alk.className = 'mce-track-head-btn';
      alk.title = tr.lockDur
        ? 'Cadeado ativo: o áudio acompanha a duração do vídeo (até o tamanho do áudio)'
        : 'Cadeado desligado: duração do áudio livre';
      alk.innerHTML = tr.lockDur ? LOCK_CLOSED : LOCK_OPEN;
      if(tr.lockDur) alk.style.color = 'var(--acc)';
      alk.addEventListener('click', function(){ snapshot(); tr.lockDur = !tr.lockDur; renderAll(); drawFrame(); });
      extraRow.appendChild(alk);
      /* +SFX: galeria de efeitos (Carro/Moto) → início da faixa */
      var addSfx = document.createElement('button');
      addSfx.className = 'mce-track-head-btn';
      addSfx.title = 'Adicionar efeito sonoro (SFX) no início da faixa';
      addSfx.innerHTML = ICONS.plus + '<span>SFX</span>';
      addSfx.addEventListener('click', function(){ openSfxModal(tr.id); });
      extraRow.appendChild(addSfx);
    }
    if(tr.kind === 'video'){
      var h = document.createElement('button');
      h.className = 'mce-track-head-btn' + (tr.hidden ? ' is-on' : '');
      h.title = tr.hidden ? 'Mostrar a faixa' : 'Ocultar a faixa (não aparece no preview/export)';
      h.innerHTML = tr.hidden ? ICONS.eyeoff : ICONS.eye;
      h.addEventListener('click', function(){ snapshot(); tr.hidden = !tr.hidden; renderHeads(); drawFrame(); });
      row.appendChild(h);

      var bs = document.createElement('button');
      bs.className = 'mce-track-head-btn';
      bs.title = 'Adicionar velocímetro TripRank nesta faixa';
      bs.innerHTML = ICONS.plus + '<span>TRIP</span>';
      bs.addEventListener('click', function(){ addSpeedClip(tr.id); });
      row.appendChild(bs);
    }
    if(tr.kind === 'text'){
      /* cadeado: texto e vídeo mantêm a mesma duração (alterar um afeta os outros) */
      var lk = document.createElement('button');
      lk.className = 'mce-track-head-btn';
      lk.title = textLockDur
        ? 'Cadeado ativo: texto e vídeo mantêm a mesma duração'
        : 'Cadeado desligado: duração do texto é ajustada manualmente';
      lk.innerHTML = textLockDur ? LOCK_CLOSED : LOCK_OPEN;
      if(textLockDur) lk.style.color = 'var(--acc)';
      lk.addEventListener('click', function(){
        textLockDur = !textLockDur;
        renderAll(); drawFrame();
      });
      row.appendChild(lk);

      /* alterna a visualização entre as versões A e B do texto */
      var vb = document.createElement('button');
      vb.className = 'mce-track-head-btn';
      vb.title = 'Alternar entre as versões V1 e V2 do texto (mostrando: ' + (textVariant ? 'V2' : 'V1') + ')';
      vb.innerHTML = '<span style="font-weight:700;font-size:9px">' + (textVariant ? 'V2' : 'V1') + '</span>';
      vb.style.color = 'var(--acc)';
      vb.addEventListener('click', function(){
        textVariant = textVariant ? 0 : 1;
        renderAll(); drawFrame();
      });
      row.appendChild(vb);

      /* +TXT: abre o modal de modelos */
      var addTxt = document.createElement('button');
      addTxt.className = 'mce-track-head-btn';
      addTxt.title = 'Adicionar texto';
      addTxt.innerHTML = ICONS.plus + '<span>TXT</span>';
      addTxt.addEventListener('click', function(){ addTextClip(tr.id); });
      row.appendChild(addTxt);
    }

    /* botão excluir — não aparece em faixas de texto */
    if(tr.kind !== 'text'){
      var del = document.createElement('button');
      del.className = 'mce-track-head-btn mce-track-head-del';
      del.title = 'Excluir a faixa e todos os clipes dela';
      del.innerHTML = ICONS.x;
      del.addEventListener('click', function(){ deleteTrack(tr.id); });
      row.appendChild(del);
    }

    d.appendChild(row);
    if(extraRow) d.appendChild(extraRow);   /* 2ª linha (áudio: cadeado + +SFX) */
    elHeads.appendChild(d);
  });
  renderVols();
}

/* ══════════ MIXER (estilo DaVinci) ══════════
   fader vertical em dB (+6 no topo → -50 = mudo), S/M por faixa.
   ganho acima de 0dB usa o GainNode do WebAudio (o volume do <video>
   não passa de 1) — o boost também vale no export offline. */
var DB_TOP = 6, DB_BOT = -50;
var MIX_TICKS = [6, 0, -5, -10, -15, -20, -30, -40, -50];
function dbToRatio(db){ return (DB_TOP - db) / (DB_TOP - DB_BOT); }
function ratioToDb(r){ return DB_TOP - r * (DB_TOP - DB_BOT); }
function fmtDb(db){
  if(db <= DB_BOT) return '-∞';
  return (db > 0 ? '+' : '') + db.toFixed(1);
}
function trackGain(tr){
  if(!tr) return 1;
  var db = tr.gainDb == null ? 0 : tr.gainDb;
  return db <= DB_BOT ? 0 : Math.pow(10, db / 20);
}

function renderVols(){
  var wrap = $('mce-tl-vols');
  if(!wrap) return;
  wrap.innerHTML = '';
  meterFills = {};

  var title = document.createElement('div');
  title.className = 'mce-mix-title';
  title.textContent = 'Mixer';
  wrap.appendChild(title);

  var row = document.createElement('div');
  row.className = 'mce-mix-row';
  wrap.appendChild(row);

  tracks.forEach(function(tr){
    if(tr.kind !== 'audio') return;
    if(tr.gainDb == null) tr.gainDb = 0;

    var strip = document.createElement('div');
    strip.className = 'mce-mix-strip';

    var nm = document.createElement('div');
    nm.className = 'mce-mix-name';
    nm.textContent = 'A' + audioIndexOf(tr.id);
    strip.appendChild(nm);

    /* S / M */
    var sm = document.createElement('div');
    sm.className = 'mce-mix-sm';
    var bS = document.createElement('button');
    bS.className = 'mx-s' + (tr.solo ? ' is-on' : '');
    bS.textContent = 'S';
    bS.title = 'Solo: só as faixas em solo tocam';
    bS.addEventListener('click', function(){
      snapshot();
      tr.solo = !tr.solo;
      syncMuted(); renderVols();
    });
    var bM = document.createElement('button');
    bM.className = 'mx-m' + (tr.muted ? ' is-on' : '');
    bM.textContent = 'M';
    bM.title = 'Mutar a faixa';
    bM.addEventListener('click', function(){
      snapshot();
      tr.muted = !tr.muted;
      syncMuted(); renderHeads();   /* renderHeads re-renderiza o mixer junto */
    });
    sm.appendChild(bS); sm.appendChild(bM);
    strip.appendChild(sm);

    /* leitura em dB */
    var db = document.createElement('div');
    db.className = 'mce-mix-db';
    db.textContent = fmtDb(tr.gainDb);
    strip.appendChild(db);

    /* corpo: escala + fader + medidor */
    var body = document.createElement('div');
    body.className = 'mce-mix-body';

    var scale = document.createElement('div');
    scale.className = 'mce-mix-scale';
    MIX_TICKS.forEach(function(t){
      var tk = document.createElement('span');
      tk.className = 'mce-mix-tick';
      tk.style.top = (dbToRatio(t) * 100) + '%';
      tk.textContent = t === DB_TOP ? '+6' : String(Math.abs(t));
      scale.appendChild(tk);
    });
    body.appendChild(scale);

    var fader = document.createElement('div');
    fader.className = 'mce-mix-fader';
    fader.title = 'Volume da faixa (duplo clique = 0dB)';
    var thumb = document.createElement('div');
    thumb.className = 'mce-mix-thumb';
    thumb.style.top = (dbToRatio(tr.gainDb) * 100) + '%';
    fader.appendChild(thumb);
    body.appendChild(fader);

    var meter = document.createElement('div');
    meter.className = 'mce-mix-meter';
    var fill = document.createElement('div');
    fill.className = 'mce-mix-meter-fill';
    meter.appendChild(fill);
    meterFills[tr.id] = fill;
    body.appendChild(meter);

    strip.appendChild(body);
    row.appendChild(strip);

    /* arrastar o fader */
    function setFromY(clientY){
      var r = fader.getBoundingClientRect();
      var ratio = clamp((clientY - r.top) / Math.max(1, r.height), 0, 1);
      tr.gainDb = Math.round(ratioToDb(ratio) * 10) / 10;
      thumb.style.top = (ratio * 100) + '%';
      db.textContent = fmtDb(tr.gainDb);
      applyVolumes();
    }
    fader.addEventListener('mousedown', function(e){
      e.preventDefault();
      snapshot();
      setFromY(e.clientY);
      var mv = function(ev){ setFromY(ev.clientY); };
      var up = function(){ document.removeEventListener('mousemove', mv); document.removeEventListener('mouseup', up); };
      document.addEventListener('mousemove', mv);
      document.addEventListener('mouseup', up);
    });
    fader.addEventListener('dblclick', function(){
      tr.gainDb = 0;
      thumb.style.top = (dbToRatio(0) * 100) + '%';
      db.textContent = fmtDb(0);
      applyVolumes();
    });
  });
}

function deleteTrack(trackId){
  var own = clips.filter(function(c){ return c.trackId === trackId; });
  if(own.length && !confirm('Excluir esta faixa e ' + own.length + ' clipe(s) dela?')) return;
  snapshot();
  own.forEach(function(c){
    var p = pairOf(c);
    if(p && p.trackId !== trackId){
      p.pair = null;
      if(c.kind === 'audio' && p.kind === 'video') p.audioOff = true;
      if(c.kind === 'video' && c.el && p.kind === 'audio'){ p.el = c.el; p.srcDur = c.srcDur; }
    } else if(c.el && (!p || p.trackId === trackId)){
      try{ c.el.pause(); }catch(e){}
    }
    if(selId === c.id) selId = null;
  });
  clips = clips.filter(function(c){ return c.trackId !== trackId; });
  tracks = tracks.filter(function(t){ return t.id !== trackId; });
  setSel(selIds.filter(function(id){ return !!byId(id); }));
  renderAll(); syncMuted(); drawFrame();
}

/* escada de passos "redondos" (segundos) pro rótulo da régua — como no
   Resolve: escolhe o menor passo cujo espaçamento na tela ≥ alvo de px */
var RULER_STEPS = [1/24, 2/24, 5/24, 10/24, 0.5, 1, 2, 5, 10, 15, 30, 60, 120, 240, 300, 600, 900, 1800, 3600];
function rulerStep(){
  var target = 116;   /* px desejado entre dois rótulos */
  for(var i=0;i<RULER_STEPS.length;i++){ if(RULER_STEPS[i]*PPS() >= target) return RULER_STEPS[i]; }
  return RULER_STEPS[RULER_STEPS.length-1];
}
/* passo das marcações finas = fração do passo grande (4, senão 2, senão 1) */
function rulerMinor(step){
  var d = 4;
  if((step/d)*PPS() < 9) d = 2;
  if((step/d)*PPS() < 9) d = 1;
  return d > 1 ? step/d : 0;
}
function renderRuler(){
  var w = tlDur() * PPS();
  elInner.style.width = (w + 160) + 'px';
  elRuler.innerHTML = '';
  var step = rulerStep();
  var EPS = step * 0.001;
  /* TODAS as marcações (frames/segundos/minutos) vêm do updateFrameTicks —
     sempre alinhadas em frame exato, nunca no meio de dois frames */
  /* rótulos grandes (timecode completo HH:MM:SS:FF) */
  for(var s=0; s<=tlDur() + EPS; s+=step){
    var m = document.createElement('div');
    m.className = 'mce-ruler-mark';
    m.style.left = (s * PPS()) + 'px';
    m.dataset.t = s;
    m.textContent = fmtTC(s);
    elRuler.appendChild(m);
  }
  updateFrameTicks();
}

/* marcações da régua estilo DaVinci, SEMPRE visíveis e SEMPRE em frame exato.
   O passo é o menor múltiplo de frames que caiba na tela (1f, 2f, 4f… 1s, 5s…),
   então nunca cai um traço no meio de dois frames. Níveis interpolados:
   ímpar (mais curto) < par < 12 frames < segundo < minuto (mais longo e mais
   claro). Renderizadas só na janela visível do scroll. */
var frameTickPool = [];
var TICK_LADDER = [1, 2, 4, 6, 12, 24, 48, 120, 240, 360, 720, 1440, 2880, 7200, 14400];
function tickStepFrames(){
  var px = FRAME * PPS();
  for(var i=0;i<TICK_LADDER.length;i++) if(TICK_LADDER[i] * px >= 5) return TICK_LADDER[i];
  return TICK_LADDER[TICK_LADDER.length-1];
}
function updateFrameTicks(){
  var stepF = tickStepFrames();
  var stepPx = stepF * FRAME * PPS();
  var sl = elScroll.scrollLeft, vw = elScroll.clientWidth || 0;
  var i0 = Math.max(0, Math.floor((sl - 40) / stepPx));
  var i1 = Math.min(Math.ceil((sl + vw + 40) / stepPx), Math.ceil(tlDur() * FPS / stepF));
  var used = 0;
  var FMIN = FPS * 60;
  for(var i = i0; i <= i1; i++){
    var f = i * stepF;                 /* nº do frame — sempre frame exato */
    var el = frameTickPool[used];
    if(!el){ el = document.createElement('div'); frameTickPool.push(el); }
    /* níveis RELATIVOS ao passo (padrão DaVinci em qualquer zoom): minuto é
       o mais longo/claro; segundo destaca só quando há subdivisões visíveis
       dele (senão TODO tick era "segundo" e sobravam só traços compridos);
       o resto interpola curto/médio/longo por divisibilidade (2×/4× do passo) */
    var lvl;
    if(f % FMIN === 0) lvl = 'tk-min';
    else if(stepF < FPS && f % FPS === 0) lvl = 'tk-sec';
    else if(f % (stepF * 4) === 0) lvl = 'tk-half';
    else if(f % (stepF * 2) === 0) lvl = 'tk-even';
    else lvl = 'tk-odd';
    el.className = 'mce-ruler-frame ' + lvl;
    el.style.left = (f * FRAME * PPS()) + 'px';
    el.dataset.t = f * FRAME;
    if(el.parentNode !== elRuler) elRuler.appendChild(el);
    used++;
  }
  for(var k = used; k < frameTickPool.length; k++){
    if(frameTickPool[k].parentNode) frameTickPool[k].parentNode.removeChild(frameTickPool[k]);
  }
}

/* desliza as marcações da régua junto com os clipes no zoom */
function animateRuler(){
  elRuler.classList.add('is-anim');
  /* playhead NÃO recebe is-anim: scroll imediato já reposiciona,
     a transição faria o playhead "pular" visivelmente */
  var step = rulerStep(), EPS = 0.001;
  var ms = elRuler.children;
  for(var i=ms.length-1;i>=0;i--){
    var el = ms[i];
    var t = parseFloat(el.dataset.t || '0');
    /* rótulo que não cai no passo do NOVO zoom sai na hora — sem isso, no
       zoom-out rápido os números se embolam uns sobre os outros até o
       re-render do fim da animação */
    if(el.classList.contains('mce-ruler-mark')){
      var k = t / step;
      if(Math.abs(k - Math.round(k)) > EPS){ elRuler.removeChild(el); continue; }
    }
    el.style.left = (t * PPS()) + 'px';
  }
  updateFrameTicks();   /* traços já re-renderizados no espaçamento do novo zoom */
  setTimeout(function(){
    elRuler.classList.remove('is-anim');
  }, 260);
}

/* espaçamento das linhas verticais das faixas = passo da régua (acompanha o zoom) */
function laneGridSize(){
  return (rulerStep() * PPS()) + 'px 100%';
}

function renderClips(){
  elLanes.innerHTML = '';
  var prevKind = null;
  var stickyTop = 28;   /* abaixo da régua */
  tracks.forEach(function(tr){
    var sep = groupSep(prevKind, tr);
    var lane = document.createElement('div');
    lane.className = 'mce-lane' + sep;
    prevKind = tr.kind;
    lane.dataset.track = tr.id;
    lane.style.height = trackH(tr) + 'px';
    lane.style.backgroundSize = laneGridSize();
    /* faixa de texto fixa no topo, fora do scroll vertical */
    if(tr.kind === 'text'){
      lane.classList.add('is-sticky');
      lane.style.top = stickyTop + 'px';
      stickyTop += trackH(tr);
    }
    if(sep) lane.appendChild(makeVScrollGrip());
    clips.forEach(function(c){
      if(c.trackId !== tr.id) return;
      var d = document.createElement('div');
      d.className = 'mce-clip k-' + c.kind + (c.isSfx?' is-sfx':'') + (selIds.indexOf(c.id)>-1?' is-sel':'') + (c.muted?' is-muted':'');
      d.style.left  = (c.start * PPS()) + 'px';
      d.style.width = Math.max(c.dur * PPS(), 14) + 'px';
      d.style.height = (trackH(tr) - 12) + 'px';
      d.dataset.id = c.id;
      if(c.kind === 'audio'){
        var src = clipSrc(c);
        var cache = src ? waveCache[src] : null;
        if(cache && cache.peaks){
          var wc = document.createElement('canvas');
          wc.className = 'mce-clip-wavec';
          d.appendChild(wc);   /* desenhado por updateWaveWindows (só a área visível) */
        } else {
          if(src) loadWave(src);   /* dispara a decodificação; redesenha quando pronto */
          var w = document.createElement('span');
          w.className = 'mce-clip-wave';
          d.appendChild(w);
        }
      }
      if(c.kind === 'video'){
        var vsrc = clipSrc(c);
        var tcache = vsrc ? thumbCache[vsrc] : null;
        if(tcache && tcache.canvas){
          var tcv = document.createElement('canvas');
          tcv.className = 'mce-clip-thumbc';
          d.appendChild(tcv);   /* desenhado por updateThumbWindows */
        } else if(vsrc){
          var oel = ownerEl(c);
          loadThumbs(vsrc, !!(oel && oel.crossOrigin));
        }
      }
      if(c.isSfx){
        var tag = document.createElement('span');
        tag.className = 'mce-clip-sfxtag';
        tag.textContent = 'SFX';
        d.appendChild(tag);
      }
      var label = document.createElement('span');
      label.className = 'mce-clip-label';
      label.textContent = c.name + (clipRate(c) !== 1 ? ' ×' + (Math.round(clipRate(c) * 100) / 100) : '');
      d.appendChild(label);
      var hl = document.createElement('span'); hl.className = 'mce-clip-handle h-l'; hl.dataset.h = 'l'; d.appendChild(hl);
      var hr = document.createElement('span'); hr.className = 'mce-clip-handle h-r'; hr.dataset.h = 'r'; d.appendChild(hr);
      /* ── FADE in/out (só áudio): curva visual + alças nos cantos de cima ── */
      if(c.kind === 'audio'){
        var clipW = Math.max(c.dur * PPS(), 14), clipH = trackH(tr) - 12;
        var fiPx = clamp((c.fadeIn || 0) * PPS(), 0, clipW);
        var foPx = clamp((c.fadeOut || 0) * PPS(), 0, clipW);
        var SVGNS = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(SVGNS, 'svg');
        svg.setAttribute('class', 'mce-fade-svg');
        svg.setAttribute('viewBox', '0 0 ' + clipW + ' ' + clipH);
        svg.setAttribute('preserveAspectRatio', 'none');
        var addPath = function(dstr){ var p = document.createElementNS(SVGNS, 'path'); p.setAttribute('d', dstr); p.setAttribute('class', 'mce-fade-fill'); svg.appendChild(p); };
        if(fiPx > 0.5) addPath('M0 0 L' + fiPx + ' 0 L0 ' + clipH + ' Z');
        if(foPx > 0.5) addPath('M' + clipW + ' 0 L' + (clipW - foPx) + ' 0 L' + clipW + ' ' + clipH + ' Z');
        d.appendChild(svg);
        var fih = document.createElement('span'); fih.className = 'mce-fade-handle f-in';  fih.title = 'Puxe pra dentro: fade in';  fih.style.left  = fiPx + 'px'; d.appendChild(fih);
        var foh = document.createElement('span'); foh.className = 'mce-fade-handle f-out'; foh.title = 'Puxe pra dentro: fade out'; foh.style.right = foPx + 'px'; d.appendChild(foh);
        (function(cc){
          fih.addEventListener('mousedown', function(ev){ startFadeDrag(ev, cc, 'in'); });
          foh.addEventListener('mousedown', function(ev){ startFadeDrag(ev, cc, 'out'); });
        })(c);
      }
      lane.appendChild(d);
    });
    elLanes.appendChild(lane);
  });
  updateWaveWindows();
}

/* fator de volume do fade (0..1) num instante da timeline, pro clipe de áudio */
function fadeGain(c, t){
  var fi = c.fadeIn || 0, fo = c.fadeOut || 0;
  if(fi <= 0 && fo <= 0) return 1;
  var local = t - c.start;                 /* 0 … c.dur */
  var g = 1;
  if(fi > 0 && local < fi) g = Math.max(0, local / fi);
  if(fo > 0){
    var rem = c.dur - local;
    if(rem < fo) g = Math.min(g, Math.max(0, rem / fo));
  }
  return clamp(g, 0, 1);
}
/* arrastar a alça de fade (canto superior do clipe de áudio) pra dentro do
   clipe: cria/ajusta o fade in (esquerda) ou fade out (direita) */
function startFadeDrag(e, c, side){
  e.preventDefault(); e.stopPropagation();
  snapshot();
  var x0 = e.clientX;
  var orig = side === 'in' ? (c.fadeIn || 0) : (c.fadeOut || 0);
  var mv = function(ev){
    var dxSec = (ev.clientX - x0) / PPS();
    var v = side === 'in' ? (orig + dxSec) : (orig - dxSec);   /* pra dentro = mais fade */
    var other = side === 'in' ? (c.fadeOut || 0) : (c.fadeIn || 0);
    v = clamp(v, 0, Math.max(0, c.dur - other));               /* não passa do outro fade */
    if(side === 'in') c.fadeIn = snap(v); else c.fadeOut = snap(v);
    renderClips(); drawFrame();
  };
  var up = function(){
    document.body.style.cursor = '';
    document.removeEventListener('mousemove', mv);
    document.removeEventListener('mouseup', up);
  };
  document.body.style.cursor = 'ew-resize';
  document.addEventListener('mousemove', mv);
  document.addEventListener('mouseup', up);
}

/* anima os clipes até a posição atual do estado (zoom, ripple delete etc.) */
var animTimer = null;
function animatePositions(){
  elLanes.classList.add('is-anim');
  var els = elLanes.querySelectorAll('.mce-clip');
  for(var i=0;i<els.length;i++){
    var c = byId(els[i].dataset.id);
    if(!c){ els[i].style.opacity = '0'; continue; }   /* excluído: fade out */
    var newW = Math.max(c.dur * PPS(), 14);
    /* waveform/filmstrip escala junto com o clipe durante a animação
       (redesenho nítido acontece no renderAll do fim) */
    var oldW = els[i].offsetWidth || newW;
    var ratio = oldW ? newW / oldW : 1;
    var kids = els[i].querySelectorAll('.mce-clip-wavec,.mce-clip-thumbc');
    for(var k=0;k<kids.length;k++){
      var kl = parseFloat(kids[k].style.left || '0');
      var kw = parseFloat(kids[k].style.width || String(oldW));
      kids[k].style.left  = (kl * ratio) + 'px';
      kids[k].style.width = (kw * ratio) + 'px';
    }
    els[i].style.left  = (c.start * PPS()) + 'px';
    els[i].style.width = newW + 'px';
  }
  /* linhas verticais das faixas deslizam junto (transition no background-size) */
  var lanes = elLanes.querySelectorAll('.mce-lane');
  for(var li=0;li<lanes.length;li++) lanes[li].style.backgroundSize = laneGridSize();
  if(animTimer) clearTimeout(animTimer);
  animTimer = setTimeout(function(){
    animTimer = null;
    elLanes.classList.remove('is-anim');
    renderAll();
  }, 240);
}

function renderPlayhead(){
  elPlayhead.style.left = (tCur * PPS()) + 'px';
  $('mce-time').textContent = fmtTC(tCur) + ' / ' + fmtTC(projDur());
}

/* cadeado (na coluna da timeline): quando ativo, TODO clipe de texto
   acompanha a duração do conteúdo de vídeo; desligado, é ajuste manual */
var textLockDur = true;
function updateAutoTextDur(){
  if(!textLockDur) return;
  var vEnd = 0;
  for(var i=0;i<clips.length;i++) if(clips[i].kind === 'video') vEnd = Math.max(vEnd, clips[i].start + clips[i].dur);
  if(vEnd <= 0) return;
  for(var j=0;j<clips.length;j++){
    var c = clips[j];
    if(c.kind === 'text'){
      var d = vEnd - c.start;
      if(d >= FRAME) c.dur = snap(d);
    }
  }
}

/* contexto da trava SFX ⇄ vídeo: o 1º SFX numa faixa com cadeado + o ÚLTIMO
   clipe de vídeo (o flexível). Retorna null se não houver esse par. */
function lockSfxCtx(){
  var sfx = null;
  for(var k=0;k<clips.length;k++){
    var a = clips[k];
    if(a.kind === 'audio' && a.isSfx){
      var tr = trackById(a.trackId);
      if(tr && tr.lockDur){ sfx = a; break; }
    }
  }
  if(!sfx) return null;
  /* o par do SFX considera SÓ os vídeos que ele cobre (começam antes do fim
     dele) — um vídeo adicionado DEPOIS do SFX fica fora da trava, em vez de
     virar o "par" e ser retalhado pela reconciliação */
  var sfxEnd = sfx.start + sfx.dur;
  var hasV = false, vStart = Infinity, vEnd = -1, lastV = null;
  for(var i=0;i<clips.length;i++){
    var c = clips[i];
    if(c.kind !== 'video') continue;
    if(c.start >= sfxEnd - 0.0001) continue;   /* começa depois do SFX → livre */
    hasV = true;
    if(c.start < vStart) vStart = c.start;
    if(c.start + c.dur > vEnd){ vEnd = c.start + c.dur; lastV = c; }
  }
  if(!hasV || !lastV) return null;
  var fixedBefore = Math.max(0, lastV.start - vStart);   /* vídeo antes do último */
  var vAvail = fixedBefore + (lastV.srcDur ? (lastV.srcDur - (lastV.in || 0)) / clipRate(lastV) : lastV.dur);
  var sAvail = sfx.srcDur ? (sfx.srcDur - (sfx.in || 0)) : sfx.dur;
  return { sfx: sfx, lastV: lastV, vStart: vStart, fixedBefore: fixedBefore, vAvail: vAvail, sAvail: sAvail };
}

/* aplica um comprimento COMPARTILHADO L ao par SFX ⇄ vídeo, alinhando o SFX ao
   1º vídeo. driver = quem o usuário arrastou:
     'sfx'   → L segue o SFX (o vídeo cresce/encolhe junto, até o material dele);
     'video' → L segue o vídeo (o SFX cresce/encolhe junto, até a fonte dele);
     null    → reconcilia pelo MENOR (adaptação inicial ao adicionar/reposicionar).
   O vídeo trava ao tentar passar da duração do SFX, e vice-versa. */
function reconcileLock(driver){
  var x = lockSfxCtx();
  if(!x) return;
  var Lmin = x.fixedBefore + FRAME;
  var Lmax = Math.max(Lmin, Math.min(x.vAvail, x.sAvail));
  var vExtent = (x.lastV.start - x.vStart) + x.lastV.dur;
  var L;
  if(driver === 'sfx')        L = x.sfx.dur;
  else if(driver === 'video') L = vExtent;
  else                        L = Math.min(x.sfx.dur, vExtent);
  L = clamp(L, Lmin, Lmax);
  x.sfx.start = snap(x.vStart);
  x.sfx.dur   = snap(L);
  x.lastV.dur = snap(L - x.fixedBefore);
  var lp = pairOf(x.lastV);
  if(lp){ lp.start = x.lastV.start; lp.dur = x.lastV.dur; }
}

/* trava COMBINADA (usada ao vivo no arrasto): com o cadeado de texto e/ou o de
   SFX ativos, arrastar a borda de QUALQUER um dos três — texto, vídeo ou SFX —
   redimensiona os outros juntos. Ordem importa: o SFX limita o vídeo PRIMEIRO,
   e o texto acompanha o vídeo JÁ LIMITADO — assim o texto não cresce além da
   duração do SFX. */
function syncLocks(driver){
  var lx = lockSfxCtx();
  /* ── BORDA ESQUERDA (início): corta a FRENTE dos dois em sincronia ──
     avança o mesmo delta de tempo no `in` do vídeo E do SFX, mantendo o
     conteúdo alinhado (sem o SFX "voltar ao começo" e desincronizar). */
  if(lx && drag && drag.mode === 'l' && !drag.retime && drag.lockPartner &&
     (driver === lx.sfx || driver === lx.lastV)){
    var partner = byId(drag.lockPartner);
    if(partner){
      var so = drag.orig, po = drag.lockPartnerOrig;
      var sRate = clipRate(driver), pRate = clipRate(partner);
      var delta = driver.start - so.start;   /* +: cortando a frente · -: estendendo */
      /* limite comum dos dois: nem `in` negativo, nem duração < 1 frame */
      var extendMax = Math.max(-(so.off / sRate), -(po.off / pRate));
      var trimMax   = Math.min(so.dur - FRAME, po.dur - FRAME);
      delta = clamp(delta, extendMax, trimMax);
      driver.start = snap(so.start + delta);
      driver.dur   = snap(so.dur - delta);
      driver.in    = driver.srcDur ? (so.off + delta * sRate) : 0;
      var dp = pairOf(driver); if(dp){ dp.start = driver.start; dp.dur = driver.dur; dp.in = driver.in; }
      partner.start = driver.start;
      partner.dur   = snap(po.dur - delta);
      partner.in    = partner.srcDur ? (po.off + delta * pRate) : 0;
      var pp = pairOf(partner); if(pp){ pp.start = partner.start; pp.dur = partner.dur; pp.in = partner.in; }
      if(textLockDur) updateAutoTextDur();
      return;
    }
  }
  /* ── BORDA DIREITA / demais: reconcilia comprimento ── */
  if(lx){
    if(driver === lx.sfx) reconcileLock('sfx');
    else if(driver === lx.lastV) reconcileLock('video');
    else if(driver && driver.kind === 'text' && textLockDur){
      applyLockedEnd(driver.start + driver.dur);   /* texto puxa o vídeo… */
      reconcileLock('video');                        /* …e o SFX limita/segue */
    } else {
      reconcileLock(null);
    }
  } else if(textLockDur){
    if(driver && driver.kind === 'text') applyLockedEnd(driver.start + driver.dur);
    else if(driver && driver.kind === 'video') updateAutoTextDur();
  }
  /* o texto SEMPRE acompanha o vídeo final (já limitado pelo SFX) */
  if(textLockDur) updateAutoTextDur();
}

/* cadeado da FAIXA DE ÁUDIO (tr.lockDur): áudio e vídeo com a MESMA duração,
   cortando o mais longo pra caber no mais curto. Com um SFX travado + vídeo,
   a trava é DINÂMICA (reconcileLock): arrastar o vídeo OU o SFX redimensiona
   os dois juntos. Sem vídeo, o áudio fica no tamanho cheio da fonte. */
function updateAutoAudioDur(){
  var locked = [];
  for(var k=0;k<clips.length;k++){
    var a = clips[k];
    if(a.kind !== 'audio') continue;
    var tr = trackById(a.trackId);
    if(tr && tr.lockDur) locked.push(a);
  }
  if(!locked.length) return;
  /* par SFX ⇄ vídeo: trava dinâmica */
  if(lockSfxCtx()){ reconcileLock(null); return; }
  /* fallback (áudio travado sem par SFX⇄vídeo): RESPEITA o corte manual do
     usuário (não força mais o tamanho cheio — era isso que fazia o áudio
     aparado "voltar" ao render); só limita ao material e apara o vídeo se maior */
  var hasV = false, vEnd = 0, lastV = null;
  for(var i=0;i<clips.length;i++){
    var c = clips[i];
    if(c.kind === 'video'){ hasV = true; if(c.start + c.dur >= vEnd){ vEnd = c.start + c.dur; lastV = c; } }
  }
  var aEnd = 0;
  locked.forEach(function(a){
    var avail = a.srcDur ? (a.srcDur - (a.in || 0)) : a.dur;
    if(a.dur > avail + 0.0001) a.dur = snap(Math.max(FRAME, avail));   /* só não passa do material */
    aEnd = Math.max(aEnd, a.start + a.dur);
  });
  if(hasV && lastV && aEnd > 0 && vEnd > aEnd + 0.0001){
    var vd = aEnd - lastV.start;
    if(vd >= FRAME){
      lastV.dur = snap(vd);
      var p = pairOf(lastV);
      if(p){ p.dur = lastV.dur; }
    }
  }
}

/* SFX sempre por cima: apaga a parte de qualquer OUTRO áudio que fique
   sobreposto (no tempo) a um clipe de SFX NA MESMA FAIXA — ex.: o áudio
   original do vídeo. Outras faixas de áudio (A2, A3…) coexistem livremente. */
function enforceSfxPriority(){
  var sfx = clips.filter(function(c){ return c.kind === 'audio' && c.isSfx; });
  if(!sfx.length) return;
  var EPS = 0.0001;
  sfx.forEach(function(sx){
    var s = sx.start, e = sx.start + sx.dur;
    var victims = clips.filter(function(o){
      return o !== sx && o.kind === 'audio' && !o.isSfx &&
             o.trackId === sx.trackId &&
             o.start < e - EPS && o.start + o.dur > s + EPS;
    });
    victims.forEach(function(o){
      var os = o.start, oe = o.start + o.dur;
      var coversL = s <= os + EPS, coversR = e >= oe - EPS;
      if(coversL && coversR){
        if(o.el){ try{ o.el.pause(); }catch(_){} }
        var p = pairOf(o);
        if(p){ p.pair = null; if(p.kind === 'video') p.audioOff = true; }
        var ix = clips.indexOf(o); if(ix > -1) clips.splice(ix, 1);
      } else if(coversL){
        var cut = e - os; o.start = snap(e); o.dur = snap(oe - o.start); if(o.srcDur) o.in += cut * clipRate(o);
      } else if(coversR){
        o.dur = snap(s - os);
      } else {
        var b = {}; for(var kk in o) if(o.hasOwnProperty(kk)) b[kk] = o[kk];
        b.id = uid(); b.pair = null; b.start = snap(e); b.dur = snap(oe - e);
        b.in = o.srcDur ? (o.in || 0) + (e - os) * clipRate(o) : 0;
        if(b.el){ b.el = cloneEl(b.el); warmEl(b.el, b.in); }   /* pedaço novo = elemento próprio */
        o.dur = snap(s - os); clips.push(b);
      }
    });
  });
}

var LOCK_CLOSED = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';
var LOCK_OPEN   = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 7.6-1.8"/></svg>';

/* cadeado ativo + usuário mexeu no fim de um TEXTO: o vídeo acompanha,
   e todos os textos ficam com o mesmo fim (camadas sincronizadas) */
function applyLockedEnd(newEnd){
  if(!textLockDur) return;
  var vEnd = 0, lastV = null;
  for(var i=0;i<clips.length;i++){
    var c = clips[i];
    if(c.kind === 'video' && c.start + c.dur >= vEnd){ vEnd = c.start + c.dur; lastV = c; }
  }
  if(lastV){
    var maxDur = lastV.srcDur ? (lastV.srcDur - lastV.in) : 600;
    lastV.dur = snap(clamp(newEnd - lastV.start, FRAME, maxDur));
    var p = pairOf(lastV);
    if(p){ p.dur = lastV.dur; p.in = lastV.in; }
  }
  updateAutoTextDur();
}

function renderAll(){
  updateAutoAudioDur();   /* SFX limita o vídeo PRIMEIRO… */
  updateAutoTextDur();    /* …e o texto segue o vídeo já limitado */
  enforceSfxPriority();
  renderHeads(); renderRuler(); renderClips(); renderPlayhead();
  var stageHint = $('mce-stage-hint');
  if(stageHint) stageHint.style.display = clips.length ? 'none' : 'flex';
  syncTextPanel(); syncSpeedPanel();
  if(typeof updateOverlayVis === 'function') updateOverlayVis();
}

/* aba lateral: mostra o placeholder quando nenhum painel está aberto */
function updateSideEmpty(){
  var empty = $('mce-side-empty');
  if(!empty) return;
  var t = $('mce-text-panel'), s = $('mce-speed-panel'), v = $('mce-video-panel'), a = $('mce-audio-panel');
  var open = (t && t.style.display !== 'none') || (s && s.style.display !== 'none') || (v && v.style.display !== 'none') || (a && a.style.display !== 'none');
  empty.style.display = open ? 'none' : 'flex';
}

/* ══════════ UNDO / CLIPBOARD / ÍMÃ ══════════ */
var snapOn = true;
var undoStack = [];
var clipboard = null;

function cloneData(c){
  var o = {};
  for(var k in c) if(c.hasOwnProperty(k)) o[k] = c[k];
  /* v2 (versão B do texto) é objeto — cópia profunda pro undo funcionar */
  if(c.v2){ o.v2 = {}; for(var k2 in c.v2) if(c.v2.hasOwnProperty(k2)) o.v2[k2] = c.v2[k2]; }
  return o;
}

var redoStack = [];
function curState(){
  return {
    clips:  clips.map(cloneData),
    tracks: tracks.map(cloneData),
    selId:  selId,
    selIds: selIds.slice()
  };
}
function restoreState(s){
  clips = s.clips; tracks = s.tracks; selId = s.selId; selIds = s.selIds || (s.selId ? [s.selId] : []);
  renderAll(); syncMuted(); seekMedia(); drawFrame();
}
function snapshot(){
  undoStack.push(curState());
  if(undoStack.length > 60) undoStack.shift();
  redoStack.length = 0;          /* ação nova invalida o redo */
}
function popSnapshot(){ undoStack.pop(); }
function undo(){
  var s = undoStack.pop();
  if(!s) return;
  redoStack.push(curState());
  restoreState(s);
}
function redo(){
  var s = redoStack.pop();
  if(!s) return;
  undoStack.push(curState());
  restoreState(s);
}

function cloneEl(el){
  if(!el) return null;
  var n = el.cloneNode(true);
  /* cloneNode NÃO copia propriedades — sem preload o clone carrega preguiçoso
     e o 1º seek na borda do corte demora (era o flick/trava no playback) */
  n.preload = 'auto';
  n.playsInline = true;
  n.addEventListener('seeked', function(){ if(!playing) drawFrame(); });
  try{ n.load(); }catch(e){}
  return n;
}

/* aquece um elemento clonado no ponto de mídia dado (bufferiza a borda do corte) */
function warmEl(el, t){
  if(!el || !t) return;
  var warm = function(){ try{ el.currentTime = t; }catch(_){} };
  if(el.readyState >= 1) warm();
  else el.addEventListener('loadedmetadata', warm, { once:true });
}
function copySel(){
  var c = sel();
  if(!c) return;
  var p = pairOf(c);
  clipboard = { a: cloneData(c), b: p ? cloneData(p) : null };
}
function pasteClip(){
  if(!clipboard) return;
  snapshot();
  var a = cloneData(clipboard.a); a.id = uid(); a.start = snap(tCur);
  var b = null;
  if(clipboard.b){
    b = cloneData(clipboard.b); b.id = uid(); b.start = a.start;
    a.pair = b.id; b.pair = a.id;
  } else a.pair = null;
  if(a.el) a.el = cloneEl(a.el);
  if(b && b.el) b.el = cloneEl(b.el);
  if(!trackById(a.trackId)) a.trackId = firstTrack(a.kind).id;
  if(b && !trackById(b.trackId)) b.trackId = firstTrack(b.kind).id;
  clips.push(a);
  if(b) clips.push(b);
  overwriteMoved([a]);   /* colou por cima de outro clipe? o de baixo é cortado */
  selectClip(a);
  renderAll(); syncMuted(); drawFrame();
}

/* pontos de alinhamento: início/fim dos outros clipes, playhead e 0 */
function snapPoints(excludeIds){
  var pts = [0, tCur];
  clips.forEach(function(c){
    if(excludeIds.indexOf(c.id) > -1) return;
    pts.push(c.start, c.start + c.dur);
  });
  return pts;
}
function applySnap(val, pts){
  if(!snapOn) return null;
  var th = 8 / PPS();     /* ~8px de tolerância */
  var best = null, bd = th;
  for(var i=0;i<pts.length;i++){
    var d = Math.abs(pts[i] - val);
    if(d < bd){ bd = d; best = pts[i]; }
  }
  return best;
}

/* ══════════ OVERWRITE (clipe por cima de clipe na mesma faixa) ══════════ */
/* ao soltar um clipe sobre outro NA MESMA FAIXA, a parte sobreposta do
   clipe de baixo é EXCLUÍDA (não fica camada escondida por baixo) */
function overwriteInto(c, prot, force){
  if(!c) return;
  var s = c.start, e = c.start + c.dur, EPS = 0.0001;
  var victims = clips.filter(function(o){
    return o !== c && o.trackId === c.trackId && !(prot && prot[o.id]) &&
           /* SFX sempre prevalece: nunca é cortado por outro áudio (só some
              se for um SFX cobrindo outro SFX). `force` ignora a exceção —
              usado no ripple do delete, onde quem foi puxado toma o lugar */
           !(o.isSfx && !c.isSfx && !force) &&
           /* TripRank: colocar um TRIP sobre o vídeo mantém o overlay (TRIP
              não corta vídeo), mas vídeo/imagem que SOBREPÕE um TRIP o exclui
              — mesma lógica de exclusão dos outros clipes */
           (c.kind === 'speed' ? o.kind === 'speed' : true) &&
           o.start < e - EPS && o.start + o.dur > s + EPS;
  });
  victims.forEach(function(o){
    var os = o.start, oe = o.start + o.dur;
    var coversL = s <= os + EPS, coversR = e >= oe - EPS;
    if(coversL && coversR){
      /* coberto por inteiro: sai da timeline */
      if(o.el){ try{ o.el.pause(); }catch(_){} }
      var p = pairOf(o);
      if(p){
        p.pair = null;
        if(o.kind === 'audio' && p.kind === 'video') p.audioOff = true;
        if(o.kind === 'video' && o.el && p.kind === 'audio' && !p.el){ p.el = o.el; p.srcDur = o.srcDur; }
      }
      var ix = clips.indexOf(o);
      if(ix > -1) clips.splice(ix, 1);
    } else if(coversL){
      /* corta a parte da esquerda do clipe de baixo */
      var cut = e - os;
      o.start = snap(e);
      o.dur   = snap(oe - o.start);
      if(o.srcDur) o.in += cut * clipRate(o);
    } else if(coversR){
      /* corta a parte da direita */
      o.dur = snap(s - os);
    } else {
      /* caiu no meio: o clipe de baixo vira dois pedaços (antes e depois) */
      var b = {};
      for(var k in o) if(o.hasOwnProperty(k)) b[k] = o[k];
      b.id = uid(); b.pair = null;
      b.start = snap(e);
      b.dur   = snap(oe - e);
      b.in    = (o.srcDur || o.kind === 'speed') ? (o.in || 0) + (e - os) * clipRate(o) : 0;
      if(b.el){ b.el = cloneEl(b.el); warmEl(b.el, b.in); }   /* pedaço novo = elemento próprio (sem brigar pelo player) */
      b._srcFrame = null;
      o.dur   = snap(s - os);
      clips.push(b);
      try{ if(typeof audioCtx !== 'undefined' && audioCtx) ensureGraph(); }catch(_){}
    }
  });
}
function overwriteMoved(moved){
  var prot = {};
  moved.forEach(function(c){ prot[c.id] = 1; var p = pairOf(c); if(p) prot[p.id] = 1; });
  moved.forEach(function(c){
    overwriteInto(c, prot);
    var p = pairOf(c);
    if(p) overwriteInto(p, prot);
  });
  setSel(selIds.filter(function(id){ return !!byId(id); }));
}

/* ══════════ INTERAÇÕES DA TIMELINE ══════════ */
var drag = null; /* {mode:'move'|'l'|'r'|'head', id, x0, orig:{...}, origPair:{...}, moved} */

elLanes.addEventListener('mousedown', function(e){
  /* a régua de reprodução (playhead) tem prioridade sobre arrastar clipes:
     se o clique cai bem em cima da linha do playhead, faz SCRUB em vez de
     mover o elemento que estiver embaixo (TripRank, modelo de texto etc.).
     Sem isso, um clipe sob a linha "roubava" o clique e era arrastado junto. */
  if(!cutMode && e.button === 0){
    /* a alça de corte do clipe (bordas l/r) tem prioridade sobre o scrub —
       senão, com o playhead na borda do clipe, não dava pra redimensionar */
    var _onHandle = e.target && (e.target.dataset.h === 'l' || e.target.dataset.h === 'r');
    var _ir = elInner.getBoundingClientRect();
    if(!_onHandle && Math.abs((e.clientX - _ir.left) - tCur * PPS()) <= 6){
      e.preventDefault();
      startPlayheadDrag(e);
      return;
    }
  }
  var clipEl = e.target.closest('.mce-clip');
  if(!clipEl){
    /* área vazia: inicia seleção por retângulo (marquee) */
    if(cutMode || e.button !== 0) return;
    var r0 = elInner.getBoundingClientRect();
    marquee = { x0: e.clientX - r0.left, y0: e.clientY - r0.top, moved: false };
    e.preventDefault();
    return;
  }
  var c = byId(clipEl.dataset.id);
  if(!c) return;
  if(cutMode){
    var rr = elInner.getBoundingClientRect();
    splitPairAt(c, cutTimeAt((e.clientX - rr.left) / PPS(), c));
    e.preventDefault();
    return;
  }
  /* CTRL+clique = seleção múltipla: cada clique adiciona/remove o clipe da
     seleção (par vinculado entra/sai junto) — sem iniciar arraste */
  if(e.ctrlKey && e.button === 0){
    var grpSel = [c.id];
    var cPair = pairOf(c);
    if(cPair) grpSel.push(cPair.id);
    var idsSel = selIds.slice();
    if(idsSel.indexOf(c.id) > -1){
      idsSel = idsSel.filter(function(id){ return grpSel.indexOf(id) === -1; });
    } else {
      grpSel.forEach(function(id){ if(idsSel.indexOf(id) < 0) idsSel.push(id); });
    }
    setSel(idsSel);
    renderClips();
    syncTextPanel(); syncSpeedPanel();
    e.preventDefault();
    return;
  }
  /* clicar num clipe já selecionado mantém a seleção múltipla (pra arrastar o grupo) */
  if(selIds.indexOf(c.id) === -1) selectClip(c);
  else selId = c.id;
  if(e.button === 2) return;   /* botão direito = menu de contexto */
  var mode = e.target.dataset.h === 'l' ? 'l' : (e.target.dataset.h === 'r' ? 'r' : 'move');
  var p = pairOf(c);
  snapshot();
  /* alt+clicar e arrastar o corpo do clipe = DUPLICAR (arrasta a cópia) */
  if(mode === 'move' && e.altKey){
    var dupA = cloneData(c); dupA.id = uid();
    var dupB = null;
    if(p){ dupB = cloneData(p); dupB.id = uid(); dupA.pair = dupB.id; dupB.pair = dupA.id; }
    else dupA.pair = null;
    if(dupA.el) dupA.el = cloneEl(dupA.el);
    if(dupB && dupB.el) dupB.el = cloneEl(dupB.el);
    clips.push(dupA);
    if(dupB) clips.push(dupB);
    c = dupA; p = dupB;
    selectClip(c);
  }
  drag = {
    mode: mode, id: c.id, x0: e.clientX, moved: false,
    /* alt+arrastar a extremidade = retime (muda a velocidade, não o corte) */
    retime: !!(e.altKey && (mode === 'l' || mode === 'r') && (c.kind === 'video' || c.kind === 'audio')),
    /* ids da cópia do alt+arrastar (removida se soltar sem mover) */
    dupIds: (mode === 'move' && e.altKey) ? [c.id].concat(p ? [p.id] : []) : null,
    origRate: clipRate(c),
    orig: { start: c.start, dur: c.dur, off: c.in },
    origPair: p ? { start: p.start, dur: p.dur, off: p.in } : null,
    items: mode === 'move' ? selectedClips().map(function(x){ return { id: x.id, start: x.start }; }) : null
  };
  /* trava SFX ⇄ vídeo: guarda o parceiro travado e seu estado inicial, pra o
     arrasto de borda (esq/dir) redimensionar/cortar os DOIS em sincronia */
  if(mode === 'l' || mode === 'r'){
    var lockCtx = lockSfxCtx();
    if(lockCtx && (c === lockCtx.sfx || c === lockCtx.lastV)){
      var partner = (c === lockCtx.sfx) ? lockCtx.lastV : lockCtx.sfx;
      if(partner && partner !== c){
        drag.lockPartner = partner.id;
        drag.lockPartnerOrig = { start: partner.start, dur: partner.dur, off: partner.in };
      }
    }
  }
  renderClips();
  syncTextPanel(); syncSpeedPanel();
  e.preventDefault();
});

/* seleção em área também na REGIÃO VAZIA abaixo das faixas (dentro da
   timeline): essa área não pertence ao elLanes, então o marquee não iniciava */
function startMarqueeEmpty(e){
  if(cutMode || e.button !== 0) return;
  var r0 = elInner.getBoundingClientRect();
  marquee = { x0: e.clientX - r0.left, y0: e.clientY - r0.top, moved: false };
  e.preventDefault();
}
elInner.addEventListener('mousedown', function(e){ if(e.target === elInner) startMarqueeEmpty(e); });
elScroll.addEventListener('mousedown', function(e){ if(e.target === elScroll) startMarqueeEmpty(e); });

document.addEventListener('mousemove', function(e){
  if(!drag) return;
  var c = byId(drag.id);
  if(!c){ drag = null; return; }
  var dx = (e.clientX - drag.x0) / PPS();
  var p = pairOf(c);
  var maxDur;
  if(Math.abs(dx) > 0.001) drag.moved = true;
  var excl = drag.items ? drag.items.map(function(it){ return it.id; }) : [c.id].concat(p ? [p.id] : []);
  var pts = snapPoints(excl);

  if(drag.mode === 'move'){
    var s0 = drag.orig.start + dx;
    /* ímã: tenta alinhar o início OU o fim do clipe num ponto próximo */
    var sA = applySnap(s0, pts);
    var sB = applySnap(s0 + c.dur, pts);
    if(sB !== null) sB -= c.dur;
    var chosen = null;
    if(sA !== null && sB !== null) chosen = Math.abs(sA - s0) <= Math.abs(sB - s0) ? sA : sB;
    else chosen = (sA !== null) ? sA : sB;
    var desiredStart = chosen !== null ? chosen : snap(s0);
    var shift = desiredStart - drag.orig.start;
    /* trava do GRUPO no início da timeline: o shift é limitado pelo clipe mais
       à esquerda da seleção — quando ele encosta no 0, o grupo inteiro para
       junto (mantendo o espaçamento), sem os da frente sobreporem o primeiro */
    var minStart = drag.orig.start;
    (drag.items || []).forEach(function(it){ if(it.start < minStart) minStart = it.start; });
    if(minStart + shift < 0) shift = -minStart;
    /* move todo o grupo selecionado junto (mesmo shift pra todos) */
    (drag.items || []).forEach(function(it){
      var cc = byId(it.id);
      if(cc && cc.id !== c.id) cc.start = snap(Math.max(0, it.start + shift));
    });
    c.start = snap(Math.max(0, drag.orig.start + shift));
    if(p && drag.origPair && (!drag.items || !drag.items.some(function(it){ return it.id === p.id; }))) p.start = c.start;
    /* arrastar na VERTICAL: muda o clipe pra outra faixa do mesmo tipo */
    var lr = elLanes.getBoundingClientRect();
    var yRel = e.clientY - lr.top, accY = 0, targetTr = null;
    for(var tix=0; tix<tracks.length; tix++){
      var thh = trackH(tracks[tix]);
      if(yRel >= accY && yRel < accY + thh){ targetTr = tracks[tix]; break; }
      accY += thh;
    }
    if(targetTr && targetTr.id !== c.trackId &&
       (targetTr.kind === c.kind || ((c.kind === 'speed' || c.kind === 'image') && targetTr.kind === 'video'))){
      c.trackId = targetTr.id;
      /* par vinculado acompanha a numeração (V2 ↔ A2) */
      var pl = pairOf(c);
      if(pl){
        if(c.kind === 'video' && pl.kind === 'audio'){
          var at = audioTrackForVideo(targetTr.id, false);
          if(at) pl.trackId = at.id;
        } else if(c.kind === 'audio' && pl.kind === 'video'){
          var vt = videoTrackForAudio(targetTr.id);
          if(vt) pl.trackId = vt.id;
        }
      }
    }
    /* ARRASTAR ABAIXO DE TODAS AS FAIXAS: se for áudio, oferece criar uma faixa
       de áudio nova (fantasma tracejado); a faixa nasce ao soltar (mouseup) */
    drag.dropNewAudio = false;
    if(!targetTr && yRel >= accY && c.kind === 'audio'){
      drag.dropNewAudio = true;
      placeGhostAt(ghostA, newAudioLaneTop(), NEW_AUDIO_LANE_H, c.start, c.dur);
    } else if(ghostA.classList.contains('is-virtual')){
      hideGhosts();
    }
  } else if(drag.mode === 'l'){
    if(drag.retime){
      /* alt+arrastar a borda esquerda: fim fixo, o material inteiro se
         estica/comprime — muda a velocidade, não o corte */
      var spanL = drag.orig.dur * drag.origRate;
      var minDL = Math.max(-drag.orig.start, drag.orig.dur - spanL * 10);
      var maxDL = drag.orig.dur - Math.max(FRAME, spanL / 10);
      var dL = clamp(dx, minDL, maxDL);
      var nsL = drag.orig.start + dL;
      var snpL = applySnap(nsL, pts);
      if(snpL !== null) dL = clamp(snpL - drag.orig.start, minDL, maxDL);
      c.start = snap(drag.orig.start + dL);
      c.dur   = snap(drag.orig.dur - dL);
      c.rate  = spanL / c.dur;
      if(p && drag.origPair){ p.start = c.start; p.dur = c.dur; p.rate = c.rate; }
    } else {
    /* limite esquerdo: vídeo/áudio respeitam o material; triprank respeita o
       offset da animação (in >= 0); texto é livre até o 0 da timeline */
    var minD1 = c.kind === 'text' ? -drag.orig.start
              : c.kind === 'speed' ? Math.max(-drag.orig.start, -(drag.orig.off || 0))
              : -(drag.orig.off / drag.origRate);
    var d1 = clamp(dx, minD1, drag.orig.dur - FRAME);
    var ns = drag.orig.start + d1;
    var snapped = applySnap(ns, pts);
    if(snapped !== null){
      var d2 = snapped - drag.orig.start;
      d2 = clamp(d2, minD1, drag.orig.dur - FRAME);
      d1 = d2; ns = drag.orig.start + d1;
    } else ns = snap(ns);
    c.start = ns;
    c.dur   = snap(drag.orig.dur - d1);
    c.in    = (c.srcDur || c.kind === 'speed') ? (drag.orig.off || 0) + d1 * drag.origRate : 0;
    if(p && drag.origPair){ p.start = c.start; p.dur = c.dur; p.in = c.in; }
    }
  } else if(drag.mode === 'r'){
    if(drag.retime){
      /* alt+arrastar a borda direita: início fixo, retime do material */
      var spanR = drag.orig.dur * drag.origRate;
      var ndR = clamp(drag.orig.dur + dx, Math.max(FRAME, spanR / 10), spanR * 10);
      var endSnapR = applySnap(c.start + ndR, pts);
      if(endSnapR !== null) ndR = clamp(endSnapR - c.start, Math.max(FRAME, spanR / 10), spanR * 10);
      c.dur  = snap(ndR);
      c.rate = spanR / c.dur;
      if(p){ p.dur = c.dur; p.rate = c.rate; }
    } else {
    maxDur = c.srcDur ? (c.srcDur - c.in) / clipRate(c) : 600;
    var nd = clamp(drag.orig.dur + dx, FRAME, maxDur);
    var endSnap = applySnap(c.start + nd, pts);
    if(endSnap !== null) nd = clamp(endSnap - c.start, FRAME, maxDur);
    else nd = snap(nd);
    c.dur = nd;
    if(p) p.dur = c.dur;
    }
  }
  /* trava COMBINADA AO VIVO: texto + vídeo + SFX se redimensionam/cortam juntos */
  if(drag.mode === 'l' || drag.mode === 'r') syncLocks(c);
  renderClips(); renderRuler(); renderPlayhead();
  drawFrame();
});

document.addEventListener('mouseup', function(){
  if(drag){
    var wasMove = drag.mode === 'move' && drag.moved;
    var wasResize = (drag.mode === 'l' || drag.mode === 'r') && drag.moved;
    if(!drag.moved){
      /* alt+clique sem arrastar: desfaz a duplicação (a cópia sai) */
      if(drag.dupIds){
        var dd = {};
        drag.dupIds.forEach(function(id){ dd[id] = true; });
        clips = clips.filter(function(x){ return !dd[x.id]; });
        setSel(selIds.filter(function(id){ return !dd[id]; }));
        renderAll(); drawFrame();
      }
      popSnapshot();   /* clique sem arrastar não entra no undo */
    }
    /* soltou abaixo de todas as faixas → cria a faixa de áudio nova e leva o
       clipe pra ela (issue 3) */
    var _cDrop = drag.dropNewAudio ? byId(drag.id) : null;
    var _newAudio = drag.dropNewAudio;
    hideGhosts();
    drag = null;
    if(_newAudio && _cDrop && _cDrop.kind === 'audio'){
      var nt = addTrack('audio');
      _cDrop.trackId = nt.id;
      overwriteMoved([_cDrop]);
      renderAll(); drawFrame(); seekMedia();
      return;
    }
    if(wasMove){
      /* soltar por cima de outro clipe: a parte sobreposta de baixo sai */
      overwriteMoved(selectedClips());
      renderAll(); drawFrame();
    } else if(wasResize){
      /* redimensionar também consolida o estado (trava, overlaps) na hora —
         assim o que aparece na timeline é EXATAMENTE o que vai pro render */
      renderAll(); drawFrame();
    }
    seekMedia();
  }
});

/* ══════════ VELOCIDADE DO CLIPE (menu de contexto + modal) ══════════ */
function applyClipRate(c, rate){
  rate = clamp(rate, 0.1, 10);
  var span = c.dur * clipRate(c);          /* material consumido fica fixo */
  c.rate = rate;
  c.dur  = snap(Math.max(FRAME, span / rate));
  var p = pairOf(c);
  if(p){ p.rate = rate; p.dur = c.dur; }   /* vinculados mudam igualmente */
  if(textLockDur) updateAutoTextDur();
}

var ctxMenu = null;
function hideCtxMenu(){ if(ctxMenu){ ctxMenu.remove(); ctxMenu = null; } }
elLanes.addEventListener('contextmenu', function(e){
  var clipEl = e.target.closest('.mce-clip');
  if(!clipEl) return;
  var c = byId(clipEl.dataset.id);
  if(!c) return;
  e.preventDefault();
  if(c.kind !== 'video' && c.kind !== 'audio') return;
  if(selIds.indexOf(c.id) === -1){ selectClip(c); renderClips(); }
  hideCtxMenu();
  ctxMenu = document.createElement('div');
  ctxMenu.className = 'mce-ctx';
  var it = document.createElement('button');
  it.className = 'mce-ctx-item';
  it.innerHTML = '<svg viewBox="0 0 16 16" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"><path d="M2.5 11a5.5 5.5 0 1 1 11 0"/><path d="M8 11L10.8 7"/></svg><span>Velocidade</span>';
  it.addEventListener('click', function(){ hideCtxMenu(); openSpeedModal(c); });
  ctxMenu.appendChild(it);
  uiRoot().appendChild(ctxMenu);
  ctxMenu.style.left = Math.min(e.clientX, window.innerWidth  - ctxMenu.offsetWidth  - 8) + 'px';
  ctxMenu.style.top  = Math.min(e.clientY, window.innerHeight - ctxMenu.offsetHeight - 8) + 'px';
});
document.addEventListener('mousedown', function(e){
  if(ctxMenu && !ctxMenu.contains(e.target)) hideCtxMenu();
});

function openSpeedModal(c){
  var span  = c.dur * clipRate(c);   /* material consumido (fixo no retime) */
  var rate  = clipRate(c);
  var ov = document.createElement('div');
  ov.className = 'mce-speed-ov';
  ov.innerHTML =
    '<div class="mce-speed-box">' +
      '<div class="mce-speed-title">Velocidade do clipe</div>' +
      '<div class="mce-speed-row"><label>Velocidade</label>' +
        '<div class="mce-speed-val"><input type="number" id="mce-speed-pct" min="10" max="1000" step="5"><span>%</span></div></div>' +
      '<div class="mce-speed-row"><label>Duração</label>' +
        '<div class="mce-speed-dur" id="mce-speed-dur" title="Clique e arraste pros lados">00:00:00</div></div>' +
      '<div class="mce-speed-hint">% maior = mais rápido · os vinculados mudam juntos</div>' +
      '<div class="mce-speed-btns">' +
        '<button class="mcd-btn-ghost" id="mce-speed-cancel">Cancelar</button>' +
        '<button class="mcd-btn-dl" id="mce-speed-ok">Aplicar</button></div>' +
    '</div>';
  uiRoot().appendChild(ov);
  var inp = ov.querySelector('#mce-speed-pct');
  var durEl = ov.querySelector('#mce-speed-dur');
  function refresh(fromPct){
    rate = clamp(rate, 0.1, 10);
    if(!fromPct) inp.value = Math.round(rate * 100);
    durEl.textContent = fmt(span / rate);
  }
  refresh();
  /* % ↔ duração: alterar um recalcula o outro na hora */
  inp.addEventListener('input', function(){
    var v = parseFloat(this.value);
    if(v && v >= 10 && v <= 1000){ rate = v / 100; refresh(true); }
  });
  /* a % também tem controlador horizontal: arrastar pros lados escorrega
     o valor (igual à duração); clique parado continua permitindo digitar */
  inp.addEventListener('mousedown', function(e){
    var x0 = e.clientX, r0 = rate, moved = false;
    var mv = function(ev){
      var dx = ev.clientX - x0;
      if(!moved && Math.abs(dx) < 3) return;
      if(!moved){ moved = true; inp.blur(); document.body.style.cursor = 'ew-resize'; }
      ev.preventDefault();
      rate = clamp(r0 + dx / 100, 0.1, 10);   /* 1px = 1% */
      refresh();
    };
    var up = function(){
      document.body.style.cursor = '';
      document.removeEventListener('mousemove', mv);
      document.removeEventListener('mouseup', up);
    };
    document.addEventListener('mousemove', mv);
    document.addEventListener('mouseup', up);
  });
  /* duração: clicar e arrastar pros lados (direita = mais longo/lento) */
  durEl.addEventListener('mousedown', function(e){
    e.preventDefault();
    var x0 = e.clientX, d0 = span / rate;
    document.body.style.cursor = 'ew-resize';
    var mv = function(ev){
      var nd = clamp(d0 * Math.pow(2, (ev.clientX - x0) / 150), span / 10, span * 10);
      rate = span / nd;
      refresh();
    };
    var up = function(){
      document.body.style.cursor = '';
      document.removeEventListener('mousemove', mv);
      document.removeEventListener('mouseup', up);
    };
    document.addEventListener('mousemove', mv);
    document.addEventListener('mouseup', up);
  });
  function close(){ ov.remove(); }
  ov.querySelector('#mce-speed-cancel').addEventListener('click', close);
  ov.addEventListener('mousedown', function(e){ if(e.target === ov) close(); });
  ov.querySelector('#mce-speed-ok').addEventListener('click', function(){
    snapshot();
    applyClipRate(c, rate);
    close();
    renderAll(); seekMedia(); drawFrame();
  });
}

/* ── seek pela régua ── */
function rulerSeek(e){
  var r = elInner.getBoundingClientRect();
  var t = clamp((e.clientX - r.left) / PPS(), 0, tlDur());
  /* ímã: a playhead também gruda nas bordas dos clipes e no 0 */
  var pts = [0];
  clips.forEach(function(c){ pts.push(c.start, c.start + c.dur); });
  var s = applySnap(t, pts);
  tCur = s !== null ? s : snap(t);
  renderPlayhead(); seekMedia(); drawFrame();
}
function startPlayheadDrag(e){
  rulerSeek(e);
  var lastX = e.clientX;
  var mv = function(ev){ lastX = ev.clientX; rulerSeek(ev); };
  /* arrastar até a borda rola a timeline junto (auto-scroll) */
  var edgeTick = setInterval(function(){
    var sr = elScroll.getBoundingClientRect();
    var edge = 28, speed = 0;
    if(lastX > sr.right - edge)      speed = Math.min(48, (lastX - (sr.right - edge)) * 1.5 + 6);
    else if(lastX < sr.left + edge)  speed = -Math.min(48, ((sr.left + edge) - lastX) * 1.5 + 6);
    if(speed){
      elScroll.scrollLeft += speed;
      rulerSeek({ clientX: lastX });   /* recalcula tCur com o novo scroll */
    }
  }, 30);
  var up = function(){
    clearInterval(edgeTick);
    document.removeEventListener('mousemove', mv);
    document.removeEventListener('mouseup', up);
  };
  document.addEventListener('mousemove', mv);
  document.addEventListener('mouseup', up);
}
elRuler.addEventListener('mousedown', startPlayheadDrag);
/* o playhead inteiro é clicável: segurar em QUALQUER ponto da extensão dele
   (não só na régua) arrasta igual */
elPlayhead.addEventListener('mousedown', function(e){
  if(e.button !== 0) return;
  /* se houver uma ALÇA de redimensionamento de clipe embaixo do cursor, o
     playhead cede a vez: repassa o mousedown pro clipe, pra puxar a borda do
     vídeo/áudio em vez de arrastar o playhead rosa que está por cima */
  var under = document.elementsFromPoint ? document.elementsFromPoint(e.clientX, e.clientY) : [];
  var handle = null;
  for(var i=0;i<under.length;i++){
    var el = under[i];
    if(el && el.classList && el.classList.contains('mce-clip-handle')){ handle = el; break; }
  }
  if(handle){
    var ev2 = new MouseEvent('mousedown', {
      bubbles:true, cancelable:true, view:window,
      clientX:e.clientX, clientY:e.clientY, button:0,
      ctrlKey:e.ctrlKey, altKey:e.altKey, shiftKey:e.shiftKey, metaKey:e.metaKey
    });
    handle.dispatchEvent(ev2);
    return;
  }
  e.preventDefault();
  e.stopPropagation();
  startPlayheadDrag(e);
});

/* ══════════ OPERAÇÕES ══════════ */
function splitClip(c, t){
  t = snap(t);   /* corte cai exatamente num frame */
  if(!c || !activeAt(c, t) || t - c.start < FRAME - 0.0001 || c.start + c.dur - t < FRAME - 0.0001) return null;
  var b = {};
  for(var k in c) if(c.hasOwnProperty(k)) b[k] = c[k];
  b.id    = uid();
  b.start = t;
  b.dur   = c.start + c.dur - t;
  /* triprank corta como vídeo contínuo: a metade direita continua a
     animação de onde parou (offset "in"), sem reiniciar do 0 */
  b.in    = (c.srcDur || c.kind === 'speed') ? (c.in || 0) + (t - c.start) * clipRate(c) : 0;
  b.pair  = null;
  /* a metade direita ganha o PRÓPRIO elemento de mídia — compartilhar o mesmo
     <video>/<audio> fazia as metades brigarem (uma pausava/re-seekava o que a
     outra tocava): quadro congelado no play e flick de frame no corte do export */
  if(b.el){ b.el = cloneEl(b.el); warmEl(b.el, b.in); }
  b._srcFrame = null;
  c.dur   = t - c.start;
  clips.push(b);
  /* conecta o elemento novo no grafo de áudio (se o player já foi usado) */
  try{ if(typeof audioCtx !== 'undefined' && audioCtx) ensureGraph(); }catch(_){}
  return b;
}

function splitPairAt(c, t){
  var p = pairOf(c);
  snapshot();
  var b = splitClip(c, t);
  if(!b){ popSnapshot(); return false; }
  if(p){
    var pb = splitClip(p, t);
    if(pb){ b.pair = pb.id; pb.pair = b.id; }
  }
  resolveTrackOverlaps();   /* nada de dois clipes empilhados na mesma faixa */
  selectClip(b);
  renderAll(); drawFrame();
  return true;
}

/* invariante de NLE: numa MESMA faixa dois clipes nunca ficam empilhados. Se
   houver sobreposição, o que começa DEPOIS (mais à frente / mais novo) prevalece
   e apara o de trás — "um exclui o outro" em vez de virar camada. */
function resolveTrackOverlaps(){
  var EPS = 0.0001, byTrack = {};
  clips.forEach(function(c){ (byTrack[c.trackId] = byTrack[c.trackId] || []).push(c); });
  var remove = [];
  Object.keys(byTrack).forEach(function(tid){
    var arr = byTrack[tid].slice().sort(function(a, b){
      return (a.start - b.start) || (clips.indexOf(a) - clips.indexOf(b));
    });
    for(var i=0;i<arr.length;i++){
      var cur = arr[i];
      for(var j=i+1;j<arr.length;j++){
        var nxt = arr[j];
        if(nxt.start >= cur.start + cur.dur - EPS) break;   /* adjacente/sem overlap */
        var newDur = nxt.start - cur.start;
        if(newDur <= EPS){ remove.push(cur); break; }        /* totalmente coberto */
        cur.dur = snap(newDur);                              /* apara até o próximo */
      }
    }
  });
  if(remove.length){
    var dead = {};
    remove.forEach(function(c){ dead[c.id] = 1; if(c.el){ try{ c.el.pause(); }catch(_){} } });
    clips = clips.filter(function(c){ return !dead[c.id]; });
    clips.forEach(function(c){ if(c.pair && dead[c.pair]) c.pair = null; });
  }
}
function doSplit(){
  var c = sel();
  if(!c){ alert('Selecione um clipe primeiro.'); return; }
  splitPairAt(c, tCur);
}

/* posição do corte: atraída pelo ímã (bordas de outros clipes, playhead, 0)
   e SEMPRE presa num frame exato — impossível cortar no meio de dois frames */
function cutTimeAt(rawT, c){
  var t = rawT;
  var p = c ? pairOf(c) : null;
  var pts = snapPoints(c ? [c.id].concat(p ? [p.id] : []) : []);
  var sn = applySnap(t, pts);
  if(sn !== null) t = sn;
  return snap(t);
}

/* modo cortar: mouse vira tesoura e divide onde clicar */
var cutMode = false;
function setCutMode(on){
  cutMode = on;
  var b = $('mce-split');
  if(b) b.classList.toggle('is-on', on);
  var ar = $('mce-arrow');
  if(ar) ar.classList.toggle('is-on', !on);   /* setinha acesa = mouse padrão */
  $('mce-tl').classList.toggle('is-cutting', on);
  if(!on && elCutline) hideCutlines();
}

/* risco amarelo em cima do clipe indicando onde o corte vai cair
   (aparece também no par vinculado — vídeo↔áudio cortam juntos) */
var elCutline = document.createElement('div');
elCutline.className = 'mce-cutline';
elInner.appendChild(elCutline);
var elCutline2 = document.createElement('div');
elCutline2.className = 'mce-cutline';
elInner.appendChild(elCutline2);
var cutHoverEls = [];
function clearCutHover(){
  for(var i=0;i<cutHoverEls.length;i++) cutHoverEls[i].classList.remove('is-cut-hover');
  cutHoverEls = [];
}
function hideCutlines(){
  elCutline.style.display = 'none';
  elCutline2.style.display = 'none';
  clearCutHover();
}
elLanes.addEventListener('mousemove', function(e){
  if(!cutMode){ hideCutlines(); return; }
  var overClip = e.target && e.target.closest ? e.target.closest('.mce-clip') : null;
  if(!overClip){ hideCutlines(); return; }
  var r = elInner.getBoundingClientRect();
  var cr = overClip.getBoundingClientRect();
  var c = byId(overClip.dataset.id);
  /* risco na MESMA posição onde o corte vai cair (ímã + frame exato) */
  var x = cutTimeAt((e.clientX - r.left) / PPS(), c) * PPS();
  elCutline.style.left = x + 'px';
  elCutline.style.top = (cr.top - r.top) + 'px';        /* só sobre o clipe sob o mouse */
  elCutline.style.height = cr.height + 'px';
  elCutline.style.display = 'block';
  /* par vinculado: risco + nome apagado nos dois */
  var p = pairOf(c);
  var pel = p ? elLanes.querySelector('.mce-clip[data-id="' + p.id + '"]') : null;
  clearCutHover();
  overClip.classList.add('is-cut-hover');
  cutHoverEls.push(overClip);
  if(pel){
    var pr = pel.getBoundingClientRect();
    elCutline2.style.left = x + 'px';
    elCutline2.style.top = (pr.top - r.top) + 'px';
    elCutline2.style.height = pr.height + 'px';
    elCutline2.style.display = 'block';
    pel.classList.add('is-cut-hover');
    cutHoverEls.push(pel);
  } else elCutline2.style.display = 'none';
});
elLanes.addEventListener('mouseleave', hideCutlines);

/* ── seleção por retângulo (marquee) ── */
var marquee = null;
var elMarquee = document.createElement('div');
elMarquee.className = 'mce-marquee';
elInner.appendChild(elMarquee);

function marqueeSelect(L, T, W, H){
  var RULER_H = 28;
  /* offset vertical acumulado de cada faixa (alturas variáveis) */
  var offs = {}, acc = RULER_H;
  tracks.forEach(function(tr){ offs[tr.id] = acc; acc += trackH(tr); });
  var ids = [];
  clips.forEach(function(c){
    if(offs[c.trackId] == null) return;
    var tr = trackById(c.trackId);
    var top = offs[c.trackId] + 6, bot = top + (trackH(tr) - 12);
    var cl = c.start * PPS(), cr = cl + Math.max(c.dur * PPS(), 14);
    if(cl < L + W && cr > L && top < T + H && bot > T){
      if(ids.indexOf(c.id) < 0) ids.push(c.id);
      var p = pairOf(c);
      if(p && ids.indexOf(p.id) < 0) ids.push(p.id);   /* par vinculado entra junto */
    }
  });
  setSel(ids);
  /* só troca classes — sem rebuild da timeline a cada pixel */
  var els = elLanes.querySelectorAll('.mce-clip');
  for(var k=0;k<els.length;k++) els[k].classList.toggle('is-sel', selIds.indexOf(els[k].dataset.id) > -1);
}

document.addEventListener('mousemove', function(e){
  if(!marquee) return;
  var r = elInner.getBoundingClientRect();
  var x1 = e.clientX - r.left, y1 = e.clientY - r.top;
  if(Math.abs(x1 - marquee.x0) + Math.abs(y1 - marquee.y0) > 4) marquee.moved = true;
  var L = Math.min(marquee.x0, x1), T = Math.min(marquee.y0, y1);
  var W = Math.abs(x1 - marquee.x0), H = Math.abs(y1 - marquee.y0);
  elMarquee.style.left = L + 'px';
  elMarquee.style.top = T + 'px';
  elMarquee.style.width = W + 'px';
  elMarquee.style.height = H + 'px';
  elMarquee.style.display = 'block';
  marqueeSelect(L, T, W, H);
});
document.addEventListener('mouseup', function(){
  if(!marquee) return;
  if(!marquee.moved){ setSel([]); renderClips(); }   /* clique no vazio limpa a seleção */
  marquee = null;
  elMarquee.style.display = 'none';
  syncTextPanel(); syncSpeedPanel();
});

/* exclui a seleção. Pares vinculados caem juntos (desvincule pra excluir só um).
   ripple=true (Delete): puxa os clipes seguintes pra fechar a lacuna, estilo DaVinci.
   ripple=false (Backspace): só exclui, deixando o buraco. */
function doDelete(ripple){
  var del = selectedClips();
  if(!del.length) return;
  snapshot();
  var ids = {};
  del.forEach(function(c){
    ids[c.id] = 1;
    var p = pairOf(c);
    if(p) ids[p.id] = 1;              /* vinculado → ambas as faixas afetadas */
  });
  var gone = clips.filter(function(c){ return ids[c.id]; });
  gone.forEach(function(c){ if(c.el){ try{ c.el.pause(); }catch(e){} } });
  clips = clips.filter(function(c){ return !ids[c.id]; });

  if(ripple && gone.length){
    /* intervalos removidos (mesclados) — tudo que vem depois anda pra trás */
    var iv = gone.map(function(c){ return [c.start, c.start + c.dur]; })
                 .sort(function(a,b){ return a[0]-b[0]; });
    var merged = [];
    iv.forEach(function(x){
      var last = merged[merged.length-1];
      if(last && x[0] <= last[1] + 0.001) last[1] = Math.max(last[1], x[1]);
      else merged.push([x[0], x[1]]);
    });
    var movedIds = {};
    for(var i = merged.length - 1; i >= 0; i--){
      var gap = merged[i][1] - merged[i][0];
      clips.forEach(function(c){
        if(c.start >= merged[i][1] - 0.001){
          c.start = snap(Math.max(0, c.start - gap));
          movedIds[c.id] = 1;
        }
      });
    }
    /* quem foi PUXADO toma o lugar: o que sobrou parado embaixo (SFX ou vídeo
       remanescente do par excluído) é cortado/excluído — antes ficava como
       camada sobreposta por cima do clipe puxado */
    clips.filter(function(c){ return movedIds[c.id]; }).forEach(function(c){
      overwriteInto(c, movedIds, true);
    });
  }
  setSel([]);
  animatePositions();   /* excluídos somem em fade; ripple puxa os clipes suavemente */
  renderRuler(); renderPlayhead();
  syncMuted(); seekMedia(); drawFrame();
}

/* Ctrl+Alt+L: alterna vínculo do clipe selecionado */
function toggleLink(){
  var c = sel();
  if(!c) return;
  if(pairOf(c)){ doUnlink(); return; }
  var selC = selectedClips();
  var v = null, a = null;
  selC.forEach(function(x){
    if(x.kind === 'video' && !x.pair) v = x;
    if(x.kind === 'audio' && !x.pair) a = x;
  });
  if(v && a){
    snapshot();
    v.pair = a.id; a.pair = v.id;
    selectClip(v);
    renderAll(); syncMuted();
  } else {
    alert('Para vincular, selecione um clipe de vídeo e um de áudio (sem vínculo) — ex.: com o retângulo de seleção.');
  }
}

/* desvincular: áudio e vídeo pareados viram clipes independentes */
function doUnlink(){
  var c = sel();
  if(!c){ alert('Selecione um clipe primeiro.'); return; }
  var p = pairOf(c);
  if(!p){ alert('Este clipe não está vinculado a nenhum outro.'); return; }
  snapshot();
  var vid = c.kind === 'video' ? c : (p.kind === 'video' ? p : null);
  var aud = c.kind === 'audio' ? c : (p.kind === 'audio' ? p : null);
  if(vid && aud && !aud.el && vid.el){
    aud.el = cloneEl(vid.el);   /* áudio ganha o próprio elemento de mídia */
    aud.srcDur = vid.srcDur;
    vid.audioOff = true;        /* o som passa a vir só do clipe de áudio */
  }
  c.pair = null; p.pair = null;
  renderAll(); syncMuted(); seekMedia(); drawFrame();
}

/* ══════════ FAIXAS ══════════ */
function addTrack(kind){
  snapshot();
  trackSeq[kind]++;
  var labels = { video:'MÍDIA ', audio:'ÁUDIO ', text:'TEXTO ' };
  var tr = { id: kind.charAt(0) + trackSeq[kind] + '_' + Date.now(), kind: kind, label: (labels[kind] || 'FAIXA ') + trackSeq[kind], volume:1 };
  /* faixas do mesmo tipo ficam sempre juntas:
     texto no topo · vídeo novo entra ACIMA das outras de vídeo · áudio novo entra ABAIXO */
  var idx = -1, i;
  if(kind === 'text'){
    idx = 0;
  } else if(kind === 'video'){
    for(i=0;i<tracks.length;i++) if(tracks[i].kind === 'video'){ idx = i; break; }
    if(idx < 0) idx = 0;   /* sem nenhuma de vídeo → vai pro início da timeline */
  } else {
    var last = -1;
    for(i=0;i<tracks.length;i++) if(tracks[i].kind === 'audio') last = i;
    idx = last >= 0 ? last + 1 : tracks.length;
  }
  tracks.splice(idx, 0, tr);
  renderAll();
  return tr;
}
function firstTrack(kind){
  for(var i=0;i<tracks.length;i++) if(tracks[i].kind===kind) return tracks[i];
  return addTrack(kind);
}
/* primeira faixa de áudio SEM clipes — usada quando um mp3 da galeria é
   clicado: se A1 já tem clipes, vai pro início da próxima faixa livre
   (cria uma nova se todas estiverem ocupadas) */
function firstFreeAudioTrack(){
  for(var i=0;i<tracks.length;i++){
    if(tracks[i].kind !== 'audio') continue;
    var used = clips.some(function(c){ return c.trackId === tracks[i].id; });
    if(!used) return tracks[i];
  }
  return addTrack('audio');
}
/* faixa "principal" onde a mídia nova entra: V1 (a de baixo do grupo de vídeo) / A1 */
function mainTrack(kind){
  if(kind === 'video'){
    for(var i=tracks.length-1;i>=0;i--) if(tracks[i].kind === 'video') return tracks[i];
  }
  return firstTrack(kind);
}

/* ── numeração espelhada vídeo↔áudio (V2 ↔ A2) ──
   vídeo conta de BAIXO pra cima (V1 é a de baixo); áudio de CIMA pra baixo */
function videoIndexOf(trackId){
  var n = 0;
  for(var i=tracks.length-1;i>=0;i--)
    if(tracks[i].kind === 'video'){ n++; if(tracks[i].id === trackId) return n; }
  return 0;
}
function audioIndexOf(trackId){
  var n = 0;
  for(var i=0;i<tracks.length;i++)
    if(tracks[i].kind === 'audio'){ n++; if(tracks[i].id === trackId) return n; }
  return 0;
}
function audioTrackAt(idx, create){
  var n = 0;
  for(var i=0;i<tracks.length;i++)
    if(tracks[i].kind === 'audio'){ n++; if(n === idx) return tracks[i]; }
  if(!create) return null;
  var tr = null;
  while(n < idx){ tr = addTrack('audio'); n++; }   /* cria ÁUDIO 2, 3… se precisar */
  return tr || firstTrack('audio');
}
function videoTrackAt(idx){
  var n = 0;
  for(var i=tracks.length-1;i>=0;i--)
    if(tracks[i].kind === 'video'){ n++; if(n === idx) return tracks[i]; }
  return null;
}
/* vídeo na faixa 2 → áudio do par entra na faixa de áudio 2. Se a faixa
   espelhada não existir e create=true, ELA É CRIADA (A2, A3…) pra manter a
   numeração espelhada; com create=false (fantasma) só devolve a que existir. */
function audioTrackForVideo(vTrackId, create){
  var idx = videoIndexOf(vTrackId);
  var t = idx > 0 ? audioTrackAt(idx, !!create) : null;
  if(!t) for(var i=0;i<tracks.length;i++) if(tracks[i].kind === 'audio'){ t = tracks[i]; break; }
  if(!t && create) t = firstTrack('audio');
  return t;
}
/* índice de áudio espelhado que um vídeo QUER (mesmo que a faixa ainda não
   exista) — usado pelo fantasma pra desenhar a faixa virtual que será criada */
function wantedAudioIdxForVideo(vTrackId){ return videoIndexOf(vTrackId); }
function videoTrackForAudio(aTrackId){
  var idx = audioIndexOf(aTrackId);
  return idx > 0 ? videoTrackAt(idx) : null;
}

/* ══════════ ADICIONAR MÍDIA ══════════ */
function setSrcStatus(txt, cls){
  var el = $('mce-src-status');
  el.textContent = txt;
  el.className = 'mc-tag' + (cls ? ' ' + cls : '');
}

function makeVideoEl(src, useCors, onOk, onErr){
  var v = document.createElement('video');
  v.preload = 'auto';
  if(useCors) v.crossOrigin = 'anonymous';
  v.playsInline = true;
  var failed = false;
  v.addEventListener('loadedmetadata', function(){ if(!failed) onOk(v); }, { once:true });
  v.addEventListener('error', function(){
    if(!failed){ failed = true; if(onErr) onErr(); }
  }, { once:true });
  v.addEventListener('seeked', function(){ if(!playing) drawFrame(); });
  v.src = src;
  v.load();
}

function pushVideoClips(v, name, audioName, opts){
  snapshot();
  /* sem posição explícita: entra no fim da MÍDIA existente — se não houver
     nenhum vídeo/áudio ativo na timeline, começa no segundo 0 (o texto,
     se existir, se adapta sozinho pelo cadeado) */
  var vTrackId = (opts && opts.trackId && trackById(opts.trackId) && trackById(opts.trackId).kind === 'video')
    ? opts.trackId : mainTrack('video').id;
  /* insere no início ou após o ÚLTIMO clipe da própria faixa de destino
     (mídia em outra faixa não empurra o ponto de inserção) */
  var start = (opts && opts.start != null) ? snap(Math.max(0, opts.start)) : snap(videoInsertEnd(vTrackId));
  var vc = {
    id: uid(), kind:'video', trackId: vTrackId,
    start: start, dur: snap(v.duration), in: 0, srcDur: v.duration,
    el: v, name: name, pair: null, muted:false, audioOff:false,
    srcUrl: (opts && opts.srcUrl) || null   /* link de origem (log de export) */
  };
  var ac = {
    /* áudio do par segue a numeração da faixa de vídeo (V2 → A2) */
    id: uid(), kind:'audio', trackId: audioTrackForVideo(vTrackId, true).id,
    start: start, dur: vc.dur, in: 0, srcDur: v.duration,
    el: null, name: audioName || ('♪ ' + String(name).toLowerCase()), pair: vc.id, muted:false
  };
  vc.pair = ac.id;
  clips.push(vc, ac);
  overwriteMoved([vc]);   /* caiu por cima de outro clipe? sobrepõe */
  selectClip(vc);
  setSrcStatus('✓ vídeo na timeline', 's-ok');
  renderAll(); seekMedia(); drawFrame();
}

/* imagem → clipe na faixa de MÍDIA (sem áudio; duração livre, padrão 4s) */
function pushImageClip(img, name, opts){
  snapshot();
  var vTrackId = (opts && opts.trackId && trackById(opts.trackId) && trackById(opts.trackId).kind === 'video')
    ? opts.trackId : mainTrack('video').id;
  var start = (opts && opts.start != null) ? snap(Math.max(0, opts.start)) : snap(videoInsertEnd(vTrackId));
  var c = {
    id: uid(), kind:'image', trackId: vTrackId,
    start: start, dur: snap((opts && opts.dur) || 4), in: 0, srcDur: 0,
    el: img, name: name || 'IMAGEM', pair: null, muted:false,
    srcUrl: (opts && opts.srcUrl) || null
  };
  clips.push(c);
  overwriteMoved([c]);
  selectClip(c);
  setSrcStatus('✓ imagem na timeline', 's-ok');
  renderAll(); seekMedia(); drawFrame();
}

/* ══════════ LOG DE EXPORTAÇÃO (base de dados) ══════════ */
var MC_USER = (function(){
  var r = document.getElementById('mc-root');
  var n = r && r.dataset ? String(r.dataset.customer || '').trim() : '';
  return n || 'anônimo';
})();

/* nome do usuário pra arquivo (sem acento/espaço, minúsculo) */
function mcUserSlug(){
  var n = String(MC_USER || '').trim() || 'anonimo';
  try{ n = n.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); }catch(_){}
  n = n.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  return n || 'anonimo';
}

/* ── contador diário de vídeos renderizados (v1-nome, v2-nome…) —
   reseta à meia-noite no horário de Brasília ── */
function brtToday(){
  try{ return new Date().toLocaleDateString('en-CA', { timeZone: 'America/Sao_Paulo' }); }
  catch(_){ return new Date().toISOString().slice(0, 10); }
}
var exportSeqNum = 0;   /* nº do vídeo desta sessão de export (as 2 versões compartilham) */
var exportCancelled = false;   /* cancelou = nenhum arquivo baixa depois */
function nextRenderSeq(){
  var day = brtToday(), n = 0;
  try{
    var s = JSON.parse(localStorage.getItem('mce_render_count') || 'null');
    if(s && s.day === day) n = parseInt(s.n, 10) || 0;
  }catch(_){}
  n++;
  try{ localStorage.setItem('mce_render_count', JSON.stringify({ day: day, n: n })); }catch(_){}
  return n;
}

/* srcUrl → { count, last (ms), users: { nome: vezes } } */
var exportStats = {};

function timeAgo(ts){
  var d = Math.floor((Date.now() - ts) / 86400000);
  if(d < 1) return 'hoje';
  if(d <= 30) return d + 'd atrás';
  if(d < 365){
    var m = Math.floor(d / 30), rd = d % 30;
    return m + 'm' + (rd ? ' ' + rd + 'd' : '') + ' atrás';
  }
  return Math.floor(d / 365) + 'a atrás';
}

function loadExportStats(){
  gas({ resource:'export_log', action:'stats' }, function(err, d){
    if(!err && d && d.stats){ exportStats = d.stats; renderPool(); }
  }, 30000);
}

function escapeHtml(s){
  return String(s).replace(/[&<>"']/g, function(m){
    return ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' })[m];
  });
}

/* ── popup de histórico (hover nos vídeos já exportados) ── */
var usedPop = null;
function showUsedPop(card, st){
  if(!usedPop){
    usedPop = document.createElement('div');
    usedPop.className = 'mce-used-pop';
    uiRoot().appendChild(usedPop);
  }
  var names = Object.keys(st.users || {}).sort(function(a, b){ return st.users[b] - st.users[a]; });
  var rows = names.map(function(u){
    return '<div class="mce-used-pop-user"><span>' + escapeHtml(u) + '</span><span>' + st.users[u] + 'x</span></div>';
  }).join('');
  usedPop.innerHTML =
    '<div class="mce-used-pop-head"><span class="mce-used-pop-dot"></span>' +
    '<span class="mce-used-pop-title">Já exportado</span>' +
    '<span class="mce-used-pop-count">' + st.count + 'x</span></div>' +
    '<div class="mce-used-pop-last">última vez: <b>' + timeAgo(st.last) + '</b></div>' +
    (rows ? '<div class="mce-used-pop-users">' + rows + '</div>' : '');
  var r = card.getBoundingClientRect();
  usedPop.style.display = 'block';
  var pw = usedPop.offsetWidth, ph = usedPop.offsetHeight;
  var x = r.right + 10;
  if(x + pw > window.innerWidth - 8) x = r.left - pw - 10;
  usedPop.style.left = Math.max(8, x) + 'px';
  usedPop.style.top = clamp(r.top, 8, Math.max(8, window.innerHeight - ph - 8)) + 'px';
}
function hideUsedPop(){ if(usedPop) usedPop.style.display = 'none'; }
/* safety: hide popup on scroll and before re-rendering pool */
(function(){
  var poolScroll = document.querySelector('.mce-pool-scroll');
  if(poolScroll) poolScroll.addEventListener('scroll', hideUsedPop);
})();

function logExport(urls){
  /* registra no banco: link + usuário + data (uma linha por vídeo) */
  gas({ resource:'export_log', action:'log', user: MC_USER, urls: urls.join('|') }, function(){}, 30000);
  /* otimista: marca localmente na hora */
  urls.forEach(function(u){
    var s = exportStats[u] || (exportStats[u] = { count: 0, last: 0, users: {} });
    s.count++;
    s.last = Date.now();
    s.users[MC_USER] = (s.users[MC_USER] || 0) + 1;
  });
  renderPool();
}

/* ══════════ GALERIA DE MÍDIA (media pool) ══════════ */
var pool = [];

/* exclui da timeline, na hora, todos os clipes criados a partir de um item
   da galeria (vídeo e o áudio pareado — que usa o mesmo <video> por trás) */
function removePoolClips(it){
  var victims = clips.filter(function(c){
    var el = ownerEl(c);
    return !!(el && (el.src === it.url || el.currentSrc === it.url));
  });
  if(!victims.length) return;
  snapshot();
  var dead = {};
  victims.forEach(function(c){
    dead[c.id] = true;
    if(c.el){ try{ c.el.pause(); }catch(_){} }
  });
  clips = clips.filter(function(c){ return !dead[c.id]; });
  clips.forEach(function(c){ if(c.pair && dead[c.pair]) c.pair = null; });
  setSel(selIds.filter(function(id){ return !dead[id]; }));
  renderAll(); syncMuted(); seekMedia(); drawFrame();
}

function renderPool(){
  hideUsedPop();
  var g = $('mce-pool-grid');
  if(!g) return;
  g.innerHTML = '';
  var empty = $('mce-pool-empty');
  if(empty) empty.style.display = pool.length ? 'none' : 'flex';
  pool.forEach(function(it){
    var card = document.createElement('div');
    card.className = 'mce-pool-card';
    card.title = 'Clique ou arraste pra timeline';
    /* já exportado alguma vez: tint vermelho na thumbnail + popup no hover */
    var st = it.srcUrl ? exportStats[it.srcUrl] : null;
    if(st && st.count > 0){
      card.classList.add('is-used');
      card.title = '';
      var tint = document.createElement('div');
      tint.className = 'mce-pool-used-tint';
      card.appendChild(tint);
      card.addEventListener('mouseenter', function(){ showUsedPop(card, st); });
      card.addEventListener('mouseleave', hideUsedPop);
    }
    /* arrastar o card direto pra timeline */
    card.draggable = true;
    card.addEventListener('dragstart', function(ev){
      poolDragItem = it;
      try{ ev.dataTransfer.setData('text/plain', it.name || 'media'); }catch(_){}
      ev.dataTransfer.effectAllowed = 'copy';
    });
    card.addEventListener('dragend', function(){ poolDragItem = null; hideGhosts(); });
    if(it.type === 'video'){
      var v = document.createElement('video');
      v.muted = true; v.playsInline = true; v.preload = 'metadata';
      v.src = it.url;
      card.appendChild(v);
    } else if(it.type === 'image'){
      var im = document.createElement('img');
      im.src = it.url;
      im.style.cssText = 'width:100%;aspect-ratio:1/1;object-fit:contain;display:block;background:#000;pointer-events:none';
      card.appendChild(im);
    } else {
      var ic = document.createElement('div');
      ic.className = 'mce-pool-audio';
      ic.textContent = '♪';
      card.appendChild(ic);
    }
    var lb = document.createElement('span');
    lb.className = 'mce-pool-label';
    lb.textContent = it.name;
    card.appendChild(lb);
    var del = document.createElement('button');
    del.className = 'mce-pool-del';
    del.innerHTML = '&times;';
    del.title = 'Remover da galeria';
    del.addEventListener('click', function(ev){
      ev.stopPropagation();
      removePoolClips(it);   /* some da timeline instantaneamente */
      pool = pool.filter(function(p){ return p !== it; });
      renderPool();
    });
    card.appendChild(del);
    card.addEventListener('click', function(){ poolInsert(it); });
    g.appendChild(card);
  });
}

function poolAdd(it){
  it.id = it.id || uid();
  pool.push(it);
  probePoolDur(it);   /* duração pro retângulo fantasma do drag */
  if(it.type === 'video') try{ maybeBuildProxy(it); }catch(_){}   /* vídeo hostil a seek → proxy em bg */
  renderPool();
  if(pinQueue > 0) pinQueueMsg();
  else setSrcStatus('✓ na galeria — clique pra usar', 's-ok');
  showToast(it.type === 'audio' ? 'Áudio adicionado às mídias' : (it.type === 'image' ? 'Imagem adicionada às mídias' : 'Vídeo adicionado às mídias'), 'ok');
}

/* ── toast flutuante de confirmação (canto inferior direito) ──
   entra subindo, fica um instante e some subindo em fade.
   kind: 'fila' (amarelo, entrou na fila) | 'ok' (verde, finalizado) */
var toastWrap = null;
function showToast(msg, kind){
  if(!toastWrap){
    toastWrap = document.createElement('div');
    toastWrap.className = 'mce-toasts';
    uiRoot().appendChild(toastWrap);
  }
  var t = document.createElement('div');
  t.className = 'mce-toast' + (kind === 'fila' ? ' t-fila' : ' t-ok');
  t.innerHTML = '<span class="mce-toast-dot"></span><span>' + escapeHtml(msg) + '</span>';
  toastWrap.appendChild(t);
  requestAnimationFrame(function(){
    requestAnimationFrame(function(){ t.classList.add('is-in'); });
  });
  setTimeout(function(){
    t.classList.add('is-out');
    setTimeout(function(){ t.remove(); }, 550);
  }, 2600);
}

/* lê a duração do item da galeria (usada no fantasma do drag & drop) */
function probePoolDur(it){
  if(it.dur) return;
  if(it.type === 'image'){ it.dur = 4; return; }   /* imagem: duração padrão do fantasma */
  var m = document.createElement(it.type === 'video' ? 'video' : 'audio');
  m.preload = 'metadata';
  m.addEventListener('loadedmetadata', function(){ it.dur = (isFinite(m.duration) && m.duration > 0) ? m.duration : 0; }, { once:true });
  m.src = it.url;
}

/* insere um item da galeria na timeline (novo elemento de mídia por inserção).
   opts {start, trackId} = posição do drop quando arrastado pra timeline */
function poolInsert(it, opts){
  opts = opts || {};
  if(opts.srcUrl == null) opts.srcUrl = it.srcUrl || null;
  if(it.type === 'video'){
    setSrcStatus('carregando ' + it.name + '…', 's-loading');
    makeVideoEl(it.url, !!it.cors, function(v){
      pushVideoClips(v, it.name, it.audioName, opts);
    }, function(){
      setSrcStatus('erro ao carregar ' + it.name, 's-err');
    });
  } else if(it.type === 'image'){
    var img = new Image();
    img.onload = function(){ pushImageClip(img, it.name, opts); };
    img.onerror = function(){ setSrcStatus('erro ao carregar ' + it.name, 's-err'); };
    img.src = it.url;
  } else {
    var a = document.createElement('audio');
    a.preload = 'auto';
    a.addEventListener('loadedmetadata', function(){
      snapshot();
      /* clique na galeria (sem posição/faixa explícita): vai pro INÍCIO da
         primeira faixa de áudio livre — se A1 já tem clipes, entra na próxima */
      var clicked = !(opts && (opts.start != null || opts.trackId != null));
      var aTrackId, aStart;
      if(clicked){
        aTrackId = firstFreeAudioTrack().id;
        aStart = 0;
      } else {
        aTrackId = (opts.trackId && trackById(opts.trackId) && trackById(opts.trackId).kind === 'audio')
          ? opts.trackId : firstTrack('audio').id;
        aStart = (opts.start != null) ? Math.max(0, opts.start) : mediaEnd();
      }
      var c = {
        id: uid(), kind:'audio', trackId: aTrackId,
        start: snap(aStart),
        dur: snap(a.duration), in: 0, srcDur: a.duration,
        el: a, name: it.name, pair: null, muted:false
      };
      clips.push(c);
      overwriteMoved([c]);
      selectClip(c);
      setSrcStatus('✓ áudio na timeline', 's-ok');
      renderAll(); seekMedia();
    }, { once:true });
    a.src = it.url;
    a.load();
  }
}

/* ── arrastar da galeria pra timeline (drag & drop) ── */
var poolDragItem = null;

/* posição/faixa alvo do drop (mesma conta pro fantasma e pro drop real).
   dur (opcional) permite o ímã grudar também o FIM do fantasma */
function dropTarget(e, dur){
  var r = elInner.getBoundingClientRect();
  var t = snap(clamp((e.clientX - r.left) / PPS(), 0, tlDur()));
  /* ímã: gruda início/fim do fantasma nas bordas dos clipes e na playhead */
  var pts = snapPoints([]);
  var s1 = applySnap(t, pts);
  var s2 = dur ? applySnap(t + dur, pts) : null;
  if(s2 != null && (s1 == null || Math.abs(s2 - (t + dur)) < Math.abs(s1 - t))){
    t = snap(Math.max(0, s2 - dur));
  } else if(s1 != null){
    t = snap(s1);
  }
  var lr = elLanes.getBoundingClientRect();
  var yRel = e.clientY - lr.top, acc = 0, target = null;
  for(var i=0;i<tracks.length;i++){
    var h = trackH(tracks[i]);
    if(yRel >= acc && yRel < acc + h){ target = tracks[i]; break; }
    acc += h;
  }
  return { t: t, track: target };
}

/* topo (px) de uma faixa dentro do mce-tl-inner (régua = 28px) */
function laneTopOf(trackId){
  var acc = 28;
  for(var i=0;i<tracks.length;i++){
    if(tracks[i].id === trackId) return acc;
    acc += trackH(tracks[i]);
  }
  return null;
}

/* retângulos fantasma mostrando onde o clipe vai entrar (vídeo E áudio) */
var ghostV = document.createElement('div');
ghostV.className = 'mce-drop-ghost';
var ghostA = document.createElement('div');
ghostA.className = 'mce-drop-ghost';
elInner.appendChild(ghostV);
elInner.appendChild(ghostA);
function hideGhosts(){ ghostV.style.display = 'none'; ghostA.style.display = 'none'; ghostV.classList.remove('is-virtual'); ghostA.classList.remove('is-virtual'); }
function placeGhost(g, tr, t, dur){
  var top = tr ? laneTopOf(tr.id) : null;
  if(top == null){ g.style.display = 'none'; return; }
  /* duração inválida (0/NaN/Infinity) → largura padrão fixa (evita fantasma aleatório) */
  var dw = (dur && isFinite(dur) && dur > 0) ? dur : 4;
  g.classList.remove('is-virtual');
  g.style.left   = (t * PPS()) + 'px';
  g.style.width  = Math.max(dw * PPS(), 14) + 'px';
  g.style.top    = (top + 6) + 'px';
  g.style.height = (trackH(tr) - 12) + 'px';
  g.style.display = 'block';
}
/* fantasma numa FAIXA VIRTUAL (que ainda vai ser criada) — tracejado */
function placeGhostAt(g, topPx, heightPx, t, dur){
  var dw = (dur && isFinite(dur) && dur > 0) ? dur : 4;
  g.classList.add('is-virtual');
  g.style.left   = (t * PPS()) + 'px';
  g.style.width  = Math.max(dw * PPS(), 14) + 'px';
  g.style.top    = (topPx + 6) + 'px';
  g.style.height = (heightPx - 12) + 'px';
  g.style.display = 'block';
}
/* topo (px) de onde uma faixa de áudio NOVA apareceria (logo após a última de
   áudio, ou no fim da timeline se não houver nenhuma) */
function newAudioLaneTop(){
  var acc = 28, lastBottom = null;
  for(var i=0;i<tracks.length;i++){
    var h = trackH(tracks[i]);
    if(tracks[i].kind === 'audio') lastBottom = acc + h;
    acc += h;
  }
  return lastBottom != null ? lastBottom : acc;
}
var NEW_AUDIO_LANE_H = 88;   /* altura padrão de faixa de áudio (trackH) */
function updateDropGhosts(e){
  var it = poolDragItem;
  if(!it){ hideGhosts(); return; }
  var dur = it.dur || 4;
  if(!isFinite(dur) || dur <= 0) dur = 4;
  var d = dropTarget(e, dur);
  if(it.type === 'video'){
    /* vídeo na faixa sob o mouse (se for de vídeo) + áudio na faixa espelhada */
    var vTr = (d.track && d.track.kind === 'video') ? d.track : null;
    if(!vTr) for(var i=tracks.length-1;i>=0;i--) if(tracks[i].kind === 'video'){ vTr = tracks[i]; break; }
    placeGhost(ghostV, vTr, d.t, dur);
    /* áudio na faixa espelhada; se ela ainda NÃO existir, mostra a faixa
       virtual (será criada ao soltar) em vez de cair na A1 */
    var mir = vTr ? audioTrackForVideo(vTr.id, false) : null;
    var wantIdx = vTr ? wantedAudioIdxForVideo(vTr.id) : 0;
    if(mir && audioIndexOf(mir.id) === wantIdx){
      placeGhost(ghostA, mir, d.t, dur);
    } else {
      placeGhostAt(ghostA, newAudioLaneTop(), NEW_AUDIO_LANE_H, d.t, dur);
    }
  } else if(it.type === 'image'){
    /* imagem: só a faixa de mídia (sem áudio espelhado) */
    var iTr = (d.track && d.track.kind === 'video') ? d.track : null;
    if(!iTr) for(var k2=tracks.length-1;k2>=0;k2--) if(tracks[k2].kind === 'video'){ iTr = tracks[k2]; break; }
    ghostA.style.display = 'none';
    placeGhost(ghostV, iTr, d.t, dur);
  } else {
    var aTr = (d.track && d.track.kind === 'audio') ? d.track : null;
    if(!aTr) for(var j=0;j<tracks.length;j++) if(tracks[j].kind === 'audio'){ aTr = tracks[j]; break; }
    ghostV.style.display = 'none';
    placeGhost(ghostA, aTr, d.t, dur);
  }
}

function poolDragOver(e){
  if(!poolDragItem) return;
  /* se na verdade é um arquivo do SO sendo arrastado, o item de galeria está
     obsoleto — limpa e deixa o handler de arquivo cuidar (fantasma correto) */
  var ts = e.dataTransfer && e.dataTransfer.types;
  if(ts && Array.prototype.indexOf.call(ts, 'Files') > -1){ poolDragItem = null; hideGhosts(); return; }
  e.preventDefault();
  e.dataTransfer.dropEffect = 'copy';
  updateDropGhosts(e);
}
function poolDrop(e){
  if(!poolDragItem) return;
  e.preventDefault();
  var it = poolDragItem;
  poolDragItem = null;
  hideGhosts();
  var d = dropTarget(e, it.dur || 4);
  poolInsert(it, { start: d.t, trackId: d.track ? d.track.id : null });
}
elScroll.addEventListener('dragover', poolDragOver);
elScroll.addEventListener('dragleave', function(e){
  if(e.target === elScroll) hideGhosts();
});
elScroll.addEventListener('drop', poolDrop);

/* rede de segurança do FANTASMA: o dragend do card some quando a galeria
   re-renderiza no meio do arrasto (o card original é substituído), e aí o
   fantasma ficava preso pra sempre. Estes listeners no documento garantem
   que qualquer fim de arrasto — ou um clique/toque depois — limpe o estado. */
document.addEventListener('dragend', function(){ poolDragItem = null; hideGhosts(); });
document.addEventListener('drop', function(){ if(!poolDragItem) hideGhosts(); });
document.addEventListener('mousedown', function(){ if(!poolDragItem) hideGhosts(); });
window.addEventListener('blur', function(){ poolDragItem = null; hideGhosts(); });

/* a coluna de nomes das faixas também aceita o drop — se o fantasma está
   aparecendo, soltar ali insere do mesmo jeito (a faixa vem do Y do mouse) */
var elHeadcol = document.querySelector('#mc-root .mce-tl-headcol') || document.querySelector('.mce-tl-headcol');
if(elHeadcol){
  elHeadcol.addEventListener('dragover', poolDragOver);
  elHeadcol.addEventListener('drop', poolDrop);
}

/* ── arrastar arquivos do COMPUTADOR → só o bloco de MÍDIA vira alvo
   (destaque no próprio bloco, sem overlay/blur na tela toda) ── */
function isFileDrag(e){
  var ts = e.dataTransfer && e.dataTransfer.types;
  var hasFiles = !!(ts && Array.prototype.indexOf.call(ts, 'Files') > -1);
  /* arquivo do SO tem 'Files' → é autoritativo: limpa qualquer arraste de
     galeria obsoleto (que fazia o fantasma sair com a duração de OUTRO item) */
  if(hasFiles){ if(poolDragItem){ poolDragItem = null; hideGhosts(); } return true; }
  return false;
}
var elPool = $('mce-pool');
if(elPool){
  elPool.addEventListener('dragenter', function(e){
    if(!isFileDrag(e)) return;
    e.preventDefault();
    elPool.classList.add('is-file-target');
  });
  elPool.addEventListener('dragover', function(e){
    if(!isFileDrag(e)) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = 'copy';
    elPool.classList.add('is-file-target');
  });
  elPool.addEventListener('dragleave', function(e){
    /* só apaga quando o mouse realmente sai do bloco (não dos filhos) */
    if(!elPool.contains(e.relatedTarget)) elPool.classList.remove('is-file-target');
  });
  elPool.addEventListener('drop', function(e){
    elPool.classList.remove('is-file-target');
    if(poolDragItem) return;
    if(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length){
      e.preventDefault();
      addLocalFiles(e.dataTransfer.files);
    }
  });
}
/* arrastar arquivos do COMPUTADOR → timeline: mostra fantasma e adiciona ao soltar */
var fileDragLast = null;   /* última posição válida do fantasma (usada se soltar fora) */
/* tipo do arquivo arrastado (quando o navegador expõe o MIME no dragover):
   'audio' | 'image' | 'video' | null (desconhecido) */
function fileDragKind(e){
  var items = e.dataTransfer && e.dataTransfer.items;
  if(items) for(var i=0;i<items.length;i++){
    var it = items[i];
    if(it.kind !== 'file') continue;
    var t = String(it.type || '').toLowerCase();
    if(t.indexOf('audio/') === 0) return 'audio';
    if(t.indexOf('image/') === 0) return 'image';
    if(t.indexOf('video/') === 0) return 'video';
  }
  return null;
}
function fileGhosts(d, kind){
  /* ÁUDIO: fantasma só na faixa de áudio (nunca na de vídeo) */
  if(kind === 'audio'){
    var aTr = (d.track && d.track.kind === 'audio') ? d.track : null;
    if(!aTr) for(var j=0;j<tracks.length;j++) if(tracks[j].kind === 'audio'){ aTr = tracks[j]; break; }
    ghostV.style.display = 'none';
    placeGhost(ghostA, aTr, d.t, 4);
    return;
  }
  var vTr = (d.track && d.track.kind === 'video') ? d.track : null;
  if(!vTr) for(var i=tracks.length-1;i>=0;i--) if(tracks[i].kind === 'video'){ vTr = tracks[i]; break; }
  placeGhost(ghostV, vTr, d.t, 4);
  /* IMAGEM: não tem áudio → sem fantasma de áudio. VÍDEO/desconhecido: mostra o par
     (na faixa espelhada, ou numa faixa virtual se ela ainda não existir) */
  if(kind === 'image'){ ghostA.style.display = 'none'; return; }
  var mirF = vTr ? audioTrackForVideo(vTr.id, false) : null;
  var wIdxF = vTr ? wantedAudioIdxForVideo(vTr.id) : 0;
  if(mirF && audioIndexOf(mirF.id) === wIdxF) placeGhost(ghostA, mirF, d.t, 4);
  else placeGhostAt(ghostA, newAudioLaneTop(), NEW_AUDIO_LANE_H, d.t, 4);
}
elScroll.addEventListener('dragover', function(e){
  if(!isFileDrag(e)) return;
  e.preventDefault();
  e.dataTransfer.dropEffect = 'copy';
  /* mostra fantasma na posição do mouse */
  var d = dropTarget(e, 4);
  fileDragLast = d;
  fileGhosts(d, fileDragKind(e));
});
elScroll.addEventListener('dragleave', function(e){
  if(isFileDrag(e) && e.target === elScroll) hideGhosts();
});
elScroll.addEventListener('drop', function(e){
  if(!isFileDrag(e)) return;
  hideGhosts();
  if(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length){
    e.preventDefault();
    var d = dropTarget(e, 4);
    fileDragLast = null;
    addLocalFilesToTimeline(e.dataTransfer.files, d);
  }
});
/* soltar o ARQUIVO em cima da coluna de NOMES das faixas: não ignora — adiciona
   do mesmo jeito, mantendo o tempo da última posição do fantasma */
if(elHeadcol){
  elHeadcol.addEventListener('dragover', function(e){
    if(!isFileDrag(e)) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = 'copy';
    var d = dropTarget(e, 4);
    if(fileDragLast) d.t = fileDragLast.t;   /* o X sobre os nomes não vale — mantém o tempo */
    fileDragLast = d;
    fileGhosts(d, fileDragKind(e));
  });
  elHeadcol.addEventListener('drop', function(e){
    if(!isFileDrag(e)) return;
    e.preventDefault();
    hideGhosts();
    var d = fileDragLast || dropTarget(e, 4);
    fileDragLast = null;
    if(e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length){
      addLocalFilesToTimeline(e.dataTransfer.files, d);
    }
  });
}
/* fora do bloco de mídia: impede o navegador de abrir o arquivo, mas não faz nada */
document.addEventListener('dragover', function(e){ if(isFileDrag(e)) e.preventDefault(); });
document.addEventListener('drop', function(e){
  if(isFileDrag(e) && !(elPool && elPool.contains(e.target)) && !elScroll.contains(e.target)) e.preventDefault();
});

function pushPinClips(v, url, hdUrl){
  /* vídeo validado → entra na galeria (não mais direto na timeline) */
  var it = {
    type:'video', url: v.currentSrc || v.src, cors: !!v.crossOrigin,
    srcUrl: url,   /* link do pin — usado no log de exportação */
    hdUrl: hdUrl || null,   /* 1080p pra baixar em segundo plano (upgrade de qualidade) */
    name: 'PIN ' + (url.match(/pin\/(\d+)/) ? url.match(/pin\/(\d+)/)[1].slice(-6) : 'vídeo'),
    audioName: '♪ áudio do pin'
  };
  poolAdd(it);
  prefetchPinBlob(it);   /* baixa os bytes (1080p) em segundo plano (playback + turbo) */
  pinDone(null);
}

/* pré-baixa os bytes do vídeo do Pinterest em SEGUNDO PLANO, assim que ele
   entra na galeria, e troca a fonte por um arquivo local (blob):
   1) o playback não trava mais esperando o CDN (era o congelamento);
   2) o export entra no TURBO completo (multi-worker) — que exige vídeo local;
   3) no export os bytes já estão prontos (nada de esperar o proxy na hora). */
function prefetchPinBlob(it){
  if(!it || it.type !== 'video' || !it.url || /^blob:/i.test(it.url)) return;
  /* baixa o 1080p (hdUrl) quando existir — o item da galeria começa em 720p
     (importação instantânea) e sobe pra máx. qualidade em segundo plano.
     Ao virar blob local, o export também volta pro turbo multi-worker. */
  var srcDl = it.hdUrl || it.url;
  rawBytes(srcDl).then(function(ab){
    if(!ab) return;
    var blobUrl = URL.createObjectURL(new Blob([ab], { type:'video/mp4' }));
    _rawCache[blobUrl] = Promise.resolve(ab);   /* export lê da memória */
    it.url = blobUrl;    /* próximas inserções na timeline já usam o local (1080p) */
    it.cors = false;
    it.hdReady = !!it.hdUrl;   /* marca que subiu pra 1080p */
    if(typeof renderPool === 'function') try{ renderPool(); }catch(_){}
    /* pin com GOP esparso também ganha proxy de edição (seek/cortes lisos) */
    try{ maybeBuildProxy(it); }catch(_){}
  }).catch(function(e){ try{ console.warn('prefetch pin falhou:', srcDl, e); }catch(_){} });
}

/* ── arquivos do computador (vídeo ou áudio) → galeria ── */
function addLocalFiles(files){
  Array.prototype.forEach.call(files, function(file){
    var url = URL.createObjectURL(file);
    var name = String(file.name || 'ARQUIVO').replace(/\.[^.]+$/, '').slice(0, 16).toUpperCase();
    if(/^audio\//i.test(file.type || '')){
      poolAdd({ type:'audio', url: url, name: '♪ ' + name.toLowerCase() });
    } else if(/^image\//i.test(file.type || '')){
      var img = new Image();
      img.onload = function(){ poolAdd({ type:'image', url: url, name: name, srcUrl: 'file:' + (file.name || name) }); };
      img.onerror = function(){ setSrcStatus('erro: não consegui ler ' + name, 's-err'); };
      img.src = url;
    } else {
      setSrcStatus('carregando ' + name + '…', 's-loading');
      makeVideoEl(url, false, function(v){
        poolAdd({ type:'video', url: url, cors:false, name: name, srcUrl: 'file:' + (file.name || name) });
      }, function(){
        setSrcStatus('erro: não consegui ler ' + name, 's-err');
      });
    }
  });
}

/* arquivos do computador → timeline (adiciona na galeria E insere na posição do
   drop). VÁRIOS arquivos entram EM SEQUÊNCIA: cada um começa onde o anterior
   termina (o carregamento é assíncrono, então encadeia um a um). */
function addLocalFilesToTimeline(files, dropInfo){
  var list = Array.prototype.slice.call(files);
  var track = dropInfo.track || null;
  function step(i, startT){
    if(i >= list.length) return;
    var file = list[i];
    var url = URL.createObjectURL(file);
    var name = String(file.name || 'ARQUIVO').replace(/\.[^.]+$/, '').slice(0, 16).toUpperCase();
    var next = function(endT){ step(i + 1, endT); };
    if(/^audio\//i.test(file.type || '')){
      var it = { type:'audio', url: url, name: '♪ ' + name.toLowerCase() };
      poolAdd(it);
      var a = document.createElement('audio');
      a.preload = 'auto';
      a.addEventListener('loadedmetadata', function(){
        snapshot();
        var aTrackId = (track && track.kind === 'audio') ? track.id : firstTrack('audio').id;
        var st = snap(Math.max(0, startT));
        var c = {
          id: uid(), kind:'audio', trackId: aTrackId,
          start: st, dur: snap(a.duration), in: 0, srcDur: a.duration,
          el: a, name: it.name, pair: null, muted:false
        };
        clips.push(c);
        overwriteMoved([c]);
        selectClip(c);
        setSrcStatus('✓ áudio na timeline', 's-ok');
        renderAll(); seekMedia();
        next(c.start + c.dur);
      }, { once:true });
      a.addEventListener('error', function(){ setSrcStatus('erro: não consegui ler ' + name, 's-err'); next(startT); }, { once:true });
      a.src = url; a.load();
    } else if(/^image\//i.test(file.type || '')){
      var img = new Image();
      img.onload = function(){
        poolAdd({ type:'image', url: url, name: name, srcUrl: 'file:' + (file.name || name) });
        var st = snap(Math.max(0, startT));
        pushImageClip(img, name, { start: st, trackId: (track && track.kind === 'video') ? track.id : null, srcUrl: 'file:' + (file.name || name) });
        next(st + 4);   /* imagem = 4s padrão */
      };
      img.onerror = function(){ setSrcStatus('erro: não consegui ler ' + name, 's-err'); next(startT); };
      img.src = url;
    } else {
      setSrcStatus('carregando ' + name + '…', 's-loading');
      makeVideoEl(url, false, function(v){
        poolAdd({ type:'video', url: url, cors:false, name: name, srcUrl: 'file:' + (file.name || name) });
        var st = snap(Math.max(0, startT));
        pushVideoClips(v, name, '♪ áudio de ' + name.toLowerCase(), { start: st, trackId: (track && track.kind === 'video') ? track.id : null, srcUrl: 'file:' + (file.name || name) });
        next(st + v.duration);
      }, function(){
        setSrcStatus('erro: não consegui ler ' + name, 's-err'); next(startT);
      });
    }
  }
  step(0, dropInfo.t);
}

/* fila de pins: o botão nunca trava — dá pra colar vários links seguidos.
   status mostra só "N vídeo(s) na fila"; erros são avisados individualmente */
var pinQueue = 0;
function pinQueueMsg(){
  if(pinQueue > 0) setSrcStatus(pinQueue + (pinQueue > 1 ? ' vídeos na fila' : ' vídeo na fila'), 's-loading');
  else setSrcStatus('✓ na galeria — clique pra usar', 's-ok');
}
function pinDone(errMsg){
  pinQueue = Math.max(0, pinQueue - 1);
  if(errMsg) setSrcStatus('erro: ' + errMsg, 's-err');
  else pinQueueMsg();
}

function addPinterest(){
  var url = $('mce-pin-url').value.trim();
  if(!url || !/pinterest\.com|pin\.it/i.test(url)){
    alert('Cole um link válido do Pinterest.\nEx.: https://br.pinterest.com/pin/123456/');
    return;
  }
  $('mce-pin-url').value = '';   /* campo liberado pro próximo link */
  importPinUrl(url);
}

/* importa um pin pela URL — usado pelo campo da topbar E pelo botão
   "reimportar" do histórico */
function importPinUrl(url){
  pinQueue++;
  pinQueueMsg();
  showToast('Vídeo adicionado à fila', 'fila');   /* feedback imediato no clique */

  gas({ resource:'pinterest_video', url:url }, function(err, d){
    if(err || !d || d.error || !d.url){
      pinDone(d && d.error ? d.error : (err ? err.message : 'vídeo não encontrado'));
      return;
    }
    pinHistAdd(url, d.url);   /* registra no histórico (Midnight Sync) */
    /* d.url = 720p (importação instantânea); d.url_hd = 1080p (upgrade em background).
       1ª tentativa: tocar o 720p direto do CDN do Pinterest.
       Se o CDN bloquear (CORS), cai pro proxy do GAS. */
    makeVideoEl(d.url, true, function(v){
      pushPinClips(v, url, d.url_hd);
    }, function(){
      gas({ resource:'proxy_video', video_url:d.url }, function(err2, d2){
        if(err2 || !d2 || d2.error || !d2.b64){
          pinDone(d2 && d2.error ? d2.error : (err2 ? err2.message : 'download falhou'));
          return;
        }
        var blobUrl = URL.createObjectURL(b64ToBlob(d2.b64, d2.mime || 'video/mp4'));
        makeVideoEl(blobUrl, false, function(v){
          pushPinClips(v, url, d.url_hd);
        }, function(){
          pinDone('vídeo veio corrompido');
        });
      }, 240000);
    });
  }, 60000);
}

/* ══════════ HISTÓRICO DO PINTEREST (botão relógio na topbar) ══════════
   Cada pin importado com sucesso é registrado no Midnight Sync
   (resource=pin_history, aba "pin_history": url | video_url | user | ts | count).
   O modal lista os vídeos com miniatura, link e botão de reimportar. */
var pinHist = null;   /* cache da última listagem */

function pinHistAdd(url, videoUrl){
  pinHist = null;   /* invalida o cache — próxima abertura recarrega */
  gas({ resource:'pin_history', action:'add', url:url, video_url:videoUrl || '', user:MC_USER }, function(){}, 30000);
}

function pinHistOpen(){
  var ov = $('mce-hist-overlay');
  if(!ov) return;
  ov.classList.add('is-open');
  if(pinHist){ pinHistRender(pinHist); return; }
  $('mce-hist-list').innerHTML = '<div class="mce-hist-empty">carregando histórico…</div>';
  gas({ resource:'pin_history', action:'list' }, function(err, d){
    if(err || !d || d.error){
      $('mce-hist-list').innerHTML = '<div class="mce-hist-empty">erro: ' + escapeHtml((d && d.error) || (err ? err.message : 'sem resposta')) + '</div>';
      return;
    }
    pinHist = d.rows || [];
    pinHistRender(pinHist);
  }, 30000);
}

function pinHistClose(){
  var ov = $('mce-hist-overlay');
  if(ov) ov.classList.remove('is-open');
}

function pinHistRender(rows){
  var list = $('mce-hist-list');
  list.innerHTML = '';
  if(!rows.length){
    list.innerHTML = '<div class="mce-hist-empty">nenhum vídeo importado ainda —<br>cole um link do pinterest pra começar</div>';
    return;
  }
  rows.forEach(function(it){
    var row = document.createElement('div');
    row.className = 'mce-hist-row';
    /* miniatura: o próprio vídeo do CDN (1º frame, preload=metadata) */
    var th = document.createElement('div');
    th.className = 'mce-hist-thumb';
    if(it.video_url && !/\.m3u8/i.test(it.video_url)){
      var v = document.createElement('video');
      v.muted = true; v.preload = 'metadata'; v.playsInline = true;
      v.src = it.video_url;
      v.addEventListener('error', function(){ th.textContent = '▶'; }, { once:true });
      th.appendChild(v);
    } else {
      th.textContent = '▶';
    }
    var info = document.createElement('div');
    info.className = 'mce-hist-info';
    var a = document.createElement('a');
    a.className = 'mce-hist-link';
    a.href = it.url; a.target = '_blank'; a.rel = 'noopener';
    a.title = it.url;
    a.textContent = it.url.replace(/^https?:\/\/(www\.)?/i, '');
    var meta = document.createElement('span');
    meta.className = 'mce-hist-meta';
    meta.textContent = (it.user ? it.user + ' · ' : '') + timeAgo(it.ts) + (it.count > 1 ? ' · ' + it.count + 'x' : '');
    info.appendChild(a); info.appendChild(meta);
    var btn = document.createElement('button');
    btn.className = 'mcd-btn-sm mce-hist-reimport';
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-2.64-6.36"/><polyline points="21 3 21 9 15 9"/></svg> Reimportar';
    btn.addEventListener('click', function(){ importPinUrl(it.url); });
    row.appendChild(th); row.appendChild(info); row.appendChild(btn);
    list.appendChild(row);
  });
}

/* ── áudio: link direto de MP3/M4A (ou use o botão de upload do computador) ── */
function addAudioPrompt(trackId){
  var url = prompt('Cole um link direto de MP3/M4A (ou use o botão de upload pra pegar um arquivo do computador):');
  if(!url) return;
  url = url.trim();
  setSrcStatus('baixando áudio…', 's-loading');

  var finish = function(blobUrl){
    var a = document.createElement('audio');
    a.preload = 'auto';
    a.src = blobUrl;
    a.addEventListener('loadedmetadata', function(){
      snapshot();
      var c = {
        id: uid(), kind:'audio', trackId: trackId,
        start: snap(tCur), dur: snap(a.duration), in: 0, srcDur: a.duration,
        el: a, name: '♪ áudio', pair: null, muted:false
      };
      clips.push(c);
      overwriteMoved([c]);   /* caiu por cima de outro áudio? o de baixo é cortado */
      selectClip(c);
      setSrcStatus('✓ áudio na timeline', 's-ok');
      renderAll(); seekMedia();
    }, { once:true });
    a.load();
  };

  /* baixa via proxy pra evitar CORS; se vier URL, baixa de novo pelo proxy */
  gas({ resource:'proxy_video', video_url:url }, function(err, d){
    if(err || !d || d.error || !(d.b64 || d.url)){
      setSrcStatus('erro no áudio: ' + (d && d.error ? d.error : (err ? err.message : 'sem dados')), 's-err');
      return;
    }
    if(d.b64){
      finish(URL.createObjectURL(b64ToBlob(d.b64, d.mime || 'audio/mpeg')));
    } else {
      gas({ resource:'proxy_video', video_url:d.url }, function(e2, d2){
        if(e2 || !d2 || d2.error || !d2.b64){
          setSrcStatus('erro ao baixar áudio', 's-err');
          return;
        }
        finish(URL.createObjectURL(b64ToBlob(d2.b64, d2.mime || 'audio/mpeg')));
      }, 240000);
    }
  }, 240000);
}

/* ══════════ SFX (efeitos de som — Carro/Moto) ══════════
   Galeria de áudios hospedados no CDN da Shopify, registrados na aba 'sfx'
   do GAS (id | name | category | url). O botão +SFX na faixa de áudio abre
   o modal; clicar num som adiciona um clipe de áudio no início (tempo 0). */
var sfxItems = [];
var sfxModalCat = 'carro';
var sfxSub = '';   /* subfiltro: '' (todos) | '0-100' | 'alta' | 'drift' */
var sfxTrackId = null;
var SFX_SUBS = [{ id:'0-100', label:'0-100' }, { id:'alta', label:'Alta velocidade' }, { id:'drift', label:'Drift' }];
var sfxPreviewAudio = null;   /* áudio tocado no hover da galeria */
function sfxSubOf(s){
  var v = String((s && s.subcategory) || '').toLowerCase();
  return (v === '0-100' || v === 'alta' || v === 'drift') ? v : '';
}
function fmtSfxDur(s){
  s = Math.max(0, s || 0);
  if(s < 60) return (Math.round(s * 10) / 10) + 's';
  return Math.floor(s / 60) + ':' + ('0' + Math.round(s % 60)).slice(-2);
}
/* toca/pausa o preview no hover (um único elemento reaproveitado) */
function sfxPreview(url, on){
  if(!sfxPreviewAudio){ sfxPreviewAudio = new Audio(); sfxPreviewAudio.preload = 'auto'; sfxPreviewAudio.crossOrigin = 'anonymous'; }
  var a = sfxPreviewAudio;
  if(on){ try{ if(a.src !== url) a.src = url; a.currentTime = 0; a.play().catch(function(){}); }catch(_){} }
  else { try{ a.pause(); }catch(_){} }
}

function loadCachedSfx(){
  try{ var s = localStorage.getItem('mce_sfx'); if(s) sfxItems = JSON.parse(s); }catch(_){}
}
function loadSfx(cb){
  loadCachedSfx();
  gas({ resource:'sfx', action:'list' }, function(err, d){
    if(!err && d && Array.isArray(d.sfx)){
      sfxItems = d.sfx;
      try{ localStorage.setItem('mce_sfx', JSON.stringify(sfxItems)); }catch(_){}
      if(sfxModalOpen()) renderSfxModal();
    }
    if(cb) cb();
  }, 30000);
}
function sfxCatOf(s){ return (s && String(s.category).toLowerCase() === 'moto') ? 'moto' : 'carro'; }
function sfxModalOpen(){ var ov = $('mce-sfx-modal-overlay'); return !!(ov && ov.classList.contains('is-open')); }

/* cria o modal do SFX uma vez (reaproveita o estilo do modal de texto) */
function ensureSfxModal(){
  var ov = $('mce-sfx-modal-overlay');
  if(ov) return ov;
  ov = document.createElement('div');
  ov.id = 'mce-sfx-modal-overlay';
  ov.className = 'mce-text-modal-overlay';
  ov.innerHTML =
    '<div class="mce-text-modal">'
    + '<div class="mce-text-modal-head"><h2>Adicionar SFX</h2>'
    + '<button class="mce-text-modal-close" id="mce-sfx-close">&times;</button></div>'
    + '<div class="mce-cat-tabs" id="mce-sfx-tabs"></div>'
    + '<div class="mce-sfx-subtabs" id="mce-sfx-subtabs"></div>'
    + '<div class="mce-text-modal-grid" id="mce-sfx-grid"></div>'
    + '</div>';
  uiRoot().appendChild(ov);
  ov.addEventListener('click', function(e){ if(e.target === ov) closeSfxModal(); });
  ov.querySelector('#mce-sfx-close').addEventListener('click', closeSfxModal);
  var tabs = ov.querySelector('#mce-sfx-tabs');
  TPL_CATS.forEach(function(cat){
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'mce-cat-tab'; b.dataset.cat = cat.id; b.textContent = cat.label;
    b.addEventListener('click', function(){ sfxModalCat = cat.id; renderSfxModal(); });
    tabs.appendChild(b);
  });
  /* subcategorias (abaixo de Carro/Moto): Todos · 0-100 · Alta velocidade · Drift */
  var subtabs = ov.querySelector('#mce-sfx-subtabs');
  [{ id:'', label:'Todos' }].concat(SFX_SUBS).forEach(function(sc){
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'mce-sfx-subtab'; b.dataset.sub = sc.id; b.textContent = sc.label;
    b.addEventListener('click', function(){ sfxSub = sc.id; renderSfxModal(); });
    subtabs.appendChild(b);
  });
  bindSfxScrub();
  return ov;
}
function openSfxModal(trackId){
  sfxTrackId = trackId;
  ensureSfxModal();
  $('mce-sfx-modal-overlay').classList.add('is-open');   /* visível ANTES de medir o layout */
  renderSfxModal();
  loadSfx();   /* atualiza do servidor em segundo plano */
}
function closeSfxModal(){
  var ov = $('mce-sfx-modal-overlay');
  if(ov) ov.classList.remove('is-open');
  sfxTrackId = null;
}

function renderSfxModal(){
  var ov = ensureSfxModal();
  ov.querySelectorAll('#mce-sfx-tabs .mce-cat-tab').forEach(function(b){
    b.classList.toggle('is-on', b.dataset.cat === sfxModalCat);
  });
  ov.querySelectorAll('#mce-sfx-subtabs .mce-sfx-subtab').forEach(function(b){
    b.classList.toggle('is-on', b.dataset.sub === sfxSub);
  });
  var grid = $('mce-sfx-grid');
  grid.innerHTML = '';
  var items = sfxItems.filter(function(s){
    return sfxCatOf(s) === sfxModalCat && (!sfxSub || sfxSubOf(s) === sfxSub);
  });
  if(!items.length){
    var empty = document.createElement('div');
    empty.className = 'mce-sfx-empty';
    empty.textContent = 'nenhum SFX aqui — suba os .mp3 no CDN e registre na aba sfx (botão direito categoriza)';
    grid.appendChild(empty);
    return;
  }
  var pending = [];   /* canvases a dimensionar/desenhar após o layout */
  items.forEach(function(sfx){
    var card = document.createElement('div');
    card.className = 'mce-tpl-card mce-sfx-card';
    card.title = 'Clique: adicionar no início · passe o mouse: ouvir · botão direito: categorizar';
    var box = document.createElement('div');
    box.className = 'mce-sfx-wavebox';
    var cvs = document.createElement('canvas');
    cvs.className = 'mce-sfx-wave';
    box.appendChild(cvs);
    card.appendChild(box);
    pending.push({ cvs: cvs, box: box, url: sfx.url });
    var lbl = document.createElement('span');
    lbl.className = 'mce-tpl-label';
    lbl.textContent = sfx.name || 'SFX';
    card.appendChild(lbl);
    /* clicar no espectro adiciona (a menos que tenha sido um arraste da barra) */
    card.addEventListener('click', function(){
      if(sfxSuppressClick){ sfxSuppressClick = false; return; }
      addSfxToTrack(sfx, sfxTrackId);
    });
    /* arrastar em cima do espectro move a barra amarela (avança/volta o preview) */
    cvs.addEventListener('mousedown', function(e){
      if(e.button !== 0) return;
      e.preventDefault();
      sfxPreview(sfx.url, true); startSfxProgress(cvs, sfx.url);
      sfxScrub = { canvas: cvs, url: sfx.url, moved: false };
      sfxSeekAt(e.clientX);
    });
    /* passar o mouse toca o áudio + barra amarela de progresso; sair pausa */
    card.addEventListener('mouseenter', function(){ sfxPreview(sfx.url, true); startSfxProgress(cvs, sfx.url); });
    card.addEventListener('mouseleave', function(){ if(!sfxScrub){ sfxPreview(sfx.url, false); stopSfxProgress(); } });
    /* botão direito → menu de subcategoria (grava no banco) */
    card.addEventListener('contextmenu', function(e){ showSfxCtxMenu(e, sfx); });
    grid.appendChild(card);
  });
  /* dimensiona cada canvas pela largura REAL do box (após o layout) — assim o
     espectro e a fonte da duração não saem esticados/comprimidos */
  requestAnimationFrame(function(){
    pending.forEach(function(it){
      var w = Math.max(120, Math.round(it.box.clientWidth || it.box.getBoundingClientRect().width || 240));
      var h = Math.max(40, Math.round(it.box.clientHeight || 70));
      it.cvs.width = w; it.cvs.height = h;
      drawSfxWave(it.cvs, it.url);
    });
  });
}

/* menu de botão direito: define a subcategoria e grava no banco */
function closeSfxCtxMenu(){ var m = $('mce-sfx-ctx'); if(m) m.remove(); }
function showSfxCtxMenu(e, sfx){
  e.preventDefault();
  closeSfxCtxMenu();
  var m = document.createElement('div');
  m.className = 'mce-ctx mce-sfx-ctx';
  m.id = 'mce-sfx-ctx';
  SFX_SUBS.forEach(function(o){
    var b = document.createElement('button');
    b.className = 'mce-ctx-item' + (sfxSubOf(sfx) === o.id ? ' is-on' : '');
    b.textContent = o.label;
    b.addEventListener('click', function(){ closeSfxCtxMenu(); sfxSetSubcat(sfx, o.id); });
    m.appendChild(b);
  });
  uiRoot().appendChild(m);   /* dentro do #mc-root → herda as variáveis de tema (fonte/cores) */
  m.style.left = Math.min(e.clientX, window.innerWidth - m.offsetWidth - 8) + 'px';
  m.style.top  = Math.min(e.clientY, window.innerHeight - m.offsetHeight - 8) + 'px';
  setTimeout(function(){
    function out(ev){ if(!m.contains(ev.target)){ closeSfxCtxMenu(); document.removeEventListener('mousedown', out); } }
    document.addEventListener('mousedown', out);
  }, 10);
}
function sfxSetSubcat(sfx, sub){
  sub = (sub === '0-100' || sub === 'alta' || sub === 'drift') ? sub : '';
  var prev = sfx.subcategory || '';
  sfx.subcategory = sub;
  try{ localStorage.setItem('mce_sfx', JSON.stringify(sfxItems)); }catch(_){}
  renderSfxModal();
  gas({ resource:'sfx', action:'setcat', url: sfx.url, id: sfx.id, subcategory: sub }, function(err, d){
    if(err || !d || d.error){
      sfx.subcategory = prev;   /* reverte se falhou */
      try{ localStorage.setItem('mce_sfx', JSON.stringify(sfxItems)); }catch(_){}
      renderSfxModal();
      alert('Erro ao salvar categoria do SFX.');
    }
  }, 30000);
}

/* desenha a onda + duração + (opcional) barra amarela de progresso do preview */
function paintSfxWave(canvas, cache, progress){
  var g = canvas.getContext('2d'), W = canvas.width, H = canvas.height;
  var peaks = cache.peaks, mx = cache.max || 1;
  g.clearRect(0, 0, W, H);
  g.fillStyle = 'rgba(234,252,240,.9)';
  for(var x=0; x<W; x+=2){
    var idx = Math.floor((x / W) * peaks.length);
    var v = waveCurve((peaks[Math.min(peaks.length - 1, idx)] || 0) / mx);
    var h = Math.max(1, v * (H - 4));
    g.fillRect(x, (H - h) / 2, 1.4, h);
  }
  /* barra amarela indicando a posição do player (hover) */
  if(progress != null){
    var px = Math.max(0, Math.min(W - 2, progress * W));
    g.fillStyle = '#fff200';
    g.fillRect(px, 0, 2, H);
  }
  /* duração no canto inferior direito */
  if(cache.dur){
    var t = fmtSfxDur(cache.dur);
    g.font = '600 11px "SF Mono", SFMono-Regular, ui-monospace, Menlo, Monaco, monospace';
    var tw = g.measureText(t).width;
    g.fillStyle = 'rgba(0,0,0,.55)';
    g.fillRect(W - tw - 11, H - 17, tw + 8, 14);
    g.fillStyle = 'rgba(255,255,255,.95)';
    g.textBaseline = 'middle'; g.textAlign = 'left';
    g.fillText(t, W - tw - 7, H - 10);
  }
}
/* forma de onda do arquivo inteiro (reaproveita waveCache/loadWave) */
function drawSfxWave(canvas, url){
  var g = canvas.getContext('2d'), W = canvas.width, H = canvas.height;
  var cache = waveCache[url];
  if(cache && typeof cache === 'object'){ paintSfxWave(canvas, cache, null); return; }
  /* placeholder (linha central) enquanto decodifica */
  g.clearRect(0, 0, W, H);
  g.strokeStyle = 'rgba(234,252,240,.25)';
  g.beginPath(); g.moveTo(0, H / 2); g.lineTo(W, H / 2); g.stroke();
  if(cache === 'fail') return;
  loadWave(url);   /* dispara fetch+decode; redesenha quando o cache ficar pronto */
  var tries = 0;
  var iv = setInterval(function(){
    var c2 = waveCache[url];
    if(c2 && typeof c2 === 'object'){ clearInterval(iv); if(document.body.contains(canvas)) drawSfxWave(canvas, url); }
    else if(c2 === 'fail' || ++tries > 40){ clearInterval(iv); }
  }, 150);
}

/* animação da barra de progresso enquanto o preview toca no hover */
var sfxPreviewRAF = 0, sfxPreviewCanvas = null, sfxPreviewUrl = '';
function startSfxProgress(canvas, url){
  sfxPreviewCanvas = canvas; sfxPreviewUrl = url;
  cancelAnimationFrame(sfxPreviewRAF);
  sfxPreviewRAF = requestAnimationFrame(sfxProgressTick);
}
function stopSfxProgress(){
  cancelAnimationFrame(sfxPreviewRAF); sfxPreviewRAF = 0;
  var cvs = sfxPreviewCanvas, url = sfxPreviewUrl;
  sfxPreviewCanvas = null; sfxPreviewUrl = '';
  if(cvs && url) drawSfxWave(cvs, url);   /* redesenha sem a barra */
}
function sfxProgressTick(){
  var a = sfxPreviewAudio, cvs = sfxPreviewCanvas, url = sfxPreviewUrl;
  if(!a || !cvs){ sfxPreviewRAF = 0; return; }
  var cache = waveCache[url];
  if(cache && typeof cache === 'object'){
    var dur = a.duration || cache.dur || 0;
    paintSfxWave(cvs, cache, dur > 0 ? (a.currentTime / dur) : null);
  }
  sfxPreviewRAF = requestAnimationFrame(sfxProgressTick);
}

/* arraste da barra amarela = avançar/voltar o preview (clicar no espectro adiciona) */
var sfxScrub = null, sfxSuppressClick = false, sfxScrubBound = false;
function sfxSeekAt(clientX){
  if(!sfxScrub || !sfxPreviewAudio) return;
  var a = sfxPreviewAudio, cvs = sfxScrub.canvas, cache = waveCache[sfxScrub.url];
  var r = cvs.getBoundingClientRect();
  var ratio = Math.max(0, Math.min(1, (clientX - r.left) / (r.width || 1)));
  var dur = (isFinite(a.duration) && a.duration) ? a.duration : ((cache && cache.dur) || 0);
  if(dur){ try{ a.currentTime = ratio * dur; }catch(_){} }
  if(cache && typeof cache === 'object') paintSfxWave(cvs, cache, ratio);
}
function bindSfxScrub(){
  if(sfxScrubBound) return;
  sfxScrubBound = true;
  document.addEventListener('mousemove', function(e){ if(sfxScrub){ sfxScrub.moved = true; sfxSeekAt(e.clientX); } });
  document.addEventListener('mouseup', function(){ if(sfxScrub){ if(sfxScrub.moved) sfxSuppressClick = true; sfxScrub = null; } });
}

/* adiciona o SFX como clipe de áudio no início (tempo 0) da faixa de áudio */
function addSfxToTrack(sfx, trackId){
  if(!sfx || !sfx.url) return;
  var tr = trackId ? trackById(trackId) : null;
  if(!tr || tr.kind !== 'audio'){
    tr = tracks.filter(function(t){ return t.kind === 'audio'; })[0] || addTrack('audio');
  }
  tr.lockDur = true;   /* +SFX já entra com o cadeado ativado (áudio ⇄ vídeo) */
  var a = document.createElement('audio');
  a.preload = 'auto';
  a.crossOrigin = 'anonymous';   /* CDN da Shopify libera CORS → export lê os bytes */
  a.src = sfx.url;
  a.addEventListener('loadedmetadata', function(){
    snapshot();
    var c = {
      id: uid(), kind:'audio', trackId: tr.id, isSfx: true,
      start: 0, dur: snap(a.duration), in: 0, srcDur: a.duration,
      el: a, name: '♪ ' + (sfx.name || 'SFX'), pair: null, muted:false
    };
    clips.push(c);
    overwriteMoved([c]);   /* caiu por cima de outro áudio? o de baixo é cortado */
    selectClip(c);
    renderAll(); seekMedia();
  }, { once:true });
  a.addEventListener('error', function(){ alert('Não consegui carregar o SFX: ' + (sfx.name || sfx.url)); }, { once:true });
  a.load();
  closeSfxModal();
}

/* ══════════ TEXTO ANIMADO ══════════ */

/* ── modelos de texto (CRUD via GAS) ── */
var textTemplates = [];
var pendingTextTrackId = null;

function cacheTemplates(){
  try{ localStorage.setItem('mce_text_tpls', JSON.stringify(textTemplates)); }catch(_){}
}
function loadCachedTemplates(){
  try{
    var s = localStorage.getItem('mce_text_tpls');
    if(s){ textTemplates = JSON.parse(s); }
  }catch(_){}
}

function loadTextTemplates(cb){
  loadCachedTemplates();
  gas({ resource:'text_templates', action:'list' }, function(err, d){
    if(!err && d && Array.isArray(d.templates)){
      /* GAS pode não retornar campos extras (modelType, padV, chapeu, gradHeight…).
         Mescla: usa o que o GAS trouxe como base, mas preenche campos faltantes
         a partir da versão em cache (que preserva tudo localmente). */
      var cacheMap = {};
      textTemplates.forEach(function(t){ if(t.id) cacheMap[t.id] = t; });
      var extraFields = ['category','city','modelType','padding','padV','chapeu','chapeuSize','chapeuGap','showBg','gradHeight',
                    'text2','size2','lineGap2','x2','y2','padding2','padV2','chapeu2','chapeuSize2','chapeuGap2','showBg2','gradHeight2',
                    'modelType2','upper','upper2','chapeuUpper','chapeuUpper2'];
      var merged = d.templates.map(function(remote){
        /* fallback: preenche campos nulos do cache local (templates antigos) */
        var cached = cacheMap[remote.id];
        if(cached){
          extraFields.forEach(function(k){
            if(remote[k] == null && cached[k] != null) remote[k] = cached[k];
          });
        }
        return remote;
      });
      textTemplates = merged;
      cacheTemplates();
    }
    if(cb) cb();
  }, 30000);
}

function saveTextTemplate(data, cb){
  /* otimista: o modelo aparece na lista NA HORA; se o servidor falhar, sai */
  var temp = {
    id: 'tmp_' + Date.now(), name: data.name || '', modelType: data.modelType || 1,
    category: data.category || 'carro',
    modelType2: data.modelType2, upper: data.upper, upper2: data.upper2,
    chapeuUpper: data.chapeuUpper, chapeuUpper2: data.chapeuUpper2,
    text: data.text, size: data.size, lineGap: data.lineGap, x: data.x, y: data.y,
    padding: data.padding, padV: data.padV, chapeu: data.chapeu, chapeuSize: data.chapeuSize, chapeuGap: data.chapeuGap, showBg: data.showBg, gradHeight: data.gradHeight,
    text2: data.text2, size2: data.size2, lineGap2: data.lineGap2, x2: data.x2, y2: data.y2,
    padding2: data.padding2, padV2: data.padV2, chapeu2: data.chapeu2, chapeuSize2: data.chapeuSize2, chapeuGap2: data.chapeuGap2, showBg2: data.showBg2, gradHeight2: data.gradHeight2
  };
  textTemplates.push(temp);
  /* o clipe passa a apontar pro modelo recém-salvo — o próximo "Salvar modelo"
     oferece ATUALIZAR este modelo, em vez de só salvar outro novo */
  selectedTemplateId = temp.id;
  cacheTemplates();
  renderTextModal();
  gas({
    resource:'text_templates', action:'save',
    name: data.name || '', modelType: data.modelType || 1,
    category: data.category || 'carro',
    modelType2: data.modelType2 || data.modelType || 1,
    upper: data.upper || '', upper2: data.upper2 || '',
    chapeuUpper: data.chapeuUpper || '', chapeuUpper2: data.chapeuUpper2 || '',
    text: data.text, size: data.size, lineGap: data.lineGap,
    x: data.x, y: data.y,
    padding: data.padding, padV: data.padV, chapeu: data.chapeu, chapeuSize: data.chapeuSize, chapeuGap: data.chapeuGap, showBg: data.showBg, gradHeight: data.gradHeight,
    text2: data.text2, size2: data.size2, lineGap2: data.lineGap2,
    x2: data.x2, y2: data.y2,
    padding2: data.padding2, padV2: data.padV2, chapeu2: data.chapeu2, chapeuSize2: data.chapeuSize2, chapeuGap2: data.chapeuGap2, showBg2: data.showBg2, gradHeight2: data.gradHeight2
  }, function(err, d){
    if(err || !d || d.error){
      if(selectedTemplateId === temp.id) selectedTemplateId = null;
      textTemplates = textTemplates.filter(function(t){ return t !== temp; });
      cacheTemplates();
      renderTextModal();
      alert('Erro ao salvar modelo: ' + (d && d.error ? d.error : (err ? err.message : 'desconhecido')));
    } else if(d.template){
      /* mantém o vínculo do clipe quando o id temporário vira o id real —
         senão "Atualizar modelo atual" parava de aparecer depois do save */
      if(selectedTemplateId === temp.id) selectedTemplateId = d.template.id;
      temp.id = d.template.id;   /* troca o id temporário pelo real do banco */
      cacheTemplates();   /* atualiza cache com id real */
    }
    if(cb) cb(err, d);
  }, 30000);
}

function deleteTextTemplate(tplId, cb){
  /* otimista: some da lista na hora; se o servidor falhar, volta */
  var gone = null;
  textTemplates = textTemplates.filter(function(t){
    if(t.id === tplId){ gone = t; return false; }
    return true;
  });
  cacheTemplates();
  renderTextModal();
  gas({ resource:'text_templates', action:'delete', tplId: tplId, id: tplId }, function(err, d){
    if(err || !d || d.error){
      if(gone) textTemplates.push(gone);
      cacheTemplates();
      renderTextModal();
      alert('Erro ao excluir modelo: ' + (d && d.error ? d.error : (err ? err.message : 'desconhecido')));
    }
    if(cb) cb();
  }, 30000);
}

function renameTextTemplate(tpl, name, category){
  /* otimista: renomeia (e recategoriza) na hora; se o servidor falhar, volta */
  var oldName = tpl.name, oldCat = tpl.category;
  var cat = (category === 'moto' || category === 'carro') ? category : tpl.category;
  tpl.name = name;
  tpl.category = cat || 'carro';
  cacheTemplates();
  renderTextModal();
  var req = { resource:'text_templates', action:'rename', tplId: tpl.id, name: name };
  if(cat) req.category = cat;   /* o lápis manda a categoria escolhida junto */
  gas(req, function(err, d){
    if(err || !d || d.error){
      tpl.name = oldName; tpl.category = oldCat;
      cacheTemplates();
      renderTextModal();
      alert('Erro ao renomear modelo.');
    }
  }, 30000);
}

var selectedTemplateId = null;   /* id do modelo em uso (para "atualizar modelo") */

function updateTextTemplate(tplId, data, cb){
  /* encontra o template na lista local e atualiza */
  var tpl = null;
  for(var i=0;i<textTemplates.length;i++){
    if(textTemplates[i].id === tplId){ tpl = textTemplates[i]; break; }
  }
  if(!tpl){ if(cb) cb(); return; }
  var keys = Object.keys(data);
  for(var k=0;k<keys.length;k++) tpl[keys[k]] = data[keys[k]];
  cacheTemplates();
  renderTextModal();
  var gasData = { resource:'text_templates', action:'update', tplId: tplId, id: tplId };
  for(var j=0;j<keys.length;j++) gasData[keys[j]] = data[keys[j]];
  /* extras removido — GAS agora tem colunas dedicadas pra tudo */
  gas(gasData, function(err, d){
    if(err || !d || d.error){
      alert('Erro ao atualizar modelo: ' + (d && d.error ? d.error : (err ? err.message : 'desconhecido')));
    }
    if(cb) cb(err, d);
  }, 30000);
}

/* desenha um preview do modelo num mini-canvas (9:16) */
function drawTemplatePreview(canvas, tpl){
  var W = 135, H = 240;
  canvas.width = W; canvas.height = H;
  var g = canvas.getContext('2d');
  g.fillStyle = '#000';
  g.fillRect(0, 0, W, H);
  var sc = W / PROJ_W;
  g.save();
  g.scale(sc, sc);
  var mt = tpl.modelType || 1;
  if(mt === 2) drawTemplatePreview2(g, tpl);
  else if(mt === 3) drawTemplatePreview3(g, tpl);
  else drawTemplatePreview1(g, tpl);
  g.restore();
}
function drawTemplatePreview1(g, tpl){
  var lines = caseTxt(tpl.upper, tpl.text).split('\n').filter(function(l){ return l.length; });
  if(!lines.length) lines = [' '];
  var size = tpl.size;
  g.font = '700 ' + size + 'px "Montserrat", sans-serif';
  var lineH = Math.round(size * 1.04);
  var gapPct = tpl.lineGap == null ? 30 : tpl.lineGap;
  var gap = Math.round(size * gapPct / 100);
  var padH = Math.round(size * 0.28), padV = Math.round(size * 0.10);
  var barW = Math.max(9, Math.round(size * 0.24));   /* barra mais grossa, sem gap */
  var gapBar = 0;
  var maxW = 0, widths = [];
  for(var i=0;i<lines.length;i++){
    var w = g.measureText(lines[i]).width;
    widths.push(w); maxW = Math.max(maxW, w + padH*2);
  }
  var blockH = lines.length * (lineH + padV*2) + (lines.length - 1) * gap;
  var bx = (tpl.x != null ? tpl.x : 0.08) * PROJ_W, by = (tpl.y != null ? tpl.y : 0.5) * PROJ_H - blockH/2;
  g.fillStyle = '#e10600';
  g.fillRect(bx, by, barW, blockH);
  g.textBaseline = 'middle';
  g.font = '700 ' + size + 'px "Montserrat", sans-serif';
  var chipStartX = bx + barW + gapBar;
  for(var j=0;j<lines.length;j++){
    var chipW = widths[j] + padH*2;
    var chipH = lineH + padV*2;
    var rowY = by + j * (chipH + gap);
    g.fillStyle = '#ffffff';
    g.fillRect(chipStartX, rowY, chipW, chipH);
    g.fillStyle = '#0a0a0a';
    g.fillText(lines[j], chipStartX + padH, rowY + chipH/2 + size*0.04);
  }
}
function drawTemplatePreview2(g, tpl){
  var lines = caseTxt(tpl.upper, tpl.text).split('\n').filter(function(l){ return l.length; });
  if(!lines.length) lines = [' '];
  var size = tpl.size;
  g.font = '500 ' + size + 'px "Helvetica Neue", Helvetica, Arial, sans-serif';
  var lineH = Math.round(size * 1.15);
  var gapPct = tpl.lineGap == null ? 20 : tpl.lineGap;
  var gap = Math.round(size * gapPct / 100);
  var padH = tpl.padding != null ? tpl.padding : Math.round(size * 0.4);
  var padV = tpl.padV != null ? tpl.padV : Math.round(size * 0.2);
  var maxW = 0;
  for(var i=0;i<lines.length;i++) maxW = Math.max(maxW, g.measureText(lines[i]).width);
  var blockW = maxW + padH * 2;
  var blockH = lines.length * lineH + (lines.length - 1) * gap + padV * 2;
  var bx = (PROJ_W - blockW) / 2;
  var by = tpl.y != null ? tpl.y * PROJ_H - blockH / 2 : (PROJ_H - blockH) / 2;
  g.fillStyle = '#1c18c7';
  g.fillRect(bx, by, blockW, blockH);
  g.textBaseline = 'middle'; g.textAlign = 'center';
  g.font = '500 ' + size + 'px "Helvetica Neue", Helvetica, Arial, sans-serif';
  for(var j=0;j<lines.length;j++){
    var ty = by + padV + j * (lineH + gap) + lineH / 2;
    g.fillStyle = '#ffffff';
    g.fillText(lines[j], PROJ_W / 2, ty);
  }
  g.textAlign = 'left';
}
function drawTemplatePreview3(g, tpl){
  /* espelha o textLayout3/drawText3 (animação no estado final):
     degradê com a MESMA altura salva; 0 = fundo sólido (retângulos) */
  var gh = (tpl.gradHeight != null && tpl.gradHeight !== '') ? parseFloat(tpl.gradHeight) : 0.65;
  if(isNaN(gh)) gh = 0.65;
  var showBg = gh <= 0;
  if(!showBg){
    var grad = g.createLinearGradient(0, PROJ_H, 0, PROJ_H * (1 - gh));
    grad.addColorStop(0, '#1c18c7'); grad.addColorStop(1, 'rgba(28,24,199,0)');
    g.fillStyle = grad;
    g.fillRect(0, 0, PROJ_W, PROJ_H);
  }
  var emul = !upFlag(tpl.upper);   /* T desligado → small-caps emulado */
  var lines = caseTxt(tpl.upper, tpl.text).split('\n').filter(function(l){ return l.length; });
  if(!lines.length) lines = [' '];
  var size = tpl.size;
  g.font = '400 ' + size + 'px "Bebas Neue", sans-serif';
  var lineH = Math.round(size * 1.05);
  var gapPct = tpl.lineGap == null ? 10 : tpl.lineGap;
  var gap = Math.round(size * gapPct / 100);
  var padH = tpl.padding != null ? tpl.padding : Math.round(size * 0.3);
  var padV = tpl.padV != null ? tpl.padV : Math.round(size * 0.22);
  var chipH = lineH + padV * 2;
  /* degradê OFF = bloco único (margem única); ON = por linha (igual ao drawText3) */
  var maxW = 0;
  for(var mi=0;mi<lines.length;mi++) maxW = Math.max(maxW, bebasWidth(g, lines[mi], size, emul));
  var blockH = showBg
    ? (lines.length * lineH + (lines.length - 1) * gap + padV * 2)
    : (lines.length * chipH + (lines.length - 1) * gap);
  var bx = (tpl.x != null ? tpl.x : 0.08) * PROJ_W;
  var by = (tpl.y != null ? tpl.y : 0.75) * PROJ_H - blockH / 2;
  /* fundo sólido (degradê = 0): UM retângulo cobrindo todo o texto */
  if(showBg){
    g.fillStyle = '#1c18c7';
    g.fillRect(bx, by, maxW + padH * 2, blockH);
  }
  if(tpl.chapeu){
    var cs = tpl.chapeuSize || Math.round(size * 0.4);
    var cg = tpl.chapeuGap != null ? tpl.chapeuGap : Math.round(size * 0.15);
    g.fillStyle = '#fff'; g.textBaseline = 'middle'; g.textAlign = 'left';
    bebasFillText(g, caseTxt(tpl.chapeuUpper, tpl.chapeu), bx + padH, by - cg - cs * 0.6, cs, !upFlag(tpl.chapeuUpper));
  }
  g.textBaseline = 'alphabetic'; g.textAlign = 'left';
  for(var j=0;j<lines.length;j++){
    g.fillStyle = '#ffffff';
    var baseY = showBg
      ? (by + padV + j * (lineH + gap) + lineH * 0.5 + size * 0.35)
      : (by + j * (chipH + gap) + chipH / 2 + size * 0.35);
    bebasFillText(g, lines[j], bx + padH, baseY, size, emul);
  }
  g.textBaseline = 'middle';
}

/* monta um "tpl" com os campos da VERSÃO 2 do modelo (fallback pra V1) —
   usado pelo hover do card, que mostra a v2 daquele modelo */
function tplVariant2(tpl){
  function pick(k2, k1){ return (tpl[k2] != null && tpl[k2] !== '') ? tpl[k2] : tpl[k1]; }
  return {
    modelType: pick('modelType2', 'modelType'),
    text: pick('text2', 'text'), size: pick('size2', 'size'), lineGap: pick('lineGap2', 'lineGap'),
    x: pick('x2', 'x'), y: pick('y2', 'y'),
    padding: pick('padding2', 'padding'), padV: pick('padV2', 'padV'),
    chapeu: pick('chapeu2', 'chapeu'), chapeuSize: pick('chapeuSize2', 'chapeuSize'), chapeuGap: pick('chapeuGap2', 'chapeuGap'),
    showBg: pick('showBg2', 'showBg'), gradHeight: pick('gradHeight2', 'gradHeight'),
    upper: pick('upper2', 'upper'), chapeuUpper: pick('chapeuUpper2', 'chapeuUpper')
  };
}

/* categorias dos modelos de texto (abas do modal + seletor ao salvar) */
var TPL_CATS = [{ id:'carro', label:'Carro' }, { id:'moto', label:'Moto' }];
var tplModalCat = 'carro';   /* aba ativa do modal (padrão: carro) */
var tplModalCity = '';       /* filtro de cidade do modal ('' = todas) */
function tplCatOf(tpl){ return (tpl && String(tpl.category).toLowerCase() === 'moto') ? 'moto' : 'carro'; }

/* ══════════ CIDADES (capitais do BR) nos modelos de texto ══════════
   Cada modelo tem uma cidade (capital, 'nenhuma' ou vazio). O dropdown e o
   filtro do modal ordenam as capitais pelas mais usadas (contadas a cada
   render), com desempate alfabético. A 1ª opção é sempre "Nenhuma". */
var BR_CAPITALS = ['Aracaju','Belo Horizonte','Belém','Boa Vista','Brasília','Campo Grande','Cuiabá','Curitiba','Florianópolis','Fortaleza','Goiânia','João Pessoa','Macapá','Maceió','Manaus','Natal','Palmas','Porto Alegre','Porto Velho','Recife','Rio Branco','Rio de Janeiro','Salvador','São Luís','São Paulo','Teresina','Vitória'];
var cityUsage = {};   /* nome(minúsculo) → contagem de uso */
function tplCityOf(tpl){ return String((tpl && tpl.city) || ''); }

function loadCachedCityUsage(){
  try{ var s = localStorage.getItem('mce_city_usage'); if(s) cityUsage = JSON.parse(s) || {}; }catch(_){}
}
function loadCityUsage(cb){
  loadCachedCityUsage();
  populateCityControls();
  gas({ resource:'city_usage', action:'list' }, function(err, d){
    if(!err && d && Array.isArray(d.cities)){
      var m = {};
      d.cities.forEach(function(it){ if(it && it.city) m[String(it.city).toLowerCase()] = Number(it.count) || 0; });
      cityUsage = m;
      try{ localStorage.setItem('mce_city_usage', JSON.stringify(cityUsage)); }catch(_){}
      populateCityControls();
    }
    if(cb) cb();
  }, 30000);
}
/* capitais ordenadas: mais usadas primeiro; empate por ordem alfabética */
function orderedCapitals(){
  return BR_CAPITALS.slice().sort(function(a, b){
    var ua = cityUsage[a.toLowerCase()] || 0, ub = cityUsage[b.toLowerCase()] || 0;
    if(ub !== ua) return ub - ua;
    return a.localeCompare(b, 'pt-BR');
  });
}
/* dropdown do painel de texto: TODAS as capitais (ordenadas por uso) */
function populateCityControls(){
  var opts = orderedCapitals().map(function(c){ return '<option value="' + c + '">' + c + '</option>'; }).join('');
  var selEl = $('mce-text-city');
  if(selEl){
    var cur = selEl.value;
    selEl.innerHTML = '<option value="" disabled hidden>Cidade…</option><option value="nenhuma">Nenhuma</option>' + opts;
    selEl.value = cur || '';
  }
  populateCityFilter();
}
/* filtro do modal: SÓ as cidades que têm ao menos um modelo registrado
   NA CATEGORIA ATIVA (carro ou moto) */
function populateCityFilter(){
  var flt = $('mce-modal-city-filter');
  if(!flt) return;
  var present = {}, hasNone = false;
  textTemplates.forEach(function(t){
    if(tplCatOf(t) !== tplModalCat) return;   /* só a categoria escolhida */
    var cc = String((t && t.city) || '').trim();
    if(!cc || cc.toLowerCase() === 'nenhuma'){ hasNone = true; return; }
    present[cc] = true;
  });
  var caps = orderedCapitals().filter(function(c){ return present[c]; });
  Object.keys(present).forEach(function(c){ if(caps.indexOf(c) < 0) caps.push(c); });   /* segurança */
  var curF = flt.value;
  var html = '<option value="">Todas as cidades</option>';
  if(hasNone) html += '<option value="nenhuma">Nenhuma</option>';
  html += caps.map(function(c){ return '<option value="' + c + '">' + c + '</option>'; }).join('');
  flt.innerHTML = html;
  /* mantém o filtro atual se ainda existir; senão volta pra "todas" */
  var stillValid = (curF === '') || (curF === 'nenhuma' && hasNone) || (caps.indexOf(curF) >= 0);
  flt.value = stillValid ? curF : '';
  if(flt.value !== curF) tplModalCity = flt.value;
}
/* soma +1 de uso pras cidades dos textos do vídeo (chamado ao fim do export) */
function bumpCityUsageFromTimeline(){
  var set = {};
  clips.forEach(function(c){
    if(c.kind === 'text' && c.city && String(c.city).toLowerCase() !== 'nenhuma') set[c.city] = 1;
  });
  var cities = Object.keys(set);
  if(!cities.length) return;
  cities.forEach(function(c){ cityUsage[c.toLowerCase()] = (cityUsage[c.toLowerCase()] || 0) + 1; });
  try{ localStorage.setItem('mce_city_usage', JSON.stringify(cityUsage)); }catch(_){}
  populateCityControls();
  gas({ resource:'city_usage', action:'bump', cities: JSON.stringify(cities) }, function(){}, 30000);
}
/* o modelo bate com o filtro de cidade do modal? */
function tplCityMatch(tpl, filter){
  if(!filter) return true;
  var cc = tplCityOf(tpl).toLowerCase();
  if(filter === 'nenhuma') return !cc || cc === 'nenhuma';
  return cc === filter.toLowerCase();
}

/* abas Carro/Moto no topo do modal — criadas uma vez, entre o cabeçalho e o grid */
function ensureCatTabs(){
  var modal = document.querySelector('.mce-text-modal');
  if(!modal) return;
  var tabs = modal.querySelector('.mce-cat-tabs');
  if(!tabs){
    tabs = document.createElement('div');
    tabs.className = 'mce-cat-tabs';
    TPL_CATS.forEach(function(cat){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mce-cat-tab';
      b.dataset.cat = cat.id;
      b.textContent = cat.label;
      b.addEventListener('click', function(){ tplModalCat = cat.id; renderTextModal(); });
      tabs.appendChild(b);
    });
    var grid = modal.querySelector('.mce-text-modal-grid');
    modal.insertBefore(tabs, grid);
  }
  tabs.querySelectorAll('.mce-cat-tab').forEach(function(b){
    b.classList.toggle('is-on', b.dataset.cat === tplModalCat);
  });
}

/* renderiza o grid do modal (só os modelos da categoria/aba ativa) */
function renderTextModal(){
  ensureCatTabs();
  var grid = $('mce-text-modal-grid');
  /* limpa tudo menos o card "Novo" */
  var cards = grid.querySelectorAll('.mce-tpl-card:not(.mce-tpl-new)');
  for(var i=0;i<cards.length;i++) cards[i].remove();
  /* filtro de cidade: só cidades com modelo, refletindo o valor atual */
  populateCityFilter();
  /* insere modelos salvos da categoria ativa (e da cidade filtrada) */
  textTemplates.filter(function(t){ return tplCatOf(t) === tplModalCat && tplCityMatch(t, tplModalCity); }).forEach(function(tpl){
    var card = document.createElement('div');
    card.className = 'mce-tpl-card';
    card.title = 'Duplo clique ou clique para adicionar';
    /* preview */
    var prev = document.createElement('div');
    prev.className = 'mce-tpl-preview';
    var cvs = document.createElement('canvas');
    drawTemplatePreview(cvs, tpl);
    prev.appendChild(cvs);
    card.appendChild(prev);
    /* hover no card: mostra a V2 do modelo; sai = volta pra V1 */
    card.addEventListener('mouseenter', function(){ drawTemplatePreview(cvs, tplVariant2(tpl)); });
    card.addEventListener('mouseleave', function(){ drawTemplatePreview(cvs, tpl); });
    /* label */
    var lbl = document.createElement('span');
    lbl.className = 'mce-tpl-label';
    lbl.textContent = tpl.name || (tpl.text || '').split('\n')[0].slice(0, 20) || 'MODELO';
    card.appendChild(lbl);
    /* botão renomear (fica salvo no banco) */
    var ren = document.createElement('button');
    ren.className = 'mce-tpl-ren';
    ren.innerHTML = '<svg viewBox="0 0 24 24" width="10" height="10" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5z"/></svg>';
    ren.title = 'Renomear modelo';
    ren.addEventListener('click', function(e){
      e.stopPropagation();
      openNameModal(tpl.name || '', function(novo, cat){
        renameTextTemplate(tpl, novo, cat);
      }, { category: tplCatOf(tpl) });
    });
    card.appendChild(ren);
    /* botão excluir */
    var del = document.createElement('button');
    del.className = 'mce-tpl-del';
    del.innerHTML = '&times;';
    del.title = 'Excluir modelo';
    del.addEventListener('click', function(e){
      e.stopPropagation();
      if(!confirm('Excluir este modelo de texto?')) return;
      deleteTextTemplate(tpl.id);
    });
    card.appendChild(del);
    /* clique simples ou duplo → adiciona + memoriza qual modelo foi usado */
    card.addEventListener('dblclick', function(e){ e.preventDefault(); selectedTemplateId = tpl.id; addTextFromTemplate(tpl); });
    card.addEventListener('click', function(e){
      if(e.target.closest('.mce-tpl-del') || e.target.closest('.mce-tpl-ren')) return;
      selectedTemplateId = tpl.id;
      addTextFromTemplate(tpl);
    });
    grid.appendChild(card);
  });
}

var textModalApplyId = null;   /* id do clipe de texto que vai receber o modelo escolhido */
function openTextModal(trackId){
  pendingTextTrackId = trackId;
  renderTextModal();
  $('mce-text-modal-overlay').classList.add('is-open');
}
function closeTextModal(){
  $('mce-text-modal-overlay').classList.remove('is-open');
  pendingTextTrackId = null;
  textModalApplyId = null;
}

/* botão "todos os modelos" do painel de texto: abre o modal em modo trocar */
on('mce-all-tpl', 'click', function(){
  var c = sel();
  if(!c || c.kind !== 'text') return;
  openTextModal(null);
  textModalApplyId = c.id;
});

function addTextFromTemplate(tpl){
  var mt = tpl.modelType || 1;
  /* modo "trocar modelo": aplica APENAS na VERSÃO ativa (V1/V2) do clipe.
     Com a V2 selecionada, entra a V2 do modelo escolhido — inclusive o TIPO
     de modelo e as configurações de texto dela. A outra versão não muda. */
  if(textModalApplyId){
    var c0 = byId(textModalApplyId);
    closeTextModal();
    if(c0 && c0.kind === 'text'){
      snapshot();
      ensureV2(c0);
      var D0 = tData(c0);
      var V = textVariant === 1 ? '2' : '';
      var pick = function(k){
        var v = tpl[k + V];
        if(V && (v == null || v === '')) v = tpl[k];   /* V2 vazia no modelo → cai na V1 dele */
        return v;
      };
      D0.modelType = Number(pick('modelType')) || 1;
      if(pick('text')) D0.text = pick('text');
      if(pick('x') != null && pick('x') !== '') D0.x = Number(pick('x'));
      if(pick('y') != null && pick('y') !== '') D0.y = Number(pick('y'));
      if(pick('size')) D0.size = Number(pick('size'));
      if(pick('lineGap') != null && pick('lineGap') !== '') D0.lineGap = Number(pick('lineGap'));
      if(pick('padding') != null && pick('padding') !== '') D0.padding = Number(pick('padding'));
      if(pick('padV') != null && pick('padV') !== '') D0.padV = Number(pick('padV'));
      if(pick('chapeu') != null) D0.chapeu = pick('chapeu');
      if(pick('chapeuSize') != null && pick('chapeuSize') !== '') D0.chapeuSize = Number(pick('chapeuSize'));
      if(pick('chapeuGap') != null && pick('chapeuGap') !== '') D0.chapeuGap = Number(pick('chapeuGap'));
      if(pick('showBg') != null) D0.showBg = String(pick('showBg')) === 'true';
      if(pick('gradHeight') != null && pick('gradHeight') !== '') D0.gradHeight = parseFloat(pick('gradHeight'));
      D0.upper = upFlag(pick('upper'));
      D0.chapeuUpper = upFlag(pick('chapeuUpper'));
      if(textVariant === 0) c0.name = (String(c0.text).split('\n')[0] || 'TEXTO').slice(0, 18);
      selectClip(c0);
      renderAll(); drawFrame();
    }
    return;
  }
  closeTextModal();
  snapshot();
  var tr = pendingTextTrackId ? trackById(pendingTextTrackId) : firstTrack('text');
  if(!tr) tr = firstTrack('text');
  var vEnd = 0;
  clips.forEach(function(cc){ if(cc.kind === 'video') vEnd = Math.max(vEnd, cc.start + cc.dur); });
  /* cadeado LIGADO: começa no 0 e cobre o vídeo. Cadeado DESLIGADO: entra na
     posição do playhead (player rosa), sobrescrevendo o que estiver por baixo */
  var start0 = textLockDur ? 0 : snap(tCur);
  var d = (textLockDur && vEnd > FRAME) ? snap(vEnd) : 4;
  var c = {
    id: uid(), kind:'text', trackId: tr.id,
    start: start0, dur: d, in: 0, srcDur: 0, autoDur: textLockDur && vEnd > FRAME,
    el: null, name: (tpl.text || 'TEXTO').split('\n')[0].slice(0, 18), pair: null, muted:false,
    modelType: mt,
    city: tpl.city || '',   /* herda a cidade do modelo */
    text: tpl.text || 'SEU TEXTO\nAQUI',
    x: tpl.x != null ? tpl.x : (mt === 2 ? 0.5 : 0.08),
    y: tpl.y != null ? tpl.y : (mt === 3 ? 0.75 : 0.5),
    size: tpl.size || Math.round(PROJ_W * (mt === 3 ? 0.12 : 0.085)),
    lineGap: tpl.lineGap != null ? tpl.lineGap : (mt === 2 ? 20 : (mt === 3 ? 10 : 30)),
    padding: tpl.padding != null ? tpl.padding : undefined,
    padV: tpl.padV != null ? tpl.padV : undefined,
    chapeu: tpl.chapeu || '', chapeuSize: tpl.chapeuSize, chapeuGap: tpl.chapeuGap, showBg: !!tpl.showBg,
    gradHeight: (tpl.gradHeight != null && tpl.gradHeight !== '') ? parseFloat(tpl.gradHeight) : (mt === 3 ? 0.65 : undefined),
    upper: upFlag(tpl.upper), chapeuUpper: upFlag(tpl.chapeuUpper)
  };
  c.v2 = {
    modelType: (tpl.modelType2 != null && tpl.modelType2 !== '') ? (Number(tpl.modelType2) || 1) : mt,
    text:    tpl.text2    != null ? tpl.text2    : c.text,
    x:       tpl.x2       != null ? tpl.x2       : c.x,
    y:       tpl.y2       != null ? tpl.y2       : c.y,
    size:    tpl.size2    != null ? tpl.size2    : c.size,
    lineGap: tpl.lineGap2 != null ? tpl.lineGap2 : c.lineGap,
    padding: tpl.padding2 != null ? tpl.padding2 : c.padding,
    padV:    tpl.padV2    != null ? tpl.padV2    : c.padV,
    chapeu:  tpl.chapeu2  != null ? tpl.chapeu2  : c.chapeu,
    chapeuSize: tpl.chapeuSize2 != null ? tpl.chapeuSize2 : c.chapeuSize,
    chapeuGap:  tpl.chapeuGap2  != null ? tpl.chapeuGap2  : c.chapeuGap,
    showBg:  tpl.showBg2  != null ? tpl.showBg2  : c.showBg,
    gradHeight: (tpl.gradHeight2 != null && tpl.gradHeight2 !== '') ? parseFloat(tpl.gradHeight2) : c.gradHeight,
    upper: (tpl.upper2 != null && tpl.upper2 !== '') ? upFlag(tpl.upper2) : c.upper,
    chapeuUpper: (tpl.chapeuUpper2 != null && tpl.chapeuUpper2 !== '') ? upFlag(tpl.chapeuUpper2) : c.chapeuUpper
  };
  clips.push(c);
  overwriteMoved([c]);
  selectClip(c);
  renderAll(); drawFrame();
}

function addTextClip(trackId){
  openTextModal(trackId);
}

function ensureV2(c){
  if(!c.v2) c.v2 = { text: c.text, x: c.x, y: c.y, size: c.size, lineGap: c.lineGap,
    padding: c.padding, padV: c.padV, chapeu: c.chapeu, chapeuSize: c.chapeuSize, chapeuGap: c.chapeuGap, showBg: c.showBg, gradHeight: c.gradHeight,
    modelType: c.modelType, upper: c.upper, chapeuUpper: c.chapeuUpper };
  if(c.v2.modelType == null) c.v2.modelType = c.modelType;
  return c.v2;
}

function syncTextPanel(){
  var c = sel();
  var panel = $('mce-text-panel');
  if(c && c.kind === 'text'){
    panel.style.display = 'block';
    ensureV2(c);
    var D = tData(c);
    var mt = tModel(c);   /* modelo da versão ativa */
    /* título do painel conforme o tipo */
    var headEl = panel.querySelector('.mc-panel-head h2');
    if(headEl) headEl.textContent = mt === 2 ? 'Texto centralizado' : mt === 3 ? 'Texto degradê' : 'Texto animado';
    if(document.activeElement !== $('mce-text-input')) $('mce-text-input').value = D.text;
    var szIn = $('mce-text-size');
    if(szIn){
      szIn.min = (mt === 2) ? 30 : 20;   /* modelo 2: mínimo 30; demais: 20 */
      szIn.value = D.size;
    }
    var lh = $('mce-text-lineh');
    if(lh){
      /* modelo 3 aceita altura de linha NEGATIVA (linhas mais coladas) */
      lh.min = mt === 3 ? -60 : 0;
      lh.value = D.lineGap == null ? 30 : D.lineGap;
    }
    var tb1 = $('mce-copy-tab1'), tb2 = $('mce-copy-tab2');
    if(tb1) tb1.classList.toggle('is-on', textVariant === 0);
    if(tb2) tb2.classList.toggle('is-on', textVariant === 1);
    /* botões T (uppercase) da versão ativa */
    /* modelo 3 (Bebas Neue, já caixa-alta): sem opção de uppercase nos campos */
    var upBtn = $('mce-text-upper');
    if(upBtn){ upBtn.classList.toggle('is-on', upFlag(D.upper)); upBtn.style.display = (mt === 3) ? 'none' : ''; }
    var chUpBtn = $('mce-text-chapeu-upper');
    if(chUpBtn){ chUpBtn.classList.toggle('is-on', upFlag(D.chapeuUpper)); chUpBtn.style.display = (mt === 3) ? 'none' : ''; }
    /* o uppercase também vale pro CONTEÚDO do bloco de texto (caixa e chapéu) */
    var txtIn = $('mce-text-input');
    if(txtIn) txtIn.classList.toggle('is-upper', upFlag(D.upper));
    var chapInp = $('mce-text-chapeu');
    if(chapInp) chapInp.classList.toggle('is-upper', upFlag(D.chapeuUpper));
    /* controles extras (modelo 2: margem | modelo 3: chapéu, distância, fundo) */
    var padRow = $('mce-text-padding-row');
    var padVRow = $('mce-text-padv-row');
    var chapRow = $('mce-text-chapeu-row');
    var chapSizeRow = $('mce-text-chapeu-size-row');
    var chapGapRow = $('mce-text-chapeu-gap-row');
    /* margens (lateral/vertical): modelo 2 sempre; modelo 3 só com o degradê
       desligado (bloco único atrás do texto) */
    var m3BgOff = (mt === 3 && D.gradHeight != null && D.gradHeight <= 0);
    var showMargins = (mt === 2 || m3BgOff);
    if(padRow) padRow.style.display = showMargins ? '' : 'none';
    if(padVRow) padVRow.style.display = showMargins ? '' : 'none';
    if(chapRow) chapRow.style.display = mt === 3 ? '' : 'none';
    if(chapSizeRow) chapSizeRow.style.display = mt === 3 ? '' : 'none';
    if(chapGapRow) chapGapRow.style.display = mt === 3 ? '' : 'none';
    if(showMargins){
      var padIn = $('mce-text-padding');
      var defPadH = mt === 3 ? Math.round(D.size * 0.3) : Math.round(D.size * 0.4);
      if(padIn) padIn.value = D.padding != null ? D.padding : defPadH;
      var padVIn = $('mce-text-padv');
      var defPadV = mt === 3 ? Math.round(D.size * 0.22) : Math.round(D.size * 0.2);
      if(padVIn) padVIn.value = D.padV != null ? D.padV : defPadV;
    }
    var ghRow = $('mce-text-grad-height-row');
    if(ghRow) ghRow.style.display = mt === 3 ? '' : 'none';
    if(mt === 3){
      var chapIn = $('mce-text-chapeu');
      if(chapIn && document.activeElement !== chapIn) chapIn.value = D.chapeu || '';
      var csIn = $('mce-text-chapeu-size');
      if(csIn) csIn.value = D.chapeuSize || Math.round(D.size * 0.4);
      var cgIn = $('mce-text-chapeu-gap');
      if(cgIn) cgIn.value = D.chapeuGap != null ? D.chapeuGap : Math.round(D.size * 0.15);
      /* showBg derivado de gradHeight === 0 */
      var ghIn = $('mce-text-grad-height');
      if(ghIn) ghIn.value = D.gradHeight != null ? Math.round(D.gradHeight * 100) : 65;
    }
    /* cidade: dropdown sempre visível pro clipe de texto; valor = cidade do clipe
       (vazio = placeholder "Cidade…", obrigatório na hora de salvar o modelo) */
    var cityRow = $('mce-text-city-row');
    if(cityRow) cityRow.style.display = '';
    var citySel = $('mce-text-city');
    if(citySel){
      if(!citySel.options || citySel.options.length <= 2) populateCityControls();
      citySel.value = c.city || '';
    }
  } else {
    panel.style.display = 'none';
  }
  updateSideEmpty();
}

/* abas Copy 1 / Copy 2: trocam a versão ativa (preview + caixa + sliders) */
function setTextVariant(v){
  if(textVariant === v) return;
  textVariant = v;
  renderAll(); drawFrame();
}
on('mce-copy-tab1', 'click', function(){ setTextVariant(0); });
on('mce-copy-tab2', 'click', function(){ setTextVariant(1); });

on('mce-text-input', 'focus', function(){ if(sel() && sel().kind === 'text') snapshot(); });
on('mce-text-size', 'mousedown', function(){ if(sel() && sel().kind === 'text') snapshot(); });
on('mce-text-input', 'input', function(){
  var c = sel();
  if(c && c.kind === 'text'){
    tData(c).text = this.value;
    /* o nome do clipe segue a Copy 1 */
    if(textVariant === 0) c.name = (this.value.split('\n')[0] || 'TEXTO').slice(0, 18);
    renderClips(); drawFrame();
  }
});
on('mce-text-size', 'input', function(){
  var c = sel();
  if(c && c.kind === 'text'){ tData(c).size = parseInt(this.value, 10) || 90; drawFrame(); }
});
on('mce-text-lineh', 'mousedown', function(){ if(sel() && sel().kind === 'text') snapshot(); });
on('mce-text-lineh', 'input', function(){
  var c = sel();
  if(c && c.kind === 'text'){
    var v = parseInt(this.value, 10);
    tData(c).lineGap = isNaN(v) ? 30 : v;
    drawFrame();
  }
});

/* ── controles extras para modelo 2 e 3 ── */
on('mce-text-padding', 'mousedown', function(){ if(sel() && sel().kind === 'text') snapshot(); });
on('mce-text-padding', 'input', function(){
  var c = sel();
  if(c && c.kind === 'text'){ tData(c).padding = parseInt(this.value, 10) || 0; drawFrame(); }
});
on('mce-text-padv', 'mousedown', function(){ if(sel() && sel().kind === 'text') snapshot(); });
on('mce-text-padv', 'input', function(){
  var c = sel();
  if(c && c.kind === 'text'){ tData(c).padV = parseInt(this.value, 10) || 0; drawFrame(); }
});
on('mce-text-chapeu', 'focus', function(){ if(sel() && sel().kind === 'text') snapshot(); });
on('mce-text-chapeu', 'input', function(){
  var c = sel();
  if(c && c.kind === 'text'){ tData(c).chapeu = this.value; drawFrame(); }
});
on('mce-text-chapeu-size', 'mousedown', function(){ if(sel() && sel().kind === 'text') snapshot(); });
on('mce-text-chapeu-size', 'input', function(){
  var c = sel();
  if(c && c.kind === 'text'){ tData(c).chapeuSize = parseInt(this.value, 10) || 30; drawFrame(); }
});
on('mce-text-chapeu-gap', 'mousedown', function(){ if(sel() && sel().kind === 'text') snapshot(); });
on('mce-text-chapeu-gap', 'input', function(){
  var c = sel();
  if(c && c.kind === 'text'){ tData(c).chapeuGap = parseInt(this.value, 10) || 0; drawFrame(); }
});
/* botões T: liga/desliga o uppercase da versão ativa (texto e chapéu) */
on('mce-text-upper', 'click', function(){
  var c = sel();
  if(!c || c.kind !== 'text') return;
  snapshot();
  var D = tData(c);
  D.upper = !upFlag(D.upper);
  syncTextPanel(); drawFrame();
});
on('mce-text-chapeu-upper', 'click', function(){
  var c = sel();
  if(!c || c.kind !== 'text') return;
  snapshot();
  var D = tData(c);
  D.chapeuUpper = !upFlag(D.chapeuUpper);
  syncTextPanel(); drawFrame();
});
/* showBg agora é derivado: gradHeight === 0 → fundo sólido */
on('mce-text-grad-height', 'mousedown', function(){ if(sel() && sel().kind === 'text') snapshot(); });
on('mce-text-grad-height', 'input', function(){
  var c = sel();
  if(c && c.kind === 'text'){
    tData(c).gradHeight = parseInt(this.value, 10) / 100;
    /* degradê 0 = bloco único → mostra/oculta as margens lateral/vertical na hora */
    syncTextPanel();
    drawFrame();
  }
});

/* ══════════ TRIPRANK / VELOCÍMETRO ══════════ */
function addSpeedClip(trackId){
  snapshot();
  /* triprank entra numa faixa de vídeo (não existe mais faixa "speed") */
  var tr = trackId ? trackById(trackId) : mainTrack('video');
  if(!tr) tr = mainTrack('video');
  var c = {
    id: uid(), kind:'speed', trackId: tr.id,
    start: 0, dur: 10, in: 0, srcDur: 0,   /* entra sempre no INÍCIO da faixa */
    el: null, name: 'TRIPRANK', pair: null, muted:false,
    speedTime: 2.92,  /* tempo 0-100 km/h em segundos (input do usuário) */
    x: 0.5, y: 0.18,  /* x travado no centro; y = TOPO do bloco (normalizado) */
    scale: 0.8        /* tamanho do bloco (redimensionável no painel) */
  };
  clips.push(c);
  overwriteMoved([c]);   /* caiu por cima de outro TripRank? o de baixo é cortado */
  selectClip(c);
  renderAll(); drawFrame();
}

/* física: duas fases — aceleração constante até 100km/h, depois drag */
var FPS24 = 24;                    /* fps de trabalho */
var DOTS_LIT_END = 2 + 12/FPS24;   /* 2:12 — última bolinha vermelha acende (1 a cada 12f) */
var DOTS_GREEN_T = 2 + 20/FPS24;   /* 2:20 — todas ficam verdes (largada) */
var DOTS_FADE_A  = 3 + 7/FPS24;    /* 3:07 — começam a perder opacidade */
var DOTS_FADE_B  = 3 + 17/FPS24;   /* 3:17 — somem por completo */
var DRAG_N  = 1.8911;    /* calibrado p/ 0-200 = 3.22 × t100 (9.66s com t100=3s) */
var VMAX_KMH = 244;      /* velocidade máxima — trava em 244 ao chegar nos 800m */
var REF_VEND = VMAX_KMH / 3.6;  /* extensão linear após 800m (m/s) */

/* tabelas de referência distância×tempo — duas âncoras de t100:
   t100=3s: 30m-2.14 | 200m-6.32 | 300m-8.09 | 400m-9.59  | 800m-15.95
   t100=4s: 30m-2.85 | 200m-8.42 | 300m-10.78| 400m-12.79 | 800m-21.26
   para outros t100: interpolação/extrapolação linear entre as âncoras */
var REF_T100_A = 3.0, REF_T100_B = 4.0;
var REF_D  = [0, 30,   200,  300,   400,   800];
var REF_TA = [0, 2.14, 6.32, 8.09,  9.59,  15.95];
var REF_TB = [0, 2.85, 8.42, 10.78, 12.79, 21.26];

/* monta curva (tempos + slopes monotônicos Fritsch-Carlson) p/ um t100 */
var _speedCurveCache = {};
function speedCurve(t100){
  var key = String(t100);
  if(_speedCurveCache[key]) return _speedCurveCache[key];
  var n = REF_D.length, i;
  var T = new Array(n);
  for(i=0;i<n;i++) T[i] = REF_TA[i] + (REF_TB[i] - REF_TA[i]) * (t100 - REF_T100_A);
  var h = [], dl = [];
  for(i=0;i<n-1;i++){ h.push(T[i+1]-T[i]); dl.push((REF_D[i+1]-REF_D[i])/(T[i+1]-T[i])); }
  var M = new Array(n); M[0] = 0; M[n-1] = REF_VEND;
  for(i=1;i<n-1;i++){
    var w1 = 2*h[i] + h[i-1], w2 = h[i] + 2*h[i-1];
    M[i] = (w1 + w2) / (w1/dl[i-1] + w2/dl[i]);
  }
  var cv = { T:T, M:M };
  _speedCurveCache[key] = cv;
  return cv;
}

/* distância na curva de referência (Hermite monotônico) */
function refDist(cv, tau){
  var T = cv.T, M = cv.M, n = T.length;
  if(tau <= 0) return 0;
  if(tau >= T[n-1]) return REF_D[n-1] + REF_VEND * (tau - T[n-1]);
  var i = n - 2;
  for(var k=1;k<n;k++){ if(tau <= T[k]){ i = k-1; break; } }
  var h = T[i+1] - T[i], x = (tau - T[i]) / h, x1 = 1 - x;
  return (1+2*x)*x1*x1*REF_D[i] + x*x1*x1*h*M[i]
       + x*x*(3-2*x)*REF_D[i+1] + x*x*(x-1)*h*M[i+1];
}
/* inverso: tempo p/ atingir distância dd */
function refTimeForDist(cv, dd){
  var T = cv.T, n = T.length;
  if(dd <= 0) return 0;
  if(dd >= REF_D[n-1]) return T[n-1] + (dd - REF_D[n-1]) / REF_VEND;
  var i = n - 2;
  for(var k=1;k<n;k++){ if(dd <= REF_D[k]){ i = k-1; break; } }
  var lo = T[i], hi = T[i+1];
  for(var it=0;it<50;it++){
    var mid = (lo + hi) / 2;
    if(refDist(cv, mid) < dd) lo = mid; else hi = mid;
  }
  return (lo + hi) / 2;
}

function speedCalc(c, localT){
  var t100 = c.speedTime || 2.92;
  var v100 = 100 / 3.6;             /* 27.778 m/s */
  var a0   = v100 / t100;           /* aceleração fase 1 */
  var np1  = DRAG_N + 1;            /* n+1 */
  var curve = speedCurve(t100);     /* curva distância×tempo p/ este t100 */

  /* ── fase dos dots: acendem 1 a cada 12 frames, sem fade-in ── */
  var green = localT >= DOTS_GREEN_T;
  var dots = [];
  for(var d=0;d<5;d++){
    var tOn = (d + 1) * (DOTS_LIT_END / 5);
    dots.push(green ? 'green' : (localT >= tOn ? 'red' : 'off'));
  }
  var dotsAlpha = 0;
  if(localT < DOTS_FADE_A) dotsAlpha = 1;
  else if(localT < DOTS_FADE_B) dotsAlpha = 1 - (localT - DOTS_FADE_A) / (DOTS_FADE_B - DOTS_FADE_A);
  var dotsComplete = green;   /* largada = luz verde */

  /* tempo real de aceleração (após a luz verde) */
  var T = dotsComplete ? localT - DOTS_GREEN_T : 0;

  /* ── velocidade atual ── */
  var vMs, vKmh;
  if(T <= t100){
    vMs  = a0 * T;                   /* fase 1: constante */
  } else {
    /* fase 2: v = v100 * [np1*T/t100 - DRAG_N]^(1/np1) */
    var u = np1 * T / t100 - DRAG_N;
    vMs = v100 * Math.pow(u, 1/np1);
  }
  vKmh = Math.min(vMs * 3.6, VMAX_KMH);   /* trava em 244 km/h */

  /* ── distância atual (curva de referência) ── */
  var dist = refDist(curve, T);

  /* ── helpers p/ tempo de milestone ── */
  function timeForDist(dd){
    return refTimeForDist(curve, dd);
  }
  function timeForSpeed(vTarget){
    var vT = vTarget / 3.6;
    if(vT <= v100) return t100 * vT / v100;
    /* fase 2: t = t100*((vT/v100)^np1 + DRAG_N) / np1 */
    return t100 * (Math.pow(vT/v100, np1) + DRAG_N) / np1;
  }

  /* ── milestones ── */
  var t0_200 = timeForSpeed(200);
  /* time = valor exibido; at = instante real em que é atingido (p/ 100-200 são diferentes) */
  var milestones = [
    { label:'30m',         time: timeForDist(30) },
    { label:'0-100km/h',   time: t100 },
    { label:'200m',        time: timeForDist(200) },
    { label:'300m',        time: timeForDist(300) },
    { label:'400m',        time: timeForDist(400) },
    { label:'100-200km/h', time: t0_200 - t100, at: t0_200 },
    { label:'0-200km/h',   time: t0_200 },
    { label:'800m',        time: timeForDist(800) }
  ];

  /* revelação sequencial: um milestone só conclui quando todos os
     anteriores já concluíram — mesmo que, em segundos, tenha sido
     atingido antes (ex.: 100-200km/h nunca aparece antes de 300m) */
  var prevDone = true;
  for(var i=0;i<milestones.length;i++){
    var m = milestones[i];
    if(prevDone && T >= (m.at != null ? m.at : m.time)) m.status = 'done';
    else {
      m.status = prevDone ? 'active' : 'pending';
      prevDone = false;
    }
  }

  return {
    speed: dotsComplete ? Math.min(VMAX_KMH, Math.round(vKmh)) : 0,
    dist: dist,
    milestones: milestones,
    dots: dots,
    dotsComplete: dotsComplete,
    dotsAlpha: dotsAlpha,
    pct: Math.min(1, vKmh / 100),
    accelT: T,
    localT: localT
  };
}

/* fonte do overlay (TripRank = fonte custom via @font-face no editor.html) */
var SPEED_FONT = '"TripRank","Bebas Neue",ui-monospace,Consolas,monospace';

/* logo TripRank */
var TRIP_LOGO_OK = false;
var TRIP_LOGO = new Image();
TRIP_LOGO.crossOrigin = 'anonymous';
TRIP_LOGO.onload = function(){ TRIP_LOGO_OK = true; try{ drawFrame(); }catch(e){} };
TRIP_LOGO.onerror = function(){ TRIP_LOGO_OK = false; try{ drawFrame(); }catch(e){} };
TRIP_LOGO.src = 'https://cdn.shopify.com/s/files/1/0719/0174/1228/files/tripr.png?v=1784083448';
if(document.fonts && document.fonts.load){
  document.fonts.load('700 80px TripRank').then(function(){ try{ drawFrame(); }catch(e){} }).catch(function(){});
  document.fonts.load('400 30px TripRank').then(function(){ try{ drawFrame(); }catch(e){} }).catch(function(){});
}

function speedRoundRect(x, y, w, h, r){
  ctx.beginPath();
  ctx.moveTo(x+r, y);
  ctx.arcTo(x+w, y, x+w, y+h, r);
  ctx.arcTo(x+w, y+h, x, y+h, r);
  ctx.arcTo(x, y+h, x, y, r);
  ctx.arcTo(x, y, x+w, y, r);
  ctx.closePath();
}

function drawSpeed(c, t){
  /* c.in = offset de animação (clipe cortado continua de onde estava) */
  var localT = (t - c.start) + (c.in || 0);
  var S = speedCalc(c, localT);

  /* milestones visíveis (só aparecem depois da largada) */
  var visibleMs = [];
  if(S.dotsComplete){
    for(var i=0;i<S.milestones.length;i++){
      var m = S.milestones[i];
      if(m.status === 'done' || m.status === 'active') visibleMs.push(m);
    }
  }

  /* dimensões do bloco */
  var boxW = 540, boxH_base = 280;
  var msRowH = 54;
  var msBlock = visibleMs.length * msRowH;
  var msGap = visibleMs.length > 0 ? 32 : 0;
  var boxH = boxH_base + msGap + msBlock;

  /* sempre centralizado no frame; c.y é o TOPO do bloco (cresce pra baixo);
     c.scale redimensiona tudo em torno do topo-centro */
  var scl = c.scale || 0.8;
  var topY = (c.y != null ? c.y : 0.18) * PROJ_H;
  ctx.save();
  ctx.translate(PROJ_W / 2, topY);
  ctx.scale(scl, scl);
  var cx = 0;
  var bx = -boxW/2, by = 0;

  /* ── fundo: retângulo translúcido (cantos retos) atrás de tudo ── */
  var padBg = 14;
  ctx.fillStyle = 'rgba(0,0,0,0.35)';
  ctx.fillRect(bx - padBg, by - padBg, boxW + padBg*2, boxH + padBg*2);

  /* ── header: logo direto sobre o vídeo (sem faixa branca), com sombra ── */
  var headH = 76;
  if(TRIP_LOGO_OK && TRIP_LOGO.width > 0){
    var lh = 42, lw = lh * (TRIP_LOGO.width / TRIP_LOGO.height);
    if(lw > boxW - 60){ lw = boxW - 60; lh = lw * (TRIP_LOGO.height / TRIP_LOGO.width); }
    ctx.save();
    /* bolinha vermelha na esquerda do bloco */
    ctx.fillStyle = '#ef4444';
    ctx.beginPath(); ctx.arc(bx + 28, by + headH/2, 8, 0, Math.PI*2); ctx.fill();
    ctx.drawImage(TRIP_LOGO, cx - lw/2, by + (headH - lh)/2, lw, lh);
    ctx.restore();
  } else {
    /* fallback enquanto a logo carrega */
    ctx.save();
    ctx.fillStyle = '#ef4444';
    ctx.beginPath(); ctx.arc(bx + 28, by + headH/2, 8, 0, Math.PI*2); ctx.fill();
    ctx.font = '700 44px ' + SPEED_FONT;
    ctx.fillStyle = '#ffffff';
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';
    ctx.fillText('TripRank', cx + 10, by + headH/2 + 2);
    ctx.restore();
  }

  /* ── velocidade grande (centralizada) ── */
  ctx.save();
  ctx.font = '700 84px ' + SPEED_FONT;
  ctx.fillStyle = '#ffffff';
  ctx.textBaseline = 'middle';
  ctx.textAlign = 'center';
  ctx.fillText(S.speed + ' km/h', cx, by + 172);
  ctx.restore();

  /* ── 5 dots (vermelhas → verdes na largada → fade-out) ── */
  if(S.dotsAlpha > 0){
    var dotY = by + 240;
    var dotSpacing = 34;   /* mais próximas */
    var dotStartX = cx - (dotSpacing * 2);
    ctx.save();
    ctx.globalAlpha = S.dotsAlpha;
    for(var d=0;d<5;d++){
      var ddx = dotStartX + d * dotSpacing;
      var st = S.dots[d];
      ctx.beginPath();
      ctx.arc(ddx, dotY, 14, 0, Math.PI*2);   /* maiores */
      if(st === 'off'){
        ctx.fillStyle = '#4d1411';           /* apagada: vermelho escuro */
        ctx.fill();
      } else {
        ctx.fillStyle = st === 'green' ? '#22dd55' : '#ef4444';
        ctx.fill();
      }
      /* borda interna de 1px preta (50% opacidade) */
      ctx.beginPath();
      ctx.arc(ddx, dotY, 13.5, 0, Math.PI*2);
      ctx.lineWidth = 1;
      ctx.strokeStyle = 'rgba(0,0,0,0.5)';
      ctx.stroke();
    }
    ctx.restore();
  }

  /* ── milestones (dot + label verdes, tempo branco à direita) ── */
  if(visibleMs.length > 0){
    var msY = by + boxH_base + msGap;
    ctx.save();
    ctx.font = '700 27px ' + SPEED_FONT;
    for(var mi=0;mi<visibleMs.length;mi++){
      var ms = visibleMs[mi];
      var rowY = msY + mi * msRowH;
      var done = ms.status === 'done';

      /* dot de status */
      ctx.beginPath();
      ctx.arc(bx + 28, rowY + 5, 7, 0, Math.PI*2);
      ctx.fillStyle = done ? '#22dd55' : '#ffffff';
      ctx.fill();

      /* label (sempre branco) */
      ctx.fillStyle = '#ffffff';
      ctx.textBaseline = 'middle';
      ctx.textAlign = 'left';
      ctx.fillText(ms.label, bx + 48, rowY + 5);

      /* tempo ou ? */
      ctx.textAlign = 'right';
      if(done){
        ctx.fillStyle = '#ffffff';
        ctx.fillText(ms.time.toFixed(2) + 's', bx + boxW - 28, rowY + 5);
      } else {
        ctx.fillStyle = '#ffffff';
        ctx.fillText('?', bx + boxW - 28, rowY + 5);
      }
      ctx.textAlign = 'left';
    }
    ctx.restore();
  }

  ctx.restore();   /* fecha o translate/scale do bloco */
}

function syncSpeedPanel(){
  var c = sel();
  var panel = $('mce-speed-panel');
  if(c && c.kind === 'speed'){
    panel.style.display = 'block';
    if(document.activeElement !== $('mce-speed-time')) $('mce-speed-time').value = c.speedTime || 2.92;
    var sc = $('mce-speed-scale');
    if(sc && document.activeElement !== sc) sc.value = Math.round((c.scale || 0.8) * 100);
  } else {
    panel.style.display = 'none';
  }
  syncVideoPanel();   /* painel de mídia (corte/espelhar) acompanha a seleção */
  syncAudioPanel();   /* painel de volume acompanha a seleção de áudio */
  updateSideEmpty();
}

/* ══════════ PAINEL DE ÁUDIO (volume do clipe) ══════════
   Aparece ao selecionar um clipe de áudio. O slider vai de 0 a 300% —
   acima de 100% o som fica MAIS ALTO (boost via GainNode por elemento no
   grafo WebAudio) e o espectro sonoro desenhado na faixa cresce junto. */
function audSel(){
  var c = sel();
  return (c && c.kind === 'audio') ? c : null;
}
function audSelAll(){
  return selectedClips().filter(function(c){ return c.kind === 'audio'; });
}
/* volume que governa o áudio de um clipe (o próprio, se for áudio; o áudio
   pareado, se for vídeo) — 1 = 100% */
function clipVol(c){
  var gov = (c && c.kind === 'audio') ? c : (c ? pairOf(c) : null);
  var v = gov && gov.vol != null ? gov.vol : (c && c.vol != null ? c.vol : 1);
  return (v == null || isNaN(v)) ? 1 : v;
}
/* escala em dB (mesmo padrão do mixer): slider -50..+24 dB, 0 dB = neutro.
   c.vol continua LINEAR por dentro (preview/export/onda) — só a UI fala dB. */
var CLIPVOL_DB_MIN = -50, CLIPVOL_DB_MAX = 24;
function clipVolToDb(v){
  if(v == null) return 0;
  if(v <= 0) return CLIPVOL_DB_MIN;
  return clamp(20 * Math.log10(v), CLIPVOL_DB_MIN, CLIPVOL_DB_MAX);
}
function dbToClipVol(db){
  if(db <= CLIPVOL_DB_MIN) return 0;
  return Math.pow(10, clamp(db, CLIPVOL_DB_MIN, CLIPVOL_DB_MAX) / 20);
}
function fmtClipDb(db){
  if(db <= CLIPVOL_DB_MIN) return '-∞ dB';
  return (db > 0 ? '+' : '') + db.toFixed(1) + ' dB';
}
function syncAudioPanel(){
  var panel = $('mce-audio-panel');
  if(!panel) return;
  var c = audSel();
  if(c){
    panel.style.display = 'block';
    var db = clipVolToDb(c.vol != null ? c.vol : 1);
    var sl = $('mce-audio-vol');
    if(sl && document.activeElement !== sl) sl.value = db;
    var lab = $('mce-audio-vol-val');
    if(lab) lab.textContent = fmtClipDb(db);
  } else {
    panel.style.display = 'none';
  }
}
var _audVolSnapped = false;
on('mce-audio-vol', 'input', function(){
  var all = audSelAll(); if(!all.length) return;
  if(!_audVolSnapped){ snapshot(); _audVolSnapped = true; }
  var db = clamp(parseFloat(this.value) || 0, CLIPVOL_DB_MIN, CLIPVOL_DB_MAX);
  var v = dbToClipVol(db);
  all.forEach(function(c){ c.vol = v; });
  var lab = $('mce-audio-vol-val');
  if(lab) lab.textContent = fmtClipDb(db);
  updateWaveWindows();   /* espectro na faixa cresce/encolhe junto */
});
on('mce-audio-vol', 'change', function(){ _audVolSnapped = false; });
on('mce-audio-vol-reset', 'click', function(){
  var all = audSelAll(); if(!all.length) return;
  snapshot();
  all.forEach(function(c){ c.vol = 1; });
  syncAudioPanel(); updateWaveWindows();
});

on('mce-speed-time', 'input', function(){
  var c = sel();
  if(c && c.kind === 'speed'){
    var v = parseFloat(this.value);
    if(!isNaN(v) && v > 0) c.speedTime = v;
    drawFrame();
  }
});
on('mce-speed-time', 'focus', function(){ if(sel() && sel().kind === 'speed') snapshot(); });
/* controlador horizontal do 0-100: clicar e ARRASTAR pros lados escorrega o
   valor (1px = 0.01s), igual ao da velocidade do clipe; clique parado
   continua permitindo digitar normalmente */
(function(){
  var inp = $('mce-speed-time');
  if(!inp) return;
  inp.addEventListener('mousedown', function(e){
    var c = sel();
    if(!c || c.kind !== 'speed') return;
    var allS = selectedClips().filter(function(x){ return x.kind === 'speed'; });
    var x0 = e.clientX, v0 = parseFloat(inp.value) || c.speedTime || 2.92;
    var moved = false, snapped = false;
    var mv = function(ev){
      var dx = ev.clientX - x0;
      if(!moved && Math.abs(dx) < 3) return;
      if(!moved){
        moved = true;
        if(!snapped){ snapshot(); snapped = true; }
        inp.blur();
        document.body.style.cursor = 'ew-resize';
      }
      ev.preventDefault();
      var v = clamp(Math.round((v0 + dx * 0.01) * 100) / 100, 1, 30);
      inp.value = v;
      allS.forEach(function(x){ x.speedTime = v; });   /* aplica a todos os selecionados */
      drawFrame();
    };
    var up = function(){
      document.body.style.cursor = '';
      document.removeEventListener('mousemove', mv);
      document.removeEventListener('mouseup', up);
    };
    document.addEventListener('mousemove', mv);
    document.addEventListener('mouseup', up);
  });
})();
on('mce-speed-scale', 'mousedown', function(){ if(sel() && sel().kind === 'speed') snapshot(); });
on('mce-speed-scale', 'input', function(){
  var c = sel();
  if(c && c.kind === 'speed'){
    var v = parseInt(this.value, 10);
    if(!isNaN(v)){
      var sv = clamp(v, 40, 150) / 100;
      selectedClips().filter(function(x){ return x.kind === 'speed'; })
        .forEach(function(x){ x.scale = sv; });   /* aplica a todos os selecionados */
    }
    drawFrame();
  }
});

/* ══════════ PAINEL DE MÍDIA (corte estilo DaVinci + espelhar) ══════════
   Aparece ao selecionar um clipe de vídeo/imagem. Os 4 campos cortam cada
   lado (em %, 0-45); arrastar pros lados escorrega o valor (igual à
   velocidade). Espelhar inverte a mídia horizontalmente. */
var CROP_KEYS = { 'mce-crop-l':'cropL', 'mce-crop-r':'cropR', 'mce-crop-t':'cropT', 'mce-crop-b':'cropB' };
function vidSel(){
  var c = sel();
  return (c && (c.kind === 'video' || c.kind === 'image')) ? c : null;
}
/* TODOS os clipes de mídia selecionados — a mudança no painel se aplica a todos */
function vidSelAll(){
  return selectedClips().filter(function(c){ return c.kind === 'video' || c.kind === 'image'; });
}
function syncVideoPanel(){
  var panel = $('mce-video-panel');
  if(!panel) return;
  var c = vidSel();
  if(c){
    panel.style.display = 'block';
    Object.keys(CROP_KEYS).forEach(function(id){
      var inp = $(id);
      if(inp && document.activeElement !== inp) inp.value = Math.round((c[CROP_KEYS[id]] || 0) * 100);
    });
    var px = $('mce-pos-x'), py = $('mce-pos-y'), sc = $('mce-vid-scale');
    if(px && document.activeElement !== px) px.value = Math.round((c.posX || 0) * 1000) / 10;
    if(py && document.activeElement !== py) py.value = Math.round((c.posY || 0) * 1000) / 10;
    if(sc && document.activeElement !== sc) sc.value = Math.round((c.vScale != null ? c.vScale : 1) * 100);
    var mb = $('mce-video-mirror');
    if(mb) mb.classList.toggle('is-on', !!c.mirror);
  } else {
    panel.style.display = 'none';
  }
}
/* campo numérico com ARRASTE lateral (mesmo padrão do corte/velocidade) */
function bindVidDragInput(id, min, max, perPx, apply, round){
  round = round || 1;   /* granularidade do valor (0.1 = suave; 1 = inteiro) */
  var quant = function(v){ v = Math.round(v / round) * round; return parseFloat(v.toFixed(3)); };
  on(id, 'focus', function(){ if(vidSel()) snapshot(); });
  on(id, 'input', function(){
    var all = vidSelAll(); if(!all.length) return;
    var v = clamp(parseFloat(this.value) || 0, min, max);
    all.forEach(function(c){ apply(c, v); });   /* aplica a todos os selecionados */
    drawFrame();
  });
  var inp = $(id); if(!inp) return;
  inp.addEventListener('mousedown', function(e){
    var all = vidSelAll(); if(!all.length) return;
    var x0 = e.clientX, v0 = parseFloat(inp.value) || 0;
    var moved = false, snapped = false;
    /* INCREMENTAL + sensor de velocidade do mouse: devagar = ajuste fino;
       rápido = anda um pouco mais por px (com teto baixo, sem saltos) */
    var acc = v0, lastX = e.clientX, lastT = performance.now();
    var mv = function(ev){
      var dxTot = ev.clientX - x0;
      if(!moved && Math.abs(dxTot) < 3) return;
      if(!moved){
        moved = true;
        if(!snapped){ snapshot(); snapped = true; }
        inp.blur();
        document.body.style.cursor = 'ew-resize';
        lastX = ev.clientX; lastT = performance.now();
        return;
      }
      ev.preventDefault();
      var now = performance.now();
      var dx = ev.clientX - lastX;
      var dt = Math.max(1, now - lastT);
      lastX = ev.clientX; lastT = now;
      var speed = Math.abs(dx) / dt;                   /* px por ms */
      var gain = clamp(0.6 + speed * 0.6, 0.6, 1.5);   /* velocidade MÁX. menor (era 2.5) */
      var step = clamp(dx * perPx * gain, -1.5, 1.5);  /* teto por movimento bem baixo */
      acc = clamp(acc + step, min, max);
      var v = quant(acc);
      inp.value = v;
      all.forEach(function(c){ apply(c, v); });   /* aplica a todos os selecionados */
      drawFrame();
    };
    var up = function(){
      document.body.style.cursor = '';
      document.removeEventListener('mousemove', mv);
      document.removeEventListener('mouseup', up);
    };
    document.addEventListener('mousemove', mv);
    document.addEventListener('mouseup', up);
  });
}
/* posição (deslocamento em % do quadro): passo FINO (0.1) → arraste suave, sem
   pulos de ~11px por unidade. Escala mantém passo inteiro. */
bindVidDragInput('mce-pos-x', -100, 100, 0.10, function(c, v){ c.posX = v / 100; }, 0.1);
bindVidDragInput('mce-pos-y', -100, 100, 0.10, function(c, v){ c.posY = v / 100; }, 0.1);
bindVidDragInput('mce-vid-scale', 10, 300, 0.30, function(c, v){ c.vScale = v / 100; });
/* reset (ícone no cabeçalho + duplo clique no campo) — aplica a todos os
   selecionados. Blur pra a sincronização do painel atualizar o campo na hora. */
function vidReset(fn){
  var all = vidSelAll(); if(!all.length) return;
  snapshot();
  all.forEach(fn);
  try{ if(document.activeElement && document.activeElement.blur) document.activeElement.blur(); }catch(_){}
  syncVideoPanel(); drawFrame();
}
on('mce-pos-reset',   'click',    function(){ vidReset(function(c){ c.posX = 0; c.posY = 0; }); });
on('mce-scale-reset', 'click',    function(){ vidReset(function(c){ c.vScale = 1; }); });
on('mce-pos-x',       'dblclick', function(){ vidReset(function(c){ c.posX = 0; }); });
on('mce-pos-y',       'dblclick', function(){ vidReset(function(c){ c.posY = 0; }); });
on('mce-vid-scale',   'dblclick', function(){ vidReset(function(c){ c.vScale = 1; }); });
Object.keys(CROP_KEYS).forEach(function(id){
  var key = CROP_KEYS[id];
  on(id, 'focus', function(){ if(vidSel()) snapshot(); });
  on(id, 'input', function(){
    var all = vidSelAll(); if(!all.length) return;
    var v = clamp(parseFloat(this.value) || 0, 0, 45) / 100;
    all.forEach(function(c){ c[key] = v; });   /* aplica a todos os selecionados */
    drawFrame();
  });
  /* clicar e arrastar pros lados = vai cortando o lado conforme puxa */
  (function(){
    var inp = $(id); if(!inp) return;
    inp.addEventListener('mousedown', function(e){
      var all = vidSelAll(); if(!all.length) return;
      var x0 = e.clientX, v0 = parseFloat(inp.value) || 0;
      var moved = false, snapped = false;
      var mv = function(ev){
        var dx = ev.clientX - x0;
        if(!moved && Math.abs(dx) < 3) return;
        if(!moved){
          moved = true;
          if(!snapped){ snapshot(); snapped = true; }
          inp.blur();
          document.body.style.cursor = 'ew-resize';
        }
        ev.preventDefault();
        var v = clamp(Math.round(v0 + dx * 0.2), 0, 45);
        inp.value = v;
        all.forEach(function(c){ c[key] = v / 100; });   /* aplica a todos os selecionados */
        drawFrame();
      };
      var up = function(){
        document.body.style.cursor = '';
        document.removeEventListener('mousemove', mv);
        document.removeEventListener('mouseup', up);
      };
      document.addEventListener('mousemove', mv);
      document.addEventListener('mouseup', up);
    });
  })();
});
on('mce-video-mirror', 'click', function(){
  var all = vidSelAll(); if(!all.length) return;
  snapshot();
  var c = vidSel() || all[0];
  var nv = !c.mirror;                 /* novo estado do clipe principal… */
  all.forEach(function(cc){ cc.mirror = nv; });   /* …aplicado a todos os selecionados */
  this.classList.toggle('is-on', nv);
  drawFrame();
});

/* ── versões A/B do texto ──
   cada clipe de texto guarda duas versões (texto, posição, tamanho, altura
   da linha). textVariant escolhe qual aparece no preview/render. */
var textVariant = 0;   /* 0 = versão A · 1 = versão B */
function tData(c){
  if(textVariant === 1){
    if(!c.v2) c.v2 = { text: c.text, x: c.x, y: c.y, size: c.size, lineGap: c.lineGap,
      padding: c.padding, padV: c.padV, chapeu: c.chapeu, chapeuSize: c.chapeuSize, chapeuGap: c.chapeuGap, showBg: c.showBg, gradHeight: c.gradHeight,
      modelType: c.modelType, upper: c.upper, chapeuUpper: c.chapeuUpper };
    return c.v2;
  }
  return c;
}

/* ── uppercase por versão ──
   upFlag: maiúsculas LIGADAS a menos que explicitamente desligadas
   ('off'/false — o GAS devolve string). caseTxt aplica no texto. */
function upFlag(v){
  return !(v === false || v === 'false' || v === 'off' || v === 0 || v === '0');
}
function caseTxt(up, s){
  s = String(s == null ? '' : s);
  return upFlag(up) ? s.toUpperCase() : s;
}
/* tipo de modelo da VERSÃO ativa — V1 e V2 podem usar modelos diferentes */
function tModel(c){
  var D = tData(c);
  var mt = D.modelType != null ? D.modelType : c.modelType;
  return Number(mt) || 1;
}

/* layout do bloco de texto (usado no draw e no hit-test) */
function textLayout(c){
  var D = tData(c);
  var lines = caseTxt(D.upper, D.text).split('\n').filter(function(l){ return l.length; });
  if(!lines.length) lines = [' '];
  var size  = D.size;
  ctx.font  = '700 ' + size + 'px "Montserrat", sans-serif';
  var lineH = Math.round(size * 1.04);
  var gapPct = D.lineGap == null ? 30 : D.lineGap;
  var gap   = Math.round(size * gapPct / 100);   /* espaçado entre as linhas (controlável) */
  var padH  = Math.round(size * 0.28);   /* respiro horizontal do fundo branco */
  var padV  = Math.round(size * 0.10);
  var barW  = Math.max(9, Math.round(size * 0.24));   /* barra vermelha mais grossa */
  var gapBar = 0;                                     /* colada nos retângulos brancos */
  var maxW = 0, widths = [];
  for(var i=0;i<lines.length;i++){
    var w = ctx.measureText(lines[i]).width;
    widths.push(w);
    maxW = Math.max(maxW, w + padH*2);
  }
  var blockH = lines.length * (lineH + padV*2) + (lines.length - 1) * gap;
  var blockW = barW + gapBar + maxW;
  var cx = D.x * PROJ_W, cy = D.y * PROJ_H;
  return {
    lines:lines, widths:widths, size:size, lineH:lineH, gap:gap, padH:padH, padV:padV,
    barW:barW, gapBar:gapBar, blockW:blockW, blockH:blockH,
    /* ANCORA À ESQUERDA: D.x é a borda ESQUERDA do bloco (não o centro).
       Assim, ao adicionar linhas ou digitar textos maiores, a borda esquerda
       fica fixa e o bloco só cresce pra direita/baixo — não "recentraliza". */
    x: cx, y: cy - blockH/2
  };
}

function drawText(c, t){
  var mt = tModel(c);   /* modelo da VERSÃO ativa (V1/V2 podem diferir) */
  if(mt === 2) return drawText2(c, t);
  if(mt === 3) return drawText3(c, t);
  return drawText1(c, t);
}
/* ── MODELO 1: barra vermelha + chips brancos (original) ── */
function drawText1(c, t){
  var L = textLayout(c);
  var local = t - c.start;
  var barP = easeOut(local / 0.33);
  var chipStartX = L.x + L.barW + L.gapBar;
  var bh = L.blockH * barP;
  ctx.fillStyle = '#e10600';
  ctx.fillRect(L.x, L.y + (L.blockH - bh)/2, L.barW, bh);
  ctx.textBaseline = 'middle';
  ctx.font = '700 ' + L.size + 'px "Montserrat", sans-serif';
  for(var i=0;i<L.lines.length;i++){
    var delay = 0.14 + i * 0.18;
    var p = easeOut((local - delay) / 0.66);
    if(p <= 0) continue;
    var chipW = L.widths[i] + L.padH*2;
    var chipH = L.lineH + L.padV*2;
    var rowY  = L.y + i * (chipH + L.gap);
    var offset = (1 - p) * chipW;
    ctx.save();
    ctx.beginPath();
    ctx.rect(chipStartX - L.gapBar/2, rowY - 4, PROJ_W, chipH + 8);
    ctx.clip();
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(chipStartX - offset, rowY, chipW, chipH);
    ctx.fillStyle = '#0a0a0a';
    ctx.fillText(L.lines[i], chipStartX - offset + L.padH, rowY + chipH/2 + L.size*0.04);
    ctx.restore();
  }
}

/* ── MODELO 2: texto centralizado, Helvetica bold branca, retângulo azul #1c18c7 ── */
function textLayout2(c){
  var D = tData(c);
  var lines = caseTxt(D.upper, D.text).split('\n').filter(function(l){ return l.length; });
  if(!lines.length) lines = [' '];
  var size = D.size;
  ctx.font = '500 ' + size + 'px "Helvetica Neue", Helvetica, Arial, sans-serif';
  var lineH = Math.round(size * 1.15);
  var gapPct = D.lineGap == null ? 20 : D.lineGap;
  var gap = Math.round(size * gapPct / 100);
  var padH = D.padding != null ? D.padding : Math.round(size * 0.4);
  var padV = D.padV != null ? D.padV : Math.round(size * 0.2);
  var maxW = 0, widths = [];
  for(var i=0;i<lines.length;i++){
    var w = ctx.measureText(lines[i]).width;
    widths.push(w); maxW = Math.max(maxW, w);
  }
  var blockH = lines.length * lineH + (lines.length - 1) * gap + padV * 2;
  var blockW = maxW + padH * 2;
  return {
    lines:lines, widths:widths, size:size, lineH:lineH, gap:gap, padH:padH, padV:padV,
    blockW:blockW, blockH:blockH,
    x: (PROJ_W - blockW) / 2, y: D.y * PROJ_H - blockH / 2
  };
}
function drawText2(c, t){
  var L = textLayout2(c);
  var D = tData(c);
  /* retângulo azul de fundo */
  ctx.fillStyle = '#1c18c7';
  ctx.fillRect(L.x, L.y, L.blockW, L.blockH);
  /* texto branco centralizado */
  ctx.textBaseline = 'middle';
  ctx.textAlign = 'center';
  ctx.font = '500 ' + L.size + 'px "Helvetica Neue", Helvetica, Arial, sans-serif';
  for(var i=0;i<L.lines.length;i++){
    var ty = L.y + L.padV + i * (L.lineH + L.gap) + L.lineH / 2;
    /* drop shadow (diffuse: multiple passes) */
    ctx.fillStyle = 'rgba(0,0,0,0.18)';
    ctx.fillText(L.lines[i], PROJ_W/2 + 3, ty + 3);
    ctx.fillStyle = 'rgba(0,0,0,0.22)';
    ctx.fillText(L.lines[i], PROJ_W/2 + 5, ty + 5);
    ctx.fillStyle = 'rgba(0,0,0,0.12)';
    ctx.fillText(L.lines[i], PROJ_W/2 + 7, ty + 7);
    /* borda preta (stroke) */
    ctx.strokeStyle = '#000';
    ctx.lineWidth = 4;
    ctx.lineJoin = 'round';
    ctx.strokeText(L.lines[i], PROJ_W/2, ty);
    /* texto branco */
    ctx.fillStyle = '#ffffff';
    ctx.fillText(L.lines[i], PROJ_W/2, ty);
  }
  ctx.textAlign = 'left';
}

/* ── MODELO 3: degradê azul de baixo pra cima, Bebas Neue, chapéu de texto ── */
/* a Bebas Neue NÃO tem minúsculas de verdade (a fonte desenha tudo como
   maiúscula) — por isso o botão T "não fazia nada" no modelo 3. Com o T
   DESLIGADO, emulamos caixa-baixa em small-caps: as letras minúsculas saem
   menores (78%) que as maiúsculas. */
function bebasSegs(line){
  line = String(line == null ? '' : line);
  var segs = [], cur = '', curLow = null;
  for(var i=0;i<line.length;i++){
    var ch = line.charAt(i);
    var low = ch !== ch.toUpperCase();
    if(curLow === null){ curLow = low; cur = ch; }
    else if(low === curLow){ cur += ch; }
    else { segs.push({ t: cur, low: curLow }); cur = ch; curLow = low; }
  }
  if(cur) segs.push({ t: cur, low: !!curLow });
  return segs;
}
function bebasFont(size){ return '400 ' + Math.round(size) + 'px "Bebas Neue", sans-serif'; }
function bebasWidth(g, line, size, emul){
  if(!emul){ g.font = bebasFont(size); return g.measureText(line).width; }
  var segs = bebasSegs(line), w = 0;
  for(var i=0;i<segs.length;i++){
    g.font = bebasFont(size * (segs[i].low ? 0.78 : 1));
    w += g.measureText(segs[i].t).width;
  }
  return w;
}
function bebasFillText(g, line, x, y, size, emul){
  if(!emul){ g.font = bebasFont(size); g.fillText(line, x, y); return; }
  var segs = bebasSegs(line), cx = x;
  for(var i=0;i<segs.length;i++){
    g.font = bebasFont(size * (segs[i].low ? 0.78 : 1));
    g.fillText(segs[i].t, cx, y);
    cx += g.measureText(segs[i].t).width;
  }
}
function textLayout3(c){
  var D = tData(c);
  var emul = !upFlag(D.upper);   /* T desligado → small-caps emulado */
  var lines = caseTxt(D.upper, D.text).split('\n').filter(function(l){ return l.length; });
  if(!lines.length) lines = [' '];
  var size = D.size;
  ctx.font = '400 ' + size + 'px "Bebas Neue", sans-serif';
  var lineH = Math.round(size * 1.05);
  var gapPct = D.lineGap == null ? 10 : D.lineGap;
  var gap = Math.round(size * gapPct / 100);
  var padH = D.padding != null ? D.padding : Math.round(size * 0.3);
  var padV = D.padV != null ? D.padV : Math.round(size * 0.22);
  var maxW = 0, widths = [];
  for(var i=0;i<lines.length;i++){
    var w = bebasWidth(ctx, lines[i], size, emul);
    widths.push(w); maxW = Math.max(maxW, w);
  }
  var showBg = D.gradHeight != null ? D.gradHeight <= 0 : false;
  /* degradê OFF → bloco único: margem vertical única em volta (padV top/bottom),
     linhas separadas só pelo gap. degradê ON → espaçamento por linha (original). */
  var blockH = showBg
    ? (lines.length * lineH + (lines.length - 1) * gap + padV * 2)
    : (lines.length * (lineH + padV * 2) + (lines.length - 1) * gap);
  var blockW = maxW + padH * 2;
  /* chapéu (uppercase próprio, ligável/desligável) */
  var chapeu = caseTxt(D.chapeuUpper, D.chapeu || '');
  var chapeuSize = D.chapeuSize || Math.round(size * 0.4);
  var chapeuGap = D.chapeuGap != null ? D.chapeuGap : Math.round(size * 0.15);
  return {
    lines:lines, widths:widths, size:size, lineH:lineH, gap:gap, padH:padH, padV:padV,
    blockW:blockW, blockH:blockH,
    x: D.x * PROJ_W, y: D.y * PROJ_H - blockH / 2,
    chapeu:chapeu, chapeuSize:chapeuSize, chapeuGap:chapeuGap,
    gradHeight: D.gradHeight != null ? D.gradHeight : 0.65,
    showBg: showBg,
    emul: emul, chapEmul: !upFlag(D.chapeuUpper)
  };
}
function drawText3(c, t){
  var L = textLayout3(c);
  var D = tData(c);
  var local = t - c.start;

  /* ── DEGRADÊ OFF: bloco único que engloba todo o texto, margens lateral/
     vertical, SEM animação (nem do texto nem do retângulo) ── */
  if(L.showBg){
    ctx.fillStyle = '#1c18c7';
    ctx.fillRect(L.x, L.y, L.blockW, L.blockH);
    if(L.chapeu){
      ctx.textBaseline = 'middle'; ctx.textAlign = 'left';
      ctx.fillStyle = '#ffffff';
      bebasFillText(ctx, L.chapeu, L.x + L.padH, L.y - L.chapeuGap - L.chapeuSize * 0.6, L.chapeuSize, L.chapEmul);
    }
    ctx.textAlign = 'left'; ctx.textBaseline = 'alphabetic'; ctx.fillStyle = '#ffffff';
    for(var j=0;j<L.lines.length;j++){
      var lineTop = L.y + L.padV + j * (L.lineH + L.gap);
      bebasFillText(ctx, L.lines[j], L.x + L.padH, lineTop + L.lineH * 0.5 + L.size * 0.35, L.size, L.emul);
    }
    return;
  }

  /* ── DEGRADÊ ON: degradê azul de baixo pra cima + texto animado (original) ── */
  var gh = D.gradHeight != null ? D.gradHeight : 0.65;
  var grad = ctx.createLinearGradient(0, PROJ_H, 0, PROJ_H * (1 - gh));
  grad.addColorStop(0, '#1c18c7');
  grad.addColorStop(1, 'rgba(28,24,199,0)');
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, PROJ_W, PROJ_H);

  /* chapéu (texto menor acima do bloco principal) */
  if(L.chapeu){
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'left';
    var chapY = L.y - L.chapeuGap - L.chapeuSize * 0.6;
    var chapP = easeOut((local - 0.08) / 0.5);
    if(chapP > 0){
      ctx.save();
      ctx.globalAlpha = chapP;
      ctx.fillStyle = '#ffffff';
      bebasFillText(ctx, L.chapeu, L.x + L.padH, chapY, L.chapeuSize, L.chapEmul);
      ctx.restore();
    }
  }

  /* texto principal (animação: cada linha vem da esquerda) */
  ctx.textAlign = 'left';
  for(var i=0;i<L.lines.length;i++){
    var delay = 0.14 + i * 0.18;
    var p = easeOut((local - delay) / 0.66);
    if(p <= 0) continue;
    var chipH = L.lineH + L.padV * 2;
    var rowY = L.y + i * (chipH + L.gap);
    var textY = rowY + chipH / 2;
    var offsetX = (1 - p) * 200;
    ctx.save();
    ctx.globalAlpha = p;
    ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = '#ffffff';
    bebasFillText(ctx, L.lines[i], L.x + L.padH - offsetX, textY + L.size * 0.35, L.size, L.emul);
    ctx.restore();
  }
}

/* ══════════ RENDER DO FRAME ══════════ */
function drawFrame(){
  /* reamostragem de alta qualidade ao escalar o vídeo pro canvas (nítido) */
  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = 'high';
  /* desenha em coordenadas do projeto (1080x1920); o canvas pode estar
     em resolução menor no preview — a transform escala tudo */
  ctx.setTransform(cv.width / PROJ_W, 0, 0, cv.height / PROJ_H, 0, 0);
  ctx.fillStyle = '#000';
  ctx.fillRect(0, 0, PROJ_W, PROJ_H);

  /* vídeos e imagens: faixas de baixo pra cima (a de cima cobre) */
  for(var ti = tracks.length - 1; ti >= 0; ti--){
    var tr = tracks[ti];
    if(tr.kind !== 'video' || tr.hidden) continue;
    for(var i=0;i<clips.length;i++){
      var c = clips[i];
      if(c.trackId !== tr.id || (c.kind !== 'video' && c.kind !== 'image') || !activeAt(c, tCur) || !c.el) continue;
      var v = c.el;
      /* render rápido: se um frame já decodificado (WebCodecs) foi injetado
         pra este clipe, desenha ele no lugar do <video> — o resto do pipeline
         (escala, overlays) fica idêntico */
      var fr = c._srcFrame;
      var vw = fr ? fr.displayWidth : (v.videoWidth || v.naturalWidth);
      var vh = fr ? fr.displayHeight : (v.videoHeight || v.naturalHeight);
      if(vw){
        var s = Math.min(PROJ_W / vw, PROJ_H / vh) * (c.vScale != null ? c.vScale : 1);
        var dw = vw * s, dh = vh * s;
        var dx = (PROJ_W - dw) / 2 + (c.posX || 0) * PROJ_W;
        var dy = (PROJ_H - dh) / 2 + (c.posY || 0) * PROJ_H;
        drawMediaClip(ctx, fr || v, c, vw, vh, dx, dy, dw, dh);
      }
    }
  }
  /* textos por cima */
  for(var j=0;j<clips.length;j++){
    var tc = clips[j];
    if(tc.kind === 'text' && activeAt(tc, tCur)) drawText(tc, tCur);
  }
  /* speed overlays por cima de tudo */
  for(var si=0;si<clips.length;si++){
    var sc = clips[si];
    if(sc.kind === 'speed' && activeAt(sc, tCur)) drawSpeed(sc, tCur);
  }
}

/* ══════════ ENGINE DE PLAYBACK ══════════ */
function mediaOwners(){
  /* clipes que possuem elemento de MÍDIA próprio (imagem não tem currentTime) */
  return clips.filter(function(c){ return !!c.el && c.kind !== 'image'; });
}

/* desenha vídeo/imagem com corte (cropL/R/T/B, frações 0..0.45) e espelhamento.
   O corte é estilo DaVinci: a mídia fica no mesmo lugar/escala, só a borda
   cortada some (não re-escala nem move). */
function drawMediaClip(g, src, c, vw, vh, dx, dy, dw, dh){
  var cl = c.cropL || 0, cr = c.cropR || 0, ct2 = c.cropT || 0, cb = c.cropB || 0;
  var sw = vw * (1 - cl - cr), sh = vh * (1 - ct2 - cb);
  if(sw <= 0 || sh <= 0) return;
  var flip = !!c.mirror;
  if(flip){ g.save(); g.translate(dx * 2 + dw, 0); g.scale(-1, 1); }
  g.drawImage(src, vw * cl, vh * ct2, sw, sh,
              dx + cl * dw, dy + ct2 * dh, dw * (1 - cl - cr), dh * (1 - ct2 - cb));
  if(flip) g.restore();
}

function trackMuted(trackId){
  var t = trackById(trackId);
  return !!(t && t.muted);
}

/* solo: se alguma faixa de áudio está em solo, só as em solo tocam */
function anySolo(){
  for(var i=0;i<tracks.length;i++)
    if(tracks[i].kind === 'audio' && tracks[i].solo) return true;
  return false;
}
function trackAudible(tr){
  if(!tr) return !anySolo();
  if(tr.muted) return false;
  if(anySolo()) return !!tr.solo;
  return true;
}

function clipIsAudible(c){
  /* c é dono do elemento — decide se o áudio dele deve tocar */
  if(c.kind === 'video'){
    if(c.audioOff || c.muted) return false;
    var p = pairOf(c);
    if(p) return !p.muted && trackAudible(trackById(p.trackId));
    return trackAudible(null);
  }
  return !c.muted && trackAudible(trackById(c.trackId));
}

function syncMuted(){
  /* baseline de áudio por faixa (mute/solo/volume). O mute por ESTADO
     (ativo x pré-roll) é feito no syncMedia, que roda todo frame — aqui não,
     porque syncMuted só é chamado em seek/play e ficaria desatualizado. */
  mediaOwners().forEach(function(c){ c.el.muted = !clipIsAudible(c); });
  applyVolumes();
}

function audioSideTrack(c){
  /* faixa que manda no áudio deste dono de mídia */
  if(c.kind === 'video'){
    var p = pairOf(c);
    return p ? trackById(p.trackId) : null;
  }
  return trackById(c.trackId);
}
function applyVolumes(){
  mediaOwners().forEach(function(c){
    var tr = audioSideTrack(c);
    var g = trackGain(tr);
    var node = tr && gainNodes[tr.id];
    if(node && c.el._mceSrc){
      /* grafo ativo: ganho no GainNode (permite boost acima de 1) */
      node.gain.value = g;
      c.el.volume = 1;
    } else {
      c.el.volume = clamp(g, 0, 1);
    }
  });
}

/* ── grafo WebAudio: medidores de volume + export ── */
var graphNodes = {};
/* retoma o AudioContext quando o navegador o suspende no meio da edição.
   Como todo elemento com _mceSrc só sai pelo grafo, um contexto suspenso deixa
   TODO o áudio mudo — era o que fazia o som "parar de funcionar" (às vezes ao
   mexer na velocidade, que abre modal e reposiciona a mídia). */
function resumeAudio(){
  try{ if(audioCtx && audioCtx.state === 'suspended') audioCtx.resume(); }catch(_){}
}
function ensureGraph(){
  var AC = window.AudioContext || window.webkitAudioContext;
  if(!AC) return;
  if(!audioCtx){
    audioCtx = new AC();
    audioDest = audioCtx.createMediaStreamDestination();
    /* auto-resume: se o contexto suspender sozinho, tenta voltar na hora */
    try{ audioCtx.onstatechange = function(){ if(audioCtx.state === 'suspended') resumeAudio(); }; }catch(_){}
    /* qualquer interação do usuário revive o áudio (gesto válido pro resume) */
    document.addEventListener('mousedown', resumeAudio, true);
    document.addEventListener('keydown', resumeAudio, true);
    document.addEventListener('visibilitychange', function(){ if(!document.hidden) resumeAudio(); });
  }
  if(audioCtx.state === 'suspended') audioCtx.resume();
  mediaOwners().forEach(function(c){
    if(!c.el._mceSrc){
      try{ c.el._mceSrc = audioCtx.createMediaElementSource(c.el); }
      catch(e){ return; }
    }
    /* gain POR ELEMENTO: volume do clipe (permite boost acima de 100%) —
       fica entre a fonte e o gain da faixa */
    if(!c.el._mceGain){
      c.el._mceGain = audioCtx.createGain();
      try{ c.el._mceSrc.disconnect(); }catch(e){}
      c.el._mceSrc.connect(c.el._mceGain);
    }
    var tr = audioSideTrack(c);
    var tid = tr ? tr.id : '_none';
    if(c.el._mceTrack !== tid){
      try{ c.el._mceGain.disconnect(); }catch(e){}
      c.el._mceGain.connect(analyserFor(tid));
      c.el._mceTrack = tid;
    }
  });
}
var gainNodes = {};
function analyserFor(tid){
  /* cadeia por faixa: fonte → gain (fader do mixer) → analyser → saídas */
  if(!graphNodes[tid]){
    var an = audioCtx.createAnalyser();
    an.fftSize = 256;
    an.connect(audioCtx.destination);
    an.connect(audioDest);
    var g = audioCtx.createGain();
    g.connect(an);
    graphNodes[tid] = an;
    gainNodes[tid] = g;
  }
  return gainNodes[tid];   /* as fontes entram pelo gain */
}
var meterData = new Uint8Array(256);
function updateMeters(){
  for(var tid in meterFills){
    var an = graphNodes[tid];
    var fill = meterFills[tid];
    if(!an || !fill){ if(fill) fill.style.height = '0%'; continue; }
    an.getByteTimeDomainData(meterData);
    var peak = 0;
    for(var i=0;i<meterData.length;i++){
      var v = Math.abs(meterData[i] - 128) / 128;
      if(v > peak) peak = v;
    }
    fill.style.height = Math.min(100, Math.round(peak * 130)) + '%';
  }
}

/* seeks das setinhas (frame a frame): pressões rápidas viram UM seek só na
   posição final — sem os seeks intermediários enfileirados que faziam o
   player "pular" sozinho pra frente/trás */
var _stepSeekT = null;
function scheduleStepSeek(){
  if(_stepSeekT) clearTimeout(_stepSeekT);
  _stepSeekT = setTimeout(function(){
    _stepSeekT = null;
    seekMedia(); drawFrame();
  }, 70);
}

function seekMedia(){
  mediaOwners().forEach(function(c){
    if(activeAt(c, tCur)){
      var want = mediaTimeAt(c, tCur);
      if(Math.abs(c.el.currentTime - want) > 0.05){
        try{ c.el.currentTime = clamp(want, 0, (c.srcDur || want) - 0.01); }catch(e){}
      }
    }
  });
  syncMuted();
}
/* seek FRAME-EXATO (setinhas): o limiar de 0,05s do seekMedia é maior que 1
   frame (0,0417s a 24fps), então o step de 1 frame não seekava e o quadro não
   trocava. Aqui força o seek em qualquer diferença perceptível. */
function seekMediaExact(){
  mediaOwners().forEach(function(c){
    if(activeAt(c, tCur)){
      var want = mediaTimeAt(c, tCur);
      if(Math.abs(c.el.currentTime - want) > 0.001){
        try{ c.el.currentTime = clamp(want, 0, (c.srcDur || want) - 0.01); }catch(e){}
      }
    }
  });
  syncMuted();
}

/* quanto tempo (s) antes de um clipe entrar já começamos a "aquecer" o áudio
   dele — rodando mudo e sincronizado — pra o som sair sem cortar o início */
var PREROLL = 0.28;

/* DIAG do playback: loga o estado dos elementos perto das fronteiras de corte */
function _pbNear(t){
  if(!playing) return false;
  for(var i=0;i<clips.length;i++){
    var c = clips[i];
    if(c.kind === 'video' && c.start > 0.01 && Math.abs(t - c.start) < 0.6) return true;
  }
  return false;
}
function syncMedia(){
  /* o clipe mestre É o relógio — nunca leva seek durante o play
     (era o re-seek constante que deixava o vídeo travado/stuttering) */
  var master = (playing && playDir > 0) ? masterVideoClip() : null;
  var _dg = _pbNear(tCur);
  mediaOwners().forEach(function(c){
    var el = c.el;
    if(activeAt(c, tCur)){
      var want = mediaTimeAt(c, tCur);
      if(_dg && c.kind === 'video') console.log('[MCE-PB] t=' + tCur.toFixed(3) + ' ' + c.name
        + ' ATIVO ct=' + (el.currentTime || 0).toFixed(3) + ' want=' + want.toFixed(3)
        + ' paused=' + el.paused + ' seeking=' + el.seeking + ' rs=' + el.readyState
        + ' net=' + el.networkState + ' err=' + (el.error ? el.error.code : 0)
        + ' src=' + String(el.currentSrc || el.src || '').slice(-24)
        + (c === master ? ' [MASTER]' : ''));
      var th = (playing && playDir > 0) ? 0.4 : 0.25;
      /* _stepSeekT: setinhas em sequência — segura o re-seek até a última */
      if(!_stepSeekT && c !== master && !el.seeking && Math.abs(el.currentTime - want) > th){
        try{ el.currentTime = want; }catch(e){}
      }
      /* velocidade do clipe (retime) aplicada na mídia. preservesPitch
         desligado fora do 1x: o corretor de pitch em rates altos custa CPU
         (stuttering) e é o que faz o áudio "sumir" em algumas velocidades */
      var pr = clipRate(c);
      if(el.playbackRate !== pr){ try{ el.playbackRate = pr; }catch(_){} }
      try{
        var pp = (pr === 1);
        if(el.preservesPitch !== pp) el.preservesPitch = pp;
      }catch(_){}
      /* watchdog anti-congelamento: tocando, mas o currentTime não anda
         (decoder/buffer preso) → re-chuta o elemento; o áudio das outras
         faixas continua e o quadro volta a andar */
      if(playing && playDir > 0 && !el.paused){
        var nowTs = performance.now();
        if(el._mceStallCT !== el.currentTime){
          el._mceStallCT = el.currentTime;
          el._mceStallTs = nowTs;
        } else if(nowTs - (el._mceStallTs || nowTs) > 700){
          el._mceStallTs = nowTs;
          resumeAudio();                       /* contexto suspenso? revive */
          try{ el.currentTime = want; }catch(_){}
          el.play().catch(function(){});
        }
      }
      /* clipe ATIVO: som ligado conforme a faixa (mute/solo). Feito aqui, todo
         frame, pra o áudio voltar na hora que o clipe entra — inclusive o que
         estava em pré-roll (mudo) na borda anterior. */
      el.muted = !clipIsAudible(c);
      /* FADE in/out: multiplica o volume do elemento pela curva do fade. O
         clipe que manda no fade é o próprio (áudio) ou o áudio pareado (vídeo). */
      var govFade = (c.kind === 'audio') ? c : pairOf(c);
      var fg = govFade ? fadeGain(govFade, tCur) : 1;
      try{
        var cv = clipVol(c);   /* volume do clipe (painel de áudio) */
        if(c.el._mceGain){
          /* grafo ativo: boost acima de 100% entra pelo gain por elemento */
          c.el._mceGain.gain.value = cv;
          el.volume = clamp(fg, 0, 1);
        } else {
          var baseVol = c.el._mceSrc ? 1 : clamp(trackGain(audioSideTrack(c)), 0, 1);
          el.volume = clamp(baseVol * fg * cv, 0, 1);
        }
      }catch(_){}
      /* reverso: mídia fica pausada e é só "puxada" pelos seeks */
      if(playing && playDir > 0 && el.paused){ el.play().catch(function(){}); }
      if((!playing || playDir < 0) && !el.paused) el.pause();
    } else {
      /* PRÉ-ROLL: aquece o áudio/vídeo do próximo clipe ANTES da borda, tocando
         mudo e sincronizado, pra o som sair na hora sem cortar o início.
         A janela é dimensionada pelo ponto de entrada (c.in): se o clipe foi
         aparado no começo por MENOS que PREROLL, começamos o pré-roll mais tarde
         — assim o elemento chega EXATAMENTE em c.in na borda, sem adiantar e
         pular frames. (o bug antes: janela fixa colava a mídia no 0 e ela
         chegava adiantada, engolindo os primeiros frames do clipe aparado.) */
      var rate = clipRate(c);
      var inPt = Math.max(0, c.in || 0);
      var win  = Math.min(PREROLL, inPt / rate);   /* janela que faz chegar exato em c.in */
      var lead = c.start - tCur;                    /* quanto falta pro clipe entrar */
      if(_dg && c.kind === 'video' && lead > 0 && lead < 0.6) console.log('[MCE-PB] t=' + tCur.toFixed(3) + ' ' + c.name
        + ' PREROLL lead=' + lead.toFixed(3) + ' ct=' + (el.currentTime || 0).toFixed(3)
        + ' paused=' + el.paused + ' seeking=' + el.seeking + ' rs=' + el.readyState
        + ' src=' + String(el.currentSrc || el.src || '').slice(-24));
      if(playing && playDir > 0 && lead > 0 && lead <= Math.max(win, 0.35)){
        if(el.playbackRate !== rate){ try{ el.playbackRate = rate; }catch(_){} }
        el.muted = true;                            /* pré-roll é sempre mudo (só aquece) */
        /* alvo FIXO: o frame de ENTRADA do clipe (c.in). Perseguir um alvo
           móvel disparava um último seek em cima da borda — em arquivo de
           seek lento (GOP esparso: Pinterest/IA) ele não terminava a tempo e
           o clipe entrava congelado. Agora: UM seek, cedo (350ms antes),
           direto no frame de entrada; o elemento espera PAUSADO e só começa
           a tocar faltando ~80ms (aquece o áudio sem sair do lugar). */
        if(!el.seeking && Math.abs(el.currentTime - inPt) > 0.05){
          try{ el.currentTime = clamp(inPt, 0, (c.srcDur || (inPt + 1)) - 0.01); }catch(e){}
        }
        if(lead <= 0.08){ if(el.paused) el.play().catch(function(){}); }
        else if(!el.paused){ el.pause(); }
      } else if(!el.paused){
        el.pause();
      }
    }
  });
}

/* clipe de vídeo "mestre" do relógio: o de cima, visível e ativo agora.
   Durante o play/export a timeline segue o currentTime DELE em vez do
   relógio de parede — sem drift, sem re-seeks, sem vídeo travado no render */
function masterVideoClip(){
  for(var ti=0; ti<tracks.length; ti++){
    var tr = tracks[ti];
    if(tr.kind !== 'video' || tr.hidden) continue;
    for(var i=0;i<clips.length;i++){
      var c = clips[i];
      if(c.trackId === tr.id && c.kind === 'video' && c.el && activeAt(c, tCur)) return c;
    }
  }
  return null;
}

function tick(ts){
  /* export frame a frame: o loop de preview não mexe em nada */
  if(exportFrameMode){ rafId = requestAnimationFrame(tick); return; }
  if(playing){
    var dt = (ts - lastTs) / 1000;
    lastTs = ts;
    tCur += dt * playDir;
    /* converge SUAVEMENTE pro relógio do vídeo mestre — sem pulos pra
       trás nem pra frente (o pulo por frame era o que causava stuttering) */
    if(playDir > 0){
      var mc = masterVideoClip();
      if(mc && !mc.el.paused && mc.el.readyState >= 2 && !mc.el.seeking){
        var err = (mc.start + (mc.el.currentTime - mc.in) / clipRate(mc)) - tCur;
        /* NUNCA rebobina a timeline de forma visível (era o "volta um frame
           aleatório" no corte): converge normal, mas atraso grande do vídeo
           é resolvido re-posicionando o VÍDEO no relógio — não o contrário */
        if(err > -0.05 && Math.abs(err) <= 0.5){
          tCur += err * 0.35;
        } else if(err <= -0.05 && err > -2){
          var nowC = performance.now();
          if(!mc.el._mceCatchT || nowC - mc.el._mceCatchT > 500){
            mc.el._mceCatchT = nowC;
            try{ mc.el.currentTime = mediaTimeAt(mc, tCur); }catch(_){}
          }
        }
      }
    }
    var end = projDur();
    if(playDir > 0 && tCur >= end){
      if(exporting){ tCur = end; finishExport(); }
      else if(loopPlay){ tCur = 0; seekMedia(); }
      else { tCur = end; stop(false); }
    } else if(playDir < 0 && tCur <= 0){
      if(loopPlay){ tCur = end; seekMedia(); }
      else { tCur = 0; stop(false); playDir = 1; }
    }
    if(exporting){
      var pct = end ? Math.min(100, Math.round(tCur/end*100)) : 100;
      $('mce-export-bar').style.width = pct + '%';
      $('mce-export-pct').textContent = pct + '%';
    }
  }
  /* no play, a timeline acompanha a playhead quando ela atinge a borda */
  if(playing){
    var phX = tCur * PPS() - elScroll.scrollLeft;
    var vw = elScroll.clientWidth;
    if(phX > vw - 80)   elScroll.scrollLeft = Math.max(0, tCur * PPS() - (vw - 80));
    else if(phX < 0)    elScroll.scrollLeft = Math.max(0, tCur * PPS() - 40);
  }
  syncMedia();
  drawFrame();
  renderPlayhead();
  updateMeters();
  rafId = requestAnimationFrame(tick);
}

var playDir = 1;      /* 1 = normal, -1 = reverso (como no Resolve) */
var loopPlay = false; /* loop ligado/desligado */

function play(){
  if(!clips.length) return;
  if(playDir > 0 && tCur >= projDur() - 0.05) tCur = 0;
  if(playDir < 0 && tCur <= 0.05) tCur = projDur();
  playing = true;
  lastTs = performance.now();
  ensureGraph();
  seekMedia();
  syncMuted();
  /* inicia já os clipes ativos sem esperar o 1º frame do loop — reduz o
     atraso do som ao dar play (inclusive perto do fim de um clipe) */
  if(playDir > 0){
    mediaOwners().forEach(function(c){
      if(activeAt(c, tCur) && c.el.paused){ try{ c.el.play().catch(function(){}); }catch(e){} }
    });
  }
}
function pause(){
  playing = false;
  mediaOwners().forEach(function(c){ if(!c.el.paused) c.el.pause(); });
}
function stop(reset){
  pause();
  if(reset !== false) tCur = 0;
  seekMedia(); drawFrame(); renderPlayhead();
}

/* ══════════ EXPORT ══════════ */
/* Chrome grava WebM sem o campo Duration — o Windows mostra o vídeo "sem
   duração". Este patch escreve a duração (= duração total da timeline)
   direto no cabeçalho EBML do arquivo. */
function vintLen_(b){ for(var i=0;i<8;i++){ if(b & (0x80 >> i)) return i+1; } return -1; }
function readEl_(u8, pos, end){
  if(pos >= end) return null;
  var il = vintLen_(u8[pos]); if(il < 0 || pos + il > end) return null;
  var id = 0; for(var i=0;i<il;i++) id = id*256 + u8[pos+i];
  var sp = pos + il;
  var sl = vintLen_(u8[sp]); if(sl < 0 || sp + sl > end) return null;
  var mask = 0x80 >> (sl-1);
  var first = u8[sp] & (mask - 1);
  var size = first, unknown = (first === mask - 1);
  for(var j=1;j<sl;j++){ size = size*256 + u8[sp+j]; if(u8[sp+j] !== 0xFF) unknown = false; }
  var ds = sp + sl;
  var de = unknown ? end : Math.min(end, ds + size);
  return { id:id, pos:pos, sizePos:sp, sizeLen:sl, dataStart:ds, dataEnd:de, end:de, unknown:unknown, size:size };
}
function encodeVint_(val, len){
  var max = Math.pow(2, 7*len) - 2;
  if(val > max) return null;
  var bytes = new Uint8Array(len);
  for(var i=len-1;i>0;i--){ bytes[i] = val % 256; val = Math.floor(val/256); }
  bytes[0] = val | (0x80 >> (len-1));
  return bytes;
}
function patchWebm_(u8, durationMs){
  var end = u8.length, pos = 0, seg = null, el, i;
  while(pos < end){
    el = readEl_(u8, pos, end);
    if(!el) return null;
    if(el.id === 0x18538067){ seg = el; break; }
    pos = el.end;
  }
  if(!seg) return null;
  pos = seg.dataStart;
  var info = null;
  while(pos < seg.dataEnd){
    el = readEl_(u8, pos, seg.dataEnd);
    if(!el) break;
    if(el.id === 0x1549A966){ info = el; break; }
    if(el.id === 0x1F43B675) break;
    pos = el.end;
  }
  if(!info) return null;
  var scale = 1000000, dur = null;
  pos = info.dataStart;
  while(pos < info.dataEnd){
    el = readEl_(u8, pos, info.dataEnd);
    if(!el) break;
    if(el.id === 0x2AD7B1){
      scale = 0;
      for(i=el.dataStart;i<el.dataEnd;i++) scale = scale*256 + u8[i];
      if(!scale) scale = 1000000;
    }
    if(el.id === 0x4489) dur = el;
    pos = el.end;
  }
  var tc = durationMs * 1000000 / scale;
  var f64 = new DataView(new ArrayBuffer(8));
  f64.setFloat64(0, tc, false);
  if(dur){
    if(dur.size === 8){ for(i=0;i<8;i++) u8[dur.dataStart+i] = f64.getUint8(i); return u8; }
    if(dur.size === 4){
      var f32 = new DataView(new ArrayBuffer(4));
      f32.setFloat32(0, tc, false);
      for(i=0;i<4;i++) u8[dur.dataStart+i] = f32.getUint8(i);
      return u8;
    }
    return null;
  }
  var insert = new Uint8Array(11);
  insert[0] = 0x44; insert[1] = 0x89; insert[2] = 0x88;
  for(i=0;i<8;i++) insert[3+i] = f64.getUint8(i);
  var newSizeBytes = encodeVint_((info.dataEnd - info.dataStart) + 11, info.sizeLen);
  if(!newSizeBytes) return null;
  var segPatch = null;
  if(!seg.unknown){
    segPatch = encodeVint_(seg.size + 11, seg.sizeLen);
    if(!segPatch) return null;
  }
  var out = new Uint8Array(u8.length + 11);
  out.set(u8.subarray(0, info.sizePos), 0);
  out.set(newSizeBytes, info.sizePos);
  out.set(u8.subarray(info.dataStart, info.dataEnd), info.dataStart);
  out.set(insert, info.dataEnd);
  out.set(u8.subarray(info.dataEnd), info.dataEnd + 11);
  if(segPatch) out.set(segPatch, seg.sizePos);
  return out;
}
function fixWebmDuration(blob, durationMs, cb){
  var fr = new FileReader();
  fr.onload = function(){
    try{
      var out = patchWebm_(new Uint8Array(fr.result), durationMs);
      cb(out ? new Blob([out], { type: blob.type }) : blob);
    }catch(e){ cb(blob); }
  };
  fr.onerror = function(){ cb(blob); };
  fr.readAsArrayBuffer(blob);
}
/* Mesmo problema quando o Chrome grava MP4: mvhd/tkhd/mdhd saem com
   duração 0 e o Windows mostra o vídeo "sem duração". Este patch escreve
   a duração da timeline direto nos cabeçalhos do MP4. */
function patchMp4_(u8, durationMs){
  function rd32(p){ return u8[p]*16777216 + u8[p+1]*65536 + u8[p+2]*256 + u8[p+3]; }
  function wr32(p, v){ u8[p]=(v>>>24)&255; u8[p+1]=(v>>>16)&255; u8[p+2]=(v>>>8)&255; u8[p+3]=v&255; }
  function wr64(p, v){
    var hi = Math.floor(v / 4294967296);
    wr32(p, hi); wr32(p+4, v - hi*4294967296);
  }
  /* percorre boxes MP4 entre start..end chamando cb(tipo, iníciodados, fim) */
  function boxes(start, end, cb){
    var p = start;
    while(p + 8 <= end){
      var sz = rd32(p);
      var type = String.fromCharCode(u8[p+4], u8[p+5], u8[p+6], u8[p+7]);
      var hdr = 8, boxEnd;
      if(sz === 1){ boxEnd = p + rd32(p+8)*4294967296 + rd32(p+12); hdr = 16; }
      else if(sz === 0){ boxEnd = end; }
      else boxEnd = p + sz;
      if(boxEnd <= p || boxEnd > end) return;
      cb(type, p + hdr, boxEnd);
      p = boxEnd;
    }
  }
  var changed = false, movTs = 1000;
  boxes(0, u8.length, function(t, ds, de){
    if(t !== 'moov') return;
    boxes(ds, de, function(t2, ds2, de2){
      if(t2 === 'mvhd'){
        var ver = u8[ds2], d;
        if(ver === 0){ movTs = rd32(ds2+12) || 1000; d = Math.round(durationMs*movTs/1000); wr32(ds2+16, d); }
        else { movTs = rd32(ds2+20) || 1000; d = Math.round(durationMs*movTs/1000); wr64(ds2+24, d); }
        changed = true;
      }
      if(t2 === 'trak'){
        boxes(ds2, de2, function(t3, ds3, de3){
          if(t3 === 'tkhd'){
            var tv = u8[ds3], td = Math.round(durationMs*movTs/1000);
            if(tv === 0) wr32(ds3+20, td); else wr64(ds3+28, td);
            changed = true;
          }
          if(t3 === 'mdia'){
            boxes(ds3, de3, function(t4, ds4){
              if(t4 !== 'mdhd') return;
              var mv = u8[ds4], ts;
              if(mv === 0){ ts = rd32(ds4+12) || 1000; wr32(ds4+16, Math.round(durationMs*ts/1000)); }
              else { ts = rd32(ds4+20) || 1000; wr64(ds4+24, Math.round(durationMs*ts/1000)); }
              changed = true;
            });
          }
        });
      }
      if(t2 === 'mvex'){
        boxes(ds2, de2, function(t3, ds3){
          if(t3 !== 'mehd') return;
          var ev = u8[ds3], ed = Math.round(durationMs*movTs/1000);
          if(ev === 0) wr32(ds3+4, ed); else wr64(ds3+4, ed);
          changed = true;
        });
      }
    });
  });
  return changed ? u8 : null;
}
function fixMp4Duration(blob, durationMs, cb){
  var fr = new FileReader();
  fr.onload = function(){
    try{
      var out = patchMp4_(new Uint8Array(fr.result), durationMs);
      cb(out ? new Blob([out], { type: blob.type }) : blob);
    }catch(e){ cb(blob); }
  };
  fr.onerror = function(){ cb(blob); };
  fr.readAsArrayBuffer(blob);
}
var exportDurMs = 0;
function pickMime(){
  /* prioridade total pro MP4/H.264 (compatível com WhatsApp e editores).
     strings com profile explícito — o Chrome rejeita "avc1" genérico e
     sem isso o export caía em WebM, que o WhatsApp não abre */
  var list = [
    'video/mp4;codecs="avc1.640028,mp4a.40.2"',
    'video/mp4;codecs="avc1.4D401F,mp4a.40.2"',
    'video/mp4;codecs="avc1.42E01E,mp4a.40.2"',
    'video/mp4;codecs=avc1.42E01E,mp4a.40.2',
    'video/mp4;codecs=avc1,mp4a.40.2',
    'video/mp4',
    'video/webm;codecs=vp9,opus',
    'video/webm;codecs=vp8,opus',
    'video/webm'
  ];
  for(var i=0;i<list.length;i++){
    try{
      if(window.MediaRecorder && MediaRecorder.isTypeSupported(list[i])) return list[i];
    }catch(e){}
  }
  return '';
}

/* download + restauração da UI (comum aos dois caminhos de export) */
function exportCleanup(){
  $('mce-export-overlay').classList.remove('is-open');
  exporting = false;
  setCanvasRes(PREVIEW_SCALE);   /* volta pro preview leve */
  drawFrame();
}
/* linha de diagnóstico no overlay de export — mostra o MOTOR em uso, pra
   identificar qual caminho de render está rodando de verdade nesta máquina */
function setExportDiag(txt){
  try{ var e = document.querySelector('.mce-export-sub'); if(e) e.textContent = txt; }catch(_){}
}

function exportDone(finalBlob, ext){
  /* export cancelado: NUNCA baixa o arquivo que terminou depois do cancelamento */
  if(exportCancelled) return;
  var suffix = exportPassTotal > 1 ? (textVariant === 0 ? '-v1' : '-v2') : '';
  /* nome do arquivo: {nº do vídeo do dia com 3 dígitos}-{usuário} — contador
     diário que reseta à meia-noite (horário de Brasília). Só conta quando o
     arquivo realmente sai (cancelou = não consome número). */
  if(!exportSeqNum) exportSeqNum = nextRenderSeq();
  var a = document.createElement('a');
  a.href = URL.createObjectURL(finalBlob);
  a.download = ('00' + exportSeqNum).slice(-3) + '-' + mcUserSlug() + suffix + '.' + ext;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(function(){ URL.revokeObjectURL(a.href); }, 60000);
  /* ainda tem versão de texto pra renderizar? roda a próxima passada */
  exportPassList.shift();
  if(exportPassList.length){
    runExportPass();
    return;
  }
  textVariant = exportVariantPrev;
  bumpCityUsageFromTimeline();   /* conta o uso das cidades dos textos do vídeo */
  exportCleanup();
  renderAll();
  if(ext === 'webm'){
    alert('Atenção: seu navegador não suporta exportação em MP4, então o vídeo saiu em WebM — o WhatsApp e alguns editores não abrem esse formato. Atualize o Chrome/Edge.');
  }
}

/* ── caminho 1: export DETERMINÍSTICO frame a frame (WebCodecs + mp4-muxer).
   Nada roda em tempo real: cada vídeo é posicionado no tempo EXATO do frame
   (seek + espera do 'seeked'), o canvas é desenhado e codificado. O arquivo
   sai perfeitamente fluido mesmo que a máquina não dê conta em tempo real —
   era isso que causava a mídia travada/stuttering no vídeo final.
   Áudio: mixado offline (OfflineAudioContext) e codificado em AAC. ── */
var exportFrameMode = false;
var exportAbort = false;

function wcFrameSupported(){
  return !!(window.VideoEncoder && window.AudioEncoder && window.OfflineAudioContext && window.Mp4Muxer && window.VideoFrame);
}

/* seek frame-exato: espera o 'seeked' E o frame ser realmente apresentado
   (requestVideoFrameCallback) antes de resolver — sem isso, às vezes o canvas
   era desenhado com o frame anterior, gerando a trepidação no export */
function seekElTo(el, t){
  return new Promise(function(res){
    /* já está (praticamente) no tempo pedido: setar currentTime pro mesmo
       valor NÃO dispara 'seeked' e o frame ficaria esperando o timeout —
       resolve direto (o frame apresentado já é o certo) */
    if(Math.abs((el.currentTime || 0) - t) < 0.4 / FPS){ res(); return; }
    var done = false;
    var fin = function(){
      if(done) return;
      done = true;
      el.removeEventListener('seeked', onSeeked);
      res();
    };
    var onSeeked = function(){
      /* garante que o frame recém-buscado foi decodificado e pintado.
         rVFC nem sempre dispara em <video> fora da tela (só desenhado no
         canvas), então corre em paralelo com um timeout curto — sem isso
         cada frame caía na rede de segurança de 800ms e o export levava
         uma eternidade */
      if(el.requestVideoFrameCallback){
        try{
          el.requestVideoFrameCallback(function(){ fin(); });
          setTimeout(fin, 40);   /* era 100 — o 'seeked' já garante o frame decodificado */
          return;
        }catch(_){}
      }
      fin();
    };
    el.addEventListener('seeked', onSeeked);
    try{ el.currentTime = t; }catch(e){ fin(); return; }
    setTimeout(fin, 400);   /* rede de segurança (era 800) */
  });
}

/* cache de AudioBuffer por src (decodifica 1x, reusa nas 2 passadas) */
var _exportBufCache = {};
function decodeClipBuffer(src){
  if(_exportBufCache[src]) return _exportBufCache[src];
  var AC = window.AudioContext || window.webkitAudioContext;
  /* rawBytes = fetch com fallback pro proxy (CORS) e cache compartilhado com o
     decode de vídeo; slice(0) porque decodeAudioData consome o buffer */
  _exportBufCache[src] = rawBytes(src).then(function(buf){
    if(!waveAC) waveAC = new AC();
    return waveAC.decodeAudioData(buf.slice(0));
  });
  return _exportBufCache[src];
}

/* mixa todo o áudio audível da timeline num buffer offline (2ch) */
function renderOfflineAudio(dur, sr){
  var oac = new OfflineAudioContext(2, Math.max(1, Math.ceil(dur * sr)), sr);
  var jobs = [];
  mediaOwners().forEach(function(c){
    if(!clipIsAudible(c)) return;
    var src = c.el.currentSrc || c.el.src;
    if(!src) return;
    var tr = audioSideTrack(c);
    var vol = trackGain(tr) * clipVol(c);   /* fader do mixer × volume do clipe */
    jobs.push(decodeClipBuffer(src).then(function(buf){
      var node = oac.createBufferSource();
      node.buffer = buf;
      node.playbackRate.value = clipRate(c);   /* retime também no export */
      var g = oac.createGain();
      /* FADE in/out: automação de ganho no export (0 → vol → 0). O fade vem do
         clipe de áudio (ou do áudio pareado, no caso do vídeo). */
      var govF = (c.kind === 'audio') ? c : pairOf(c);
      var fi = govF ? (govF.fadeIn || 0) : 0, fo = govF ? (govF.fadeOut || 0) : 0;
      var cs = Math.max(0, c.start), ce = cs + c.dur;
      if(fi > 0 || fo > 0){
        fi = Math.min(fi, c.dur); fo = Math.min(fo, c.dur);
        g.gain.setValueAtTime(fi > 0 ? 0.0001 : vol, cs);
        if(fi > 0) g.gain.linearRampToValueAtTime(vol, cs + fi);
        if(fo > 0){
          g.gain.setValueAtTime(vol, Math.max(cs + fi, ce - fo));
          g.gain.linearRampToValueAtTime(0.0001, ce);
        }
      } else {
        g.gain.value = vol;
      }
      node.connect(g);
      g.connect(oac.destination);
      var off = Math.max(0, c.in);
      /* duração em tempo de MÍDIA (c.dur × rate), tocada em c.dur segundos */
      var d = Math.min(c.dur * clipRate(c), Math.max(0, buf.duration - off));
      if(d > 0) node.start(Math.max(0, c.start), off, d);
    }).catch(function(){ /* clipe sem áudio decodificável: segue sem ele */ }));
  });
  return Promise.all(jobs).then(function(){ return oac.startRendering(); });
}

/* ══════════ RENDER RÁPIDO (WebCodecs · decode sequencial, sem seek) ══════════
   Em vez de dar seek no <video> a cada frame (lento: decodifica do keyframe
   pra frente toda vez), demuxa o arquivo (mp4box) e decodifica os frames EM
   ORDEM num VideoDecoder. Entrega o frame exato pra cada instante da timeline,
   sem espera de 'seeked'. É por CLIPE (o tempo de mídia de um clipe cresce de
   forma monotônica durante o export, então dá pra decodificar só pra frente).
   Requisitos: window.MP4Box (arquivo mp4box.all.min.js nos Assets) + VideoDecoder
   + fonte MP4/H.264 acessível por fetch (mesmo domínio / CORS). Qualquer falha
   → aquele clipe volta pro seek automaticamente. Desligar: localStorage
   'mce_fast_render' = '0'. */
var _fastMap = {};      /* clipId -> FastSource | false(falhou) | null(construindo) */
var _rawCache = {};     /* url -> Promise<ArrayBuffer> (baixa 1x por sessão) */
function srcKey(c){ return c.el && (c.el.currentSrc || c.el.src) || ''; }
/* bytes do arquivo, cacheados. Pra Pinterest via proxy o src já é um blob
   (leitura instantânea, sem rede); pro CDN direto baixa 1x e reusa nas duas
   passadas do export (variantes A/B do texto). */
function rawBytes(url){
  if(_rawCache[url]) return _rawCache[url];
  var p;
  if(/pinimg\.com|pinterest\./i.test(url)){
    /* CDN do Pinterest sempre bloqueia CORS no fetch → vai DIRETO pro proxy
       (evita o erro no console e a tentativa perdida) */
    p = proxyBytes(url);
  } else {
    p = fetch(url).then(function(r){ if(!r.ok) throw new Error('http ' + r.status); return r.arrayBuffer(); })
        .catch(function(){ return proxyBytes(url); });   /* bloqueou → proxy do servidor */
  }
  _rawCache[url] = p;
  p.catch(function(){ delete _rawCache[url]; });   /* não cacheia erro */
  return p;
}
/* baixa os bytes pelo proxy do GAS (server-side, sem CORS) — mesmo endpoint do
   fallback de adicionar pin. Usado quando o fetch direto do CDN é bloqueado. */
function proxyBytes(url){
  return new Promise(function(resolve, reject){
    if(typeof gas !== 'function'){ reject(new Error('sem proxy')); return; }
    gas({ resource:'proxy_video', video_url: url }, function(err, d){
      if(err || !d || d.error || !d.b64){ reject(err || new Error('proxy falhou')); return; }
      try{
        var bin = atob(d.b64), u = new Uint8Array(bin.length);
        for(var i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i);
        resolve(u.buffer);
      }catch(e){ reject(e); }
    }, 240000);
  });
}
/* modo de render: 'normal' (seek) | 'fast' (WebCodecs) | 'turbo' (WebCodecs +
   ajustes agressivos). Compatível com a flag antiga 'mce_fast_render'. */
function renderMode(){
  try{ var m = localStorage.getItem('mce_render_mode'); if(m) return m; }catch(_){}
  try{ if(localStorage.getItem('mce_fast_render') === '0') return 'normal'; }catch(_){}
  return 'turbo';   /* padrão = turbo adaptativo */
}
function turboOn(){ return renderMode() === 'turbo'; }
function fastEnabled(){
  if(renderMode() === 'normal') return false;
  return !!(window.MP4Box && window.VideoDecoder && window.EncodedVideoChunk);
}
function resetFast(){
  for(var k in _fastMap){ var fs=_fastMap[k]; if(fs && fs.destroy) try{ fs.destroy(); }catch(e){} }
  _fastMap = {};
  clips.forEach(function(c){ if(c._srcFrame){ c._srcFrame = null; } });
}
/* pré-monta o provider de TODOS os clipes de vídeo antes do loop de frames —
   sem isso o decoder do clipe seguinte só começava a montar quando o clipe
   entrava, e os primeiros frames caíam no seek do elemento (preto na transição) */
function warmFastAll(){
  if(!fastEnabled()) return Promise.resolve(null);
  var vids = clips.filter(function(c){ return c.kind === 'video' && c.el; });
  if(!vids.length) return Promise.resolve(null);
  vids.forEach(function(c){ getFast(c); });   /* dispara a montagem de todos */
  return new Promise(function(res){
    var t0 = performance.now();
    (function poll(){
      var pending = vids.some(function(c){ return _fastMap[c.id] === null; });
      if(!pending || performance.now() - t0 > 6000) res(null);
      else setTimeout(poll, 50);
    })();
  });
}
/* pega/começa o provider do clipe. Retorna o provider PRONTO, ou null (ainda
   construindo ou indisponível → o chamador usa seek nesse frame). */
function getFast(c){
  if(!fastEnabled()) return null;
  var id = c.id, cur = _fastMap[id];
  if(cur === false) return null;
  if(cur && cur.ready) return cur;
  if(cur === undefined){
    _fastMap[id] = null;                 /* marca "construindo" */
    var k = srcKey(c);
    if(!k){ _fastMap[id] = false; return null; }
    FastSource.create(k).then(function(fs){
      /* clipe APARADO (in > 0): posiciona no keyframe antes do ponto de
         entrada — sem isso o decoder varria o arquivo inteiro do 0 até o
         corte (a travada no render na área do corte) */
      if(fs && fs.seekToKeyframe) fs.seekToKeyframe(Math.max(0, (c.in || 0) - 0.1));
      _fastMap[id] = fs || false;
    }).catch(function(){ _fastMap[id] = false; });
  }
  return null;
}
function getDescBox(file, trackId){
  try{
    var trak = file.getTrackById(trackId);
    var entries = trak.mdia.minf.stbl.stsd.entries;
    for(var i=0;i<entries.length;i++){
      var e = entries[i], box = e.avcC || e.hvcC || e.vpcC || e.av1C;
      if(box){
        var DS = window.DataStream || (window.MP4Box && window.MP4Box.DataStream);
        if(!DS) return null;
        var ds = new DS(undefined, 0, DS.BIG_ENDIAN);
        box.write(ds);
        return new Uint8Array(ds.buffer, 8);   /* tira o cabeçalho do box (size+type) */
      }
    }
  }catch(e){}
  return null;
}
function FastSource(){}
FastSource.create = function(url){
  return new Promise(function(resolve){
    if(!fastEnabled()){ resolve(null); return; }
    rawBytes(url).then(function(master){
      var ab = master.slice(0);   /* cópia: mp4box pode consumir o buffer */
      var self = new FastSource();
      self.samples = []; self.frames = []; self.fed = 0;
      self.decoder = null; self.done = false; self.ready = false;
      self.error = false; self.waiters = [];
      var file = window.MP4Box.createFile();
      var settled = false;
      var giveUp = function(){ if(settled) return; settled = true; try{ if(self.decoder) self.decoder.close(); }catch(e){} resolve(null); };
      file.onError = giveUp;
      file.onSamples = function(id, u, samples){
        for(var i=0;i<samples.length;i++){
          var s = samples[i];
          self.samples.push({ data: s.data, cts: s.cts, dur: s.duration, ts: s.timescale, key: !!s.is_sync });
        }
      };
      file.onReady = function(info){
        var vt = info.videoTracks && info.videoTracks[0];
        if(!vt){ giveUp(); return; }
        var cfg = { codec: vt.codec, codedWidth: (vt.video && vt.video.width) || vt.track_width, codedHeight: (vt.video && vt.video.height) || vt.track_height, optimizeForLatency: true };
        var desc = getDescBox(file, vt.id);
        if(desc) cfg.description = desc;
        var boot = function(hw){
          if(hw) cfg.hardwareAcceleration = hw;
          try{
            self.decoder = new VideoDecoder({
              output: function(frame){ self._onFrame(frame); },
              error:  function(e){ self.error = true; self._wake(); }
            });
            self.decoder.configure(cfg);
          }catch(e){ giveUp(); return; }
          file.setExtractionOptions(vt.id, null, { nbSamples: 1000000000 });
          file.start(); file.flush();
          if(!self.samples.length){ giveUp(); return; }   /* nada extraído → seek */
          self.ready = true; settled = true; resolve(self);
        };
        if(window.VideoDecoder.isConfigSupported){
          var probe = Object.assign({}, cfg, { hardwareAcceleration:'prefer-hardware' });
          window.VideoDecoder.isConfigSupported(probe).then(function(s){
            if(s && s.supported) boot('prefer-hardware');
            else window.VideoDecoder.isConfigSupported(cfg).then(function(s2){
              (s2 && s2.supported) ? boot(null) : giveUp();
            }).catch(giveUp);
          }).catch(function(){ boot(null); });
        } else boot(null);
      };
      ab.fileStart = 0;
      file.appendBuffer(ab);
      file.flush();
      setTimeout(giveUp, 8000);   /* trava de segurança na montagem */
    }).catch(function(){ resolve(null); });
  });
};
FastSource.prototype._wake = function(){ var w=this.waiters; this.waiters=[]; for(var i=0;i<w.length;i++) w[i](); };
FastSource.prototype._onFrame = function(frame){
  var ts = frame.timestamp;
  /* CATCH-UP (clipe aparado): frame muito ANTES do alvo atual nunca será
     exibido — fecha na hora. Sem isso o pool do decoder de hardware esgotava
     (ele guarda ~8-16 frames) e o decode travava exatamente no corte. */
  if(this.pendingT != null && ts < this.pendingT - 200000){
    try{ frame.close(); }catch(e){}
    this._wake();
    return;
  }
  var f=this.frames, i=f.length;
  while(i>0 && f[i-1].timestamp > ts) i--;
  f.splice(i,0,frame);
  this._wake();
};
FastSource.prototype._pump = function(){
  var d=this.decoder; if(!d) return;
  while(d.decodeQueueSize < 16 && this.fed < this.samples.length){   /* lookahead maior = decoder sempre à frente */
    var s=this.samples[this.fed++];
    try{
      d.decode(new EncodedVideoChunk({
        type: s.key ? 'key' : 'delta',
        timestamp: Math.round(s.cts / s.ts * 1e6),
        duration:  Math.round(s.dur / s.ts * 1e6),
        data: s.data
      }));
    }catch(e){ this.error = true; break; }
  }
  if(this.fed >= this.samples.length && !this.done){
    this.done = true;
    try{ d.flush().then(this._wake.bind(this), function(){}); }catch(e){}
  }
};
/* posiciona o decoder no KEYFRAME cujo tempo <= mediaTime (segundos) — usado
   pra clipes aparados começarem perto do ponto de entrada, sem varrer o
   arquivo desde o início. Só vale ANTES do primeiro decode. */
FastSource.prototype.seekToKeyframe = function(mediaTime){
  if(this.fed > 0 || !this.samples.length) return;   /* já decodificando — não mexe */
  var idx = 0;
  for(var i=0;i<this.samples.length;i++){
    var s = this.samples[i];
    if(s.key){
      var ct = s.cts / s.ts;
      if(ct <= mediaTime) idx = i; else break;
    }
  }
  this.fed = idx;
};
/* retorna o VideoFrame que cobre o tempo de mídia t (segundos). Decodifica só
   pra frente e fecha os frames já passados. Resolve null se não der (o
   chamador cai pro seek). */
FastSource.prototype.frameAt = function(t){
  var self=this, tt=Math.round(t*1e6);
  self.pendingT = tt;   /* alvo atual — frames muito antes disso são descartados no _onFrame */
  return new Promise(function(resolve){
    var settled=false, done=function(v){ if(settled) return; settled=true; resolve(v); };
    var check=function(){
      if(self.error){ done(null); return true; }
      var f=self.frames, idx=-1;
      for(var i=0;i<f.length;i++){ if(f[i].timestamp <= tt) idx=i; else break; }
      var haveNext = f.length && f[f.length-1].timestamp > tt;
      if(idx>=0 && (haveNext || self.done)){
        for(var j=0;j<idx;j++){ try{ f[j].close(); }catch(e){} }
        self.frames = f.slice(idx);
        done(self.frames[0]); return true;
      }
      if(self.done){ done(f.length ? f[0] : null); return true; }
      return false;
    };
    var loop=function(){ if(settled) return; self._pump(); if(!check()) self.waiters.push(loop); };
    setTimeout(function(){ done(null); }, 4000);   /* stall → seek */
    loop();
  });
};
FastSource.prototype.destroy = function(){
  try{ if(this.decoder && this.decoder.state !== 'closed') this.decoder.close(); }catch(e){}
  for(var i=0;i<this.frames.length;i++){ try{ this.frames[i].close(); }catch(e){} }
  this.frames = []; this.samples = [];
};

/* ══════════ PROXY DE EDIÇÃO (vídeos hostis a seek — ex.: gerados por IA) ══════════
   Arquivos com keyframes esparsos (GOP gigante) fazem QUALQUER seek decodificar
   segundos de vídeo → playback, setinhas e bordas de corte travam (em qualquer
   player). Ao detectar um arquivo assim, o editor re-encoda em segundo plano com
   keyframe a cada 1s (mesma resolução, 10 Mbps ≈ visualmente idêntico) e passa a
   usar o proxy na galeria e na timeline. Mesma ideia do "optimized media" do
   DaVinci. */
var _proxyDone = {};   /* url original → url do proxy | false (analisando/não precisa) */

function proxySupported(){
  return !!(window.MP4Box && window.VideoDecoder && window.VideoEncoder && window.AudioEncoder && window.Mp4Muxer && window.EncodedVideoChunk);
}

/* conta os keyframes do arquivo (pra decidir se precisa de proxy) */
function analyzeKF(ab){
  return new Promise(function(res){
    try{
      var file = window.MP4Box.createFile(), done = false;
      var fin = function(v){ if(done) return; done = true; res(v); };
      file.onError = function(){ fin(null); };
      file.onReady = function(info){
        var vt = info.videoTracks && info.videoTracks[0];
        if(!vt){ fin(null); return; }
        file.setExtractionOptions(vt.id, null, { nbSamples: 1000000000 });
        file.onSamples = function(id, u, samples){
          if(done) return;
          var keys = 0;
          for(var i=0;i<samples.length;i++) if(samples[i].is_sync) keys++;
          fin({ keys: keys, frames: samples.length, dur: vt.duration / vt.timescale });
        };
        file.start(); file.flush();
      };
      var cp = ab.slice(0); cp.fileStart = 0;
      file.appendBuffer(cp); file.flush();
      setTimeout(function(){ fin(null); }, 8000);
    }catch(e){ res(null); }
  });
}

/* analisa o item da galeria e, se o arquivo for hostil a seek, gera o proxy */
function maybeBuildProxy(it){
  if(!proxySupported() || !it || it.type !== 'video' || !it.url) return;
  if(_proxyDone[it.url] !== undefined) return;
  _proxyDone[it.url] = false;   /* analisando (não repete) */
  var origUrl = it.url;
  rawBytes(origUrl).then(function(ab){
    return analyzeKF(ab).then(function(inf){
      if(!inf || !inf.keys || !inf.dur) return;
      var kfInt = inf.dur / inf.keys;
      console.log('[MCE-KF] ' + it.name + ' — frames=' + inf.frames + ' keyframes=' + inf.keys + ' · intervalo≈' + kfInt.toFixed(2) + 's');
      if(kfInt <= 1.8 || inf.dur < 3) return;   /* keyframes densos → seek ok, sem proxy */
      showToast('Otimizando ' + it.name + ' pra edição…', 'fila');
      return buildProxyBlob(ab).then(function(purl){
        if(!purl){ console.warn('[MCE-KF] proxy falhou pra ' + it.name); return; }
        _proxyDone[origUrl] = purl;
        _rawCache[purl] = null; delete _rawCache[purl];   /* deixa o cache limpo */
        if(it.url === origUrl) it.url = purl;   /* galeria passa a usar o proxy */
        swapClipsSrc(origUrl, purl);
        showToast('Vídeo otimizado pra edição', 'ok');
        console.log('[MCE-KF] proxy pronto: ' + it.name);
      });
    });
  }).catch(function(e){ try{ console.warn('[MCE-KF] análise falhou:', e); }catch(_){} });
}

/* troca a fonte dos clipes que já estão na timeline (preserva a posição) */
function swapClipsSrc(origUrl, proxyUrl){
  clips.forEach(function(c){
    if(c.kind !== 'video' || !c.el) return;
    var k = c.el.currentSrc || c.el.src;
    if(k !== origUrl) return;
    var t = c.el.currentTime || 0;
    c.el.src = proxyUrl;
    try{ c.el.load(); }catch(_){}
    warmEl(c.el, t || (c.in || 0));
  });
  renderAll(); drawFrame();
}

/* re-encoda o arquivo: vídeo com keyframe a cada 1s + áudio AAC re-encodado */
function buildProxyBlob(ab){
  return new Promise(function(resolveAll){
    var fin = function(v){ resolveAll(v || null); };
    try{
      /* 1) áudio primeiro (define sampleRate do muxer); arquivo sem áudio → só vídeo */
      var AC = window.AudioContext || window.webkitAudioContext;
      var audioP = (AC ? new Promise(function(res){
        try{
          var actx = new AC();
          actx.decodeAudioData(ab.slice(0)).then(function(buf){ try{ actx.close(); }catch(_){} res(buf); },
                                                function(){ try{ actx.close(); }catch(_){} res(null); });
        }catch(e){ res(null); }
      }) : Promise.resolve(null));

      /* 2) parse do vídeo */
      var file = window.MP4Box.createFile();
      var vt = null, vSamples = [];
      file.onError = function(){ fin(null); };
      file.onReady = function(info){
        vt = info.videoTracks && info.videoTracks[0];
        if(!vt){ fin(null); return; }
        file.setExtractionOptions(vt.id, null, { nbSamples: 1000000000 });
        file.onSamples = function(id, u, samples){
          for(var i=0;i<samples.length;i++){ var s = samples[i]; vSamples.push({ data:s.data, cts:s.cts, dur:s.duration, ts:s.timescale, key:!!s.is_sync }); }
        };
        file.start(); file.flush();
        if(!vSamples.length){ fin(null); return; }
        audioP.then(function(audioBuf){ runProxyEncode(file, vt, vSamples, audioBuf, fin); });
      };
      var cp = ab.slice(0); cp.fileStart = 0;
      file.appendBuffer(cp); file.flush();
      setTimeout(function(){ if(!vt) fin(null); }, 8000);
    }catch(e){ fin(null); }
  });
}

function runProxyEncode(file, vt, samples, audioBuf, fin){
  try{
    var W = ((vt.video && vt.video.width) || vt.track_width) & ~1;
    var H = ((vt.video && vt.video.height) || vt.track_height) & ~1;
    if(!W || !H){ fin(null); return; }
    var hasAudio = !!(audioBuf && audioBuf.length);
    var SR = hasAudio ? audioBuf.sampleRate : 48000;
    var muxCfg = {
      target: new Mp4Muxer.ArrayBufferTarget(),
      video: { codec:'avc', width: W, height: H, frameRate: 30 },
      fastStart: 'in-memory'
    };
    if(hasAudio) muxCfg.audio = { codec:'aac', sampleRate: SR, numberOfChannels: 2 };
    var muxer = new Mp4Muxer.Muxer(muxCfg);
    var failed = false, vDone = false, aDone = !hasAudio;
    var venc2 = null, dec2 = null;
    var fail = function(){
      if(failed) return; failed = true;
      try{ venc2 && venc2.close(); }catch(_){}
      try{ dec2 && dec2.close(); }catch(_){}
      fin(null);
    };
    var doneCheck = function(){
      if(failed || !vDone || !aDone) return;
      try{
        muxer.finalize();
        fin(URL.createObjectURL(new Blob([muxer.target.buffer], { type:'video/mp4' })));
      }catch(e){ fin(null); }
    };

    /* ── áudio: buffer decodificado → AAC ── */
    if(hasAudio){
      try{
        var aenc2 = new AudioEncoder({
          output: function(ch, meta){ try{ muxer.addAudioChunk(ch, meta); }catch(e){ fail(); } },
          error: fail
        });
        aenc2.configure({ codec:'mp4a.40.2', sampleRate: SR, numberOfChannels: 2, bitrate: 192000 });
        var L = audioBuf.getChannelData(0);
        var R = audioBuf.numberOfChannels > 1 ? audioBuf.getChannelData(1) : L;
        var CH = 4800;
        for(var off = 0; off < audioBuf.length; off += CH){
          var n = Math.min(CH, audioBuf.length - off);
          var data = new Float32Array(n * 2);
          data.set(L.subarray(off, off + n), 0);
          data.set(R.subarray(off, off + n), n);
          aenc2.encode(new AudioData({ format:'f32-planar', sampleRate: SR, numberOfFrames: n, numberOfChannels: 2, timestamp: Math.round(off / SR * 1e6), data: data }));
        }
        aenc2.flush().then(function(){ try{ aenc2.close(); }catch(_){} aDone = true; doneCheck(); }, fail);
      }catch(e){ fail(); return; }
    }

    /* ── vídeo: decode sequencial → encode keyframe a cada 24 frames (~1s) ── */
    try{
      venc2 = new VideoEncoder({
        output: function(ch, meta){ try{ muxer.addVideoChunk(ch, meta); }catch(e){ fail(); } },
        error: fail
      });
      venc2.configure({ codec:'avc1.640028', width: W, height: H, bitrate: 10000000, framerate: 30 });
    }catch(e){ fail(); return; }
    var dcfg = { codec: vt.codec, codedWidth: W, codedHeight: H, optimizeForLatency: true };
    var desc = getDescBox(file, vt.id);
    if(desc) dcfg.description = desc;
    /* timestamps do proxy começam do 0 (tira offset de edit list) */
    var t0 = Infinity;
    for(var si = 0; si < samples.length; si++){ var sc = samples[si].cts / samples[si].ts; if(sc < t0) t0 = sc; }
    if(!isFinite(t0)) t0 = 0;
    var outIdx = 0, fed2 = 0, vFlushed = false;
    try{
      dec2 = new VideoDecoder({
        output: function(frame){
          if(failed){ try{ frame.close(); }catch(_){} return; }
          try{
            var nf = new VideoFrame(frame, { timestamp: Math.max(0, frame.timestamp - Math.round(t0 * 1e6)) });
            venc2.encode(nf, { keyFrame: (outIdx % 24) === 0 });
            outIdx++;
            nf.close();
          }catch(e){ fail(); }
          try{ frame.close(); }catch(_){}
          pump2();
        },
        error: fail
      });
      dec2.configure(dcfg);
    }catch(e){ fail(); return; }
    function pump2(){
      if(failed) return;
      while(dec2.decodeQueueSize < 8 && fed2 < samples.length){
        var s = samples[fed2++];
        try{ dec2.decode(new EncodedVideoChunk({ type: s.key ? 'key' : 'delta', timestamp: Math.round(s.cts / s.ts * 1e6), duration: Math.round(s.dur / s.ts * 1e6), data: s.data })); }
        catch(e){ fail(); return; }
      }
      if(fed2 >= samples.length && !vFlushed){
        vFlushed = true;
        dec2.flush().then(function(){ return venc2.flush(); }).then(function(){
          try{ dec2.close(); }catch(_){}
          try{ venc2.close(); }catch(_){}
          vDone = true; doneCheck();
        }, fail);
      }
    }
    pump2();
  }catch(e){ fin(null); }
}

/* espera o encoder esvaziar a fila SEM idle fixo: resolve no evento 'dequeue'
   (ou num poll de 1ms como fallback). Substitui o setTimeout(15) que só
   desperdiçava tempo entre frames. */
function drainEncoder(enc, target){
  return new Promise(function(res){
    if(enc.encodeQueueSize <= target){ res(); return; }
    var done=false, fin=function(){ if(done) return; done=true; try{ enc.removeEventListener && enc.removeEventListener('dequeue', h); }catch(e){} clearInterval(iv); clearTimeout(to); res(); };
    var h=function(){ if(enc.encodeQueueSize <= target) fin(); };
    try{ enc.addEventListener && enc.addEventListener('dequeue', h); }catch(e){}
    var iv=setInterval(function(){ if(enc.encodeQueueSize <= target) fin(); }, 1);
    var to=setTimeout(fin, 1000);   /* trava de segurança */
  });
}

/* ══════════ TURBO · encode de vídeo em Web Worker (Etapa 1) ══════════
   Proxy com a MESMA interface do VideoEncoder (configure/encode/flush/close/
   encodeQueueSize), mas que roda o encoder numa thread separada. Os frames
   compostos são TRANSFERIDOS (zero-cópia) pro worker. */
function WorkerVideoEncoder(blobUrl, onChunk){
  this.w = new Worker(blobUrl);
  this._q = 0; this._flushRes = null; this.error = null;
  var self = this;
  this.w.onmessage = function(e){
    var m = e.data || {};
    if(m.type === 'chunk'){
      self._q = Math.max(0, self._q - 1);
      var chunk = new EncodedVideoChunk({ type: m.chunkType, timestamp: m.timestamp, duration: m.duration, data: m.data });
      onChunk(chunk, m.decoderConfig ? { decoderConfig: m.decoderConfig } : undefined);
    } else if(m.type === 'flushed'){ if(self._flushRes){ self._flushRes(); self._flushRes = null; } }
    else if(m.type === 'error'){ self.error = m.message; if(window.console) console.warn('worker enc:', m.message); }
  };
  this.w.onerror = function(ev){ self.error = (ev && ev.message) || 'worker error'; };
}
WorkerVideoEncoder.prototype.configure = function(cfg){ this.w.postMessage({ type: 'config', cfg: cfg }); };
WorkerVideoEncoder.prototype.encode = function(frame, opts){ this._q++; this.w.postMessage({ type: 'frame', frame: frame, keyFrame: !!(opts && opts.keyFrame) }, [frame]); };
Object.defineProperty(WorkerVideoEncoder.prototype, 'encodeQueueSize', { get: function(){ return this._q; } });
WorkerVideoEncoder.prototype.flush = function(){ var self = this; return new Promise(function(res){ self._flushRes = res; self.w.postMessage({ type: 'flush' }); }); };
WorkerVideoEncoder.prototype.close = function(){ var w = this.w; try{ w.postMessage({ type: 'close' }); }catch(e){} setTimeout(function(){ try{ w.terminate(); }catch(e){} }, 200); };

/* o worker vem dos Assets (cross-origin no Shopify) → baixa e vira Blob URL,
   que o construtor Worker aceita mesmo cross-origin */
var _workerBlob = null;
function ensureWorkerBlob(){
  if(_workerBlob) return _workerBlob;
  var url = window.MCE_WORKER_URL || '';
  if(!url || !window.Worker){ _workerBlob = Promise.resolve(null); return _workerBlob; }
  _workerBlob = fetch(url).then(function(r){ if(!r.ok) throw new Error('http ' + r.status); return r.text(); })
    .then(function(code){ return URL.createObjectURL(new Blob([code], { type: 'text/javascript' })); })
    .catch(function(){ return null; });
  return _workerBlob;
}
/* PROBE: valida ponta-a-ponta (transfere 1 frame na config real, espera o
   chunk). Só usa o worker se isso funcionar; senão, encoder normal na main. */
var _workerProbe = null;
function probeWorker(vcfg){
  if(_workerProbe) return _workerProbe;
  _workerProbe = ensureWorkerBlob().then(function(blobUrl){
    if(!blobUrl || !window.OffscreenCanvas || !window.VideoFrame) return null;
    return new Promise(function(resolve){
      var w; try{ w = new Worker(blobUrl); }catch(e){ resolve(null); return; }
      var done = false, fin = function(ok){ if(done) return; done = true; clearTimeout(to); try{ w.terminate(); }catch(e){} resolve(ok ? blobUrl : null); };
      w.onmessage = function(e){ var d = e.data || {}; if(d.type === 'chunk') fin(true); else if(d.type === 'error') fin(false); };
      w.onerror = function(){ fin(false); };
      var to = setTimeout(function(){ fin(false); }, 3000);
      try{
        w.postMessage({ type: 'config', cfg: vcfg });
        var oc = new OffscreenCanvas(vcfg.width, vcfg.height);
        var g = oc.getContext('2d'); if(g){ g.fillStyle = '#000'; g.fillRect(0, 0, vcfg.width, vcfg.height); }
        var vf = new VideoFrame(oc, { timestamp: 0, duration: Math.round(1e6 / FPS) });
        w.postMessage({ type: 'frame', frame: vf, keyFrame: true }, [vf]);
        w.postMessage({ type: 'flush' });
      }catch(e){ fin(false); }
    });
  }).catch(function(){ return null; });
  return _workerProbe;
}

/* ══════════ FASE 2 · render completo dentro do worker (vídeo + texto) ══════════ */
var _fetchTextCache = {}, _fetchBytesCache = {};
function fetchText(url){
  if(!url) return Promise.resolve(null);
  if(_fetchTextCache[url]) return _fetchTextCache[url];
  var p = fetch(url).then(function(r){ if(!r.ok) throw 0; return r.text(); }).catch(function(){ return null; });
  _fetchTextCache[url] = p; return p;
}
function fetchBytes(url){
  if(!url) return Promise.resolve(null);
  if(_fetchBytesCache[url]) return _fetchBytesCache[url];
  var p = fetch(url).then(function(r){ if(!r.ok) throw 0; return r.arrayBuffer(); }).catch(function(){ return null; });
  _fetchBytesCache[url] = p; return p;
}
/* bytes da Bebas Neue (modelo 3) pro worker: resolve o woff2 real via o CSS
   do Google Fonts — cacheado por sessão */
var _bebasBytesP = null;
function getBebasBytes(){
  if(_bebasBytesP) return _bebasBytesP;
  _bebasBytesP = fetchText('https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap')
    .then(function(css){
      if(!css) return null;
      /* o css2 traz VÁRIOS subsets e o latin-ext vem ANTES do latin — pegar o
         primeiro url() carregava um subset SEM os glifos básicos, e o worker
         caía no fallback (era a "outra fonte" do modelo 3 ao renderizar com
         vídeo). Pega explicitamente o bloco do subset latin. */
      var m = css.match(/\/\*\s*latin\s*\*\/[^}]*?url\((https:[^)]+\.woff2)\)/);
      if(!m) m = css.match(/url\((https:[^)]+\.woff2)\)/);
      return m ? fetchBytes(m[1]) : null;
    }).catch(function(){ return null; });
  return _bebasBytesP;
}
/* cria o worker completo a partir dos Assets (baixa como texto → Blob URL pra
   contornar cross-origin) e injeta o mp4box via importScripts (Blob também) */
function bootFullWorker(){
  return Promise.all([ fetchText(window.MCE_FULL_WORKER_URL), fetchText(window.MCE_MP4BOX_URL) ]).then(function(codes){
    var wcode = codes[0], mcode = codes[1];
    if(!wcode || !mcode) return null;
    var w;
    try{ w = new Worker(URL.createObjectURL(new Blob([wcode], { type:'text/javascript' }))); }
    catch(e){ return null; }
    var mUrl = URL.createObjectURL(new Blob([mcode], { type:'text/javascript' }));
    return new Promise(function(resolve){
      var to = setTimeout(function(){ try{ w.terminate(); }catch(e){} resolve(null); }, 8000);
      w.onmessage = function(e){
        var m = e.data || {};
        if(m.type === 'booted'){ clearTimeout(to); if(m.ok) resolve(w); else { try{ w.terminate(); }catch(_){} resolve(null); } }
      };
      w.onerror = function(){ clearTimeout(to); try{ w.terminate(); }catch(e){} resolve(null); };
      w.postMessage({ type:'boot', mp4boxBlobUrl: mUrl });
    });
  }).catch(function(){ return null; });
}
/* serializa o estado necessário (variante de texto atual via tData) */
function serializeForWorker(){
  var tks = tracks.map(function(t){ return { id:t.id, kind:t.kind, hidden:!!t.hidden }; });
  var cls = [];
  clips.forEach(function(c){
    if(c.kind === 'video' && c.el){
      cls.push({ id:c.id, kind:'video', trackId:c.trackId, start:c.start, dur:c.dur, in:c.in||0, rate:clipRate(c), srcDur:c.srcDur||0, src: srcKey(c),
        cropL:c.cropL||0, cropR:c.cropR||0, cropT:c.cropT||0, cropB:c.cropB||0, mirror:!!c.mirror,
        posX:c.posX||0, posY:c.posY||0, vScale:(c.vScale != null ? c.vScale : 1) });
    } else if(c.kind === 'text'){
      var D = tData(c);
      cls.push({
        id:c.id, kind:'text', trackId:c.trackId, start:c.start, dur:c.dur,
        modelType: Number(D.modelType != null ? D.modelType : c.modelType) || 1,
        text:D.text, x:D.x, y:D.y, size:D.size, lineGap:D.lineGap, upper: upFlag(D.upper),
        padding: D.padding, padV: D.padV,
        chapeu: D.chapeu || '', chapeuSize: D.chapeuSize, chapeuGap: D.chapeuGap,
        chapeuUpper: upFlag(D.chapeuUpper),
        showBg: !!D.showBg, gradHeight: D.gradHeight
      });
    } else if(c.kind === 'speed'){
      cls.push({ id:c.id, kind:'speed', trackId:c.trackId, start:c.start, dur:c.dur, in:c.in||0, speedTime:c.speedTime||2.92, scale:c.scale||0.8, y:(c.y != null ? c.y : 0.18) });
    }
  });
  return { tracks:tks, clips:cls };
}
/* logo do TripRank como ImageBitmap (transferível pro worker) */
function getLogoBitmap(){
  return new Promise(function(resolve){
    try{
      if(typeof TRIP_LOGO !== 'undefined' && TRIP_LOGO_OK && TRIP_LOGO.naturalWidth){
        createImageBitmap(TRIP_LOGO).then(resolve, function(){ resolve(null); });
        return;
      }
    }catch(e){}
    if(window.MCE_LOGO_URL){
      fetch(window.MCE_LOGO_URL).then(function(r){ if(!r.ok) throw 0; return r.blob(); })
        .then(function(b){ return createImageBitmap(b); }).then(resolve, function(){ resolve(null); });
    } else resolve(null);
  });
}
/* lê os keyframes (em frames da TIMELINE) de um clipe de vídeo simples, via
   mp4box na thread principal — pra cortar os segmentos exatamente nos GOPs e
   evitar re-decode de overlap quando os keyframes são esparsos */
function keyframeFramesFromBytes(bytes, clip){
  return new Promise(function(resolve){
    try{
      if(!window.MP4Box){ resolve(null); return; }
      var file = window.MP4Box.createFile(), kf = [], settled = false;
      var fin = function(){ if(settled) return; settled = true; resolve(kf.length ? kf : null); };
      file.onError = function(){ if(!settled){ settled = true; resolve(null); } };
      file.onReady = function(info){
        var vt = info.videoTracks && info.videoTracks[0];
        if(!vt){ if(!settled){ settled = true; resolve(null); } return; }
        file.setExtractionOptions(vt.id, null, { nbSamples: 1000000000 });
        file.start(); file.flush(); fin();
      };
      file.onSamples = function(id, u, samples){
        for(var i = 0; i < samples.length; i++){
          var s = samples[i];
          if(s.is_sync){
            var mt = s.cts / s.timescale;
            var tf = Math.round(clip.start * FPS + (mt - (clip.in || 0)) * FPS / (clip.rate || 1));
            if(tf >= 0) kf.push(tf);
          }
        }
      };
      var ab = bytes.slice(0); ab.fileStart = 0;
      file.appendBuffer(ab); file.flush();
      setTimeout(fin, 4000);
    }catch(e){ resolve(null); }
  });
}
function planKeyframeSegments(kf, total, N){
  kf = kf.filter(function(f){ return f < total; }).sort(function(a, b){ return a - b; });
  var uniq = []; for(var i = 0; i < kf.length; i++){ if(!uniq.length || kf[i] !== uniq[uniq.length - 1]) uniq.push(kf[i]); }
  kf = uniq;
  if(!kf.length || kf[0] > 0) kf.unshift(0);
  var boundaries;
  if(kf.length <= N) boundaries = kf.slice();
  else { boundaries = []; for(var j = 0; j < N; j++){ var b = kf[Math.floor(j * kf.length / N)]; if(!boundaries.length || b !== boundaries[boundaries.length - 1]) boundaries.push(b); } }
  var segs = [];
  for(var k = 0; k < boundaries.length; k++){
    var s = boundaries[k], e = (k + 1 < boundaries.length) ? boundaries[k + 1] : total;
    if(s < e) segs.push({ start: s, end: e });
  }
  return segs;
}
/* plano de segmentos: alinhado a keyframes no caso comum (1 vídeo, sem retime);
   senão, corte uniforme */
function computeSegments(total, N, ser){
  var vClips = ser.clips.filter(function(c){ return c.kind === 'video' && c.src; });
  var uniform = function(){ var segs = [], per = Math.ceil(total / N); for(var i = 0; i < N; i++){ var s = i * per, e = Math.min(total, (i + 1) * per); if(s < e) segs.push({ start: s, end: e }); } return segs; };
  if(vClips.length !== 1 || (vClips[0].rate || 1) !== 1) return Promise.resolve(uniform());
  return rawBytes(vClips[0].src).then(function(bytes){ return keyframeFramesFromBytes(bytes, vClips[0]); })
    .then(function(kf){ if(!kf || kf.length < 2) return uniform(); var segs = planKeyframeSegments(kf, total, N); return (segs && segs.length) ? segs : uniform(); })
    .catch(function(){ return uniform(); });
}
function runExportFull(onFail){
  var dur = projDur();
  var total = Math.max(1, Math.round(dur * FPS));
  var SR = 48000;
  var kfEvery = Math.max(1, Math.round(FPS * 5));
  exportAbort = false; exportFrameMode = true; exporting = true;
  setExportDiag('motor: TURBO paralelo (multi-worker)');
  var vcfg = {
    codec:'avc1.640028', width: cv.width, height: cv.height,
    bitrate: 10000000, framerate: FPS, latencyMode:'realtime', bitrateMode:'variable'
  };
  var failed = false, workers = [];
  var killWorkers = function(){ workers.forEach(function(w){ try{ w.terminate(); }catch(e){} }); workers = []; };
  var bail = function(){ if(failed) return; failed = true; killWorkers(); exportFrameMode = false; exporting = false; if(onFail) onFail(); };

  /* nº de workers ADAPTATIVO à máquina (encode/decode por software escala com
     os núcleos, sem o limite de sessão da GPU):
       - hardwareConcurrency conta THREADS; o ganho vai até os núcleos FÍSICOS,
         então uso ~metade como estimativa;
       - limito pela RAM aproximada (cada worker guarda cópia do vídeo + buffers);
       - teto 12 (acima disso satura).
     Máquina fraca pega poucos; forte, mais. Override: window.MCE_MAX_WORKERS.
     Ainda exijo ~2s por segmento (Math.floor(total/48)) pra alinhar com os
     keyframes e não desperdiçar decode nas emendas. */
  var hc = navigator.hardwareConcurrency || 4;
  var mem = navigator.deviceMemory || 4;   /* GB aprox (Chrome limita a 8) */
  var auto = Math.max(1, Math.min(Math.round(hc / 2), Math.round(mem * 1.5), 12));
  var maxW = window.MCE_MAX_WORKERS || auto;
  var cores = Math.max(1, Math.min(hc, maxW));
  var N = Math.max(1, Math.min(cores, Math.floor(total / 48) || 1));

  var ser = serializeForWorker();
  var vids = {};
  ser.clips.forEach(function(c){ if(c.kind === 'video' && c.src) vids[c.src] = 1; });
  var srcs = Object.keys(vids);
  var bootJobs = []; for(var bi = 0; bi < N; bi++) bootJobs.push(bootFullWorker());

  Promise.all([
    renderOfflineAudio(dur, SR),
    fetchBytes(window.MCE_FONT_URL),
    fetchBytes(window.MCE_TRIPFONT_BOLD_URL),
    fetchBytes(window.MCE_TRIPFONT_URL),
    fetchBytes(window.MCE_LOGO_URL),
    Promise.all(srcs.map(function(s){ return rawBytes(s).then(function(ab){ return { src:s, ab:ab }; }, function(){ return { src:s, ab:null }; }); })),
    Promise.all(bootJobs),
    computeSegments(total, N, ser),
    getBebasBytes()
  ]).then(function(r){
    if(exportAbort){ exportFrameMode = false; exporting = false; return; }
    var audioBuf = r[0], fontBytes = r[1], tripBold = r[2], tripReg = r[3], logoBytes = r[4], vlist = r[5], ws = r[6], segs = r[7], bebasBytes = r[8];
    workers = ws.filter(function(w){ return !!w; });
    if(!workers.length){ bail(); return; }
    /* modelo 3 usa Bebas Neue: sem os bytes da fonte, o worker sairia com a
       fonte errada → cai pro render da thread principal (fiel) */
    var needBebas = ser.clips.some(function(c){ return c.kind === 'text' && Number(c.modelType) === 3; });
    if(needBebas && !bebasBytes){ killWorkers(); bail(); return; }
    /* segmentos alinhados a keyframes (r[7]); reconcilia com os workers que
       realmente subiram */
    var uni = function(cnt){ var a = [], per = Math.ceil(total / cnt); for(var i = 0; i < cnt; i++){ var s = i * per, e = Math.min(total, (i + 1) * per); if(s < e) a.push({ start: s, end: e }); } return a; };
    if(!segs || !segs.length || segs.length > workers.length) segs = uni(workers.length);
    else if(segs.length < workers.length){ for(var wi = segs.length; wi < workers.length; wi++){ try{ workers[wi].terminate(); }catch(e){} } workers = workers.slice(0, segs.length); }
    N = workers.length;

    /* AUTO: paralelo por software só compensa com segmentos suficientes. Com
       poucos GOPs (keyframes esparsos) ou máquina fraca, 1 encoder de HARDWARE
       (caminho Rápido, thread única) é mais rápido — então cai pra ele. */
    var PAR_MIN = window.MCE_PAR_MIN || 4;
    if(N < PAR_MIN){ killWorkers(); if(window.MCE_DEBUG && window.console) console.log('[turbo] ' + N + ' segmento(s) < ' + PAR_MIN + ' → usando Rápido (hardware)'); bail(); return; }

    /* paralelo: a GPU normalmente só deixa 1 encoder de hardware; com N>1 os
       extras dão deadlock. Então força SOFTWARE (sem limite de sessão). */
    var swMode = (N > 1);
    vcfg.hardwareAcceleration = swMode ? 'prefer-software' : 'prefer-hardware';

    var srcMaster = {};
    vlist.forEach(function(it){ if(it.ab) srcMaster[it.src] = it.ab; });

    var muxer = new Mp4Muxer.Muxer({
      target: new Mp4Muxer.ArrayBufferTarget(),
      video: { codec:'avc', width: cv.width, height: cv.height, frameRate: FPS },
      audio: { codec:'aac', sampleRate: SR, numberOfChannels: 2 },
      fastStart: 'in-memory'
    });
    var aEnc = new AudioEncoder({ output: function(chunk, meta){ try{ muxer.addAudioChunk(chunk, meta); }catch(e){} }, error: function(){} });
    aEnc.configure({ codec:'mp4a.40.2', sampleRate: SR, numberOfChannels: 2, bitrate: 192000 });
    var CH = 4800, Lc = audioBuf.getChannelData(0), Rc = audioBuf.numberOfChannels > 1 ? audioBuf.getChannelData(1) : Lc;
    for(var off = 0; off < audioBuf.length; off += CH){
      var n = Math.min(CH, audioBuf.length - off);
      var data = new Float32Array(n * 2);
      data.set(Lc.subarray(off, off + n), 0); data.set(Rc.subarray(off, off + n), n);
      aEnc.encode(new AudioData({ format:'f32-planar', sampleRate: SR, numberOfFrames: n, numberOfChannels: 2, timestamp: Math.round(off / SR * 1e6), data: data }));
    }

    /* cada worker renderiza seu segmento (alinhado a keyframe) em paralelo */
    var allChunks = [], doneCount = 0, prog = new Array(N), finalized = false;
    for(var pi = 0; pi < N; pi++) prog[pi] = 0;
    var updateProgress = function(){
      var sum = 0; for(var k = 0; k < N; k++) sum += prog[k];
      var pct = Math.round(Math.min(100, sum / total * 100));
      $('mce-export-bar').style.width = pct + '%'; $('mce-export-pct').textContent = pct + '%';
    };
    /* ao terminar TODOS: ordena os chunks por timestamp e muxa em ordem.
       A muxagem roda em LOTES (macrotasks) — muxar milhares de chunks de uma
       vez travava a interface perto do fim ("trava no final") */
    var finalizeAll = function(){
      if(finalized) return; finalized = true;
      var subEl = document.querySelector('.mce-export-sub');
      if(subEl) subEl.textContent = 'finalizando o arquivo…';
      allChunks.sort(function(a, b){ return a.ts - b.ts; });
      var dc = null, k;
      for(k = 0; k < allChunks.length; k++){ if(allChunks[k].dc){ dc = allChunks[k].dc; break; } }
      var idx = 0, firstChunk = true;
      var pump = function(){
        var end = Math.min(allChunks.length, idx + 400);
        for(; idx < end; idx++){
          var ch = allChunks[idx];
          try{
            var chunk = new EncodedVideoChunk({ type: ch.type, timestamp: ch.ts, duration: ch.dur, data: ch.data });
            muxer.addVideoChunk(chunk, (firstChunk && dc) ? { decoderConfig: dc } : undefined);
            firstChunk = false;
          }catch(e){}
        }
        if(idx < allChunks.length){ setTimeout(pump, 0); return; }
        aEnc.flush().then(function(){
          try{ aEnc.close(); }catch(e){}
          muxer.finalize();
          killWorkers();
          exportFrameMode = false; exporting = false;
          exportDone(new Blob([muxer.target.buffer], { type:'video/mp4' }), 'mp4');
        }, function(){ bail(); });
      };
      pump();
    };

    workers.forEach(function(w, idx){
      var segStart = segs[idx].start, segEnd = segs[idx].end;
      w.onmessage = function(e){
        var m = e.data || {};
        if(exportAbort){ killWorkers(); exportFrameMode = false; exporting = false; return; }
        if(m.type === 'chunk'){
          allChunks.push({ ts: m.timestamp, type: m.chunkType, dur: m.duration, data: m.data, dc: m.decoderConfig || null });
        } else if(m.type === 'progress'){
          prog[idx] = Math.max(0, m.f - segStart); updateProgress();
        } else if(m.type === 'done'){
          prog[idx] = segEnd - segStart; updateProgress();
          doneCount++; if(doneCount >= N) finalizeAll();
        } else if(m.type === 'diag'){
          if(window.MCE_DEBUG && window.console) console.log('[turbo worker]', m.msg);
        } else if(m.type === 'error'){
          if(window.console) console.warn('full worker:', m.message);
          try{ aEnc.close(); }catch(e){}
          bail();
        }
      };
      w.onerror = function(){ bail(); };

      /* cada worker recebe sua CÓPIA dos bytes (transfer neutraliza) + segmento */
      var srcBytes = {}, transfer = [];
      srcs.forEach(function(s){ if(srcMaster[s]){ var cp = srcMaster[s].slice(0); srcBytes[s] = cp; transfer.push(cp); } });
      var fb = fontBytes ? fontBytes.slice(0) : null;
      var tb = tripBold ? tripBold.slice(0) : null;
      var tr = tripReg ? tripReg.slice(0) : null;
      var lb = logoBytes ? logoBytes.slice(0) : null;
      var bb = bebasBytes ? bebasBytes.slice(0) : null;
      if(fb) transfer.push(fb);
      if(tb) transfer.push(tb);
      if(tr) transfer.push(tr);
      if(lb) transfer.push(lb);
      if(bb) transfer.push(bb);
      w.postMessage({
        type:'render', fps: FPS, kfEvery: kfEvery, segStart: segStart, segEnd: segEnd, vcfg: vcfg,
        tracks: ser.tracks, clips: ser.clips, srcBytes: srcBytes, swDecode: swMode,
        fontBytes: fb, tripBoldBytes: tb, tripRegBytes: tr, logoBytes: lb, bebasBytes: bb
      }, transfer);
    });

    /* watchdog: se o progresso travar por 45s, cai pro render normal */
    var lastSum = -1, stuckSince = Date.now();
    var watchdog = setInterval(function(){
      if(finalized || failed){ clearInterval(watchdog); return; }
      var sum = 0; for(var k = 0; k < N; k++) sum += prog[k];
      if(sum > lastSum){ lastSum = sum; stuckSince = Date.now(); }
      else if(Date.now() - stuckSince > 45000){
        clearInterval(watchdog);
        if(window.console) console.warn('turbo: sem progresso por 45s, caindo pro render normal');
        bail();
      }
    }, 2000);
  }).catch(function(){ bail(); });
}

/* dispatcher: no TURBO, se a timeline for só vídeo+texto (sem TripRank) e o
   worker completo estiver disponível, renderiza tudo dentro do worker (Fase 2).
   Qualquer impedimento → cai no caminho da thread principal (runExportFramesMain). */
function hasSpeedClip(){ for(var i=0;i<clips.length;i++) if(clips[i].kind === 'speed') return true; return false; }
function fullWorkerEligible(){
  return turboOn() && !!window.MCE_FULL_WORKER_URL
      && !!(window.Worker && window.OffscreenCanvas && window.VideoDecoder && window.VideoEncoder && window.MP4Box);
}
/* TURBO ADAPTATIVO: escolhe o melhor caminho por tipo de fonte.
   - Vídeos locais (blob:) → render paralelo completo (Fase 2, multi-worker
     software encode). Os bytes já estão na memória — transfer instantâneo.
   - Vídeos do Pinterest (CDN pinimg/pinterest) → single-thread HW encode.
     O download via proxy CORS é lento; ficar esperando em N workers não
     compensa. O hardware encoder (1 thread) roda o frame assim que o seek
     do <video> entrega, sem precisar baixar o arquivo inteiro antes.
   Qualquer falha no caminho escolhido cai no seguinte automaticamente. */
function allClipsLocal(){
  for(var i=0;i<clips.length;i++){
    if(clips[i].kind !== 'video') continue;
    var s = srcKey(clips[i]);
    if(s && !/^blob:/i.test(s)) return false;
  }
  return true;
}
function runExportFrames(){
  /* o worker completo agora desenha os 3 modelos de texto (1, 2 e 3, com
     chapéu/degradê e as fontes carregadas por bytes) — não precisa mais cair
     pra thread principal quando há modelo 2/3 na timeline */
  /* imagens na timeline: o worker não desenha <img> — usa o caminho principal */
  var hasImage = clips.some(function(c){ return c.kind === 'image'; });
  if(fullWorkerEligible() && allClipsLocal() && !hasImage){
    /* local: render paralelo (decode+encode em N workers por software) */
    runExportFull(function(){ runExportFramesMain(); });
    return;
  }
  /* Pinterest / CDN / misto / sem worker: single-thread, HW accel,
     com FastSource (decode sequencial via WebCodecs) quando disponível */
  runExportFramesMain();
}

function runExportFramesMain(){
  var dur = projDur();
  var total = Math.max(1, Math.round(dur * FPS));
  var SR = 48000;
  /* turbo: menos keyframes (a cada 5s vs 2s) → menos trabalho de encode e
     arquivo menor. Some granularidade de scrub, mas o vídeo final é o mesmo. */
  var kfEvery = Math.max(1, Math.round(FPS * (turboOn() ? 5 : 2)));
  resetFast();
  exportAbort = false;
  exportFrameMode = true;
  exporting = true;

  /* config de vídeo montada ANTES: usada tanto no encoder normal quanto no
     worker. bitrate fixo 10 Mbps; 'realtime' + 'prefer-hardware' (GPU). */
  var vbr = 10000000;
  var vcfg = {
    codec:'avc1.640028', width: cv.width, height: cv.height,
    bitrate: vbr, framerate: FPS,
    latencyMode: 'realtime', bitrateMode: 'variable',
    hardwareAcceleration: 'prefer-hardware'
  };

  /* garante as fontes dos textos ANTES de desenhar qualquer frame — sem isso
     o modelo 3 podia sair com a fonte fallback no arquivo final */
  var fontsReady = (document.fonts && document.fonts.load)
    ? Promise.all([
        document.fonts.load('700 100px "Montserrat"').catch(function(){}),
        document.fonts.load('400 100px "Bebas Neue"').catch(function(){})
      ])
    : Promise.resolve(null);
  /* áudio offline + (no turbo) o probe do worker + PRÉ-MONTAGEM dos decoders
     de todos os clipes (evita o preto na transição), em paralelo */
  Promise.all([
    renderOfflineAudio(dur, SR),
    (turboOn() ? probeWorker(vcfg) : Promise.resolve(null)),
    fontsReady,
    warmFastAll()
  ]).then(function(pair){
    var audioBuf = pair[0], workerUrl = pair[1];
    /* diagnóstico visível: motor + quantos decoders rápidos ficaram prontos */
    var nProv = 0, nVid = 0;
    clips.forEach(function(c){ if(c.kind === 'video' && c.el){ nVid++; var p = _fastMap[c.id]; if(p && p.ready) nProv++; } });
    setExportDiag('motor: ' + (workerUrl ? 'turbo (worker único)' : 'thread principal')
      + ' · decoders ' + nProv + '/' + nVid
      + (window.MP4Box ? '' : ' · MP4BOX AUSENTE → modo seek'));
    if(exportAbort){ exportFrameMode = false; exporting = false; return; }
    var muxer = new Mp4Muxer.Muxer({
      target: new Mp4Muxer.ArrayBufferTarget(),
      video: { codec:'avc', width: cv.width, height: cv.height, frameRate: FPS },
      audio: { codec:'aac', sampleRate: SR, numberOfChannels: 2 },
      fastStart: 'in-memory'
    });
    var vOut = function(chunk, meta){ try{ muxer.addVideoChunk(chunk, meta); }catch(e){} };
    /* TURBO: encode numa Web Worker (o probe já confirmou que funciona aqui).
       Senão, encoder normal na thread principal com fallback hw→sw. */
    var onWorker = !!workerUrl, vEnc;
    if(onWorker){
      vEnc = new WorkerVideoEncoder(workerUrl, vOut);
      vEnc.configure(vcfg);   /* o worker faz o fallback hw→sw por dentro */
    } else {
      vEnc = new VideoEncoder({
        output: vOut,
        error: function(e){ if(window.console) console.warn('vEnc', e); }
      });
      try{ vEnc.configure(vcfg); }
      catch(e){
        try{ vcfg.hardwareAcceleration = 'no-preference'; vEnc.configure(vcfg); }
        catch(e2){ vcfg.latencyMode = 'quality'; vEnc.configure(vcfg); }   /* último recurso */
      }
    }
    var aEnc = new AudioEncoder({
      output: function(chunk, meta){ try{ muxer.addAudioChunk(chunk, meta); }catch(e){} },
      error: function(e){ if(window.console) console.warn('aEnc', e); }
    });
    aEnc.configure({ codec:'mp4a.40.2', sampleRate: SR, numberOfChannels: 2, bitrate: 192000 });

    /* áudio inteiro em blocos de 0.1s */
    var CH = 4800;
    var L = audioBuf.getChannelData(0);
    var R = audioBuf.numberOfChannels > 1 ? audioBuf.getChannelData(1) : L;
    for(var off = 0; off < audioBuf.length; off += CH){
      var n = Math.min(CH, audioBuf.length - off);
      var data = new Float32Array(n * 2);
      data.set(L.subarray(off, off + n), 0);
      data.set(R.subarray(off, off + n), n);
      aEnc.encode(new AudioData({
        format: 'f32-planar', sampleRate: SR, numberOfFrames: n, numberOfChannels: 2,
        timestamp: Math.round(off / SR * 1e6), data: data
      }));
    }

    /* vídeo frame a frame */
    mediaOwners().forEach(function(c){ try{ c.el.pause(); }catch(e){} });
    var f = 0;

    function abortEnc(){
      try{ vEnc.close(); }catch(e){}
      try{ aEnc.close(); }catch(e){}
      resetFast();
      exportFrameMode = false;
      exporting = false;
    }

    /* DIAG: fronteiras (inícios de clipes de vídeo além do 0) — loga o que é
       desenhado perto delas pra capturar a travada do corte com precisão */
    var _diagBounds = [];
    clips.forEach(function(c){ if(c.kind === 'video' && c.start > 0.01) _diagBounds.push(c.start); });
    function _nearBound(t){ for(var bi=0;bi<_diagBounds.length;bi++) if(Math.abs(t - _diagBounds[bi]) < 0.5) return true; return false; }

    function step(){
      if(exportAbort){ abortEnc(); return; }
      if(f >= total){ finish(); return; }
      tCur = f / FPS;
      var seeks = [], frameClips = [];
      mediaOwners().forEach(function(c){
        if(c.kind !== 'video' || !c.el || !activeAt(c, tCur)) return;
        /* busca no MEIO do intervalo do frame (não na borda): cai sempre
           dentro do frame certo, sem a ambiguidade que repetia/pulava frames */
        var want = clamp(mediaTimeAt(c, tCur) + 0.5 / FPS, 0, (c.srcDur || 1e9) - 0.001);
        var fs = getFast(c);
        var dg = _nearBound(tCur);
        if(fs){
          frameClips.push(c);
          seeks.push(fs.frameAt(want).then(function(vfr){
            if(dg) console.log('[MCE-DIAG] f=' + f + ' t=' + tCur.toFixed(3) + ' clip=' + c.name
              + ' in=' + (c.in||0).toFixed(3) + ' want=' + want.toFixed(3)
              + (vfr ? ' frame=' + (vfr.timestamp/1e6).toFixed(3) : ' FRAME=NULL→SEEK el@' + (c.el.currentTime||0).toFixed(3)));
            if(vfr){ c._srcFrame = vfr; }        /* decode direto (rápido) */
            else { c._srcFrame = null; return seekElTo(c.el, want); }   /* deu ruim → seek */
          }));
        } else {
          c._srcFrame = null;
          if(dg) console.log('[MCE-DIAG] f=' + f + ' t=' + tCur.toFixed(3) + ' clip=' + c.name + ' SEM PROVIDER → seek want=' + want.toFixed(3));
          seeks.push(seekElTo(c.el, want));      /* provider ainda montando / indisponível */
        }
      });
      Promise.all(seeks).then(function(){
        if(exportAbort){ abortEnc(); return; }
        drawFrame();
        /* solta as referências dos frames decodificados (o provider os fecha
           ao avançar); durante o preview normal _srcFrame fica sempre null */
        for(var fi=0; fi<frameClips.length; fi++) frameClips[fi]._srcFrame = null;
        var vf = new VideoFrame(cv, {
          timestamp: Math.round(f * 1e6 / FPS),
          duration: Math.round(1e6 / FPS)
        });
        vEnc.encode(vf, { keyFrame: f % kfEvery === 0 });
        if(!onWorker) vf.close();   /* no worker o frame é transferido (fechado lá) */
        f++;
        if(f % 6 === 0 || f >= total){
          var pct = Math.round(f / total * 100);
          $('mce-export-bar').style.width = pct + '%';
          $('mce-export-pct').textContent = pct + '%';
        }
        /* backpressure: só pausa quando a fila do encoder está bem cheia, e
           espera por evento (não idle fixo) — mantém a GPU saturada.
           A cada 8 frames dá um respiro de macrotask pro decoder/encoder
           entregarem os callbacks e a barra de progresso pintar. */
        if(vEnc.encodeQueueSize > 24) drainEncoder(vEnc, 10).then(step);
        else if(f % 8 === 0) setTimeout(step, 0);
        else step();
      });
    }

    function finish(){
      var subEl = document.querySelector('.mce-export-sub');
      if(subEl) subEl.textContent = 'finalizando o arquivo…';
      Promise.all([vEnc.flush(), aEnc.flush()]).then(function(){
        try{ vEnc.close(); }catch(e){}
        try{ aEnc.close(); }catch(e){}
        muxer.finalize();
        resetFast();
        exportFrameMode = false;
        exporting = false;
        exportDone(new Blob([muxer.target.buffer], { type: 'video/mp4' }), 'mp4');
      }).catch(function(err){
        resetFast();
        exportFrameMode = false;
        exportPassList = [];
        textVariant = exportVariantPrev;
        exportCleanup();
        alert('Erro ao finalizar o MP4: ' + (err && err.message ? err.message : err));
      });
    }

    step();
  }).catch(function(){
    /* mix offline falhou (ex.: fonte sem CORS) → cai pro export em tempo real */
    exportFrameMode = false;
    exporting = false;
    runExportRealtime();
  });
}

/* ── caminho 2 (fallback): MediaRecorder ── */
function startExportMR(stream){
  var mime = pickMime();
  exportChunks = [];
  try{
    exportRec = new MediaRecorder(stream, { mimeType: mime, videoBitsPerSecond: 10000000, audioBitsPerSecond: 192000 });
  }catch(e){
    exportRec = new MediaRecorder(stream);
  }
  exportRec.ondataavailable = function(e){ if(e.data && e.data.size) exportChunks.push(e.data); };
  exportRec.onstop = function(){
    var type = exportRec.mimeType || 'video/webm';
    var blob = new Blob(exportChunks, { type: type });
    var ext = type.indexOf('mp4') > -1 ? 'mp4' : 'webm';
    var done = function(finalBlob){ exportDone(finalBlob, ext); };
    /* duração do arquivo = duração total dos clipes da timeline */
    if(type.indexOf('webm') > -1) fixWebmDuration(blob, exportDurMs, done);
    else if(type.indexOf('mp4') > -1) fixMp4Duration(blob, exportDurMs, done);
    else done(blob);
  };
  exportRec.start(500);
}

/* export em passadas: com clipes de texto, renderiza e baixa automaticamente
   as DUAS versões (A e B); sem texto, uma passada só */
var exportPassList = [];
var exportPassTotal = 1;
var exportVariantPrev = 0;

function startExport(){
  if(!clips.length){ alert('Adicione algo na timeline primeiro.'); return; }
  exportSeqNum = 0;   /* novo export = novo número (as versões V1/V2 compartilham) */
  exportCancelled = false;
  /* registra no banco: cada link de vídeo exportado + usuário + data */
  var expUrls = [];
  clips.forEach(function(c){
    if(c.kind === 'video' && c.srcUrl && expUrls.indexOf(c.srcUrl) < 0) expUrls.push(c.srcUrl);
  });
  if(expUrls.length) logExport(expUrls);
  var hasText = false;
  for(var i=0;i<clips.length;i++) if(clips[i].kind === 'text'){ hasText = true; break; }
  exportPassList = hasText ? [0, 1] : [0];
  exportPassTotal = exportPassList.length;
  exportVariantPrev = textVariant;
  runExportPass();
}

function runExportPass(){
  textVariant = exportPassList[0];
  stop(true);
  playDir = 1;   /* export sempre roda pra frente */
  exportDurMs = Math.round(projDur() * 1000);

  setCanvasRes(1);        /* export em resolução cheia (1080x1920) */
  drawFrame();

  var passLabel = exportPassTotal > 1 ? ('EXPORTANDO VÍDEO — ' + (textVariant ? 'V2 (2/2)' : 'V1 (1/2)')) : 'EXPORTANDO VÍDEO';
  var titleEl = document.querySelector('.mce-export-title');
  if(titleEl) titleEl.textContent = passLabel;
  var subEl = document.querySelector('.mce-export-sub');

  $('mce-export-bar').style.width = '0%';
  $('mce-export-pct').textContent = '0%';
  $('mce-export-overlay').classList.add('is-open');

  exportRec = null;
  if(wcFrameSupported()){
    /* caminho novo: render frame a frame — vídeo 100% fluido no arquivo */
    if(subEl) subEl.textContent = 'renderizando, aguarde...';
    runExportFrames();
  } else if(window.MediaRecorder){
    if(subEl) subEl.textContent = 'a gravação roda em tempo real — não troque de aba';
    runExportRealtime();
  } else {
    $('mce-export-overlay').classList.remove('is-open');
    alert('Seu navegador não suporta gravação de vídeo. Use Chrome ou Edge.');
    textVariant = exportVariantPrev;
    setCanvasRes(PREVIEW_SCALE); drawFrame();
  }
}

/* fallback: gravação em tempo real via MediaRecorder (navegadores antigos) */
function runExportRealtime(){
  ensureGraph();
  applyVolumes();
  var stream = cv.captureStream(FPS);   /* 24fps */
  audioDest.stream.getAudioTracks().forEach(function(t){ stream.addTrack(t); });
  startExportMR(stream);
  exporting = true;
  play();
}

function finishExport(){
  pause();
  if(exportRec && exportRec.state !== 'inactive') exportRec.stop();
}

on('mce-export-cancel', 'click', function(){
  exportPassList = [];
  textVariant = exportVariantPrev;
  exportCancelled = true;      /* nada mais baixa desta sessão de export */
  exportAbort = true;          /* interrompe o render frame a frame */
  exportFrameMode = false;
  if(exportRec && exportRec.state !== 'inactive'){
    exportRec.onstop = function(){};
    exportRec.stop();
  }
  pause();
  exportCleanup();
  renderAll();
});

/* ══════════ DRAG DO TEXTO NO PREVIEW ══════════ */
var stageDrag = null;

function canvasPoint(e){
  var r = cv.getBoundingClientRect();
  return {
    x: (e.clientX - r.left) * (PROJ_W / r.width),
    y: (e.clientY - r.top) * (PROJ_H / r.height)
  };
}
function textAtPoint(pt){
  /* checa speed clips primeiro (ficam por cima) */
  for(var s=clips.length-1;s>=0;s--){
    var sc = clips[s];
    if(sc.kind !== 'speed' || !activeAt(sc, tCur)) continue;
    var sscl = sc.scale || 0.8;
    var boxW = 540 * sscl, boxH = 620 * sscl;
    var scx = PROJ_W/2 - boxW/2;                       /* sempre centralizado */
    var scy = (sc.y != null ? sc.y : 0.18) * PROJ_H;   /* topo do bloco */
    if(pt.x >= scx - 20 && pt.x <= scx + boxW + 20 && pt.y >= scy - 20 && pt.y <= scy + boxH + 20) return sc;
  }
  for(var i=clips.length-1;i>=0;i--){
    var c = clips[i];
    if(c.kind !== 'text' || !activeAt(c, tCur)) continue;
    var mt = tModel(c);
    var L = mt === 2 ? textLayout2(c) : mt === 3 ? textLayout3(c) : textLayout(c);
    if(pt.x >= L.x - 20 && pt.x <= L.x + L.blockW + 20 && pt.y >= L.y - 20 && pt.y <= L.y + L.blockH + 20) return c;
  }
  return null;
}

cv.addEventListener('mousedown', function(e){
  /* só o botão esquerdo arrasta texto/TripRank. O clique do scroll (botão do
     meio) e o direito são ignorados aqui — antes eles iniciavam o arraste do
     texto E, ao subir pro stage, o pan ao mesmo tempo, fazendo o texto trepidar. */
  if(e.button !== 0) return;
  var pt = canvasPoint(e);
  var c = textAtPoint(pt);
  if(c){
    e.stopPropagation();   /* impede o pan do stage de disparar junto (fim da trepidação) */
    selectClip(c);
    snapshot();
    var P = c.kind === 'text' ? tData(c) : c;
    stageDrag = { id: c.id, dx: pt.x - P.x * PROJ_W, dy: pt.y - P.y * PROJ_H, moved: false };
    cv.classList.add('mce-grabbing');
    renderClips(); syncTextPanel(); syncSpeedPanel();
    e.preventDefault();
  }
});
document.addEventListener('mousemove', function(e){
  if(stageDrag){
    var c = byId(stageDrag.id);
    if(!c){ stageDrag = null; return; }
    var pt = canvasPoint(e);
    stageDrag.moved = true;
    var P = c.kind === 'text' ? tData(c) : c;   /* texto: move a versão ativa */
    /* triprank: travado no centro horizontal — só move na vertical */
    /* modelo 2: travado no centro (locked) — não arrasta */
    if(c.kind === 'text' && (c.modelType || 1) === 2){
      P.y = clamp((pt.y - stageDrag.dy) / PROJ_H, 0, 1);
      drawFrame();
      return;
    }
    if(c.kind === 'speed') P.x = 0.5;
    else P.x = clamp((pt.x - stageDrag.dx) / PROJ_W, 0, 1);
    P.y = clamp((pt.y - stageDrag.dy) / PROJ_H, 0, 1);
    drawFrame();
  } else if(e.target === cv){
    cv.classList.toggle('mce-grab', !!textAtPoint(canvasPoint(e)));
  }
});
document.addEventListener('mouseup', function(){
  if(stageDrag){
    if(!stageDrag.moved) popSnapshot();
    stageDrag = null;
    cv.classList.remove('mce-grabbing');
  }
});

/* ══════════ EVENTOS / INIT ══════════ */
on('mce-pin-add', 'click', addPinterest);
on('mce-pin-url', 'keydown', function(e){ if(e.key === 'Enter') addPinterest(); });
/* histórico do Pinterest (botão relógio) */
on('mce-pin-history', 'click', pinHistOpen);
on('mce-hist-close', 'click', pinHistClose);
(function(){
  var ov = $('mce-hist-overlay');
  if(ov) ov.addEventListener('click', function(e){ if(e.target === ov) pinHistClose(); });
})();
/* transporte estilo DaVinci: início · reverso · parar · play · fim · loop */
on('mce-first', 'click', function(){ pause(); playDir = 1; tCur = 0; seekMedia(); drawFrame(); renderPlayhead(); this.blur(); });
on('mce-rev', 'click', function(){
  if(!clips.length) return;
  if(playing && playDir < 0){ pause(); }
  else { playDir = -1; play(); }
  this.blur();
});
on('mce-stop', 'click', function(){ pause(); playDir = 1; seekMedia(); drawFrame(); renderPlayhead(); this.blur(); });
on('mce-play', 'click', function(){
  if(playing && playDir > 0){ this.blur(); return; }
  pause(); playDir = 1; play(); this.blur();
});
on('mce-last', 'click', function(){ pause(); playDir = 1; tCur = projDur(); seekMedia(); drawFrame(); renderPlayhead(); this.blur(); });
on('mce-loop', 'click', function(){ loopPlay = !loopPlay; this.classList.toggle('is-on', loopPlay); this.blur(); });
on('mce-arrow', 'click', function(){ setCutMode(false); });
on('mce-split', 'click', function(){ setCutMode(!cutMode); });
on('mce-delete', 'click', function(){ doDelete(false); });

/* tamanho dos itens da galeria: slider no rodapé + ctrl+scroll */
var poolItemW = 96;
function setPoolItemW(w){
  poolItemW = clamp(w, 48, 200);
  var g = $('mce-pool-grid');
  /* min() garante pelo menos 2 colunas mesmo com itens grandes */
  if(g) g.style.gridTemplateColumns = 'repeat(auto-fill,minmax(min(' + poolItemW + 'px,calc(50% - 5px)),1fr))';
  var s = $('mce-pool-size');
  if(s && parseInt(s.value, 10) !== poolItemW) s.value = poolItemW;
}
on('mce-pool-size', 'input', function(){ setPoolItemW(parseInt(this.value, 10) || 96); });
/* a thumbnail inteira precisa caber no bloco: limita a altura das miniaturas
   à altura visível da galeria (bloco pequeno → miniaturas encolhem junto) */
(function(){
  var ps = document.querySelector('.mce-pool-scroll');
  if(!ps || !window.ResizeObserver) return;
  var ro = new ResizeObserver(function(){
    ps.style.setProperty('--pool-thumb-max', Math.max(48, ps.clientHeight - 52) + 'px');
  });
  ro.observe(ps);
})();
(function(){
  var ps = document.querySelector('.mce-pool-scroll');
  if(!ps) return;
  ps.addEventListener('wheel', function(e){
    if(!e.ctrlKey) return;
    e.preventDefault();
    setPoolItemW(poolItemW + (e.deltaY > 0 ? -12 : 12));
  }, { passive:false });
})();
on('mce-magnet', 'click', function(){
  snapOn = !snapOn;
  this.classList.toggle('is-on', snapOn);
  this.title = snapOn ? 'Ímã ligado: clipes se alinham nas bordas' : 'Ímã desligado';
});
function toggleFullscreen(){
  var wrap = $('mce-stage-wrap');
  if(document.fullscreenElement) document.exitFullscreen();
  else if(wrap && wrap.requestFullscreen) wrap.requestFullscreen();
}
on('mce-fullscreen', 'click', toggleFullscreen);

/* ══════════ ZOOM DO VÍDEO (Ctrl+Scroll) ══════════ */
var stageZoom = 1;
var stagePanX = 0, stagePanY = 0;
var canvasBox = document.querySelector('.mce-canvas-box');
var stageCanvasArea = document.querySelector('.mce-stage-canvas');   /* vídeo + área cinza (sem a barra de comandos) */

function applyStageZoom(){
  var inner = canvasBox.querySelector('#mce-canvas');
  var overlay = $('mce-overlay');
  var hint = $('mce-stage-hint');
  var tf = 'scale('+stageZoom+') translate('+stagePanX+'px,'+stagePanY+'px)';
  inner.style.transform = tf;
  if(overlay) overlay.style.transform = tf;
  if(hint) hint.style.transform = tf;
  $('mce-zoom-reset').classList.toggle('is-on', stageZoom !== 1);
  /* layout 2: zoom desbloqueia o canvas do fill vertical; reset re-trava */
  inner.classList.toggle('mce-zoomed', stageZoom !== 1);
}

stageCanvasArea.addEventListener('wheel', function(e){
  if(!e.ctrlKey) return;
  e.preventDefault();
  if(document.fullscreenElement) return;   /* fullscreen: sem zoom, vídeo preenche a tela */
  var delta = e.deltaY > 0 ? -0.15 : 0.15;
  var next = Math.min(5, Math.max(0.5, stageZoom + delta));
  /* zoom em torno do ponto do mouse */
  var r = canvasBox.getBoundingClientRect();
  var mx = (e.clientX - r.left) / r.width;
  var my = (e.clientY - r.top) / r.height;
  var ratio = next / stageZoom;
  stagePanX = stagePanX - (mx - 0.5) * (ratio - 1) * (r.width / stageZoom);
  stagePanY = stagePanY - (my - 0.5) * (ratio - 1) * (r.height / stageZoom);
  stageZoom = next;
  applyStageZoom();
}, { passive: false });

/* pan com botão do meio ou Ctrl+arrastar */
var stagePanning = false, panStart = null;
stageCanvasArea.addEventListener('mousedown', function(e){
  if(document.fullscreenElement) return;   /* fullscreen: sem pan */
  if(e.button === 1 || (e.ctrlKey && e.button === 0 && stageZoom > 1)){
    stagePanning = true;
    panStart = { x: e.clientX - stagePanX, y: e.clientY - stagePanY };
    e.preventDefault();
  }
});
document.addEventListener('mousemove', function(e){
  if(stagePanning && panStart){
    stagePanX = e.clientX - panStart.x;
    stagePanY = e.clientY - panStart.y;
    applyStageZoom();
  }
});
document.addEventListener('mouseup', function(e){
  if(stagePanning){ stagePanning = false; panStart = null; }
});

on('mce-zoom-reset', 'click', function(){
  stageZoom = 1; stagePanX = 0; stagePanY = 0;
  applyStageZoom();
});

/* ══════════ TOGGLE OVERLAY ══════════ */
/* o overlay só aparece se o usuário quiser E houver vídeo na timeline */
var overlayUserOn = true;
function updateOverlayVis(){
  var ov = $('mce-overlay');
  if(!ov) return;
  var hasVideo = clips.some(function(c){ return c.kind === 'video'; });
  ov.style.display = (overlayUserOn && hasVideo) ? '' : 'none';
}
on('mce-overlay-toggle', 'click', function(){
  overlayUserOn = !overlayUserOn;
  this.classList.toggle('is-on', overlayUserOn);
  updateOverlayVis();
});
(function(){ var b = $('mce-overlay-toggle'); if(b) b.classList.add('is-on'); })();
on('mce-add-track-video', 'click', function(){ addTrack('video'); });
on('mce-add-track-audio', 'click', function(){ addTrack('audio'); });
/* mce-add-track-text removido do HTML */
/* botão split de exportar: o botão principal e a setinha abrem o menu;
   escolher Normal/Rápido define o modo (localStorage) e dispara o export */
function openExportMenu(open){
  var split = $('mce-export-split'), menu = $('mce-export-menu');
  if(!split || !menu) return;
  var show = open == null ? menu.hidden : open;
  menu.hidden = !show;
  split.classList.toggle('is-open', show);
}
function toggleExportMenu(e){ if(e){ e.preventDefault(); e.stopPropagation(); } openExportMenu(); }
/* botão principal = turbo adaptativo direto */
on('mce-export', 'click', function(e){ if(e){ e.preventDefault(); e.stopPropagation(); } openExportMenu(false); pickMode('turbo'); });
on('mce-export-caret', 'click', toggleExportMenu);
function pickMode(mode){
  try{ localStorage.setItem('mce_render_mode', mode); }catch(_){}
  try{ localStorage.setItem('mce_fast_render', mode === 'normal' ? '0' : '1'); }catch(_){}   /* compat */
  openExportMenu(false); startExport();
}
/* ── Exportar MP3: mixa o áudio da timeline (mesmo mix do export de vídeo)
   e encoda em MP3 192kbps via lamejs (carregado sob demanda do CDN) ── */
function loadLame(){
  return new Promise(function(res){
    if(window.lamejs){ res(true); return; }
    var s = document.createElement('script');
    s.src = 'https://cdn.jsdelivr.net/npm/lamejs@1.2.1/lame.min.js';
    s.onload = function(){ res(!!window.lamejs); };
    s.onerror = function(){ res(false); };
    document.head.appendChild(s);
  });
}
function encodeMp3(buf){
  var SR = buf.sampleRate;
  var L = buf.getChannelData(0);
  var R = buf.numberOfChannels > 1 ? buf.getChannelData(1) : L;
  var enc = new lamejs.Mp3Encoder(2, SR, 192);
  var BLOCK = 1152, out = [];
  var l16 = new Int16Array(BLOCK), r16 = new Int16Array(BLOCK);
  for(var i = 0; i < buf.length; i += BLOCK){
    var n = Math.min(BLOCK, buf.length - i);
    for(var j = 0; j < n; j++){
      var lv = Math.max(-1, Math.min(1, L[i + j]));
      var rv = Math.max(-1, Math.min(1, R[i + j]));
      l16[j] = lv < 0 ? lv * 32768 : lv * 32767;
      r16[j] = rv < 0 ? rv * 32768 : rv * 32767;
    }
    var b = enc.encodeBuffer(l16.subarray(0, n), r16.subarray(0, n));
    if(b.length) out.push(b);
  }
  var end = enc.flush();
  if(end.length) out.push(end);
  return new Blob(out, { type: 'audio/mp3' });
}
function exportMp3(){
  if(!clips.length) return;
  var dur = projDur();
  if(dur <= 0.01){ alert('Timeline vazia.'); return; }
  openExportMenu(false);
  showToast('Gerando MP3…', 'fila');
  loadLame().then(function(ok){
    if(!ok){ alert('Não consegui carregar o encoder de MP3 (sem internet?).'); return; }
    return renderOfflineAudio(dur, 48000).then(function(buf){
      if(!buf){ alert('Não há áudio na timeline.'); return; }
      var blob = encodeMp3(buf);
      var a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = ('00' + nextRenderSeq()).slice(-3) + '-' + mcUserSlug() + '.mp3';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(function(){ URL.revokeObjectURL(a.href); }, 60000);
      showToast('MP3 exportado', 'ok');
    });
  }).catch(function(e){
    alert('Erro ao gerar o MP3: ' + (e && e.message ? e.message : e));
  });
}
on('mce-export-mp3', 'click', function(e){ if(e) e.stopPropagation(); exportMp3(); });
/* clicar fora fecha o menu */
document.addEventListener('click', function(e){
  var split = $('mce-export-split');
  if(split && !split.contains(e.target)) openExportMenu(false);
});

/* easing idêntico ao CSS 'ease' (cubic-bezier .25,.1,.25,1) — o scroll é
   animado com a MESMA curva/duração das transitions de .22s; assim a
   playhead fica cravada no mesmo pixel da tela durante o zoom (sem flick) */
function cssEase(t){
  if(t <= 0) return 0;
  if(t >= 1) return 1;
  var x1 = .25, y1 = .1, x2 = .25, y2 = 1, lo = 0, hi = 1, u = t;
  for(var i = 0; i < 24; i++){
    u = (lo + hi) / 2;
    var x = 3*u*(1-u)*(1-u)*x1 + 3*u*u*(1-u)*x2 + u*u*u;
    if(x < t) lo = u; else hi = u;
  }
  return 3*u*(1-u)*(1-u)*y1 + 3*u*u*(1-u)*y2 + u*u*u;
}
var zoomScrollRaf = null;
function animateScrollTo(target){
  if(zoomScrollRaf){ cancelAnimationFrame(zoomScrollRaf); zoomScrollRaf = null; }
  var from = elScroll.scrollLeft, t0 = performance.now();
  if(Math.abs(target - from) < 1){ elScroll.scrollLeft = target; return; }
  var step = function(now){
    var p = clamp((now - t0) / 220, 0, 1);
    elScroll.scrollLeft = from + (target - from) * cssEase(p);
    zoomScrollRaf = p < 1 ? requestAnimationFrame(step) : null;
  };
  zoomScrollRaf = requestAnimationFrame(step);
}
function applyZoom(ni){
  if(ni === zoomIdx) return;
  var viewW = elScroll.clientWidth;
  var phOff = tCur * PPS() - elScroll.scrollLeft;
  if(phOff < 0 || phOff > viewW) phOff = viewW / 2;
  zoomIdx = ni;
  elInner.style.width = (tlDur() * PPS() + 160) + 'px';
  animateRuler();       /* régua desliza igual aos clipes */
  animatePositions();   /* clipes deslizam pro novo zoom */
  /* scroll IMEDIATO (não animado) pra que o playhead não "flique" —
     a posição final do scroll garante que o playhead fica no mesmo
     ponto visual da tela que antes */
  var targetScroll = Math.max(0, tCur * PPS() - phOff);
  if(zoomScrollRaf){ cancelAnimationFrame(zoomScrollRaf); zoomScrollRaf = null; }
  elScroll.scrollLeft = targetScroll;
  renderPlayhead();
}
on('mce-zoom-in', 'click', function(){ applyZoom(Math.min(ZOOMS.length-1, zoomIdx+1)); });
on('mce-zoom-out', 'click', function(){ applyZoom(Math.max(0, zoomIdx-1)); });

/* scroll na timeline: normal = vertical suave; ctrl = zoom; alt = horizontal suave */
var _vScrollTarget = null, _vScrollRaf = null;
function animateVScroll(target){
  /* clampa no menor máximo dos dois containers (lanes × coluna de nomes) —
     a área das lanes perde altura pra scrollbar horizontal, então o limite
     dela difere do da coluna de nomes; sem isso um para antes do outro e as
     divisórias grossas dos grupos desalinham */
  var maxV = Math.min(
    Math.max(0, elScroll.scrollHeight - elScroll.clientHeight),
    Math.max(0, elHeads.scrollHeight - elHeads.clientHeight)
  );
  _vScrollTarget = clamp(target, 0, maxV);
  if(_vScrollRaf){ cancelAnimationFrame(_vScrollRaf); _vScrollRaf = null; }
  var from = elScroll.scrollTop, t0 = performance.now();
  if(Math.abs(_vScrollTarget - from) < 1){ elScroll.scrollTop = _vScrollTarget; elHeads.scrollTop = _vScrollTarget; return; }
  var step = function(now){
    var p = clamp((now - t0) / 180, 0, 1);
    var v = from + (_vScrollTarget - from) * cssEase(p);
    elScroll.scrollTop = v;
    elHeads.scrollTop = v;
    _vScrollRaf = p < 1 ? requestAnimationFrame(step) : null;
  };
  _vScrollRaf = requestAnimationFrame(step);
}
$('mce-tl').addEventListener('wheel', function(e){
  /* shift+scroll NÃO rola a timeline (atalho desativado) */
  if(e.shiftKey && !e.ctrlKey && !e.altKey){ e.preventDefault(); return; }
  if(e.altKey && !e.ctrlKey){
    e.preventDefault();
    animateScrollTo(Math.max(0, elScroll.scrollLeft + (e.deltaY || e.deltaX) * 3));
    return;
  }
  if(e.ctrlKey){
    e.preventDefault();
    applyZoom(clamp(zoomIdx + (e.deltaY < 0 ? 1 : -1), 0, ZOOMS.length - 1));
    return;
  }
  /* scroll normal = vertical com animação suave */
  e.preventDefault();
  var cur = _vScrollTarget != null ? _vScrollTarget : elScroll.scrollTop;
  animateVScroll(cur + (e.deltaY || e.deltaX));
}, { passive:false });

/* redesenha a fatia visível das waveforms ao rolar a timeline
   (e mantém a coluna de nomes sempre alinhada verticalmente) */
elScroll.addEventListener('scroll', function(){
  /* nunca deixa as lanes passarem do máximo da coluna de nomes (senão as
     divisórias grossas desalinham no fim do scroll) */
  var maxH = Math.max(0, elHeads.scrollHeight - elHeads.clientHeight);
  if(elScroll.scrollTop > maxH) elScroll.scrollTop = maxH;
  if(elHeads.scrollTop !== elScroll.scrollTop) elHeads.scrollTop = elScroll.scrollTop;
  requestAnimationFrame(function(){ updateWaveWindows(); updateFrameTicks(); });
});

/* shift+scroll no nome da faixa = altura vertical da faixa */
elHeads.addEventListener('wheel', function(e){
  if(!e.shiftKey) return;
  e.preventDefault();
  var head = e.target.closest ? e.target.closest('.mce-track-head') : null;
  if(!head) return;
  var idx = Array.prototype.indexOf.call(elHeads.children, head);
  var tr = tracks[idx];
  if(!tr) return;
  var delta = (e.deltaY || e.deltaX) > 0 ? -8 : 8;
  tr.h = clamp(trackH(tr) + delta, 32, 160);
  renderAll();
}, { passive:false });

/* puxar pra redimensionar: o grip do preview fica na divisa entre o vídeo e
   a barra de controles — fora da área dos botões play/pause/parar/fullscreen */
/* grips do LAYOUT 1 — no layout 2 eles NÃO somem: delegam pras ações
   lay2Drag* (mesmo comportamento dos grips próprios do layout 2) */
function isLay2(){ var r = document.getElementById('mc-root'); return !!(r && r.classList.contains('lay-2')); }

/* ── redimensionar a ALTURA da timeline segurando na parte de BAIXO dos
   blocos de cima (galeria / playback / configurações), em toda a largura.
   a timeline cresce PRA CIMA: o espaço vem do bloco do playback, que encolhe
   na mesma medida (a divisa acompanha o mouse) ── */
var fitRowGrip = null;
(function(){
  var target = $('mce-tl');
  var row = $('mce-stage-row');
  if(!target || !row) return;
  var grip = document.createElement('div');
  grip.className = 'mce-row-botresize';
  grip.title = 'Arrastar pra ajustar a altura dos blocos / timeline';
  row.appendChild(grip);
  /* grip horizontal ÚNICO entre os blocos de cima e a timeline: se estende
     por TODA a largura (inclusive sob o botão de exportar e o bloco de fx) */
  fitRowGrip = function(){
    grip.style.right = '0px';
  };
  fitRowGrip();
  if(window.ResizeObserver){
    var ro = new ResizeObserver(function(){ fitRowGrip(); });
    var sideEl = $('mce-side-col');
    if(sideEl) ro.observe(sideEl);
    ro.observe(row);
  }
  grip.addEventListener('mousedown', function(e){
    if(isLay2()){ e.preventDefault(); lay2DragTopH(e); return; }   /* layout 2: altura da área de cima */
    e.preventDefault();
    var stage = $('mce-stage-wrap'), pool = $('mce-pool'), side = $('mce-side-col');
    var tl0 = target.getBoundingClientRect().height;
    var st0 = stage ? stage.getBoundingClientRect().height : 0;
    var y0 = e.clientY;
    var mv = function(ev){
      var dy = ev.clientY - y0;                    /* pra cima = negativo */
      var tlH = clamp(tl0 - dy, 120, 720);
      var stH = clamp(st0 - (tlH - tl0), 160, Math.round(window.innerHeight * 0.92));
      tlH = tl0 + (st0 - stH);                     /* respeita o limite do playback */
      target.style.height = tlH + 'px';
      if(stage) stage.style.height = stH + 'px';
      if(pool)  pool.style.height  = stH + 'px';
      /* bloco de edição EXPANDIDO não encolhe junto (a altura dele vem da coluna) */
      if(side && !sideTall) side.style.height = stH + 'px';
    };
    var up = function(){ document.removeEventListener('mousemove', mv); document.removeEventListener('mouseup', up); };
    document.addEventListener('mousemove', mv);
    document.addEventListener('mouseup', up);
  });
})();

/* ── redimensionar a LARGURA dos blocos pela borda ──
   host = onde o grip aparece; target = bloco que muda de largura
   (as bordas do playback também controlam a galeria e as configurações) */
function makeHResizer(target, edge, min, max, host, hostEdge, lay2Action){
  if(!target) return;
  host = host || target;
  hostEdge = hostEdge || edge;
  var grip = document.createElement('div');
  grip.className = 'mce-hresize ' + (hostEdge === 'right' ? 'h-right' : 'h-left');
  grip.title = 'Arrastar pra ajustar a largura';
  host.appendChild(grip);
  grip.addEventListener('mousedown', function(e){
    if(isLay2()){ e.preventDefault(); if(lay2Action) lay2Action(e); return; }   /* layout 2: ação própria */
    e.preventDefault();
    var w0 = target.getBoundingClientRect().width, x0 = e.clientX;
    var mv = function(ev){
      var dx = ev.clientX - x0;
      var w = clamp(edge === 'right' ? w0 + dx : w0 - dx, min, max);
      target.style.flex = '0 0 ' + w + 'px';
    };
    var up = function(){ document.removeEventListener('mousemove', mv); document.removeEventListener('mouseup', up); };
    document.addEventListener('mousemove', mv);
    document.addEventListener('mouseup', up);
  });
}
makeHResizer($('mce-pool'), 'right', 180, 560, null, null, lay2DragPoolW);      /* galeria: puxa pela borda direita */
makeHResizer($('mce-side-col'), 'left', 200, 560, null, null, lay2DragPoolW);   /* coluna configurações (bloco fx): borda esquerda */
/* bordas do bloco do playback: esquerda controla a galeria, direita as configurações
   (no layout 2 as duas controlam a LARGURA do próprio playback) */
makeHResizer($('mce-pool'), 'right', 180, 560, $('mce-stage-wrap'), 'left', function(e){ lay2DragPlaybackW(e, 'left'); });
makeHResizer($('mce-side-col'), 'left', 200, 560, $('mce-stage-wrap'), 'right', function(e){ lay2DragPlaybackW(e, 'right'); });

/* (grip da parte inferior da timeline REMOVIDO nos dois layouts — a altura
   vem do grip horizontal central entre os blocos de cima e a timeline) */

/* ══════════ PRESETS DE LAYOUT ([1] [2] [disquete]) ══════════
   Dois MODOS de layout:
     slot 1 = padrão (galeria | playback | configurações · timeline embaixo)
     slot 2 = playback à direita em altura cheia, timeline à esquerda,
              sem o painel de edição de texto
   O arraste das extremidades ajusta as medidas dentro do modo; o disquete
   salva essas medidas por RESOLUÇÃO (1920x1080 e 1280x720 = saves separados
   dentro do mesmo slot). Persistência no servidor. */
var layoutStore = {};                 /* "slot@resolução" -> medidas */
var activeSlot = 1;
function screenRes(){ return (window.innerWidth || 0) + 'x' + (window.innerHeight || 0); }
function layoutKey(slot){ return slot + '@' + screenRes(); }

/* ── RESPONSIVIDADE POR INTERPOLAÇÃO ──
   Os layouts salvos nas duas resoluções de referência (1360x599 e 1920x911)
   são a base; pra QUALQUER outra resolução as medidas são interpoladas
   linearmente entre elas (larguras pela largura da janela, alturas pela
   altura). Substitui o esquema antigo de um save por resolução. */
var LAYOUT_REF_A = '1360x599', LAYOUT_REF_B = '1920x911';
function parseRes(r){
  var p = String(r).split('x');
  return { w: parseFloat(p[0]) || 0, h: parseFloat(p[1]) || 0 };
}
/* interpola os números "px" dentro de uma string de estilo (width/height/flex) */
function lerpStyleVal(a, b, t){
  a = a || ''; b = b || '';
  if(!a && !b) return '';
  if(!a) return b;
  if(!b) return a;
  var re = /-?\d+(?:\.\d+)?px/g;
  var ma = a.match(re), mb = b.match(re);
  if(!ma || !mb || ma.length !== mb.length) return t < 0.5 ? a : b;
  var i = 0;
  return b.replace(re, function(m){
    var va = parseFloat(ma[i]), vb = parseFloat(m); i++;
    return Math.round(va + (vb - va) * t) + 'px';
  });
}
function lerpLayout(La, Lb, tW, tH){
  var near = tW < 0.5 ? La : Lb;
  var out = { _fx: !!near._fx, _sideTall: !!near._sideTall };
  LAYOUT_IDS.forEach(function(id){
    var a = La[id] || {}, b = Lb[id] || {};
    out[id] = {
      flex:   lerpStyleVal(a.flex,   b.flex,   tW),   /* flex-basis dos blocos = largura */
      width:  lerpStyleVal(a.width,  b.width,  tW),
      height: lerpStyleVal(a.height, b.height, tH)
    };
  });
  return out;
}
/* layout pro tamanho ATUAL da janela, interpolado entre as duas referências */
function layoutForCurrentRes(slot){
  var La = layoutStore[slot + '@' + LAYOUT_REF_A];
  var Lb = layoutStore[slot + '@' + LAYOUT_REF_B];
  if(!La && !Lb) return layoutStore[layoutKey(slot)] || null;   /* sem referência: comportamento antigo */
  if(!La) La = Lb;
  if(!Lb) Lb = La;
  var ra = parseRes(LAYOUT_REF_A), rb = parseRes(LAYOUT_REF_B);
  var tW = rb.w === ra.w ? 1 : ((window.innerWidth  || 0) - ra.w) / (rb.w - ra.w);
  var tH = rb.h === ra.h ? 1 : ((window.innerHeight || 0) - ra.h) / (rb.h - ra.h);
  /* fora da faixa 1360→1920 extrapola de forma limitada (nunca inverte medidas) */
  tW = clamp(tW, -0.35, 1.35);
  tH = clamp(tH, -0.35, 1.35);
  var L = lerpLayout(La, Lb, tW, tH);
  if(slot === 2) equalizeLay2Bottom(L);
  return L;
}
/* base inferior IGUAL nos dois layouts: a altura da linha do layout 2 é
   derivada do layout 1 (blocos de cima + folga de 12px + timeline), então
   os dois terminam exatamente na mesma linha */
function equalizeLay2Bottom(L2){
  var L1 = null;
  var La = layoutStore['1@' + LAYOUT_REF_A], Lb = layoutStore['1@' + LAYOUT_REF_B];
  if(La || Lb){
    if(!La) La = Lb;
    if(!Lb) Lb = La;
    var ra = parseRes(LAYOUT_REF_A), rb = parseRes(LAYOUT_REF_B);
    var tW = rb.w === ra.w ? 1 : ((window.innerWidth  || 0) - ra.w) / (rb.w - ra.w);
    var tH = rb.h === ra.h ? 1 : ((window.innerHeight || 0) - ra.h) / (rb.h - ra.h);
    L1 = lerpLayout(La, Lb, clamp(tW, -0.35, 1.35), clamp(tH, -0.35, 1.35));
  }
  if(!L1 || !L2) return L2;
  var rowH = parseFloat((L1['mce-stage-row'] || {}).height);
  if(isNaN(rowH)) rowH = parseFloat((L1['mce-stage-wrap'] || {}).height);
  var tlH = parseFloat((L1['mce-tl'] || {}).height);
  if(isNaN(rowH) || isNaN(tlH)) return L2;
  L2['mce-stage-row'] = L2['mce-stage-row'] || { flex:'', width:'', height:'' };
  L2['mce-stage-row'].height = Math.round(rowH + 12 + tlH) + 'px';
  return L2;
}

/* blocos cujo tamanho/posição inline são salvos no layout */
var LAYOUT_IDS = ['mce-stage-row','mce-lay2-left','mce-lay2-top','mce-pool','mce-side-col','mce-stage-wrap','mce-tl'];
function fxOn(){ var r = document.getElementById('mc-root'); return !!(r && r.classList.contains('fx-on')); }
function setFx(on, skipRender){
  var r = document.getElementById('mc-root'); if(!r) return;
  r.classList.toggle('fx-on', !!on);
  var b = document.getElementById('mce-fx-toggle'); if(b) b.classList.toggle('is-on', !!on);
  /* ao DESLIGAR o fx, a mídia volta a ocupar toda a área (limpa a largura fixa) */
  if(!on){ var p = document.getElementById('mce-pool'); if(p){ p.style.flex = ''; p.style.width = ''; } }
  if(!skipRender){ renderRuler(); renderClips(); updateWaveWindows(); drawFrame(); }
}

/* helper: cria/reusa um grip garantindo SEMPRE que o listener existe */
function makeGrip(id, cls, title, onDrag){
  var g = document.getElementById(id);
  if(!g){ g = document.createElement('div'); g.id = id; g.className = cls; g.title = title; }
  if(!g._bound){
    g._bound = true;
    g.addEventListener('mousedown', function(e){
      e.preventDefault(); e.stopPropagation();
      onDrag(e);
    });
  }
  return g;
}

/* aplica a ESTRUTURA do layout 2:
   [ (MÍDIA | TEXTO)  ▸ hgrip  ▸ TIMELINE ]  |vgrip|  [ EXPORTAR / PLAYBACK ]   + bgrip embaixo */
function setLayoutMode(slot){
  var main  = document.querySelector('.mc-main');
  var row   = document.querySelector('.mce-stage-row');
  var tlp   = document.querySelector('.mce-timeline-panel');
  var pool  = document.getElementById('mce-pool');
  var side  = document.getElementById('mce-side-col');
  var stage = document.getElementById('mce-stage-wrap');
  var root  = document.getElementById('mc-root');
  if(!root || !main || !row || !tlp || !pool || !stage) return;
  var left  = document.getElementById('mce-lay2-left');
  var top   = document.getElementById('mce-lay2-top');
  var right = document.getElementById('mce-lay2-right');
  var expp  = document.querySelector('.mce-export-panel');

  if(slot === 2){
    root.classList.add('lay-2');
    if(!left){  left  = document.createElement('div'); left.id  = 'mce-lay2-left'; }
    if(!top){   top   = document.createElement('div'); top.id   = 'mce-lay2-top'; }
    if(!right){ right = document.createElement('div'); right.id = 'mce-lay2-right'; }
    if(right.parentNode !== row) row.appendChild(right);
    right.appendChild(stage);           /* PLAYBACK em cima */
    if(expp) right.appendChild(expp);   /* EXPORTAR embaixo do playback */
    if(left.parentNode !== row) row.insertBefore(left, right);
    if(top.parentNode !== left) left.insertBefore(top, left.firstChild);
    top.appendChild(pool);              /* MÍDIA */
    if(side) top.appendChild(side);     /* TEXTO/TripRank (aparece só com fx) */
    left.appendChild(tlp);              /* TIMELINE embaixo da área de cima */
    buildLay2Grips(row, left, top, pool, stage);
    /* fx toggle entra no grupo de botões utilitários (canto sup. direito) */
    var fxBtn = document.getElementById('mce-fx-toggle');
    var stBtns = stage.querySelector('.mce-stage-btns');
    if(fxBtn && stBtns && fxBtn.parentNode !== stBtns) stBtns.insertBefore(fxBtn, stBtns.firstChild);
    /* o grupo (fx, zoom, overlay, fullscreen) sai da barra inferior e vai pro
       canto sup. DIREITO do bloco do playback — mesma linha dos botões de layout */
    if(stBtns && stBtns.parentNode !== stage) stage.appendChild(stBtns);
  } else {
    root.classList.remove('lay-2');
    root.classList.remove('fx-on');
    /* fx toggle volta pra posição original (dentro do stage-wrap, fora do stage-btns) */
    var fxBtn2 = document.getElementById('mce-fx-toggle');
    if(fxBtn2 && stage) stage.insertBefore(fxBtn2, stage.querySelector('.mce-stage-canvas'));
    /* grupo de botões volta pra barra inferior do playback */
    var stBar1 = stage ? stage.querySelector('.mce-stage-bar') : null;
    var stBtns1 = stage ? stage.querySelector('.mce-stage-btns') : null;
    if(stBar1 && stBtns1 && stBtns1.parentNode !== stBar1) stBar1.appendChild(stBtns1);
    if(pool.parentNode !== row) row.insertBefore(pool, row.firstChild);
    if(stage.parentNode !== row) row.insertBefore(stage, pool.nextSibling);   /* sai da coluna do layout 2 */
    if(side && side.parentNode !== row) row.appendChild(side);   /* volta pro fim da linha */
    if(expp && side) side.appendChild(expp);   /* EXPORTAR volta pra coluna lateral */
    /* timeline volta pra LOGO DEPOIS do stage-row (e não no final da página) */
    if(tlp.parentNode !== main || tlp.previousElementSibling !== row){
      if(row.nextSibling) main.insertBefore(tlp, row.nextSibling);
      else main.appendChild(tlp);
    }
    if(top && top.parentNode) top.parentNode.removeChild(top);
    if(left && left.parentNode) left.parentNode.removeChild(left);
    if(right && right.parentNode) right.parentNode.removeChild(right);
    /* limpa estilos inline que sobraram do layout 2 */
    row.style.height = '';
    if(stage){ stage.style.width = ''; stage.style.flex = ''; stage.style.height = ''; }
    if(pool){ pool.style.flex = ''; pool.style.width = ''; pool.style.height = ''; }
    if(side){ side.style.height = ''; }
    tlp.style.height = '';
  }
}

/* ── AÇÕES de arraste do layout 2 — usadas pelos grips próprios (mce-lay2-*)
   E pelos grips herdados do layout 1, que delegam pra cá quando o layout 2
   está ativo (antes eles simplesmente não faziam nada) ── */

/* largura do PLAYBACK. edge = qual borda foi segurada ('left' | 'right').
   No layout 2 o playback vive numa COLUNA (#mce-lay2-right, com o botão de
   exportar em cima): a largura vai em width — flex-basis aqui viraria altura */
function lay2DragPlaybackW(e, edge){
  var st = document.getElementById('mce-stage-wrap');
  if(!st) return;
  var w0 = st.getBoundingClientRect().width, x0 = e.clientX;
  var s = edge === 'right' ? 1 : -1;
  drag2(function(ev){
    var w = clamp(w0 + s * (ev.clientX - x0), 160, 1200);
    st.style.width = w + 'px';
    st.style.flex = '';
  });
}

/* altura da ÁREA DE CIMA (mídia+texto); a timeline (flex:1) preenche o resto */
function lay2DragTopH(e){
  var topEl  = document.getElementById('mce-lay2-top');
  var leftEl = document.getElementById('mce-lay2-left');
  if(!topEl || !leftEl) return;
  var h0 = topEl.getBoundingClientRect().height, y0 = e.clientY;
  drag2(function(ev){
    var maxH = leftEl.getBoundingClientRect().height - 100;
    var h = clamp(h0 + (ev.clientY - y0), 80, Math.max(100, maxH));
    topEl.style.flex = '0 0 auto';
    topEl.style.height = h + 'px';
  });
}

/* divisa MÍDIA ↔ TEXTO/fx (só age com o fx ligado; sem ele a mídia preenche tudo) */
function lay2DragPoolW(e){
  if(!fxOn()) return;
  var poolEl = document.getElementById('mce-pool');
  if(!poolEl) return;
  var w0 = poolEl.getBoundingClientRect().width, x0 = e.clientX;
  drag2(function(ev){
    var w = clamp(w0 + (ev.clientX - x0), 120, 900);
    poolEl.style.flex = '0 0 ' + w + 'px';
  });
}

/* altura de TODA a área (linha inteira) */
function lay2DragRowH(e){
  var rowEl = document.querySelector('.mce-stage-row');
  if(!rowEl) return;
  var h0 = rowEl.getBoundingClientRect().height, y0 = e.clientY;
  drag2(function(ev){
    var h = clamp(h0 + (ev.clientY - y0), 240, Math.round(window.innerHeight * 1.6));
    rowEl.style.height = h + 'px';
  });
}

/* 4 grips do layout 2 (todos salvos via snapshot dos estilos que eles mexem) */
function buildLay2Grips(row, left, top, pool, stage){
  /* 1) vertical: coluna esquerda ↔ PLAYBACK (largura do playback) */
  var vg = makeGrip('mce-lay2-vgrip', 'mce-lay2-vgrip', 'Largura do playback', function(e){ lay2DragPlaybackW(e, 'left'); });
  left.appendChild(vg);

  /* 2) horizontal: base da ÁREA DE CIMA (mídia+texto) ↔ TIMELINE — unificado */
  var hg = makeGrip('mce-lay2-hgrip', 'mce-lay2-hgrip', 'Altura da área de mídia/texto', lay2DragTopH);
  top.appendChild(hg);

  /* 3) vertical: MÍDIA ↔ TEXTO (só com fx ligado) */
  var mg = makeGrip('mce-lay2-mgrip', 'mce-lay2-mgrip', 'Largura da mídia / texto', lay2DragPoolW);
  pool.appendChild(mg);

  /* (bgrip da parte inferior removido — grips de baixo da timeline saíram) */
  var oldBg = document.getElementById('mce-lay2-bgrip');
  if(oldBg && oldBg.parentNode) oldBg.parentNode.removeChild(oldBg);
}
/* util de arraste (mousemove/mouseup) */
function drag2(mv){
  var move = function(ev){ mv(ev); };
  var up = function(){ document.removeEventListener('mousemove', move); document.removeEventListener('mouseup', up); };
  document.addEventListener('mousemove', move);
  document.addEventListener('mouseup', up);
}

/* ── expandir o bloco de edição (SÓ layout 1): a coluna direita passa a
   ocupar toda a extensão vertical; a timeline fica à esquerda dela, com a
   direita alinhada ao playback. Os grips da divisa (borda direita do playback
   e borda esquerda do bloco) controlam a largura da coluna inteira — afetam
   playback E timeline ao mesmo tempo. Estado salvo no layout (disquete). ── */
var sideTall = false;
/* expandido: a coluna do bloco de edição segue EXATAMENTE a altura da coluna
   esquerda (blocos + timeline). O conteúdo interno rola, e o botão de exportar
   trava embaixo, alinhado ao fim da timeline. */
function syncSideTallH(){
  if(!sideTall) return;
  var left = document.getElementById('mce-lay1-left');
  var side = document.getElementById('mce-side-col');
  if(!left || !side) return;
  var h = Math.round(left.getBoundingClientRect().height);
  var cur = Math.round(side.getBoundingClientRect().height);
  if(h > 0 && Math.abs(h - cur) > 1) side.style.height = h + 'px';
}
var sideTallRO = window.ResizeObserver ? new ResizeObserver(function(){ syncSideTallH(); }) : null;
/* arraste do grip vertical da divisa (playback/timeline ↔ bloco expandido):
   controla a largura do bloco de edição — o resto (flex:1) preenche */
function lay1DragSideW(e){
  var side = document.getElementById('mce-side-col');
  if(!side) return;
  var w0 = side.getBoundingClientRect().width, x0 = e.clientX;
  drag2(function(ev){
    var w = clamp(w0 - (ev.clientX - x0), 200, 700);
    side.style.flex = '0 0 ' + w + 'px';
  });
}
function setSideTall(on, skipRender){
  var root = document.getElementById('mc-root');
  var main = document.querySelector('.mc-main');
  var row  = document.getElementById('mce-stage-row');
  var tlp  = document.querySelector('.mce-timeline-panel');
  var side = document.getElementById('mce-side-col');
  if(!root || !main || !row || !tlp || !side) return;
  if(isLay2()) on = false;             /* só existe no layout 1 */
  sideTall = !!on;
  var wrap = document.getElementById('mce-lay1-row');
  var left = document.getElementById('mce-lay1-left');
  if(sideTall){
    if(!wrap){ wrap = document.createElement('div'); wrap.id = 'mce-lay1-row'; }
    if(!left){ left = document.createElement('div'); left.id = 'mce-lay1-left'; }
    if(wrap.parentNode !== main) main.insertBefore(wrap, row);
    if(left.parentNode !== wrap) wrap.insertBefore(left, wrap.firstChild);
    left.appendChild(row);               /* galeria + playback */
    left.appendChild(tlp);               /* timeline embaixo, dentro da coluna esquerda */
    wrap.appendChild(side);              /* bloco de edição vira coluna direita cheia */
    side.style.height = '';              /* altura vem do sync com a coluna esquerda */
    /* grip vertical na divisa inteira: playback/timeline ↔ bloco de edição */
    var vg = makeGrip('mce-lay1-vgrip', 'mce-lay1-vgrip', 'Largura do bloco de edição', lay1DragSideW);
    left.appendChild(vg);
    root.classList.add('side-tall');
    if(sideTallRO){ sideTallRO.disconnect(); sideTallRO.observe(left); }
    syncSideTallH();
  } else {
    root.classList.remove('side-tall');
    if(sideTallRO) sideTallRO.disconnect();
    if(wrap && wrap.parentNode){
      main.insertBefore(row, wrap);
      if(row.nextSibling) main.insertBefore(tlp, row.nextSibling);
      else main.appendChild(tlp);
      row.appendChild(side);             /* volta pro fim da linha de cima */
      wrap.parentNode.removeChild(wrap);
    }
    /* encaixe de volta SEM gap: alinha a altura com a do playback (se ele foi
       redimensionado enquanto o bloco estava expandido) */
    var stg = document.getElementById('mce-stage-wrap');
    side.style.height = (stg && stg.style.height) ? stg.style.height : '';
  }
  if(fitRowGrip) fitRowGrip();
  var b = document.getElementById('mce-side-expand');
  if(b){
    b.classList.toggle('is-on', sideTall);
    b.title = sideTall ? 'Recolher o bloco de edição' : 'Expandir o bloco de edição na vertical';
  }
  if(!skipRender){ renderRuler(); renderClips(); updateWaveWindows(); drawFrame(); }
}
on('mce-side-expand', 'click', function(){ setSideTall(!sideTall); });

/* snapshot dos estilos inline (exatamente o que você ajustou arrastando) */
function measureLayout(){
  var o = { _fx: fxOn(), _sideTall: sideTall };
  LAYOUT_IDS.forEach(function(id){
    var el = document.getElementById(id);
    if(!el) return;
    o[id] = { flex: el.style.flex || '', width: el.style.width || '', height: el.style.height || '' };
  });
  return o;
}
function applyLayout(L){
  if(!L) return;
  setFx(!!L._fx, true);   /* restaura o painel de texto/efeitos (fx), sem render prematuro */
  setSideTall(!!L._sideTall, true);   /* bloco de edição expandido (só layout 1) */
  LAYOUT_IDS.forEach(function(id){
    if(id === 'mce-tl' && isLay2()) return;   /* no layout 2 a timeline preenche via flex */
    var el = document.getElementById(id); if(!el) return;
    var s = L[id]; if(!s) return;
    el.style.flex   = s.flex   || '';
    el.style.width  = s.width  || '';
    /* bloco de edição EXPANDIDO: a altura vem do sync com a coluna esquerda
       (blocos + timeline) — nunca da medida salva, senão o botão de exportar
       desalinha da base da timeline */
    if(id === 'mce-side-col' && sideTall) return;
    el.style.height = s.height || '';
  });
  /* no layout 2: playback, coluna esquerda e timeline preenchem 100% da linha
     (só a ALTURA DA LINHA — bgrip — define o tamanho vertical). Assim os dois
     lados ficam sempre com a mesma base. */
  if(isLay2()){
    ['mce-stage-wrap','mce-lay2-left','mce-tl'].forEach(function(id){
      var el = document.getElementById(id); if(el) el.style.height = '';
    });
  }
  /* bloco de edição EXPANDIDO restaurado do save: a altura é SEMPRE a da
     coluna esquerda (blocos + timeline) — sincroniza depois que as medidas
     acima assentam, senão o bloco extrapola o limite inferior da página */
  if(sideTall){
    syncSideTallH();
    requestAnimationFrame(syncSideTallH);
    setTimeout(syncSideTallH, 120);
  }
  renderRuler(); renderClips(); updateWaveWindows(); drawFrame();
}
function clearInlineLayout(){
  LAYOUT_IDS.forEach(function(id){
    var el = document.getElementById(id); if(!el) return;
    el.style.flex = ''; el.style.width = ''; el.style.height = '';
  });
}
function highlightSlot(){
  var b1 = $('mce-lp-1'), b2 = $('mce-lp-2');
  if(b1) b1.classList.toggle('is-on', activeSlot === 1);
  if(b2) b2.classList.toggle('is-on', activeSlot === 2);
}
function selectSlot(slot){
  activeSlot = slot;
  try{ localStorage.setItem('mce_active_slot', String(slot)); }catch(_){}
  highlightSlot();
  setSideTall(false, true);  /* desfaz o bloco expandido antes de reestruturar */
  setLayoutMode(slot);       /* estrutura primeiro (cria/remove a coluna) */
  clearInlineLayout();       /* limpa medidas que sobraram do modo anterior */
  var L = layoutForCurrentRes(slot);   /* interpolado entre 1360x599 e 1920x911 */
  if(L) applyLayout(L);
  else {
    if(slot === 2) setFx(true);   /* fx ligado por padrão no layout 2 */
    renderRuler(); renderClips(); updateWaveWindows(); drawFrame();
  }
}
/* lê os layouts salvos localmente (funciona na hora, sem depender do servidor) */
function loadLocalLayouts(){
  try{
    for(var i=0;i<localStorage.length;i++){
      var k = localStorage.key(i);
      if(k && k.indexOf('mce_layout_') === 0){
        try{ layoutStore[k.slice(11)] = JSON.parse(localStorage.getItem(k)); }catch(_){}
      }
    }
  }catch(_){}
}
function loadLayouts(){
  try{ activeSlot = parseInt(localStorage.getItem('mce_active_slot'), 10) || 1; }catch(_){ activeSlot = 1; }
  loadLocalLayouts();
  selectSlot(activeSlot);    /* aplica já com o que está salvo localmente */
  /* servidor: se responder, sincroniza e re-aplica */
  gas({ resource:'editor_layout', action:'get', user: MC_USER }, function(err, d){
    if(!err && d && d.layouts){
      var changed = false;
      for(var k in d.layouts){
        try{ layoutStore[k] = (typeof d.layouts[k] === 'string') ? JSON.parse(d.layouts[k]) : d.layouts[k]; changed = true; }catch(_){}
      }
      if(changed) selectSlot(activeSlot);
    }
  }, 20000);
}
on('mce-lp-1', 'click', function(){ selectSlot(1); });
on('mce-lp-2', 'click', function(){ selectSlot(2); });

/* ao mudar o tamanho da janela, re-interpola o layout entre as duas
   resoluções de referência (1360x599 ↔ 1920x911) — responsivo em qualquer
   resolução, sem depender de um save específico por tela */
var _resizeTimer = null;
window.addEventListener('resize', function(){
  /* debounce: espera parar de mexer antes de recalcular */
  if(_resizeTimer) clearTimeout(_resizeTimer);
  _resizeTimer = setTimeout(function(){
    /* em FULLSCREEN não se mexe na estrutura: mover o elemento em tela cheia
       no DOM faz o navegador SAIR do fullscreen na hora (era o "minimiza
       sozinho", principalmente no layout 2) */
    if(document.fullscreenElement){
      renderRuler(); renderClips(); updateWaveWindows(); drawFrame();
      return;
    }
    var wasTall = sideTall;
    setSideTall(false, true);
    setLayoutMode(activeSlot);
    clearInlineLayout();
    var L = layoutForCurrentRes(activeSlot);
    if(L) applyLayout(L);
    else {
      if(activeSlot === 2) setFx(true);
      else if(wasTall) setSideTall(true, true);   /* mantém o bloco expandido */
      renderRuler(); renderClips(); updateWaveWindows(); drawFrame();
    }
  }, 200);
});
on('mce-fx-toggle', 'click', function(){ setFx(!fxOn()); });
on('mce-lp-save', 'click', function(){
  var L = measureLayout();
  var key = layoutKey(activeSlot);
  layoutStore[key] = L;
  try{ localStorage.setItem('mce_layout_' + key, JSON.stringify(L)); }catch(_){}   /* persiste local na hora */
  var isRef = screenRes() === LAYOUT_REF_A || screenRes() === LAYOUT_REF_B;
  showToast(isRef
    ? 'Layout ' + activeSlot + ' salvo (' + screenRes() + ' — referência)'
    : 'Layout ' + activeSlot + ' salvo — atenção: só ' + LAYOUT_REF_A + ' e ' + LAYOUT_REF_B + ' são usadas como referência', isRef ? 'ok' : 'fila');
  gas({ resource:'editor_layout', action:'save', user: MC_USER, key: key, json: JSON.stringify(L) }, function(){}, 20000);
});

/* ── modal de texto: eventos ── */
on('mce-text-modal-close', 'click', closeTextModal);
/* filtro de cidade do modal de modelos */
(function(){ var f = $('mce-modal-city-filter'); if(f) f.addEventListener('change', function(){ tplModalCity = this.value; renderTextModal(); }); })();
/* dropdown de cidade do painel de texto (atribui a cidade ao clipe atual) */
(function(){ var s = $('mce-text-city'); if(s) s.addEventListener('change', function(){
  var c = sel();
  if(c && c.kind === 'text'){ snapshot(); c.city = this.value; }
}); })();
$('mce-text-modal-overlay').addEventListener('click', function(e){
  if(e.target === this) closeTextModal();
});
/* ── seletor de tipo de modelo (item 15) ── */
function showTypePicker(){
  var existing = document.querySelector('.mce-type-picker');
  if(existing) existing.remove();
  var wrap = document.createElement('div');
  wrap.className = 'mce-type-picker';
  var types = [
    { id:1, label:'Modelo 1',  desc:'Montserrat · chips deslizantes' },
    { id:2, label:'Modelo 2',  desc:'Helvetica SemiBold · centralizado' },
    { id:3, label:'Modelo 3', desc:'Bebas Neue · gradiente azul' }
  ];
  types.forEach(function(tp){
    var btn = document.createElement('button');
    btn.className = 'mce-type-btn';
    /* thumbnail: primeiro modelo salvo desse tipo, ou preview padrão */
    var cvs = document.createElement('canvas');
    var sample = null;
    for(var i=0;i<textTemplates.length;i++){
      if((textTemplates[i].modelType || 1) === tp.id){ sample = textTemplates[i]; break; }
    }
    if(!sample) sample = {
      modelType: tp.id, text: 'EXEMPLO\nTEXTO',
      size: tp.id === 3 ? Math.round(PROJ_W*0.12) : Math.round(PROJ_W*0.085),
      lineGap: tp.id === 2 ? 20 : (tp.id === 3 ? 10 : 30),
      x: tp.id === 2 ? 0.5 : 0.08, y: tp.id === 3 ? 0.75 : 0.5,
      chapeu: tp.id === 3 ? 'VEÍCULO' : ''
    };
    drawTemplatePreview(cvs, sample);
    btn.appendChild(cvs);
    var lbl = document.createElement('span');
    lbl.textContent = tp.label;
    btn.appendChild(lbl);
    btn.addEventListener('click', function(){
      wrap.remove();
      /* veio de "Todos os modelos" (trocar): aplica o TIPO à versão ativa do
         clipe atual — novo clipe de texto só via +TXT na faixa */
      if(textModalApplyId) applyTypeToCurrent(tp.id);
      else createNewTextClip(tp.id);
    });
    wrap.appendChild(btn);
  });
  /* botão fechar */
  var close = document.createElement('button');
  close.className = 'mce-type-close';
  close.textContent = '×';
  close.addEventListener('click', function(){ wrap.remove(); });
  wrap.appendChild(close);
  /* clicar fora dos botões (no fundo do picker) fecha */
  wrap.addEventListener('click', function(e){
    if(e.target === wrap) wrap.remove();
  });
  document.querySelector('.mce-text-modal').appendChild(wrap);
}

/* defaults "limpos" de cada tipo de modelo (compartilhados entre criar um
   clipe novo e aplicar um tipo ao clipe atual) */
function textTypeDefaults(modelType){
  var defaults = {
    1: { text:'SEU TEXTO\nAQUI', x:0.08, y:0.5, size:Math.round(PROJ_W*0.085), lineGap:30 },
    2: { text:'SEU TEXTO\nAQUI', x:0.5, y:0.5, size:Math.round(PROJ_W*0.085), lineGap:20, padding:Math.round(PROJ_W*0.085*0.4) },
    3: { text:'SEU TEXTO\nAQUI', x:0.08, y:0.75, size:Math.round(PROJ_W*0.12), lineGap:10, chapeu:'VEÍCULO', chapeuSize:Math.round(PROJ_W*0.12*0.4), chapeuGap:Math.round(PROJ_W*0.12*0.15), showBg:false, padding:Math.round(PROJ_W*0.12*0.3), gradHeight:0.65 }
  };
  return defaults[modelType] || defaults[1];
}

/* aplica um TIPO de modelo (com os defaults dele) à VERSÃO ativa (V1/V2) do
   clipe atual — mantém o TEXTO digitado; não cria clipe novo */
function applyTypeToCurrent(modelType){
  var c = byId(textModalApplyId);
  closeTextModal();
  if(!c || c.kind !== 'text') return;
  snapshot();
  selectedTemplateId = null;
  ensureV2(c);
  var D = tData(c);
  var d = textTypeDefaults(modelType);
  D.modelType = modelType;
  D.x = d.x; D.y = d.y; D.size = d.size; D.lineGap = d.lineGap;
  D.padding = d.padding; D.padV = undefined;
  if(modelType === 3){
    if(D.chapeu == null || D.chapeu === '') D.chapeu = d.chapeu;
    D.chapeuSize = d.chapeuSize; D.chapeuGap = d.chapeuGap;
    D.showBg = d.showBg; D.gradHeight = d.gradHeight;
  }
  selectClip(c);
  renderAll(); drawFrame();
}

function createNewTextClip(modelType){
  closeTextModal();
  selectedTemplateId = null;   /* novo modelo: sem vínculo com modelo existente */
  snapshot();
  var tr = pendingTextTrackId ? trackById(pendingTextTrackId) : firstTrack('text');
  if(!tr) tr = firstTrack('text');
  var vEnd = 0;
  clips.forEach(function(cc){ if(cc.kind === 'video') vEnd = Math.max(vEnd, cc.start + cc.dur); });
  var d = textTypeDefaults(modelType);
  /* cadeado desligado → o texto novo entra na posição do playhead */
  var start0 = textLockDur ? 0 : snap(tCur);
  var c = {
    id: uid(), kind:'text', trackId: tr.id,
    start: start0, dur: (textLockDur && vEnd > FRAME) ? snap(vEnd) : 4, in: 0, srcDur: 0, autoDur: textLockDur && vEnd > FRAME,
    el: null, name: 'TEXTO', pair: null, muted:false, modelType: modelType,
    text: d.text, x: d.x, y: d.y, size: d.size, lineGap: d.lineGap,
    padding: d.padding, chapeu: d.chapeu, chapeuSize: d.chapeuSize, chapeuGap: d.chapeuGap, showBg: d.showBg, gradHeight: d.gradHeight
  };
  clips.push(c);
  overwriteMoved([c]);
  selectClip(c);
  renderAll(); drawFrame();
}
$('mce-tpl-new').addEventListener('click', function(){ showTypePicker(); });

/* ── salvar modelo de texto (menu inline + modal de nome) ── */
var _saveTplData = null;   /* dados pendentes enquanto modal de nome está aberto */

function closeSaveMenu(){ var m = $('mce-save-menu'); if(m) m.style.display = 'none'; }

function openNameModal(defaultName, onConfirm, opts){
  opts = opts || {};
  var ov = $('mce-name-modal');
  var inp = $('mce-name-input');
  /* o modal nasce DENTRO do painel de texto (que pode estar oculto/re-renderizando)
     — movê-lo pro root faz a janela abrir NA HORA, sem delay nem dependência
     do painel estar visível */
  if(ov.parentNode !== uiRoot()) uiRoot().appendChild(ov);
  inp.value = defaultName || '';

  /* ── seletor de categoria (Carro/Moto) — sempre visível ao salvar/renomear.
     Escolha obrigatória; começa em 'carro' (ou na categoria atual do modelo). */
  var chosenCat = (opts.category === 'moto') ? 'moto' : 'carro';
  var body = ov.querySelector('.mce-name-modal-body');
  var catRow = ov.querySelector('#mce-namecat');
  if(!catRow){
    catRow = document.createElement('div');
    catRow.id = 'mce-namecat';
    catRow.style.margin = '0 0 12px';
    catRow.innerHTML = '<div class="mce-namecat-lbl">Categoria</div><div class="mce-copy-tabs" id="mce-namecat-tabs">'
      + TPL_CATS.map(function(c){ return '<button type="button" class="mce-copy-tab" data-cat="'+c.id+'">'+c.label+'</button>'; }).join('')
      + '</div>';
    body.insertBefore(catRow, body.firstChild);
  }
  var catBtns = catRow.querySelectorAll('.mce-copy-tab');
  function syncCat(){ catBtns.forEach(function(b){ b.classList.toggle('is-on', b.dataset.cat === chosenCat); }); }
  catBtns.forEach(function(b){ b.onclick = function(){ chosenCat = b.dataset.cat; syncCat(); }; });
  syncCat();

  ov.style.display = 'flex';
  inp.focus(); inp.select();
  requestAnimationFrame(function(){ inp.focus(); inp.select(); });
  var okBtn = $('mce-name-ok');
  var cancelBtn = $('mce-name-cancel');
  var closeBtn = $('mce-name-modal-close');
  function closeModal(){ ov.style.display = 'none'; }
  function confirm(){
    var nome = inp.value.trim();
    if(!nome){ inp.focus(); return; }
    closeModal();
    onConfirm(nome, chosenCat);
  }
  okBtn.onclick = confirm;
  cancelBtn.onclick = closeModal;
  closeBtn.onclick = closeModal;
  inp.onkeydown = function(e){ if(e.key === 'Enter') confirm(); if(e.key === 'Escape') closeModal(); };
  ov.onclick = function(e){ if(e.target === ov) closeModal(); };
}

function buildTplData(c){
  ensureV2(c);
  return {
    modelType: c.modelType || 1,
    modelType2: (c.v2.modelType != null ? c.v2.modelType : c.modelType) || 1,
    upper: upFlag(c.upper) ? 'on' : 'off',
    upper2: upFlag(c.v2.upper) ? 'on' : 'off',
    chapeuUpper: upFlag(c.chapeuUpper) ? 'on' : 'off',
    chapeuUpper2: upFlag(c.v2.chapeuUpper) ? 'on' : 'off',
    city: c.city || '',
    text: c.text, size: c.size, lineGap: c.lineGap, x: c.x, y: c.y,
    padding: c.padding, padV: c.padV, chapeu: c.chapeu, chapeuSize: c.chapeuSize, chapeuGap: c.chapeuGap, showBg: c.showBg, gradHeight: c.gradHeight,
    text2: c.v2.text, size2: c.v2.size, lineGap2: c.v2.lineGap, x2: c.v2.x, y2: c.v2.y,
    padding2: c.v2.padding, padV2: c.v2.padV, chapeu2: c.v2.chapeu, chapeuSize2: c.v2.chapeuSize, chapeuGap2: c.v2.chapeuGap, showBg2: c.v2.showBg, gradHeight2: c.v2.gradHeight
  };
}

function doSaveAsNew(tplData, btn, html0){
  openNameModal((sel() && sel().text || '').split('\n')[0].slice(0,30) || 'MODELO', function(nome, cat){
    btn.disabled = true;
    btn.textContent = 'salvando…';
    tplData.name = nome;
    tplData.category = (cat === 'moto') ? 'moto' : 'carro';
    tplModalCat = tplData.category;   /* modal já mostra a aba do modelo recém-salvo */
    saveTextTemplate(tplData, function(){
      btn.disabled = false;
      btn.innerHTML = html0;
      showToast('Modelo salvo', 'ok');
    });
  }, { category: 'carro' });
}

function doUpdateExisting(tplData, tplId, tplName, btn, html0){
  btn.disabled = true;
  btn.textContent = 'atualizando…';
  tplData.name = tplName;
  updateTextTemplate(tplId, tplData, function(){
    btn.disabled = false;
    btn.innerHTML = html0;
    showToast('Modelo atualizado', 'ok');
  });
}

on('mce-save-tpl', 'click', function(){
  var c = sel();
  if(!c || c.kind !== 'text') return;
  /* cidade é obrigatória (mesmo "Nenhuma" precisa ser escolhida) */
  if(!c.city){
    alert('Escolha a cidade do modelo (ou "Nenhuma") antes de salvar.');
    var citySel = $('mce-text-city');
    if(citySel){ try{ citySel.focus(); }catch(_){}; }
    return;
  }
  var tplData = buildTplData(c);
  var btn = this;
  var html0 = btn.innerHTML;

  /* se NÃO veio de modelo existente → salvar como novo direto */
  if(!selectedTemplateId){
    doSaveAsNew(tplData, btn, html0);
    return;
  }

  /* veio de modelo existente → mostra menu acima do botão */
  var existingTpl = null;
  for(var i=0;i<textTemplates.length;i++){
    if(textTemplates[i].id === selectedTemplateId){ existingTpl = textTemplates[i]; break; }
  }
  if(!existingTpl){
    /* modelo não encontrado, trata como novo */
    doSaveAsNew(tplData, btn, html0);
    return;
  }

  var menu = $('mce-save-menu');
  menu.innerHTML = '';

  var optUpdate = document.createElement('button');
  optUpdate.className = 'mce-save-menu-opt';
  optUpdate.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-2.64-6.36"/><polyline points="21 3 21 9 15 9"/></svg><span>Atualizar modelo atual</span>';
  optUpdate.addEventListener('click', function(){
    closeSaveMenu();
    tplData.category = tplCatOf(existingTpl);   /* mantém a categoria atual do modelo no update */
    doUpdateExisting(tplData, selectedTemplateId, existingTpl.name, btn, html0);
  });
  menu.appendChild(optUpdate);

  var optNew = document.createElement('button');
  optNew.className = 'mce-save-menu-opt';
  optNew.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/><polyline points="17 21 17 13 7 13 7 21"/><polyline points="7 3 7 8 15 8"/></svg><span>Salvar como novo modelo</span>';
  optNew.addEventListener('click', function(){
    closeSaveMenu();
    doSaveAsNew(tplData, btn, html0);
  });
  menu.appendChild(optNew);

  menu.style.display = 'flex';

  /* fecha o menu ao clicar fora */
  setTimeout(function(){
    function outsideClick(e){
      if(!menu.contains(e.target) && e.target !== btn){
        closeSaveMenu();
        document.removeEventListener('mousedown', outsideClick);
      }
    }
    document.addEventListener('mousedown', outsideClick);
  }, 10);
});

on('mce-unlink', 'click', toggleLink);   /* alterna: desvincula E vincula de volta (Ctrl+Alt+L) */
on('mce-file-add', 'click', function(){ var i = $('mce-file-input'); if(i) i.click(); });
on('mce-file-input', 'change', function(){
  if(this.files && this.files.length) addLocalFiles(this.files);
  this.value = '';
});

document.addEventListener('keydown', function(e){
  /* Ctrl/⌘+F NUNCA abre o "localizar na página" do navegador — sempre alterna
     tela cheia, inclusive com um campo de texto (input/textarea) focado.
     Fica ANTES do return abaixo justamente pra funcionar com o foco no texto. */
  if((e.ctrlKey || e.metaKey) && !e.shiftKey && !e.altKey && (e.key === 'f' || e.key === 'F')){
    e.preventDefault();
    toggleFullscreen();
    return;
  }
  var tag = (document.activeElement && document.activeElement.tagName || '').toLowerCase();
  if(tag === 'input' || tag === 'textarea') return;
  var mod = e.ctrlKey || e.metaKey;
  if(mod && e.shiftKey && (e.key === 'z' || e.key === 'Z')){ e.preventDefault(); redo(); }
  else if(mod && (e.key === 'z' || e.key === 'Z')){ e.preventDefault(); undo(); }
  else if(mod && (e.key === 'a' || e.key === 'A')){          /* Ctrl+A = seleciona tudo */
    e.preventDefault();
    setSel(clips.map(function(c){ return c.id; }));
    renderClips();
  }
  else if(mod && e.altKey && (e.key === 'l' || e.key === 'L')){ e.preventDefault(); toggleLink(); }   /* Ctrl+Alt+L = vincular/desvincular */
  else if(mod && (e.key === 'c' || e.key === 'C')){ e.preventDefault(); copySel(); }
  else if(mod && (e.key === 'v' || e.key === 'V')){ e.preventDefault(); pasteClip(); }
  else if(mod && (e.key === 'x' || e.key === 'X')){ e.preventDefault(); doDelete(false); } /* Ctrl+X = Backspace */
  else if(mod && (e.key === 'f' || e.key === 'F')){ e.preventDefault(); toggleFullscreen(); } /* Ctrl+F = tela cheia */
  else if(e.code === 'Space'){
    e.preventDefault();
    if(document.activeElement && document.activeElement.blur) document.activeElement.blur();
    playing ? pause() : play();   /* espaço pausa se tocando, toca se pausado */
  }
  else if(e.key === 'c' || e.key === 'C'){ setCutMode(!cutMode); }
  else if(e.key === 'a' || e.key === 'A'){ setCutMode(false); }        /* A = cursor padrão */
  else if(e.key === 's' || e.key === 'S'){ doSplit(); }
  else if(e.key === 'Escape'){ setCutMode(false); }
  else if(e.key === 'ArrowRight' && !playing){
    e.preventDefault();
    tCur = snap(tCur + FRAME);
    if(tCur > projDur()) tCur = projDur();
    renderPlayhead(); seekMediaExact(); drawFrame();   /* seek IMEDIATO e frame-exato */
  }
  else if(e.key === 'ArrowLeft' && !playing){
    e.preventDefault();
    tCur = snap(tCur - FRAME);
    if(tCur < 0) tCur = 0;
    renderPlayhead(); seekMediaExact(); drawFrame();
  }
  else if(e.key === 'Delete'){ e.preventDefault(); doDelete(true); }     /* exclui e puxa (ripple) */
  else if(e.key === 'Backspace'){ e.preventDefault(); doDelete(false); } /* só exclui */
});

renderAll();
drawFrame();
rafId = requestAnimationFrame(tick);

/* carrega modelos de texto salvos + histórico de exportações + layouts */
loadTextTemplates();
loadSfx();
loadCityUsage();
loadExportStats();
loadLayouts();
/* pré-baixa a Bebas Neue pro worker de render (o export não espera a rede) */
try{ if(typeof getBebasBytes === 'function') getBebasBytes(); }catch(_){}

/* fim */
})();